(function (global, factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        module.exports = global.document
            ? // factory(global, true) :
              factory(global, true)
            : function (w) {
                  if (!w.document) {
                      throw new Error("Need a window with a document");
                  }
                  return factory(w);
              };
    } else {
        factory(global);
    }
})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {
    if (typeof Object.assign != "function") {
        Object.assign = function (target, varArgs) {
            // .length of function is 2
            "use strict";
            if (target == null) {
                // TypeError if undefined or null
                throw new TypeError(
                    "Cannot convert undefined or null to object"
                );
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) {
                    // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (
                            Object.prototype.hasOwnProperty.call(
                                nextSource,
                                nextKey
                            )
                        ) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        };
    }

    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        };
    }

    var Rotate = function (action, data, o) {
        // Angle为正时逆时针转动, 单位为弧度
        data = (Math.PI / 180) * data;
        var b = {};
        b.x =
            (action.x - o.x) * Math.cos(data) -
            (action.y - o.y) * Math.sin(data) +
            o.x;
        b.y =
            (action.x - o.x) * Math.sin(data) +
            (action.y - o.y) * Math.cos(data) +
            o.y;

        return b;
    };
    var numberOunding = function (data) {
        var rdata = data;
        if (!isNaN(rdata)) {
            rdata = new Number(rdata);
            rdata = rdata.toFixed(2) - 0;
        }
        return rdata;
    };

    // 为svg.js添加类似snap.svg的format方法
    SVG.format = (function () {
        var tokenRegex = /\{([^\}]+)\}/g,
            objNotationRegex =
                /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
            replacer = function (all, key, obj) {
                var res = obj;
                key.replace(
                    objNotationRegex,
                    function (all, name, quote, quotedName, isFunc) {
                        name = name || quotedName;
                        if (res) {
                            if (name in res) {
                                res = res[name];
                            }
                            typeof res == "function" && isFunc && (res = res());
                        }
                    }
                );
                res = (res == null || res == obj ? all : res) + "";
                return res;
            };
        return function (str, obj) {
            return String(str).replace(tokenRegex, function (all, key) {
                return replacer(all, key, obj);
            });
        };
    })();

    function handleAssetsUrl(url) {
        if (!url) return "";
        if (url.indexOf("http") === 0) {
            return url;
        }
        var reg = /^\//;
        // var qiniuAssetsUrl = 'http://www.laihua.com';
        var qiniuAssetsUrl = "https://resources.laihua.com";

        var reg2 = new RegExp(qiniuAssetsUrl + "/", "g");
        url = url.replace(reg2, "");
        // var qiniuAssetsUrl = '';
        if (!reg.test(url)) {
            return qiniuAssetsUrl + "/" + url;
        } else {
            return qiniuAssetsUrl + url;
        }
    }

    function unhandleAssetsUrl(url) {
        return url
            ? url.replace(/https:\/\/resources.laihua.com(\/)?/, "")
            : "";
    }

    function arrayUniq(a) {
        var seen = {};
        var out = [];
        var len = a.length;
        var j = 0;
        for (var i = 0; i < len; i++) {
            var item = a[i];
            if (seen[item] !== 1) {
                seen[item] = 1;
                out[j++] = item;
            }
        }
        return out;
    }

    //标准项目模板数据适应画布
    function json2uwp(json) {
        var scale = 1920 / json.resolution.width;

        json.scenes.forEach(function (scene) {
            //未加载的直接使用原数据
            //console.log("TCL: functionjson2uwp -> 未加载的直接使用原数据", scene)
            if (scene.isUnload) {
                delete scene.isUnload; //清除标记字段
                return;
            }
            scene.sprites.forEach(function (sprite) {
                var o = sprite.outward;
                o.x = numberOunding((o.x *= scale));
                o.y = numberOunding((o.y *= scale));
                o.width = numberOunding((o.width *= scale));
                o.height = numberOunding((o.height *= scale));

                var animation = sprite.stayEffect.animationGraphs;
                if (animation) {
                    if ("toBounds" in animation[0]) {
                        animation[0].toBounds.height = numberOunding(
                            (animation[0].toBounds.height *= scale)
                        );
                        animation[0].toBounds.width = numberOunding(
                            (animation[0].toBounds.width *= scale)
                        );
                        animation[0].toBounds.x = numberOunding(
                            (animation[0].toBounds.x *= scale)
                        );
                        animation[0].toBounds.y = numberOunding(
                            (animation[0].toBounds.y *= scale)
                        );
                    }
                    if ("info" in animation[0]) {
                        animation[0].info.height = numberOunding(
                            (animation[0].info.height *= scale)
                        );
                        animation[0].info.width = numberOunding(
                            (animation[0].info.width *= scale)
                        );
                        animation[0].info.points &&
                            animation[0].info.points.forEach(function (
                                point,
                                i,
                                arr
                            ) {
                                for (var j = 0; j < point.length; j++) {
                                    arr[i][j] = numberOunding(
                                        (point[j] *= scale)
                                    );
                                }
                            });
                    }
                    animation[0].path &&
                        animation[0].path.forEach(function (val, i, arr) {
                            arr[i] = val * scale;
                        });
                }
            });
            scene.cameras.forEach(function (camera, i, arr) {
                var m = camera.matrix;
                arr[i].matrix.w = numberOunding((m.w *= scale));
                arr[i].matrix.h = numberOunding((m.h *= scale));
                arr[i].matrix.x = numberOunding((m.x *= scale));
                arr[i].matrix.y = numberOunding((m.y *= scale));
            });
        });
        json.resolution.width = 1920;
        json.resolution.height = 1080;

        return json;
    }

    var _fetch = function (url, option) {
        url = handleAssetsUrl(url);

        return fetch(url, option)
            .then(function (resp) {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp;
                } else {
                    throw resp.statusText;
                }
            })
            .catch(function (err) {});
    };

    var laihuaApi = async function (url, option) {
        return fetch("/api" + url, option)
            .then(function (resp) {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp;
                } else {
                    throw resp.statusText;
                }
            })
            .catch(function (err) {
                throw err;
            });
    };

    function testBuffered(video, type, evType) {
        // evType = evType || 'progress'
        // var $video = $(video);
        // $video.on(evType, function () {
        //     var bf = $video.prop('buffered')
        //     if (bf.length > 0) {
        //         console.log({
        //             type: type,
        //             buffered: bf,
        //             bufferedStart: bf.start(bf.length - 1),
        //             bufferedEnd: bf.end(bf.length - 1)
        //         })
        //     }
        // })
    }

    function generateUUID () {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (
                c ^
                (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
            ).toString(16)
        );
    }

    var ImageLoader = klass(function () {
        //
    }).statics({
        load: function (url) {
            return new Promise(function (resolve, reject) {
                var img = new Image();
                // let reg = /^data/g;
                img.onload = function () {
                    resolve(img);
                };

                img.onerror = function (e) {
                    reject(e);
                };
                url = handleAssetsUrl(url);
                img.src = url;
            });
        },

        constructAnimPath: function (img) {
            var width = img.width,
                height = img.height,
                off = Math.max(5, Math.round(width / 10));

            width += off;
            height += off;

            var x = -off;
            var y = -off;
            var paths = [["M", x, y]];

            while (x - width < height || y - height < width) {
                x += off;
                y += off;

                if (x > width) {
                    paths.push(["L", width + off / 2, x - width]);
                } else {
                    paths.push(["L", x, 0]);
                }

                if (y > height) {
                    paths.push(["L", y - height, height + off / 2]);
                } else {
                    paths.push(["L", 0, y]);
                }
            }

            var d = "";
            paths.forEach(function (path) {
                d += path.join(" ") + " ";
            });

            return {
                d: d,
                "stroke-width": off,
                "stroke-linejoin": "round",
                stroke: "white",
                fill: "none",
            };
        },
    });

    //场景页的类
    var ScenesSprite = klass(function (id, editor, options) {
        // 分组的对象
        this.id = id; // id
        this.oldId = options.oldId || null; // 分组本身的id
        this.scenesId = id; // id
        this.resourceId = options.resourceId; // 资源id
        this.editor = editor; // 全局editor对象
        this.vipMaterials = []; // 添加付费素材
        this.vipFunctions = []; // 添加 图表

        this.uuid = id || uuid.generate();
        this.options = Object.assign({}, options);
        this.index = this.editor.sprites ? this.editor.sprites.length : 0; // 排序
        this.nowTime = 1;

        this.background = {
            // 场景背景
            data: {
                resourceId: null, // 背景资源id
                fileType: null, // 背景资源type
                type: "Color", // 背景类型 0:Color 1:Image 2:Video
                data: {
                    // 颜色背景的数据
                    blur: 0, // 高斯模糊
                    opacity: 1, // 透明度
                    color: "#ffffff", // 颜色值,8位数
                },
            },
            element: {
                // 背景的元素
                content: null,
                player: null,
            },
            bgMsg: null,
            zoomActive: false,
            zoomOptions: {},
            filter: {
                blur: 0,
                brightness: 1,
                contrast: 1,
                saturate: 1,
                grayscale: 0,
                hueRotate: 0,
                invert: 0,
                sepia: 0,
            },
        };
        this.sound = null; // 场景配音
        this.duration = options.duration || 10000; // 时间轴长
        this.sprites = []; // 元素精灵

        this.version = null; // 场景版本号
        this.adsorbArr = []; // 场景页中吸附数据
        this.groupList = options.groupList || []; // 组合元素数组

        this.fromJsonLoadingState = 0; //0: 未加载; 1: 加载中; 2: 已加载
        this.unLoadData = { json: null, resolutionWidth: 1920 }; //未加载的场景json

        this.setBackgroundLoadingObj = null;

        var dom = $("<div></div>")
            .attr({
                "data-scenesId": this.scenesId,
            })
            .css({
                position: "absolute",
                top: 0,
                left: 0,
                "z-index": this.index * 5,
                width: this.editor.option.width,
                height: this.editor.option.height,
                display: "none",
                opcity: 0,
            });
        // 添加分组元素到player层
        var $play = dom
            .clone()
            .attr({
                id: "player-scene-" + this.uuid,
            })
            .css({
                overflow: "hidden",
            });
        var $playContent = $('<div class="scenes-content"></div>');
        $playContent.appendTo($play);
        $play.appendTo(this.editor.player.ele);
        this.editor.player.scenesDict[this.uuid] = {
            ele: $play,
            eleC: $playContent,
        };
        // 添加分组元素到content层
        var $content = dom
            .clone()
            .attr({
                id: "content_scenes_" + this.scenesId + "_" + uuid.generate(),
            })
            .appendTo(this.editor.contentBody);
        // 添加分组元素到handle层
        var $handle = dom
            .clone()
            .attr({
                id: "handle_scenes_" + this.scenesId + "_" + uuid.generate(),
            })
            .appendTo(this.editor.handleBody);

        this.element = {
            player: $play, // player的html
            playerC: $playContent,
            content: $content, // content的html
            handle: $handle, // handle的html
        };

        var _this = this;

        this.editor.on("spriteRemoved", function (sprite) {
            if (
                sprite.getType() == "scenes" &&
                sprite.getAssocScenes().getScenesId() === id
            ) {
                _this.remove();
            }
        });

        // 初始加载
        this._loadPlayerEle();

        // 初始动画设为无动画
        this.updateEffect({
            code: "None",
        });

        // 镜头
        this.camera = new Camera(this);
        this.camera._defaultC();
        this.camera.init();

        // 响应播放事件
        this.onPlay = function (frame) {
            _this.effect.show(frame);
            _this.camera.play(frame);
        };
        this.editor.eve.on("play_" + this.id, this.onPlay);

        // 初始化变焦
        this.setBgZoom(false);

        // eve.on('timeline_play_scenes', this.onVideoPlayChange.bind(this));

        this.editor.eve.on(
            "timeline_play_scenes",
            this.onVideoPlayChange.bind(this)
        );

        // eve.on('timeline_play_all', this.onPlayAll.bind(this));
    }).methods({
        _setOption: function (silent) {
            // 元素分组都需要setoption
            var obj = {
                width: this.editor.clientWidth,
                height: this.editor.clientHeight,
            };
            this.options.width = silent.width;
            this.options.height = silent.height;
            this.element.player.css(obj);
            this.element.content.css(obj);
            this.element.handle.css(obj);

            if (this.background.element.content) {
                this.background.element.content.css(obj);
                this.background.element.content.find("div").css(obj);
            }
            if (this.background.element.player) {
                this.background.element.player.css(obj);
                this.background.element.player.find("div").css(obj);
            }

            this.camera && this.camera._setOption(silent);

            for (var i = 0; i < this.sprites.length; i++) {
                this.sprites[i] &&
                    typeof this.sprites[i]._setOption === "function" &&
                    this.sprites[i]._setOption(silent);
            }

            return Promise.resolve(this);
        },

        updateEffect: function (effect, undo) {
            // 设置动画
            if (undo) {
                var undoData = {};
                undoData.reData = {
                    code: this.effect.code || "None",
                };
                if (this.effect.manual) {
                    undoData.reData.manual = this.effect.manual;
                }
                undoData.data = Object.assign({}, effect);
                undoData.scenesId = this.id;
                eve("undo_redo", null, {
                    type: "updateScenesEffect",
                    data: undoData,
                });
            }
            // 清除原本的遮罩元素
            this.effect && this.effect.maskEle && this.effect.clearMask();

            var e = $.extend(true, { code: "UpIn" }, effect);
            switch (e.code) {
                case "UpIn":
                case "DownIn":
                case "LeftIn":
                case "RightIn":
                case "None":
                    this.effect = new AnimEditor.sceneEffects["move"](this, e);
                    break;
                case "ZoomIn":
                case "ZoomOut":
                case "Fade":
                    this.effect = new AnimEditor.sceneEffects["basic"](this, e);
                    break;
                case "Clipboard":
                case "Poof":
                case "Roller":
                case "Sqweegee":
                case "BlueColorSmear":
                case "WhiteColorSmear":
                case "Hands":
                case "PullDown":
                case "FanDown":
                case "FanUp":
                    this.effect = new AnimEditor.sceneEffects["lottie"](
                        this,
                        e
                    );
                    break;
                case "TvNoise":
                    this.effect = new AnimEditor.sceneEffects["TvNoise"](
                        this,
                        e
                    );
                    break;
                case "SliceVertical":
                case "SliceHorizontal":
                case "SliceCenter":
                case "Slice":
                    this.effect = new AnimEditor.sceneEffects["slice"](this, e);
                    break;
                case "Swipe":
                    this.effect = new AnimEditor.sceneEffects["Swipe"](this, e);
                    break;
                case "CameraUp":
                case "CameraDown":
                case "CameraLeft":
                case "CameraRight":
                    this.effect = new AnimEditor.sceneEffects["Camera"](
                        this,
                        e
                    );
                    break;
                case "SpiralzTech":
                case "Spiralz":
                    this.effect = new AnimEditor.sceneEffects["spiralz"](
                        this,
                        e
                    );
                    break;
                case "FlipBook":
                    this.effect = new AnimEditor.sceneEffects["FlipBook"](
                        this,
                        e
                    );
                    break;
                case "RowSpread":
                    this.effect = new AnimEditor.sceneEffects["RowSpread"](
                        this,
                        e
                    );
                    break;
                case "Mosaic":
                    this.effect = new AnimEditor.sceneEffects["Mosaic"](
                        this,
                        e
                    );
                    break;
            }

            this.effect && this.effect.init(true);
            if (effect.manual) {
                this.effect.manual = effect.manual;
            }
            eve('scene.effectUpdated', this, this.effect);
        },

        getEffect: function () {
            // 获取动画
            return this.effect;
        },

        getIndex: function () {
            // 获取z-index
            return this.index;
        },

        setIndex: function (index) {
            // 设置z-index
            //
            this.index = index;
            this.element.player.css({
                "z-index": this.index * 5,
            });
            this.element.content.css({
                "z-index": this.index * 5,
            });
            this.element.handle.css({
                "z-index": this.index * 5,
            });
        },

        on: function (evt, cb) {
            // 监听事件
            eve.on(
                "editor.scenes." + this.scenesId + "." + evt,
                function (sprite) {
                    cb(sprite);
                }
            );
        },

        show: function () {
            // 显示分组元素
            this.element.player.show();
            this.element.content.show();
            this.element.handle.show();
        },

        hide: function () {
            // 隐藏分组元素
            this.element.player.hide();
            this.element.content.hide();
            this.element.handle.hide();
        },

        getScenesId: function () {
            // 获取分组id
            return this.scenesId;
        },

        addSprite: function (data, id) {
            // 添加元素
            if (id === this.id) {
                this.sprites.push(data);
                var groupData = data.groupId,
                    groupSprites = true;

                if (groupData) {
                    for (var i = 0; i < this.groupList.length; i++) {
                        // 判断组合元素是否被删除完全

                        if (groupData.id == this.groupList[i].id) {
                            groupSprites = false;
                            break;
                        }
                    }
                    if (groupSprites) {
                        this.groupList.push(groupData);
                        eve("editor.groupListPush", this, {
                            id: this.id,
                            data: groupData,
                        });
                    }
                }
                return data;
            } else {
                return false;
            }
        },

        getSprites: function (data) {
            // 获取元素
            var spritesArray = this.sprites;
            if (data) {
                for (var i = 0; i < spritesArray.length; i++) {
                    if (data && "height" in data) {
                        if (
                            spritesArray[i].type === "Text" ||
                            spritesArray[i].type === "RichText"
                        ) {
                            var scaleBox = data.width / spritesArray[i].width;
                            if (
                                data.height <
                                spritesArray[i].height * scaleBox
                            ) {
                                scaleBox = data.height / spritesArray[i].height;
                            }
                            var increaseTop =
                                    ((data.height -
                                        spritesArray[i].height * scaleBox) /
                                        2) *
                                    -1,
                                increaseLeft =
                                    ((data.width -
                                        spritesArray[i].width * scaleBox) /
                                        2) *
                                    -1;
                        } else {
                            var scaleBox = data.height / spritesArray[i].height;
                            var increaseTop =
                                    ((data.height -
                                        spritesArray[i].height * scaleBox) /
                                        2) *
                                    -1,
                                increaseLeft =
                                    ((data.width -
                                        spritesArray[i].width * scaleBox) /
                                        2) *
                                    -1;
                        }
                        if (spritesArray[i].type === "Chart") {
                            spritesArray[i].thumbnails = spritesArray[i].ele
                                .clone()
                                .attr({
                                    id: null,
                                })
                                .css({
                                    position: "absolute",
                                    top:
                                        (spritesArray[i].height *
                                            ((1 - scaleBox) / 2) +
                                            increaseTop) *
                                        -1,
                                    left:
                                        (spritesArray[i].width *
                                            ((1 - scaleBox) / 2) +
                                            increaseLeft) *
                                        -1,
                                    transform: "none",
                                })
                                .css({
                                    transform:
                                        "scale(" +
                                        scaleBox +
                                        ", " +
                                        scaleBox +
                                        ")",
                                    display: "block",
                                })
                                .html(spritesArray[i].getPNG("transparent"));
                        } else {
                            spritesArray[i].thumbnails = spritesArray[i].ele
                                .clone()
                                .attr({
                                    id: null,
                                })
                                .css({
                                    position: "absolute",
                                    top:
                                        (spritesArray[i].height *
                                            ((1 - scaleBox) / 2) +
                                            increaseTop) *
                                        -1,
                                    left:
                                        (spritesArray[i].width *
                                            ((1 - scaleBox) / 2) +
                                            increaseLeft) *
                                        -1,
                                    transform: "none",
                                })
                                .css({
                                    display: "block",
                                    transform:
                                        "scale(" +
                                        scaleBox +
                                        ", " +
                                        scaleBox +
                                        ")",
                                });
                        }
                    }
                }
            }
            return spritesArray;
        },

        forEachSprite: function (cb) {
            // 循环操作元素
            for (var i = 0; i < this.sprites.length; i++) {
                cb(this.sprites[i]);
            }
        },

        // 场景页获取缩略图
        getThumbnails: function () {
            var background = this._setBackground(this.background.data, null, {
                isSide: true,
            });
            var _this = this;

            var arr = background.then(function (valMsg) {
                if (!valMsg) Promise.reject("_setBackground valMsg is null");
                // 同步滤镜、透明度、铺设
                var filterMask = valMsg.find(".mask-blur");
                _this._addFilter(filterMask, {});
                _this._addTransparency(filterMask);
                filterMask.css(
                    "background",
                    _this.background.element.content
                        .find(".mask-blur")
                        .css("background")
                );
                if (_this.background.data.laying === "tile") {
                    filterMask.css("background-repeat", "repeat");
                } else {
                    filterMask.css("background-repeat", "no-repeat");
                }

                var scenesDom = valMsg.prop("outerHTML");
                for (var i = 0; i < _this.sprites.length; i++) {
                    var s = _this.sprites[i];
                    var EleDom = (s.ele || $("<div></div>")).clone();
                    if (
                        s.type === "Frame" ||
                        s.type === "Svg" ||
                        s.type === "Image"
                    ) {
                        EleDom = s.getDomDiffId("thumbnail");
                    } else if (s.type === "Chart") {
                        EleDom.attr({
                            id: null,
                        }).html(s.getPNG("transparent"));
                    } else if (s.type === "Gif") {

                        EleDom.children().attr("src", s.getNumUrl(0)).show();
                    } else {
                        EleDom.find("mask").attr({
                            id: null,
                        });
                        EleDom.attr({
                            id: null,
                        });
                    }
                    scenesDom += EleDom.prop("outerHTML");
                    EleDom = null;
                }
                return {
                    dom: scenesDom,
                    width: _this.editor.clientWidth,
                };
            });
            return arr;
        },
        async createUnloadDom() {},
        getUnloadThumbnails: async function (scale) {
            if (this.fromJsonLoadingState < 1 && this.unLoadData.json) {
                var _this = this,
                    editor = this.editor;
                let json = JSON.parse(JSON.stringify(this.unLoadData.json));
                if (json.background) {
                    var bgData = {};
                    if (json.background.type === "Image") {
                        bgData = {
                            url: json.background.url,
                            blur: json.background.blur || 0,
                            opacity:
                                json.background.opacity ||
                                json.background.opactiy ||
                                1,
                        };
                    } else if (json.background.type === "Color") {
                        bgData = {
                            color: json.background.color,
                            blur: json.background.blur || 0,
                            opacity:
                                json.background.opacity ||
                                json.background.opactiy ||
                                1,
                        };
                    } else if (json.background.type === "Video") {
                        if (json.background.fileType === 26) {
                            let resp = await laihuaApi(
                                "/user/video?type=1&fileType=26&fPage=100&pIndex=1&sOfPage&id=" +
                                    json.background.resourceId
                            );
                            let respjson = await resp.json();
                            //console.log('个人视频缩略图优化', respjson);
                            if (respjson.code == "200") {
                                json.background.type = "Image";
                                bgData = {
                                    url: (respjson.data || {}).thumbnailUrl,
                                    blur: json.background.blur || 0,
                                    opacity:
                                        json.background.opacity ||
                                        json.background.opactiy ||
                                        1,
                                };
                            }
                        } else {
                            //若为视频背景则获取封面，作为图片背景显示
                            let resp = await laihuaApi(
                                "/common/material?type=3&fPage=100&pIndex=1&sOfPage&id=" +
                                    json.background.resourceId
                            );
                            let respjson = await resp.json();
                            //console.log('缩略图优化', respjson);
                            if (respjson.code == "200") {
                                json.background.type = "Image";
                                bgData = {
                                    url: (respjson.data || {}).thumbnailUrl,
                                    blur: json.background.blur || 0,
                                    opacity:
                                        json.background.opacity ||
                                        json.background.opactiy ||
                                        1,
                                };
                            }
                        }
                    }
                    let laying = "fill";
                    if (json.background.laying) {
                        laying = json.background.laying;
                    }
                    var getBgZoomOpts = function (json) {
                        var bgEffect = json.background.effect;
                        var opts;
                        if (bgEffect) {
                            opts = {
                                startTime: bgEffect.zoomStartTime,
                                endTime: bgEffect.zoomEndTime,
                                startScale: Math.max(
                                    bgEffect.zoomStartScale || 0,
                                    1
                                ),
                                endScale: Math.max(
                                    bgEffect.zoomEndScale || 0,
                                    1
                                ),
                            };
                        } else {
                            opts = {
                                startTime: json.background.zoomStartTime,
                                endTime: json.background.zoomEndTime,
                                startScale: Math.max(
                                    json.background.zoomStartScale || 0,
                                    1
                                ),
                                endScale: Math.max(
                                    json.background.zoomEndScale || 0,
                                    1
                                ),
                            };
                        }
                        return opts;
                    };
                    let myscene = await this.setBackground({
                        // 设置场景背景
                        resourceId: json.background.resourceId || "", // 背景资源id
                        fileType: json.background.fileType || "", // 背景资源type
                        type: json.background.type, // 背景类型 0:Color 1:Image 2:Video
                        data: bgData,
                        videoStartTime: json.background.startTime,
                        videoEndTime:
                            json.background.startTime +
                            Math.max(json.background.duration || 0, 1),
                        zoomActive: true, //变焦
                        zoomOptions: getBgZoomOpts(json),
                        laying: laying,
                        filter: json.background.filter,
                        userId: json.background.userId,
                    });
                    myscene.setBgZoom(true, getBgZoomOpts(json));
                    if (json.cameras) {
                        this.camera.fromJson(json.cameras, scale);
                    }

                    //设置元素, 目前只加载文字元素
                    let tasks = json.sprites.map(async function (sprite, ii) {
                        if (!_this.preSprites) {
                            _this.preSprites = [];
                        }
                        _this.sprites[ii] = _this.preSprites[ii] = {
                            FT: sprite.FT,
                            id: uuid.generate(),
                            scenesId: _this.id,
                            groupId: sprite.groupId,
                            option: {
                                scenesId: _this.id,
                                groupId: sprite.groupId,
                                fileType: sprite.fileType,
                                resourceId: sprite.resourceId,
                                resourceIds: sprite.resourceIds,
                                url: sprite.url,
                            },
                            removeSprite() {},
                        };
                        // return;
                        if (sprite.type !== "Text") {
                            return;
                        }
                        let {
                            url,
                            id,
                            resourceId,
                            fileType,
                            filter,
                            groupId = false,
                        } = sprite;
                        let option = {
                            url,
                            id,
                            resourceId,
                            fileType,
                            filter,
                            groupId,
                        };
                        option.text = sprite.text;
                        var ffu =
                            sprite.font.fontFamilyUrl ||
                            sprite.font.fontFamily ||
                            "";
                        option.font = Object.assign({}, sprite.font, {
                            fontFamilyUrl: ffu,
                        });
                        option.artStyle = sprite.artStyle;
                        option.versionAnyway =
                            sprite.versionAnyway || "Horizontal";
                        option.artType = sprite.artType;
                        option.letterSpacing = sprite.characterSpacing || 0;
                        option.lineHeight = sprite.lineSpacing || 1;
                        option.effectType = sprite.enterEffect.type || "Write";
                        option.templateFree = sprite.templateFree || false;
                        let s = await editor.addSprite(
                            sprite.type,
                            option,
                            json.id
                        );
                        _this.sprites[ii] = s;
                        _this.preSprites[ii] = s;
                        let outward = sprite.outward;
                        var _scale = sprite._scale || scale;
                        // 设置位置等信息
                        s.zIndex = sprite.zIndex;
                        s.bgColor = sprite.bgColor || "";
                        s.update({
                            width: outward.width * _scale,
                            height: outward.height * _scale,
                            positionLeft: outward.x * _scale,
                            positionTop: outward.y * _scale,
                            rotate: outward.rotation,
                            flip: outward.isFlipped,
                            opacity: outward.opacity,
                            backgroundColor: sprite.bgColor,
                        });
                    });
                    return Promise.all(tasks);
                }
            }
        },

        getBackground: function () {
            // 获取背景数据
            return this.background.data;
        },

        /**
         *
         * @param {Boolean} [background.data.onlyUpdate] 用于撤回操作，此值为true时，表示只是更新背景，不显示视频加载提示
         * @param {Boolean} [background.videoStartTime]
         * @param {Boolean} [background.videoEndTime]
         * @param {Boolean} [options.isShowLoading]
         * @param {Boolean} [options.videoPreload]
         */
        setBackground: function (background, ctrl, undo, options) {
            // 设置背景数据 ctrl->设置player层加载元素
            //视频背景参数用addVideo过滤，需要重新添加
            options = options || {};
            var _this = this;
            ele = this.background.element;

            //重复操作
            if (
                this.setBackgroundLoadingObj &&
                this.setBackgroundLoadingObj.id === background.resourceId &&
                background.data.url === this.setBackgroundLoadingObj.url
            ) {
                return Promise.resolve(_this);
            }

            this.setBackgroundLoadingObj = {
                id: background.resourceId,
                url: background.data.url,
            };

            if (background.data.onlyUpdate) {
                options.update = background.data.onlyUpdate;
            }

            if (background.videoStartTime == null) {
                // delete this.background.data.videoStartTime
                background.videoStartTime = 0;
            }
            if (background.videoEndTime == null) {
                // delete this.background.data.videoEndTime
                background.videoEndTime = parseInt(_this.duration / 1000);
            }

            if (undo) {
                var undoData = {};
                undoData.scenesId = this.id;
                undoData.reData = JSON.parse(
                    JSON.stringify(this.background.data)
                );
                undoData.reData.filter = JSON.parse(
                    JSON.stringify(this.background.filter)
                );
                undoData.data = Object.assign({}, background);
            }
            var dom = $("<div></div>").css({
                position: "absolute",
                top: 0,
                left: 0,
                width: _this.editor.clientWidth,
                height: _this.editor.clientHeight,
                background: "#fff",
            });
            // 添加背景
            if (ctrl && !ele.content) {
                ele.content = dom
                    .clone()
                    .css("overflow", "hidden")
                    .appendTo(_this.element.content);
            } else {
                ele.content.empty();
            }
            if (ctrl && !ele.player) {
                ele.player = dom.clone().appendTo(_this.element.playerC);
            } else {
                ele.player.empty();
            }

            return this._setBackground(background, ctrl, options)
                .then(function (valMsg) {
                    //返回为空则此次操作无效
                    if (!valMsg) {
                        _this.setBackgroundLoadingObj = null;
                        return Promise.resolve(_this);
                    }

                    if (!ctrl) {
                        ele.player.empty();
                        ele.player.append(valMsg.clone(true));
                        ele.content.empty();
                        ele.content.append(valMsg);
                    }
                    ele.playerVideo = ele.player.find("video.video-bg");
                    ele.contentVideo = ele.content.find("video.video-bg");

                    testBuffered(ele.playerVideo, "videoBgP");

                    if (undo) {
                        eve("undo_redo", null, {
                            type: "setBackground",
                            data: undoData,
                        });
                    }

                    if (_this.background.data.type === "Video") {
                        options.isShowLoading =
                            options.isShowLoading == null
                                ? true
                                : options.isShowLoading;
                    }

                    if (
                        /* !background.data.onlyUpdate &&  */ _this.background
                            .data.type === "Video"
                    ) {
                        _this.setVideoBgDuration({
                            start: background.videoStartTime,
                            end: background.videoEndTime,
                        });
                    }

                    _this.setBgZoom(
                        background.zoomActive,
                        background.zoomOptions
                    );

                    _this.setBackgroundFilter(background.filter, true);

                    eve("editor.spriteAdded", this, _this, {
                        spriteType: "background",
                        update: options.update,
                    });

                    eve("sceneBgAdded", this, _this, {
                        spriteType: "background",
                        update: options.update,
                        isShowLoading: options.isShowLoading,
                    });
                    _this.editor.eve.emit("sceneBgAdded", _this, {
                        spriteType: "background",
                        update: options.update,
                        isShowLoading: options.isShowLoading,
                    });
                    _this.setBackgroundLoadingObj = null;
                    return Promise.resolve(_this);
                })
                .catch((e) => {
                    console.log(e, background);
                });
        },

        /**
         *
         * @param {Object} [options]
         * @param {Boolean} options.update 表示只更新样式，不会新建背景dom
         * @param {Boolean} options.isSide 表示这个背景是为左侧场景缩略图创建的
         * @param {Number} background.videoStartTime
         */
        _setBackground: async function (background, ctrl, options) {
            // 获取dom
            options = options || {};
            var _this = this;

            this.background.data = background;
            var contentbg;
            if (options.update && this.background.contentbg) {
                contentbg = this.background.contentbg;
            } else {
                contentbg = this.background.contentbg = $(
                    '<div><div class="mask-blur-wrapper"></div></div>'
                );
            }
            contentbg.css({
                position: "absolute",
                top: 0,
                left: 0,
                margin: "0 auto",
                width: this.editor.clientWidth + "px",
                height: this.editor.clientHeight + "px",
                boxSizing: "border-box",
            });

            if (
                this.background.data.type === "Image" ||
                this.background.data.type === "Video"
            ) {
                // 判断背景类型，图片可以设置一以下属性
                if ("flip" in background.data && background.data.flip) {
                    contentbg.css({
                        transform: "scaleX(-1)",
                    });
                }
                //todo: 视频背景
                //console.log('_setBackground', this.background.data);
                if (
                    this.background.data.source === 5 &&
                    !this.background.data.data.url
                ) {
                    let getVideoUrl = async () => {
                        return await new Promise((resolve, reject) => {
                            let xhr = new XMLHttpRequest();
                            let url = `/api/user/sheTuWang/materialData?type=3&id=${_this.background.data.resourceId}`;
                            xhr.open("GET", url, true);
                            xhr.responseType = "json";
                            xhr.onloadend = function () {
                                if (this.status != 200) {
                                    resolve("");
                                }
                                //console.log('摄图网视频链接请求测试', _this.background.data.resourceId, xhr.response)
                                if (xhr.response.data && xhr.response.data.url)
                                    resolve(xhr.response.data.url);
                                else {
                                    let st = null;
                                    st = setTimeout(() => {
                                        resolve("");
                                        clearTimeout(st);
                                    }, 3000);
                                }
                            };
                            xhr.send();
                        });
                    };
                    for (let i = 0; i < 100; i++) {
                        //有新的setBackground操作进入则取消当前操作
                        if (
                            !_this.setBackgroundLoadingObj ||
                            _this.setBackgroundLoadingObj.id !=
                                _this.background.data.resourceId ||
                            _this.setBackgroundLoadingObj.url !=
                                _this.background.data.data.url
                        ) {
                            return Promise.resolve(null);
                        }
                        this.background.data.data.url = await getVideoUrl();
                        if (this.background.data.data.url) break;
                    }
                }
                //console.log('通过拦截',_this.background.data);
            }
            if (this.background.data.type !== "Video") {
                background.videoEle = null;
            }

            // Image, Video, Color 都可以设置模糊度和透明度
            if ("blur" in background.data && background.data.blur != null) {
                var blursize = 0;

                blursize =
                    (this.editor.clientHeight / 22) *
                    background.data.blur *
                    0.01;
                contentbg.css({
                    position: "absolute",
                    overflow: "hidden",
                });

                var mask;
                if (contentbg.find(".mask-blur").length > 0) {
                    mask = contentbg.find(".mask-blur");
                } else {
                    mask = $('<div class="mask-blur"></div>');
                    contentbg.empty();
                    contentbg.prepend(mask);
                }

                function observe(element) {
                    var callback = function (records) {
                        if (mask.find("video").length > 0) {
                            return;
                        }

                        var styles;
                        var layingType = (_this.background.data.laying =
                            _this.background.data.laying || "fill");
                        var layingProps = _this.getLayingProps(layingType, {
                            contentbg: contentbg,
                            bgMsg: _this.background.bgMsg,
                        });
                        var _x = layingProps.w + "px";
                        var _y = layingProps.h + "px";

                        // var _x = contentbg.width() + 'px';
                        // var _y = contentbg.height() + 'px';
                        // var _b = _this.background.bgMsg;
                        // var whRatio = _b.naturalWidth / _b.naturalHeight;
                        // var whFlag = _this.editor.optimized === 'Horizontal' ? 16 / 9
                        //     : _this.editor.optimized === 'Vertical' ? 9 / 16
                        //         : 1
                        // var isHorizontal = whRatio >= whFlag
                        // if (isHorizontal) {
                        //     _x = parseInt(_y) * whRatio + 'px'
                        // } else {
                        //     _y = parseInt(_x) / whRatio + 'px'
                        // }

                        styles = {
                            "background-size": _x + " " + _y,
                        };
                        var tileOffsetX = layingProps.tileOffsetX || 0;
                        var tileStyle = {
                            "background-repeat": "repeat",
                            "background-position": 30 + tileOffsetX + "px 30px",
                        };
                        if (layingProps.tile) {
                            style = Object.assign({}, styles, tileStyle);
                        }
                        mask.css(styles);
                    };

                    var mo = new MutationObserver(callback);

                    var options = {
                        attributes: true,
                        attributeOldValue: true,
                    };

                    mo.observe(element, options);
                }

                observe(mask[0]);

                mask.css({
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    margin: "-30px",
                    width: "auto",
                    height: "auto",
                    boxSizing: "border-box",
                    // background: '"" 0 / cover fixed',
                    // backgroundImage: contentbg.css('backgroundImage'),
                    "-webkit-filter": "blur(" + blursize + "px)",
                    "-moz-filter": "blur(" + blursize + "px)",
                    "-o-filter": "blur(" + blursize + "px)",
                    "-ms-filter": "blur(" + blursize + "px)",
                    filter: "blur(" + blursize + "px)",
                });
            }
            if (
                "opacity" in background.data &&
                background.data.opacity != null
            ) {
                contentbg.css({
                    opacity: background.data.opacity,
                });
            }

            var layingType = (_this.background.data.laying =
                _this.background.data.laying || "fill");

            switch (background.type) {
                case "Color": // color
                    this.background.bgMsg = background.data.color;
                    contentbg.css({
                        "background-color": background.data.color,
                    });
                    mask.css({
                        "background-color": background.data.color,
                    });
                    return Promise.resolve(contentbg);
                case "Image": // image
                    $(contentbg)
                        .add(mask)
                        .css({
                            "background-repeat": "no-repeat",
                            "background-image":
                                "url(" +
                                handleAssetsUrl(background.data.url) +
                                ")",
                            // 'background-size'     : bgw + 'px ' + bgh + 'px',
                            "background-size": "cover",
                            "background-position": "center center",
                            "background-color": "transparent",
                        });
                    $(contentbg).css({
                        "background-image": "none",
                    });
                    var arr = ImageLoader.load(background.data.url)
                        .then(function (img) {
                            _this.background.bgMsg = img;
                            _this.background.imgMsg = img;
                            // var bgw = (img.width / _this.editor.scale),
                            //     bgh = (img.height / _this.editor.scale);
                            var layingProps = _this.getLayingProps(layingType, {
                                contentbg: contentbg,
                                bgMsg: _this.background.bgMsg,
                            });
                            var _x = layingProps.w + "px";
                            var _y = layingProps.h + "px";

                            var layingStyles = {
                                "background-size": _x + " " + _y,
                            };
                            var tileOffsetX = layingProps.tileOffsetX || 0;
                            var tileStyle = {
                                "background-repeat": "repeat",
                                "background-position":
                                    30 + tileOffsetX + "px 30px",
                            };
                            if (layingProps.tile) {
                                layingStyles = Object.assign(
                                    {},
                                    layingStyles,
                                    tileStyle
                                );
                            }
                            mask.css(layingStyles);
                            _this.element.playerC
                                .children()
                                .eq(0)
                                .find(".mask-blur")
                                .css(layingStyles);

                            _this.element.playerC
                                .children()
                                .eq(0)
                                .add(_this.element.content)
                                .add(_this.element.content.children().eq(0))
                                .css({
                                    "background-color": "#ffffff",
                                });

                            return contentbg;
                        })
                        .catch((e) => {
                            background.data.url &&
                                this.editor.eve.emit("loadBgError", {
                                    type: "Image",
                                });
                        });
                    return Promise.resolve(contentbg);
                case "Video": // video
                    // var contentbg = '<div>'
                    if (!options || !options.update) {
                        var $video = $("<video muted></video>");
                        var _url = background.data.url;
                        if (_url && _url.indexOf("http") !== 0) {
                            _url = handleAssetsUrl(_url);
                        }
                        if (!_url) {
                            _url = null;
                        }

                        var cutStart =
                            _this.background.data.data.videoStartTime;
                        var cutEnd = _this.background.data.data.videoEndTime;
                        cutStart = cutStart == null ? 0 : cutStart;
                        cutEnd = cutEnd == null ? 1 : cutEnd;
                        $video
                            .css({ opacity: 0 })
                            .prop({
                                src: _url + "#t=" + cutStart + "," + cutEnd,
                                crossOrigin: true,
                                // poster: handleAssetsUrl(background.data.poster),
                            })
                            .one("canplaythrough", function hdr() {
                                $video.off("canplaythrough", hdr);
                                $video
                                    .prop({
                                        /* poster: '',  */
                                    })
                                    .css({ opacity: 1 });
                                _this.element.playerC
                                    .children()
                                    .eq(0)
                                    .find(".mask-blur>video")
                                    .prop({
                                        /* poster: '', */
                                    })
                                    .css({ opacity: 1 });
                                // $video[0].currentTime = _this.nowTime;
                                _this.updateBgVideo(
                                    _this.nowTime *
                                        _this.editor.option.frameRate
                                );
                            });

                        testBuffered($video, "videoBgC");

                        $video[0].dataset.url = "video-mark_" + _this.id;

                        if (options.videoPreload) {
                            $video.prop("preload", options.videoPreload);
                        }
                        $video
                            .css({
                                width: "100%",
                                height: "100%",
                                // 'width': _this.editor.clientWidth + 'px',
                                // 'height': _this.editor.clientHeight + 'px',
                                // 'background-color': _this.editor.optimized === 'Horizontal' ? 'transparent' : '#000000',
                                backgroundColor: "transparent",
                                // position: ''
                                // left: 0,
                                // right: 0,
                                // top: 0,
                                // bottom: 0,
                                // marginLeft: '30px',
                                // marginTop: '30px',
                                padding: "30px 29px",
                                boxSizing: "border-box",
                            })
                            .addClass("video-bg")
                            .appendTo(contentbg.find(".mask-blur"));
                        contentbg.find(".mask-blur").css({
                            "background-color": "transparent",
                            "background-image":
                                "url(" +
                                handleAssetsUrl(background.data.poster) +
                                ")",
                            "background-repeat": "no-repeat",
                            "background-size":
                                this.editor.clientWidth +
                                "px " +
                                this.editor.clientHeight +
                                "px",
                            "background-position": "center center",
                        });
                        contentbg.css({
                            "background-color": "transparent",
                        });

                        _this.element.playerC
                            .children()
                            .eq(0)
                            .add(_this.element.content)
                            .add(_this.element.content.children().eq(0))
                            .css({
                                "background-color": "white",
                            });

                        $video.on("loadedmetadata", function () {
                            _this.background.imgMsg = $video[0];
                            var ratio =
                                $video.prop("videoWidth") /
                                $video.prop("videoHeight");
                            var url = $video.data("url");
                            if (ratio !== 16 / 9) {
                                $('[data-url="' + url + '"]').css({
                                    backgroundColor: "#000000",
                                });
                            }
                        });

                        $video.on("error", function () {
                            _this.editor.eve.emit("loadBgError", {
                                type: "Video",
                            });
                        });

                        if (!options.isSide) {
                            background.videoEle = $video[0];
                            // eve('sceneVideoBgAdded', null, options, _this);
                        }
                    }
                    return Promise.resolve(contentbg);
                default:
                    return Promise.resolve(contentbg);
            }
        },

        /**
         * 处理 9: 16 的背景图片
         *
         */
        updateImageBgInPlayer: function () {
            var $c = this.background.element.content.find(".mask-blur");
            var $p = this.background.element.player.find(".mask-blur");
            var bs = {
                c: $c.css("backgroundSize"),
                p: $p.css("backgroundSize"),
            };
            if (bs.c === bs.p) {
                return;
            }

            $p.css("backgroundSize", bs.c);
        },

        /**
         * 更新视频背景到当前帧
         *
         * @param {Number} frame 当前帧
         * @param {Element} [videoEl] 传入video元素，则会设置该video的currentTime
         * 不传参，则设置content层、player层的video currentTime
         */
        updateBgVideo: function (frame, videoEl) {
            var _this = this;
            if (_this.background.isVideoPlay || this.editor.isVideoPlay) {
                return;
            }
            var videoEle = _this.background.element.content.find("video")[0];
            var videoEleP = _this.background.element.player.find("video")[0];
            if (!videoEle) {
                return;
            }
            var startTime = this.background.data.videoStartTime || 0;
            var endTime =
                this.background.data.videoEndTime || videoEle.duration || 1;
            var time = frame / this.editor.option.frameRate;
            // var playTime = time - startTime;
            var playDuration = Math.min(
                endTime - startTime,
                videoEle.duration - 0
            );
            if (time > playDuration) {
                time %= playDuration;
            }
            var playTime = time + startTime;

            if (videoEl) {
                videoEl.currentTime = playTime;
                return;
            }

            // var isPlayerShow = videoEleP && videoEleP.offsetWidth > 0 && this.editor.player.ele.css('display') !== 'none';
            if (
                videoEle /* && !isPlayerShow */ /* && Math.abs(frame - videoEle.currentTime * 60) > 15 */
            ) {
                videoEle.loop = true;
                videoEle.currentTime = playTime;
            }
            if (videoEleP) {
                videoEleP.currentTime = playTime;
            }

            eve("videoBgCurrentTimeChange", null, {
                currentTime: playTime,
                scene: _this,
            });
        },

        /**
         * 将视频背景到当前帧同步到左侧栏
         *
         * @param {Element|false} [videoEl] 传入video元素，则会设置该video的currentTime
         *   不传参，则设置content层、player层的video currentTime
         *   传入false，则跳过同步操作
         */
        syncVideoBgTime: function (videoEl) {
            if (videoEl === false) {
                return;
            }
            return this.updateBgVideo(
                this.nowTime * this.editor.option.frameRate,
                videoEl
            );
        },

        /**
         * 预览时播放视频背景
         *
         * @param {*} data
         */
        onVideoPlayChange: function (data) {
            if (this.editor.selectedScenes === this) {
                var _this = this;
                var videoEle = (_this.background.element.contentVideo || {})[0];
                var markTime = (videoEle || {}).currentTime;
                var videoEleP = (_this.background.element.playerVideo || {})[0];
                var startTime = _this.background.data.videoStartTime || 0;
                var endTime =
                    _this.background.data.videoEndTime ||
                    (videoEleP || {}).duration ||
                    1;
                var playDuration = Math.max(endTime - startTime, 1);

                if (!videoEleP) {
                    return;
                }
                if (data.isPlay) {
                    this.background.isVideoPlay = true;
                    var videoPlayTime =
                        (data.nowTime != null
                            ? data.nowTime
                            : (data.time || 0) / 1000) + startTime;
                    var old = videoPlayTime;
                    if (videoPlayTime >= endTime) {
                        videoPlayTime %= playDuration;
                        videoPlayTime += startTime;
                    }
                    videoEleP.currentTime = videoPlayTime || old;
                    videoEleP.loop = false;
                    videoEleP.play().catch();

                    videoEleP.addEventListener("timeupdate", onTimeUpdate);
                    if (!videoEleP.onTimeUpdate) {
                        videoEleP.onTimeUpdate = onTimeUpdate;
                    }

                    // setTimeout(function () {
                    // videoEleP.currentTime = markTime;
                    // var p = videoEleP.paused && videoEleP.play();
                    // if (p.then && p.catch) {
                    //     p.catch(function (err) {
                    //         console.warn(err);
                    //     });
                    // }
                    // }, 10);
                } else {
                    videoEleP.removeEventListener(
                        "timeupdate",
                        videoEleP.onTimeUpdate
                    );
                    videoEleP.pause();
                    // if (videoEle) {
                    //     videoEle.currentTime = getTime( (data.time || 0) / 1000 + startTime );
                    // }
                    this.background.isVideoPlay = false;
                    _this.updateBgVideo(
                        _this.nowTime * _this.editor.option.frameRate
                    );
                }
            }

            function getTime(t) {
                if (t + 0.25 >= Math.ceil(t)) {
                    return Math.ceil(t);
                } else if (t - 0.25 < Math.floor(t)) {
                    return Math.floor(t);
                } else {
                    return Math.floor(t) + 0.5;
                }
            }

            function onTimeUpdate(ev) {
                var endTime =
                    _this.background.data.videoEndTime ||
                    (videoEleP || {}).duration ||
                    1;
                var startTime = _this.background.data.videoStartTime || 0;
                var playDuration = Math.min(
                    endTime - startTime,
                    videoEleP.duration - 0
                );
                playDuration = Math.max(playDuration, 1);

                // 超出播放范围时，跳到开始时间
                if (
                    videoEleP.currentTime -
                        _this.background.data.videoStartTime >=
                    playDuration
                ) {
                    videoEleP.currentTime = startTime;
                    var p = videoEleP.paused && videoEleP.play();
                    if (p.then && p.catch) {
                        p.catch(function (err) {
                            console.warn(err);
                        });
                    }
                }
            }
        },

        /**
         * 设置视频背景播放时间段
         *
         * @param {Number} obj.start 单位为秒
         * @param {Number} obj.end 单位为秒
         * @param {Bool} undo 是否记录为撤销操作
         */
        setVideoBgDuration: function (obj, undo) {
            var _this = this;
            if (undo) {
                var undoData = {};
                undoData.reData = {
                    start: this.background.data.videoStartTime,
                    end: this.background.data.videoEndTime,
                };
                undoData.data = Object.assign({}, obj);
                undoData.scenesId = this.id;
                eve("undo_redo", null, {
                    type: "setVideoBgDuration",
                    data: undoData,
                });
            }
            obj = obj || { start: 0, end: this.duration / 1000 };
            obj = Object.assign({ useNowTime: true }, this.background.data, {
                videoStartTime: obj.start || 0,
                videoEndTime: obj.end || this.duration / 1000,
            });

            this.background.data.videoStartTime = obj.videoStartTime;
            this.background.data.videoEndTime = obj.videoEndTime;

            this.handleVideoUrl(
                this.background.element.contentVideo,
                this.background.element.playerVideo
            );

            // this.background.element.contentVideo
            //     && this.background.element.contentVideo.prop('currentTime', obj.videoStartTime);
            // this.background.element.playerVideo
            //     && this.background.element.playerVideo.prop('currentTime', obj.videoStartTime);

            if (obj.useNowTime) {
                _this.updateBgVideo(
                    _this.nowTime * _this.editor.option.frameRate
                );
            }

            eve("videoBgDurationUpdated", null);
        },

        handleVideoUrl(video, pVideo) {
            var _this = this;
            var url = _this.background.data.data.url;
            url = handleAssetsUrl(url);
            var cutStart = this.background.data.videoStartTime;
            var cutEnd = this.background.data.videoEndTime;
            url = url + "#t=" + cutStart + "," + cutEnd;
            video &&
                video.prop({
                    src: url,
                });
            pVideo &&
                pVideo.prop({
                    src: url,
                });
        },

        /**
         * 获取视频背景原本视频的时长
         *
         * @param {String} url 视频源
         */
        getMediaDurationByUrl: function (url) {
            url = url || this.background.data.data.url;
            url = handleAssetsUrl(url);
            return new Promise(function (resolve, reject) {
                var el = new Audio();
                if (/\.(mp4|ogg)$/.test(url)) {
                    el = document.createElement("video");
                }
                el.src = url;
                el.load();
                el.addEventListener("durationchange", function h() {
                    const d = el.duration || 0;
                    el.removeEventListener('durationchange', h);
                    el.remove();
                    el.srcObject = null;
                    resolve(d);
                });
            });
        },

        getSelectScenes: function () {
            // 获取显示层的元素
            this.show();
            return this.element;
        },

        _loadPlayerEle: function () {
            // 初始化加载player层元素
            this.setBackground(this.background.data, "load");
            this._loadSprites("load");
        },

        _loadSprites: function () {
            // 加载元素列表
            for (var i = 0; i < this.sprites.length; i++) {
                this.sprites[i].updateEle();
            }
        },

        removeSprite: function (id) {
            var groupId = false,
                groupSprites = 0;
            for (var i = 0; i < this.sprites.length; i++) {
                if (this.sprites[i].id === id) {
                    let rmSprite = this.sprites[i];
                    eve("editor.BeforeRemoveSprite", this, {
                        id: id,
                        data: rmSprite,
                    });
                    if (this.sprites[i].groupId)
                        groupId = this.sprites[i].groupId.id;
                    //删除lottie后释放其资源
                    if (this.sprites[i].type == "Lottie") {
                        this.sprites[i].unActiveAnimation();
                    }

                    this.sprites.splice(i, 1);
                    for (var z = i - 1; 0 <= z < this.sprites.length; z++) {
                        if (!this.sprites[z]) break; // 多个元素删除时数组长度会有影响导致元素为空
                        this.sprites[z].setIndex(z);
                    }

                    eve("editor.removeSprite", this, {
                        id: id,
                        data: rmSprite,
                    });
                    eve("editor.changeSelectScenes", this, this);
                    break;
                }
            }

            if (groupId) {
                for (var i = 0; i < this.sprites.length; i++) {
                    // 判断组合元素是否被删除完全
                    if (
                        this.sprites[i].groupId &&
                        this.sprites[i].groupId.id == groupId
                    ) {
                        groupSprites += 1;
                    }
                }
                if (!groupSprites) {
                    for (var i = 0; i < this.groupList.length; i++) {
                        // 判断组合元素是否被删除完全

                        if (groupId == this.groupList[i].id) {
                            eve("editor.groupListRemove", this, {
                                id: this.id,
                                data: this.groupList[i],
                            });
                            this.groupList.splice(i, 1);
                            break;
                        }
                    }
                }
            }
        },

        setBackgroundFlip: function (data) {
            // 设置背景是否镜像 true/false
            if (
                this.background.data.type === "Color" &&
                this.editor.selectedScenes &&
                this.editor.selectedScenes.id != this.id
            ) {
                // 判断背景类型，纯色不能设置该属性
                return false;
            }
            this.background.data.data.flip = data;
            if (data) {
                this.background.element.content
                    .children("div")
                    .css({ transform: "scaleX(-1)" });
                this.background.element.player
                    .children("div")
                    .css({ transform: "scaleX(-1)" });
            } else {
                this.background.element.content
                    .children("div")
                    .css({ transform: "none" });
                this.background.element.player
                    .children("div")
                    .css({ transform: "none" });
            }
        },

        getBackgroundFlip: function (data) {
            // 获取背景是否镜像
            var flip = this.background.element.player
                .children("div")
                .css("transform");
            if (flip != "none" && flip) {
                flip = flip.split("(")[1].split(")")[0];
                flip = new ResMatrix(flip).split();
                return flip;
            } else {
                return false;
            }
        },

        /**
         * @param {Number} data 高斯模糊，1至100，越大越模糊
         * @param {Boolean} [isChangeProp] 默认值 true，不传此参数，则会改变背景对象的属性；传false，则不改变背景对象的属性；对undo, redo 起作用
         * @param {Boolean} [undo] 默认值 false
         */
        setBackgroundBlur: function (data, isChangeProp, undo) {
            if (undo) {
                var undoData = {};
                undoData.reData = this.background.data.data.blur;
                undoData.data = data;
                undoData.scenesId = this.id;
                eve("undo_redo", null, {
                    type: "setBackgroundBlur",
                    data: undoData,
                });
            }

            if (
                /* this.background.data.type === 'Color' && */ this.editor
                    .selectedScenes &&
                this.editor.selectedScenes.id != this.id
            ) {
                // 判断背景类型，纯色不能设置该属性
                return false;
            }
            var blursize = 0;
            if (isChangeProp === void 0) {
                isChangeProp = true;
            }
            data = data - 0;
            if (isChangeProp) {
                this.background.data.data.blur = data;
            }
            blursize = (this.editor.clientHeight / 22) * data * 0.01;

            var els = [];
            els[0] = this.background.element.content
                .children("div")
                .find(".mask-blur");
            els[1] = this.background.element.player
                .children("div")
                .find(".mask-blur");
            els[0].add(els[1]).css({
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                margin: "-30px",
                width: "auto",
                height: "auto",
                "-webkit-filter": "blur(" + blursize + "px)",
                "-moz-filter": "blur(" + blursize + "px)",
                "-o-filter": "blur(" + blursize + "px)",
                "-ms-filter": "blur(" + blursize + "px)",
                filter: "blur(" + blursize + "px)",
            });

            eve("sceneBgUpdated", null, this, {
                type: "blur",
            });
        },

        getBackgroundBlur: function () {
            // 获取背景高斯模糊百分比
            return this.background.data.data.blur;
        },

        /**
         * set filter
         *
         * @param {Object} data 滤镜数据
         * @param {Boolean} [isChangeProp] 默认值 true，不传此参数，则会改变背景对象的属性；传false，则不改变背景对象的属性；对undo, redo 起作用
         * @param {Boolean} [undo] 默认值 false
         */
        setBackgroundFilter: function (data, isChangeProp, undo) {
            if (isChangeProp === void 0) {
                isChangeProp = true;
            }
            if (undo) {
                var undoData = {};
                undoData.reData = Object.assign({}, this.getBackgroundFilter());
                undoData.data = Object.assign({}, data);
                undoData.scenesId = this.id;
                eve("undo_redo", null, {
                    type: "setBackgroundFilter",
                    data: undoData,
                });
            }

            data = Object.assign({}, this.getBackgroundFilter(), data);
            if (isChangeProp) {
                this.background.filter = data;
            }

            var blursize = (this.editor.clientHeight / 22) * data.blur * 0.01;
            var template =
                "blur(&&px) brightness(&&) contrast(&&) saturate(&&) grayscale(&&) hue-rotate(&&deg) invert(&&) sepia(&&)";

            $.each(data, function (k, v) {
                if (k === "blur") {
                    v = blursize;
                }
                template = template.replace(/&&/, v);
            });

            var els = [];
            els[0] = this.background.element.content
                .children("div")
                .find(".mask-blur");
            els[1] = this.background.element.player
                .children("div")
                .find(".mask-blur");
            els[0].add(els[1]).css({
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                margin: "-30px",
                width: "auto",
                height: "auto",
                "-webkit-filter": template,
                "-moz-filter": template,
                "-o-filter": template,
                "-ms-filter": template,
                filter: template,
            });

            eve("sceneBgUpdated", null, this, {
                type: "filter",
            });
        },

        /**
         * get filter
         *
         * @returns {Object}
         */
        getBackgroundFilter: function () {
            return this.background.filter;
        },

        _addFilter(el, data) {
            data = Object.assign({}, this.getBackgroundFilter(), data);
            var blursize = (this.editor.clientHeight / 22) * data.blur * 0.01;
            var template =
                "blur(&&px) brightness(&&) contrast(&&) saturate(&&) grayscale(&&) hue-rotate(&&deg) invert(&&) sepia(&&)";

            $.each(data, function (k, v) {
                if (k === "blur") {
                    v = blursize;
                }
                template = template.replace(/&&/, v);
            });

            $(el).css({
                "-webkit-filter": template,
                "-moz-filter": template,
                "-o-filter": template,
                "-ms-filter": template,
                filter: template,
            });
        },

        _addTransparency(el, data) {
            data = data || this.getBackgroundOpacity();
            $(el).css({
                opacity: data,
            });
        },

        /**
         * @param {Number} data 透明度，0至1，0是完全透明，1是不透明
         * @param {Boolean} [isChangeProp] 不传此参数，则会改变背景对象的属性；传false，则不改变背景对象的属性；对undo, redo 起作用
         */
        setBackgroundOpacity: function (data, isChangeProp, undo) {
            if (undo) {
                var undoData = {};
                undoData.reData = this.background.data.data.opacity;
                undoData.data = data;
                undoData.scenesId = this.id;
                eve("undo_redo", null, {
                    type: "setBackgroundOpacity",
                    data: undoData,
                });
            }
            if (
                this.editor.selectedScenes &&
                this.editor.selectedScenes.id != this.id
            ) {
                return false;
            }
            if (isChangeProp === void 0) {
                isChangeProp = true;
            }
            data = data - 0;
            this.background.data.data.opacityNow = data;
            if (isChangeProp) {
                this.background.data.data.opacity = data;
            }
            var dataSize = data;
            this.background.element.content
                .children("div")
                .css({ opacity: dataSize });
            this.background.element.player
                .children("div")
                .css({ opacity: dataSize });

            // this.background.element.content.css({
            //     backgroundColor: 'transparent'
            // })

            eve("sceneBgUpdated", null, this, {
                type: "opacity",
            });
        },

        /**
         * get opacity
         *
         * @returns {Number} 0 ~ 1
         */
        getBackgroundOpacity: function () {
            return this.background.data.data.opacity;
        },

        getSound: function () {
            return this.sound || null;
        },

        setBgLaying: function (type, undo) {
            type = type || "fill";
            if (undo) {
                var undoData = {};
                var type0 = this.background.data.laying || "fill";
                undoData.reData = {
                    layingType: type0,
                };
                undoData.data = {
                    layingType: type,
                };
                undoData.scenesId = this.id;
                eve("undo_redo", null, { type: "setBgLaying", data: undoData });
            }
            this.background.data.laying = type;
            var task = this.setBackground(
                Object.assign({}, this.background.data, {
                    zoomActive: this.background.zoomActive,
                    zoomOptions: this.background.zoomOptions,
                })
            );
            task.then(function (scene) {
                eve("setBgLaying", null, scene);
            });
            return task;
        },

        /**
         * @param {String} type fill fit stretch tile
         */
        getLayingProps: function (type, options) {
            var _this = this;
            var contentbg = options.contentbg;
            var bgMsg = options.bgMsg;
            var w =
                contentbg[0].offsetWidth || parseFloat(contentbg.css("width"));
            var h =
                contentbg[0].offsetHeight ||
                parseFloat(contentbg.css("height"));
            var tile = false;
            var whRatio = bgMsg.naturalWidth / bgMsg.naturalHeight;
            var tileOffsetX = 0;

            if (_this.editor.optimized === "Vertical") {
                // w/h = 9 / 16
                w = (9 / 16) * h;
            }

            var sceneHeight = h;

            var whFlag =
                _this.editor.optimized === "Horizontal"
                    ? 16 / 9
                    : _this.editor.optimized === "Vertical"
                    ? 9 / 16
                    : 1;
            switch (type) {
                case "fill": // 填充
                    var isHorizontal = whRatio >= whFlag;

                    if (isHorizontal) {
                        w = parseFloat(h) * whRatio;
                    } else {
                        h = parseFloat(w) / whRatio;
                    }

                    break;
                case "fit": // 适应
                    if (_this.editor.optimized === "Vertical") {
                    } else {
                    }
                    if (whRatio >= 16 / 9) {
                        // 横向填满
                        h = parseFloat(w) / whRatio;
                    } else {
                        // 竖向填满
                        w = parseFloat(h) * whRatio;
                    }
                    break;
                case "stretch":
                    // w = w; h = h;
                    break;
                case "tile":
                    // w = bgMsg.naturalWidth / this.editor.scale;
                    // h = bgMsg.naturalHeight / this.editor.scale;
                    var _base =
                        _this.editor.optimized === "Vertical"
                            ? { W: 607, H: 1080 }
                            : { W: 1920, H: 1080 };

                    var _size = getSmallSize({
                        naturalWidth: bgMsg.naturalWidth,
                        naturalHeight: bgMsg.naturalHeight,
                        ratio: this.editor.scale,
                        base: _base,
                    });
                    w = _size.w;
                    h = _size.h;
                    tile = true;

                    tileOffsetX =
                        _this.editor.optimized === "Vertical"
                            ? getOffsetX(sceneHeight, w)
                            : 0;
                    break;
                default:
                    break;
            }
            function getSmallSize(input) {
                input = Object.assign(
                    {
                        naturalWidth: 0,
                        naturalHeight: 0,
                        ratio: 1,
                        base: { W: 1920, H: 1080 },
                    },
                    input
                );

                var naturalWidth = input.naturalWidth;
                var naturalHeight = input.naturalHeight;
                var ratio = input.ratio;
                var base = input.base;

                var side = Math.max(naturalWidth, naturalHeight);
                var longer = "w";
                if (naturalWidth < naturalHeight) {
                    longer = "h";
                }
                let ret = {
                    w: naturalWidth,
                    h: naturalHeight,
                };
                if (longer === "w") {
                    if (side >= base.W / 4) {
                        // ret.w / nw = ret.h / nh
                        ret.w = base.W / 4;
                        ret.h = (ret.w / naturalWidth) * naturalHeight;
                    }
                }
                if (longer === "h") {
                    if (side >= base.H / 4) {
                        // ret.w / nw = ret.h / nh
                        ret.h = base.H / 4;
                        ret.w = (ret.h / naturalHeight) * naturalWidth;
                    }
                }

                return {
                    w: ret.w / ratio,
                    h: ret.h / ratio,
                };
            }

            function getOffsetX(sceneHeight, itemWidth) {
                var bigWidth = (sceneHeight * 16) / 9;
                var smallWidth = (sceneHeight * 9) / 16;
                var coverWidth = (bigWidth - smallWidth) / 2;
                return coverWidth - itemWidth;
            }

            return {
                w: w,
                h: h,
                tile: tile,
                tileOffsetX: tileOffsetX,
            };
        },

        setSound: function (data, undo, clearGlobal) {
            var defaults = {
                resourceId: null, // 资源id 用于查询资源的信息，下同
                fileType: (data || {}).fileType || null, // 资源type
                url: null, // 资源路径
                startTime: 0, // 开始时间单位毫秒
                endTime: 0, // 结束时间
                isLoop: false, // 是否循环
                volume: 50, // 音量0-100
                subtitle: null, // 字幕（预留字段）
            };
            data = Object.assign({}, defaults, this.getSound(), data);
            if (undo) {
                var undoData = {};
                undoData.reData = Object.assign({}, this.getSound());
                undoData.data = Object.assign({}, data);
                undoData.scenesId = this.id;

                eve("undo_redo", null, {
                    type: "setSoundScenes",
                    data: undoData,
                });
            }

            this.sound = data;
            this.soundFile = {
                id: data.id || null,
                sound: this.sound,
            };
            this.editor.soundRecordMode = "scene";

            if (clearGlobal) {
                this.editor.soundRecord = null;
            }
        },

        clearSound: function () {
            this.sound = null;
            this.soundFile = null;
        },

        setDuration: function (data) {
            if (!isNaN(data)) {
                this.duration = data - 0;
                return this.duration;
            } else {
                return false;
            }
        },

        getDuration: function (data) {
            return this.duration;
        },

        /**
         *
         * @param {Object} options
         * @param {Number} options.endScale - 拉近，scale由1变大，endScale 大于1；拉远，scale由大变成1，endScale 等于1
         */
        setBgZoom: function (active, options, undo) {
            if (undo) {
                var undoData = {};
                undoData.reData = {
                    zoomActive: this.background.zoomActive,
                    zoomOptions: Object.assign({}, this.background.zoomOptions),
                };
                undoData.data = {
                    active: active,
                    zoomOptions: options,
                };
                undoData.scenesId = this.id;
                eve("undo_redo", null, {
                    type: "setBackgroundZoom",
                    data: undoData,
                });
            }
            var defaults = {
                startTime: 0,
                endTime: 0,
                startScale: 1,
                endScale: 1,
            };
            active = active || false;
            options = Object.assign(
                {},
                defaults,
                this.background.zoomOptions || {},
                options
            );
            if (options.startScale === options.endScale) {
                active = false;
            }
            this.background.zoomActive = active;
            this.background.zoomOptions = active ? options : defaults;

            var f = this.editor.option.frameRate * this.nowTime;
            this.updateBgZoomTick(f);
        },

        updateBgZoomTick: function (frame) {
            var contentEle = this.background.element.content.children().last();
            var playerEle = this.background.element.player.children().last();
            var options = this.background.zoomOptions;

            if (!this.background.zoomActive) {
                contentEle.add(playerEle).css({
                    transform: "scale(" + options.startScale + ")",
                });
                return;
            }

            var sec = frame / this.editor.option.frameRate;
            var easingParams = {
                currentTime: sec - options.startTime,
                startValue: options.startScale,
                change: options.endScale - options.startScale,
                duration: options.endTime - options.startTime,
            };
            var currentScale;
            if (options.startTime >= sec) {
                currentScale = options.startScale;
            }
            if (options.endTime <= sec) {
                currentScale = options.endScale;
            }
            if (options.startTime < sec && options.endTime > sec) {
                currentScale = EasingAnim.easeInOutQuad(
                    easingParams.currentTime,
                    easingParams.startValue,
                    easingParams.change,
                    easingParams.duration
                );
            }
            contentEle.add(playerEle).css({
                transform: "scale(" + currentScale + ")",
            });
        },

        //场景页的toJson
        toJson: function (forId) {
            //对于未加载的场景页json直接返回
            if (this.unLoadData.json) {
                if (this.fromJsonLoadingState < 2) {
                    this.unLoadData.json.isUnload = true;
                    return this.unLoadData.json;
                } else {
                    delete this.unLoadData.json.isUnload;
                }
            }

            // forId 为了获取场景页的id 和元素的id
            var sprites = [],
                bg = this.background;
            for (var i = 0, len = this.sprites.length; i < len; i++) {
                sprites.push(this.sprites[i].toJson(forId));
            }

            var _sound = this.sound
                ? this.sound.url
                    ? Object.assign({}, this.sound, {
                          startTime: getSec(this.sound.startTime),
                          endTime: getSec(this.sound.endTime),
                      })
                    : null
                : null;
            if (_sound) {
                _sound.url = unhandleAssetsUrl(_sound.url);
            }
            function getSec(ms) {
                return parseInt(ms / 1000);
            }
            function getBgOpacity(prop) {
                var inRange = prop >= 0 && prop <= 1;
                return inRange ? prop : 1;
            }
            function getBgBlur(prop) {
                var inRange = prop >= 0 && prop <= 100;
                return inRange ? prop : 0;
            }
            function getZoomParam() {
                var opts = bg.zoomActive
                    ? {
                          zoomStartTime: bg.zoomOptions.startTime,
                          zoomEndTime: bg.zoomOptions.endTime,
                          zoomStartScale: bg.zoomOptions.startScale,
                          zoomEndScale: bg.zoomOptions.endScale,
                      }
                    : {
                          zoomStartTime: 0,
                          zoomEndTime: 0,
                          zoomStartScale: 1,
                          zoomEndScale: 1,
                      };

                opts.type = "zoom";

                return {
                    effect: opts,
                };
            }

            var isSceneRecord = this.editor.soundRecordMode !== "global";

            const output = {
                id: forId ? this.uuid : this.oldId || this.uuid,
                sceneId: forId ? this.uuid : this.oldId || this.uuid,
                sprites: sprites,
                zIndex: this.index,
                index: this.index,
                resourceId: this.resourceId,
                vipMaterials: this.vipMaterials, // 添加付费素材
                vipFunctions: this.vipFunctions, // 添加 图表
                background: Object.assign(
                    {
                        trackingType: bg.data.trackingType || "",
                        fileType: bg.data.fileType,
                        resourceId: bg.data.resourceId,
                        type: bg.data.type,
                        url: bg.data.data.url || null,
                        color: bg.data.data.color || null,
                        opacity: getBgOpacity(bg.data.data.opacity),
                        blur: getBgBlur(bg.data.data.blur),
                        startTime: bg.data.videoStartTime,
                        duration: bg.data.videoEndTime - bg.data.videoStartTime,
                        laying: bg.data.laying || "fill",
                        filter: bg.filter,
                        userId: bg.data.userId,
                        poster: bg.data.data.poster,
                    },
                    getZoomParam()
                ),
                sound: isSceneRecord && _sound ? [_sound] : null,
                duration: this.duration / 1000,
                enterEffect: {
                    type: this.effect.code,
                    duration: 1,
                },
                exitEffect: {
                    type: this.effect.code,
                    duration: 1,
                    manual: this.effect.manual
                },
                groupList: this.groupList, // 组合元素数组
                cameras: $.extend(true, [], this.camera.cameras),
                version: "4.0",
            };
            if (this.FT) output.FT = this.FT;
            if (bg.FT) output.background.FT = bg.FT;
            return output;
        },

        /**
         * 场景页的fromJson
         * @param json {Object} json对象
         * @param scale {Number} 画布相对于原画布的比例
         * @param onlyScenes {Bool} 是否只是从场景页调用此方法
         * @param clear 是否清除画布
         */
        fromJson: async function (json, scale, onlyScenes, clear) {
            this.FT = json.FT;
            if (this.background) {
                this.background.FT = (json.background || {}).FT || void 0;
            }
            this.fromJsonLoadingState = 1;
            if (this.unLoadData.json) {
                eve("sceneSprite.unLoadData.fromJsonLoadingState", null, {
                    state: this.fromJsonLoadingState,
                });
                this.editor.eve.emit(
                    "sceneSprite.unLoadData.fromJsonLoadingState",
                    { state: this.fromJsonLoadingState }
                );
            }
            var _this = this,
                editor = this.editor;
            scale = scale || 1;

            //清空画布
            if (!clear) {
                await _this._clearSprites();
                await _this.clearSound();
            }

            var getEasingName = function (num) {
                var map = ["linear", "easeOutExpo", "easeOutQuint"];
                return map[num] || 1;
            };

            var pathEasingMap = ["linear", "easeInOutQuad", "easeOutQuint"];

            var getBgZoomOpts = function (json) {
                var bgEffect = json.background.effect;
                var opts;
                if (bgEffect) {
                    opts = {
                        startTime: bgEffect.zoomStartTime,
                        endTime: bgEffect.zoomEndTime,
                        startScale: Math.max(bgEffect.zoomStartScale || 0, 1),
                        endScale: Math.max(bgEffect.zoomEndScale || 0, 1),
                    };
                } else {
                    opts = {
                        startTime: json.background.zoomStartTime,
                        endTime: json.background.zoomEndTime,
                        startScale: Math.max(
                            json.background.zoomStartScale || 0,
                            1
                        ),
                        endScale: Math.max(
                            json.background.zoomEndScale || 0,
                            1
                        ),
                    };
                }

                return opts;
            };

            var formatColor = function (val) {
                if (val && val.length > 7) {
                    val = (val || "").replace(/#/, "");
                    return "#" + ("000000" + val).slice(-6);
                }

                return val;
            };

            this.resourceId = json.resourceId || this.resourceId || null;
            this.vipMaterials = json.vipMaterials || [];
            this.vipFunctions = json.vipFunctions || [];

            if (onlyScenes && json.duration) {
                // 字幕长度可能超过500，去掉判断(注意改后是否有问题)
                this.setDuration(
                    json.duration > 500 ? json.duration : json.duration * 1000
                );
            }

            if (json.exitEffect) {
                const s = { code: json.exitEffect.type };
                if (json.exitEffect.manual) {
                    s.manual = json.exitEffect.manual;
                }
                this.updateEffect(s);
            }
            if (json.background) {
                var bgData = {};
                if (
                    json.background.url &&
                    (json.background.type === "Image" ||
                        json.background.type === "Video")
                ) {
                    bgData = {
                        // 颜色背景的数据
                        url: json.background.url,
                        blur: json.background.blur || 0, // 高斯模糊
                        opacity:
                            json.background.opacity ||
                            json.background.opactiy ||
                            1, // 高斯模糊参数
                    };
                    if (json.background.type === "Video") {
                        bgData.poster = json.background.poster || "";
                    }
                } else {
                    json.background.type = "Color";
                    bgData = {
                        // 颜色背景的数据
                        color: json.background.color || "#FFFFFF", // 颜色值,8位数
                        blur: json.background.blur || 0, // 高斯模糊
                        opacity:
                            json.background.opacity ||
                            json.background.opactiy ||
                            1, // 高斯模糊参数
                    };
                }

                if (json.background.laying) {
                    laying = json.background.laying;
                } else {
                    laying = "fill";
                }

                this.setBackground({
                    // 设置场景背景
                    trackingType: json.background.trackingType,
                    resourceId: json.background.resourceId || "", // 背景资源id
                    fileType: json.background.fileType || "", // 背景资源type
                    type: json.background.type, // 背景类型 0:Color 1:Image 2:Video
                    data: bgData,

                    videoStartTime: json.background.startTime,
                    videoEndTime:
                        json.background.startTime +
                        Math.max(json.background.duration || 0, 1),

                    zoomActive: true,
                    zoomOptions: getBgZoomOpts(json),

                    laying: laying,
                    filter: json.background.filter,
                    userId: json.background.userId,
                }).then(function (scene) {
                    scene && scene.setBgZoom(true, getBgZoomOpts(json));
                });

                // this.setBgZoom(true, getBgZoomOpts(json));
            }
            if (json.cameras) {
                this.camera.fromJson(json.cameras, scale);
            }

            this.editor.soundRecordBackup = this.editor.soundRecordBackup || [];
            //插入场景页时屏蔽场景音频
            json.sound = [];
            // if (json.sound) {
            //     if (Array.isArray(json.sound)) {
            //         // if (!json.sound.length) return;
            //         // if (!json.sound[0]) return;
            //         if (json.sound.length > 0 && json.sound[0]) {
            //             json.sound[0].endTime *= 1000;
            //             json.sound[0].startTime *= 1000;
            //             this.setSound(json.sound[0]);
            //         }
            //     } else {
            //         if (!json.sound) return;

            //         json.sound.endTime *= 1000;
            //         json.sound.startTime *= 1000;
            //         this.setSound(json.sound);
            //     }
            // }
            _this.editor.soundRecordBackup[this.index] = this.getSound();

            var tasks = [];
            json.sprites.forEach(function (sprite, ii) {
                var option = {};
                option.allowFailed = true;
                option.url = sprite.url;

                if (
                    onlyScenes &&
                    _this.preSprites &&
                    _this.preSprites[ii] &&
                    !sprite.id
                ) {
                    option.id = _this.preSprites[ii].id || sprite.id;
                } else {
                    option.id = sprite.id;
                }

                option.resourceId = sprite.resourceId;
                option.fileType = sprite.fileType;
                option.filter = sprite.filter;
                option.groupId = sprite.groupId || false;

                if (sprite.sound) {
                    option.sound = {
                        url: sprite.sound.url,
                        volume: sprite.sound.volume,
                        duration: sprite.sound.duration,
                    };
                }
                if (sprite.trackingType) {
                    option.trackingType = sprite.trackingType;
                }
                if (sprite.isUser) {
                    option.isUser = sprite.isUser;
                }

                console.log(`Turbo ~ sprite`, sprite)
                // const isVirtualCharacterType = sprite.fileType === 57 || sprite.fileType === 100;
                const isWebm = /\.webm$/i.test(sprite.url);
                const isGifApng = /\.apng$/i.test(sprite.url);
                if (isGifApng || isWebm) {
                    sprite.type = 'Gif';
                    sprite.url = sprite.url.replace(/\.webm$/i, '_web.apng');
                    option.url = sprite.url;
                }

                switch (sprite.type) {
                    case "Text":
                        option.text = sprite.text;
                        var ffu =
                            sprite.font.fontFamilyUrl ||
                            sprite.font.fontFamily ||
                            "";
                        option.font = Object.assign({}, sprite.font, {
                            fontFamilyUrl: ffu,
                        });
                        option.artStyle = sprite.artStyle;
                        option.versionAnyway =
                            sprite.versionAnyway || "Horizontal";
                        option.artType = sprite.artType;
                        option.letterSpacing = sprite.characterSpacing || 0;
                        option.lineHeight = sprite.lineSpacing || 1;
                        option.effectType = sprite.enterEffect.type || "Write";
                        option.templateFree = sprite.templateFree || false;
                        break;
                    case "RichText":
                        option.lineHeight = sprite.lineSpacing || 1;
                        option.html = sprite.html;
                        option.versionAnyway =
                            sprite.versionAnyway || "Horizontal";
                        option.fontList = sprite.fontList;
                        option.resourceIds = sprite.resourceIds;
                        break;
                    case "Lottie":
                        var OhttpL = option.url.indexOf(
                            "https://resources.laihua.com/"
                        );
                        var ShttpL = sprite.url.indexOf(
                            "https://resources.laihua.com/"
                        );
                        if (OhttpL === -1) {
                            option.url =
                                "https://resources.laihua.com/" + option.url;
                        }
                        if (ShttpL === -1) {
                            sprite.url =
                                "https://resources.laihua.com/" + sprite.url;
                        }
                        option.lottieOptions = {
                            path: sprite.data || sprite.url,
                            loop: 0,
                            autoplay: true,
                        };
                        option.isLoop =
                            typeof sprite.isLoop === "boolean"
                                ? sprite.isLoop
                                : true;
                        option.numberOfLoops =
                            sprite.numberOfLoops === undefined
                                ? 5
                                : sprite.numberOfLoops;
                        break;
                    case "Chart":
                        // todo
                        var _style = JSON.parse(sprite.style || "{}"),
                            _data = JSON.parse(sprite.data || "{}");
                        option.chartOption = ChartSprite.chartFromJson({
                            chartType: sprite.chartType,
                            style: _style,
                            data: _data,
                        });
                        option.data = _data;
                        option.style = _style;
                        option.chartType = sprite.chartType;
                        option.scenesId = _this.id;
                        break;
                    case "Svg":
                        option.fill = formatColor(sprite.color);
                        option.stroke = formatColor(sprite.stroke);
                        option.strokeWidth = sprite.strokeWidth;
                        break;
                    case "Gif":
                        option.isLoop =
                            typeof sprite.isLoop === "boolean"
                                ? sprite.isLoop
                                : true;
                        option.numberOfLoops =
                            sprite.numberOfLoops === undefined
                                ? 5
                                : sprite.numberOfLoops;
                        break;
                    case "Frame":
                    case "ImageFrame":
                        sprite.type = "Frame";
                        if (sprite.fillContent) {
                            var fill = sprite.fillContent;
                            option.picUrl = fill.url;
                            option.picResourceId = fill.resourceId;
                            option.picFileType = fill.fileType;
                            option.matrix = {
                                x: fill.offsetX,
                                y: fill.offsetY,
                                width: fill.width,
                                height: fill.height,
                                rotate: fill.rotation,
                            };
                        }
                        break;
                    case "Video":
                        option.video = Object.assign({}, sprite.video, {
                            loop: sprite.isLoop || false,
                            repeatTimes:
                                sprite.numberOfLoops === undefined
                                    ? 5
                                    : sprite.numberOfLoops,
                            startTime: sprite.videoStartTime,
                            cutDuration: sprite.videoDuration,
                            volume: sprite.volume,
                            poster: sprite.poster,
                            attempt: true,
                        });
                        option.thumbnailUrl = sprite.poster;
                        option.userId = sprite.userId;
                        option.actionType = sprite.actionType;
                        break;
                    case "Image":
                        option.cropType = sprite.cropType;
                        if (!option.cropType && option.isCropped)
                            option.cropType = "free";
                        if (option.cropType)
                            option.cropBoxData = Object.assign(
                                {},
                                sprite.cropData
                            );
                        break;
                    default:
                        break;
                }
                tasks.push(
                    editor
                        .addSprite(sprite.type, option, json.id)
                        .then(function (s) {
                            s.FT = sprite.FT;
                            var st = sprite.startTime,
                                stay = sprite.stayEffect.duration,
                                outward = sprite.outward,
                                hand = sprite.enterEffect.hand,
                                exitHand = sprite.exitEffect.hand,
                                animGraphs = sprite.stayEffect.animationGraphs
                                    ? sprite.stayEffect.animationGraphs[0]
                                    : null;
                            attachAnim = sprite.stayEffect.attachAnim
                                ? sprite.stayEffect.attachAnim[0]
                                : null;
                            var _scale = sprite._scale || scale;
                            // 设置位置等信息
                            s.zIndex = sprite.zIndex;
                            s.bgColor = sprite.bgColor || "";
                            s.update({
                                width: outward.width * _scale,
                                height: outward.height * _scale,
                                positionLeft: outward.x * _scale,
                                positionTop: outward.y * _scale,
                                rotate: outward.rotation,
                                flip: outward.isFlipped,
                                opacity: outward.opacity,
                                backgroundColor: sprite.bgColor,
                            });
                            sprite.boxShadow &&
                                s.setShadow(sprite.boxShadow, "boxShadow");
                            sprite.dropShadow &&
                                s.setShadow(sprite.dropShadow, "dropShadow");

                            if (s.cropType === "svg") {
                                s.cropSvgData(option.cropBoxData).then(() => {
                                    sprite.border && s.setBorder(sprite.border);
                                });
                            } else {
                                sprite.border && s.setBorder(sprite.border);
                            }
                            if (s.cropType === "free") {
                                let rx =
                                    (outward.width * _scale) /
                                    option.cropBoxData.width;
                                let ry =
                                    (outward.height * _scale) /
                                    option.cropBoxData.height;
                                let obj = {
                                    originWidth:
                                        option.cropBoxData.originWidth * rx,
                                    originHeight:
                                        option.cropBoxData.originHeight * ry,
                                    width: outward.width * _scale,
                                    height: outward.height * _scale,
                                    deltaX: option.cropBoxData.deltaX * rx,
                                    deltaY: option.cropBoxData.deltaY * ry,
                                };
                                s.setCropBoxData(
                                    Object.assign(
                                        {
                                            top: outward.y * _scale,
                                            left: outward.x * _scale,
                                        },
                                        option.cropBoxData,
                                        obj
                                    ),
                                    { cropType: s.cropType }
                                );
                            }

                            if (
                                animGraphs &&
                                animGraphs.type === "FreePath" &&
                                !animGraphs.info.points
                            ) {
                                animGraphs.info.points = pathToPoint(
                                    animGraphs.path
                                );
                            }

                            // 设置特效
                            s.updateEffect({
                                // 入场动画
                                code: sprite.enterEffect.type,
                                direction: getSmearDire(
                                    sprite.enterEffect.direction,
                                    _this.editor.productionPlatform,
                                    sprite.enterEffect.type
                                ),
                                easing: getEasingName(
                                    sprite.enterEffect.easing
                                ),
                                drawingDuration:
                                    sprite.enterEffect.drawDuration * 1000,
                                entranceAnim: {
                                    start: st * 1000,
                                    end:
                                        st * 1000 +
                                        sprite.enterEffect.duration * 1000,
                                    hand: getHand(sprite, s),
                                    writehand: getHand(sprite, s),
                                },
                                // 出场动画
                                exitAnim: {
                                    type: sprite.exitEffect.type,
                                    direction: sprite.exitEffect.direction,
                                    easing: getEasingName(
                                        sprite.exitEffect.easing
                                    ),
                                    start:
                                        (st +
                                            (sprite.enterEffect.duration || 0) +
                                            stay) *
                                        1000,
                                    end:
                                        (st +
                                            (sprite.enterEffect.duration || 0) +
                                            stay) *
                                            1000 +
                                        sprite.exitEffect.duration * 1000,
                                    hand: exitHand
                                        ? exitHand.url
                                            ? {
                                                  x: exitHand.anchorPointX,
                                                  y: exitHand.anchorPointY,
                                                  url: handleAssetsUrl(
                                                      exitHand.url
                                                  ),
                                              }
                                            : null
                                        : null,
                                },
                                // 停留动画
                                stayAnim: attachAnim
                                    ? Object.assign(
                                          { type: attachAnim.type },
                                          JSON.parse(attachAnim.data)
                                      )
                                    : null,
                                // 路径动画
                                pathAnim: animGraphs
                                    ? {
                                          // 开始时间为元素入场结束时间
                                          type: animGraphs.type || "Path",
                                          easing:
                                              typeof animGraphs.easing ===
                                              "number"
                                                  ? pathEasingMap[
                                                        animGraphs.easing
                                                    ]
                                                  : "easeInOutQuad",
                                          loop: animGraphs.loop,
                                          start:
                                              st * 1000 +
                                              sprite.enterEffect.duration *
                                                  1000,
                                          end:
                                              st * 1000 +
                                              sprite.enterEffect.duration *
                                                  1000 +
                                              animGraphs.duration * 1000,
                                          target: {
                                              x: animGraphs.toBounds.x * _scale,
                                              y: animGraphs.toBounds.y * _scale,
                                              w:
                                                  animGraphs.toBounds.width *
                                                  _scale,
                                              h:
                                                  animGraphs.toBounds.height *
                                                  _scale,
                                              rotate: animGraphs.toRotation,
                                              opacity: animGraphs.toOpacity,
                                              fillColor: animGraphs.toFillColor,
                                              textColor: animGraphs.toTextColor,
                                          },
                                          info: animGraphs.info
                                              ? {
                                                    width:
                                                        animGraphs.info.width *
                                                        _scale,
                                                    height:
                                                        animGraphs.info.height *
                                                        _scale,
                                                    rotate: animGraphs.info
                                                        .rotate,
                                                    ccw: animGraphs.info.ccw,
                                                    path: s._scaleArr(
                                                        animGraphs.path,
                                                        _scale
                                                    ),
                                                    close: animGraphs.info
                                                        .close,
                                                    freePathType:
                                                        animGraphs.info
                                                            .freePathType,
                                                    points:
                                                        animGraphs.type ===
                                                        "FreePath"
                                                            ? s._scaleArrTwo(
                                                                  animGraphs
                                                                      .info
                                                                      .points,
                                                                  _scale
                                                              )
                                                            : [],
                                                }
                                              : null,
                                          scale: editor.scale,
                                      }
                                    : null,
                                hand: hand
                                    ? hand.url
                                        ? {
                                              x: hand.anchorPointX,
                                              y: hand.anchorPointY,
                                              url: unhandleAssetsUrl(hand.url),
                                          }
                                        : null
                                    : null,
                            });

                            s.setIndex(sprite.zIndex);
                        })
                );

                function getHand(sData, sprite) {
                    var drawhand = sData.enterEffect.hand;
                    var writehand = sData.enterEffect.writehand;
                    var url;
                    if (sData.enterEffect.type === "Write") {
                        url = (writehand || {}).url;
                        if (writehand && writehand.resourceId && url) {
                            url = handleAssetsUrl(url);
                        }
                        return writehand && writehand.url
                            ? Object.assign({}, writehand, {
                                  url: url,
                              })
                            : null;
                    }
                    return drawhand && drawhand.url
                        ? {
                              x: drawhand.anchorPointX,
                              y: drawhand.anchorPointY,
                              url: handleAssetsUrl(drawhand.url),
                          }
                        : null;
                }
                function pathToPoint(path) {
                    // 兼容老版本的自由路径动画数据
                    var points = [],
                        point = [];
                    var len = path.length / 2;
                    for (var i = 0; i < len; i++) {
                        point = point.concat(path.slice(i * 2, i * 2 + 2));
                        point = point.concat(point.concat(point));
                        points[i] = point.splice(0, 6);
                    }
                    return points;
                }
            });

            function getSmearDire(d, p, t) {
                if (/uwp/i.test(p) && /smear/i.test(t)) {
                    var map = {
                        n: "s",
                        e: "w",
                        s: "n",
                        w: "e",
                    };
                    return map[d];
                }

                return d;
            }

            return Promise.all(tasks)
                .then(function () {
                    // console.count('s')
                    // let f = _this.preSprites.filter(v => v.type === 'Text') || [];
                    // _this.sprites = [..._this.sprites, ...f];
                    // _this.preSprites = _this.preSprites.filter(v => v.type !== 'Text') || [];
                    _this.sprites.sort(function (a, b) {
                        return a.zIndex - b.zIndex;
                    });

                    var maxEnter = 1000;
                    // 时间为最后一秒,而不是最后元素的入场结束时间
                    _this.sprites.length >= 1 && (maxEnter = _this.duration);
                    // _this.sprites.forEach(function(sprite) {
                    //     if(sprite.effect.entranceAnim.end > maxEnter) {
                    //         maxEnter = sprite.effect.entranceAnim.end
                    //     }
                    // })
                    _this.nowTime = maxEnter / 1000;
                    eve("timeline_nowTime_change", null, {
                        nowTime: maxEnter / 1000,
                        noPlay: true,
                    });
                    _this.fromJsonLoadingState = 2;
                    if (_this.unLoadData) _this.unLoadData.json = null;
                    eve("sceneSprite.unLoadData.fromJsonLoadingState", null, {
                        state: _this.fromJsonLoadingState,
                    });
                    _this.editor.eve.emit(
                        "sceneSprite.unLoadData.fromJsonLoadingState",
                        { state: _this.fromJsonLoadingState }
                    );
                })
                .catch(function (err) {
                    _this.fromJsonLoadingState = 2;
                    if (_this.unLoadData) _this.unLoadData.json = null;
                    eve("sceneSprite.unLoadData.fromJsonLoadingState", null, {
                        state: _this.fromJsonLoadingState,
                    });
                    _this.editor.eve.emit(
                        "sceneSprite.unLoadData.fromJsonLoadingState",
                        { state: _this.fromJsonLoadingState }
                    );
                    console.log("err", err);
                });
        },
        toFromJson: function (json, scale, undo, someData = {}) {
            var _this = this;
            var _arr;
            if (Array.isArray(json)) {
                _arr = json;
                json = _this.toJson();
                json.sprites = json.sprites.concat(_arr);
            }

            json.id = this.id;
            json.duration = (json.duration - 0) * 1000;
            for (var t = 0; t < json.sprites.length; t++) {
                delete json.sprites[t].id;
            }

            if (undo) {
                var undoData = {};
                undoData.data = this.toJson(true);
                undoData.dubbingData = someData.dubbingData;
                undoData.subtitleData = someData.subtitleData;
            }

            return _this._clearSprites().then(function () {
                return _this.fromJson(json, scale, true).then(function () {
                    if (undo) {
                        undoData.reData = _this.toJson(true);
                        undoData.scale = _this.editor.scale;
                        undoData.scenesId = _this.id;
                        eve("undo_redo", null, {
                            type: "toFromJson",
                            data: undoData,
                        });
                    }
                    eve("toFromJsonDone", null);
                });
            });
        },
        _clearSprites: function () {
            var _this = this;
            if (!this.sprites.length) return Promise.resolve();

            return this.sprites.reduce(function (sequence, sprite) {
                return sequence.then(function () {
                    return _this.editor.removeSprite(sprite.id);
                });
            }, Promise.resolve());
        },

        // 获取惟一的背景视频或视频元素
        getSceneVideo: function () {
            if (this.background && this.background.data.type === "Video") {
                // 视频背景
                return {
                    type: "background",
                    $v: this.background.element.playerVideo,
                };
            }
            // 视频元素
            var v = null;
            this.sprites.forEach(function (s) {
                if (s.type === "Video") {
                    return (v = {
                        type: "sprite",
                        $v: s.video.pVideo,
                        sprite: s,
                    });
                    // return v = s.video.pVideo;
                }
            });
            return v;
        },
        _getAdsorbArr: function () {
            var adsorbArr = [];
            this.sprites.forEach(function (sprite) {
                if (!sprite.disabled && !sprite.selected) {
                    adsorbArr = adsorbArr.concat(sprite._getAdsorbData());
                }
            });
            this.adsorbArr = adsorbArr;
            return adsorbArr;
        },
        getTimeDom(time) {
            var background = this.background.element.content[0].outerHTML;
            var _this = this;

            var all = $("<div></div>");
            all.append($(background).attr({ id: null }));
            for (var i = 0; i < _this.sprites.length; i++) {
                if (_this.sprites[i]._getTimeDom)
                    all.append(_this.sprites[i]._getTimeDom(time));
            }
            return all;
        },
        getGroupData(id) {
            var groupData = {
                data: {},
                sprites: [],
            };
            for (var i = 0; i < this.groupList.length; i++) {
                if (id == this.groupList[i].id) {
                    groupData.data = this.groupList[i];
                }
            }
            for (var c = 0; c < this.sprites.length; c++) {
                if (
                    this.sprites[c].groupId &&
                    this.sprites[c].groupId.id == id
                ) {
                    groupData.sprites.push(this.sprites[c]);
                }
            }
            return groupData;
        },

        //激活场景页中的lottie动画
        activeAnimation: async function (force) {
            let tasks = [];
            this.sprites.forEach((sprite) => {
                if (sprite.type == "Lottie") {
                    tasks.push(sprite.activeAnimation(force));
                }
            });
            return Promise.all(tasks);
        },
        //释放场景页中的lottie动画
        unActiveAnimation() {
            for (var i in this.sprites) {
                if (this.sprites[i].type == "Lottie") {
                    this.sprites[i].unActiveAnimation();
                }
            }
        },
    });

    //元素基类
    var SpriteEle = klass(function (type, ele, editor, option) {
        var _this = this;
        this.type = type; // 元素的类型
        this.id = option.id || uuid.generate(); // 元素的id
        this.scenesId = option.scenesId; // 元素的场景id
        this.uuid = this.id;
        this.matrix = null; // 元素的旋转，缩放，位移信息
        this.width = 0;
        this.height = 0;
        this.positionTop = 0;
        this.positionLeft = 0;
        this.rotate = 0;
        this.opacity = 1;
        this.initData = {}; // 元素原始的信息(宽高等)
        this.flip = false; // 元素是否镜像翻转
        this.action = null; // 元素处于那种变化状态
        this.mpos = null; // 鼠标当前的位置信息
        this.index = 0; // 排序
        this.editor = editor; // 整个画布对象
        this.effect = null; // 动画信息
        this.selected = false; // 是否被选中
        this.opHelper = null; // handle对象
        this.disabled = false; // 元素是否显示
        this.locked = false; // 元素是否锁定
        this.option = Object.assign({}, option);
        this.adsorbData = []; // 吸附外接矩形数据
        this.filter = {
            // 元素滤镜
            blur: 0, // 模糊
            brightness: 1, // 亮度
            contrast: 1, // 对比度
            saturate: 1, // 饱和度
            grayscale: 0, // 灰度
            hueRotate: 0, // 色相
            invert: 0, // 反色
            sepia: 0, // 加温
        };
        this.groupId = option.groupId || false; // 组合元素ID
        this.boxShadow = null; // 边框阴影
        this.dropShadow = null; // 元素阴影
        this.border = null; // 元素边框
        this.bgColor = ""; // 背景填充色
        this.loadFailed = false;
        this.failedImgUrl = "/static/animengine/img/loadFailed.jpg";

        var effectCode = option.effectCode || "LeftIn";
        // 设置动画特效
        this.updateEffect({ code: effectCode });

        this.ele = $("<div></div>");
        this.helpEle = $("<div></div>");

        this.ele.attr({
            id: "sprite-" + this.uuid,
            "data-id": this.id,
        });
        this.helpEle.attr({
            id: "sprite-help-" + this.uuid,
            "data-id": this.id,
            class: "sprite-help-content sprite-help-content-dashed",
        });
        this.ele.css({
            position: "absolute",
            top: 0,
            left: 0,
        });
        ele.content.append(this.ele);
        ele.handle.append(this.helpEle);

        /**
         * @description 测试使用，需要重写
         */
        var _this = this;

        this.onPlay = function (frame) {
            _this.effect.isInit && _this.effect.show(frame);
        };

        this.editor.eve.on("play_" + this.scenesId, this.onPlay);

        this.sound = null;
        this.setSound(option.sound);
        this.setFilter(option.filter);

        // eve.on('timeline_play_scenes', onStopPlay);
        // eve.on('timeline_play_all', onStopPlay);

        // if (!this.option.resourceId) {
        //     this.option.resourceId = generateUUID();
        // }
    })
        .statics({
            gifBuffer: [],
        })
        .methods({
            setSelected: function (selected) {
                // 设置是否被选中
                this.selected = selected;
                this.showHideHandle(selected);
            },
            getElement: function () {
                return this.ele;
            },
            setOption: function (option) {
                if (this.sound) return this.setSound(option.sound);
                else return Promise.resolve();
            },
            updateSprite: function (option) {
                // 为了 effect 的 init() 操作
                var editor = this.editor,
                    player = editor.player;
                if (player.spritesDict[this.id]) {
                    player.spritesDict[this.id].ele.remove();
                    this.effect.hand = null;
                }
                player.spritesDict[this.id] = null;
                return Promise.resolve();
            },
            getType: function () {
                return this.type;
            },
            showHideSprite: function (bol) {
                // 显示和隐藏元素
                if (bol) {
                    this.ele.show();
                    this.helpEle.show();
                    this.disabled = false;
                } else {
                    this.ele.get(0).offsetWidth;
                    this.ele.hide();
                    this.helpEle.hide();
                    this.disabled = true;
                }
            },
            showHideSpriteDom: function (bol) {
                if (bol) {
                    if (this.type === "Lottie" || this.type === "Frame") {
                        this.ele.css({
                            opacity: this.opacity,
                        });
                    } else {
                        this.ele.show();
                    }
                    this.helpEle.show();
                } else {
                    if (this.type === "Lottie" || this.type === "Frame") {
                        this.ele.css({
                            opacity: 0,
                        });
                    } else {
                        this.ele.hide();
                    }
                    this.helpEle.hide();
                }
            },
            // 动画特效
            updateEffect: function (effect, undo) {
                if (!effect) return;
                if (undo) {
                    var undoData = {},
                        entrance = this.effect.entranceAnim,
                        exit = this.effect.exitAnim,
                        path = this.effect.pathAnim;
                    stay = this.effect.stayAnim;
                    undoData.reData = {
                        code: this.effect.code,
                        easing: this.effect.easing,
                        direction: this.effect.direction,
                        entranceAnim: {
                            start: entrance.start,
                            end: entrance.end,
                            hand: entrance.hand
                                ? Object.assign({}, entrance.hand)
                                : null,
                        },
                        stayAnim: $.extend(true, {}, stay),
                        exitAnim: {
                            type: exit.type,
                            easing: exit.easing,
                            direction: exit.direction,
                            start: exit.start,
                            end: exit.end,
                            hand: exit.hand
                                ? Object.assign({}, exit.hand)
                                : null,
                        },
                        pathAnim: path.end ? this.effect.getPathAnim() : null,
                    };
                    undoData.data = Object.assign({}, effect);
                    undoData.scenesId = this.scenesId;
                    undoData.id = this.id;
                    eve("undo_redo", null, {
                        type: "updateSpriteEffect",
                        data: undoData,
                    });
                }
                var option = this.effect || {
                    code: "LeftIn",
                };
                if (effect.stayAnim) option.stayAnim = null;

                if (
                    this.effect &&
                    this.effect.svg &&
                    this.effect.code.indexOf("Smear") != -1
                ) {
                    this.effect.svg.remove();
                    this.editor.player.spritesDict[this.uuid].ele.css({
                        "clip-path": "",
                    });
                }

                if (
                    effect &&
                    effect.pathAnim &&
                    effect.pathAnim.info &&
                    effect.pathAnim.info.path
                ) {
                    option.pathAnim &&
                        option.pathAnim.info &&
                        (option.pathAnim.info.path = null);
                }
                $.extend(true, effect, { entranceAnim: {}, exitAnim: {} });
                var e = $.extend(true, {}, option, effect);

                switch (e.code) {
                    case "hand":
                    case "Hand":
                        this.effect =
                            this.type === "Svg"
                                ? new HandEffect(this, e)
                                : this.type === "Image"
                                ? new AnimEditor.effects["Hand"](this, e)
                                : new FadeEffect(this, e);
                        break;
                    case "Draw":
                        this.effect =
                            this.type === "Svg" || this.type === "Image"
                                ? new AnimEditor.effects["Hand"](this, e)
                                : new FadeEffect(this, e);
                        break;
                    case "Smear":
                        this.effect = new AnimEditor.effects["Smear"](this, e);
                        break;
                    case "Type":
                        this.effect = new AnimEditor.effects["Type"](this, e);
                        break;
                    case "Roll":
                        this.effect = new AnimEditor.effects["Roll"](this, e);
                        break;
                    case "Bounce":
                        this.effect = new AnimEditor.effects["Bounce"](this, e);
                        break;
                    case "LeftIn":
                    case "RightIn":
                    case "UpIn":
                    case "DownIn":
                        this.effect = new MoveEffect(this, e);
                        break;
                    case "Write":
                    case "write":
                        // 兼容与UWP端的代码(暂时);
                        if (this.type !== "Text") {
                            this.effect =
                                this.type === "Svg"
                                    ? new HandEffect(this, e)
                                    : new AnimEditor.effects["Hand"](this, e);
                        } else {
                            this.effect = new WriteEffect(this, e);
                        }
                        break;
                    case "Appear":
                    case "appear":
                        // 兼容与UWP端的代码(暂时);
                        if (this.type === "Text") {
                            this.effect = new Appear(this, e);
                        }
                        break;
                    case "PopIn":
                        this.effect = new PopEffect(this, e);
                        break;
                    case "FadeIn":
                        this.effect = new FadeEffect(this, e);
                        break;
                    case "None":
                    default:
                        // throw "Error: unknown effect code '" + e.code + "'";
                        this.effect = new NoEffect(this, e);
                        break;
                }

                if (this.ele) this.effect.init(true);

                return Promise.resolve(this);
            },

            changeStyle: function (option) {
                option = option || {};
                var eleCss = {},
                    helpCss = {};
                if (option.init) this.initSize();
                eleCss = {
                    width: this.width,
                    height: this.height,
                    top: this.positionTop,
                    left: this.positionLeft,
                    transform:
                        "rotate(" +
                        this.rotate +
                        "deg)" +
                        (this.flip ? " scaleX(-1)" : ""),
                    zIndex: (this.index + 1) * 5,
                    opacity:
                        this._opacity == null ? this.opacity : this._opacity,
                    boxShadow: this.getShadowCss("boxShadow"),
                    backgroundColor: this.bgColor,
                };

                helpCss = {
                    width: this.width,
                    height: this.height,
                    top: this.positionTop,
                    left: this.positionLeft,
                    transform: "rotate(" + this.rotate + "deg)",
                    zIndex: this.locked ? -1 : (this.index + 1) * 5,
                };

                this.ele.css(eleCss);
                this.helpEle.css(helpCss);

                if (this.type === "Chart") {
                    if ("move" !== this.action && "spin" !== this.action) {
                        this.myChart.resize({
                            width: this.width,
                            height: this.height,
                        });
                        this.ele
                            .children("img")
                            .attr("src", this.myChart.getDataURL());
                    }
                } else if (this.type === "Text") {
                    var fontStyle = this.font;
                    fontStyle.transform =
                        "scale(" + 1 / this.editor.scale + ")";
                    this.ele.children("div").css(fontStyle);
                } else if (this.type === "RichText") {
                    this.ele
                        .children("div")
                        .css(
                            "transform",
                            "scale(" + 1 / this.editor.scale + ")"
                        );
                }

                // 同步播放层
                if (option.sync) {
                    if (this.effect.playerSprite) {
                        var font =
                            this.type === "Text"
                                ? this.ele.children("[autofocus]").css("font")
                                : null;
                        this.effect.syncSprite(eleCss, font);
                    }
                    if (this.type === "RichText") this.effect.init(true);
                }

                this.setFilter(this.filter);
                if (this.border)
                    this.border.dom.css({
                        borderWidth:
                            (this.border.width * 2) / this.editor.scale + "px",
                    });
                return Promise.resolve();
            },
            initSize: function () {
                var sizeRange = {
                        max: 450,
                        min: 50,
                    },
                    maxSide,
                    scale = 1;
                switch (this.type) {
                    case "Text":
                    case "RichText":
                        this.width = this.initData.width / this.editor.scale;
                        this.height = this.initData.height / this.editor.scale;
                        this.rotate = this.initData.rotate;
                        this.positionTop =
                            this.positionTop ||
                            (this.editor.clientHeight - this.height) / 2;
                        this.positionLeft =
                            this.positionLeft ||
                            (this.editor.clientWidth - this.width) / 2;
                        break;
                    case "Image":
                    case "Lottie":
                    case "Svg":
                    case "Gif":
                    case "Frame":
                    case "Video":
                        this.width = this.initData.width / this.editor.scale;
                        this.height = this.initData.height / this.editor.scale;
                        maxSide =
                            this.width > this.height ? this.width : this.height;
                        if (maxSide > sizeRange.max) {
                            scale = maxSide / sizeRange.max;
                        } else if (maxSide < sizeRange.min) {
                            scale = maxSide / sizeRange.min;
                        } else {
                            scale = 1;
                        }
                        this.width = this.width / scale;
                        this.height = this.height / scale;
                        this.positionTop =
                            (this.editor.clientHeight - this.height) / 2;
                        this.positionLeft =
                            (this.editor.clientWidth - this.width) / 2;
                        if (
                            this.type === "Svg" &&
                            /^(28|29)$/.test(this.option.fileType)
                        ) {
                            this.updateSprite &&
                                this.updateSprite(null, null, {
                                    width: this.width,
                                    height: this.height,
                                });
                        }
                        break;
                }
            },
            flipStyle: function (undo) {
                this.flip = !this.flip;
                this.changeStyle({ sync: true });
                if (undo) {
                    eve("undo_redo", null, {
                        type: "flip",
                        data: { id: this.id, scenesId: this.scenesId },
                    });
                }
            },
            /**
             *
             * @param {Number} opts.percent 0 - 100
             *
             */
            setTransparent: function (opts) {
                var percent = opts.percent;
                var opacity = (100 - percent) / 100;

                if (opts.undo) {
                    this._opacity = null; // 辅助的字段
                    this.update(
                        {
                            opacity: opacity,
                        },
                        opts.undo
                    );
                } else {
                    this._opacity = opacity;
                    this.changeStyle({ sync: true });
                }
            },
            /**
             *
             * @returns {Number} 0 - 100
             */
            getTransparent: function () {
                return this.toTransparent(this.opacity);
            },
            toTransparent: function (opacity) {
                return Math.round(100 - opacity * 100);
            },
            toOpacity: function (transparent) {
                return (100 - transparent) / 100;
            },
            _setOption: function () {
                // 缩放画布改变元素数据的方法
                this.width =
                    (this.width * this.initData.scale) / this.editor.scale;
                this.height =
                    (this.height * this.initData.scale) / this.editor.scale;
                this.positionTop =
                    (this.positionTop * this.initData.scale) /
                    this.editor.scale;
                this.positionLeft =
                    (this.positionLeft * this.initData.scale) /
                    this.editor.scale;
                this.initData.scale = this.editor.scale;

                if (this.effect.pathAnim.target) {
                    var calcScale =
                        this.effect.pathAnim.scale / this.editor.scale;
                    this.effect.pathAnim.target.h *= calcScale;
                    this.effect.pathAnim.target.w *= calcScale;
                    this.effect.pathAnim.target.x *= calcScale;
                    this.effect.pathAnim.target.y *= calcScale;

                    if (this.effect.pathAnim.info) {
                        this.effect.pathAnim.info.width *= calcScale;
                        this.effect.pathAnim.info.height *= calcScale;
                        this.effect.pathAnim.info.top *= calcScale;
                        this.effect.pathAnim.info.left *= calcScale;
                        this.effect.pathAnim.info.path &&
                            this._scaleArr(
                                this.effect.pathAnim.info.path,
                                calcScale
                            );
                        this.effect.pathAnim.info.points &&
                            this._scaleArrTwo(
                                this.effect.pathAnim.info.points,
                                calcScale
                            );
                        this.effect.init(true);
                    }

                    this.effect.pathAnim.scale = this.editor.scale;
                }

                this.changeStyle({ sync: true });
                if (this.opMatting && this.opMatting.isMattingStatus === 2) {
                    this.opMatting.updateMattingEl({
                        width: this.width,
                        height: this.height,
                    });
                }
                // 文字的 effect 需要重新 init()
                if (this.type === "Text" || this.type === "RichText") {
                    var editor = this.editor,
                        player = editor.player;
                    if (player.spritesDict[this.id]) {
                        player.spritesDict[this.id].ele.remove();
                        this.effect.hand = null;
                    }
                    player.spritesDict[this.id] = null;
                    this.effect.init();
                }
            },
            getIndex: function () {
                return this.index;
            },
            setIndex: function (num) {
                this.index = num;
                this.changeStyle({ sync: true });
            },
            update: function (option, undo) {
                if (undo) {
                    var undoData = {};
                    undoData.reData = {
                        width: this.width,
                        height: this.height,
                        positionLeft: this.positionLeft,
                        positionTop: this.positionTop,
                        rotate: this.rotate,
                        flip: this.flip,
                        opacity: this.opacity,
                    };
                    undoData.scenesId = this.scenesId;
                    undoData.id = this.id;
                }
                this.width =
                    option.width !== undefined ? option.width : this.width;
                this.height =
                    option.height !== undefined ? option.height : this.height;
                this.positionLeft =
                    option.positionLeft !== undefined
                        ? option.positionLeft
                        : this.positionLeft;
                this.positionTop =
                    option.positionTop !== undefined
                        ? option.positionTop
                        : this.positionTop;
                this.rotate =
                    option.rotate !== undefined ? option.rotate : this.rotate;
                this.flip = option.flip !== undefined ? option.flip : this.flip;
                this.opacity =
                    option.opacity !== undefined
                        ? option.opacity
                        : this.opacity;

                if (this.type === "Text" || this.type === "RichText") {
                    switch (
                        this.versionAnyway // 横竖版
                    ) {
                        case "Vertical": // 竖版
                            this.ele
                                .children("div")
                                .height(this.height * this.editor.scale);
                            if (this.ele.children("div").width()) {
                                this.width =
                                    this.ele.children("div").width() /
                                    this.editor.scale;
                            }
                            break;
                        default:
                            this.ele
                                .children("div")
                                .width(this.width * this.editor.scale);
                            if (this.ele.children("div").height()) {
                                this.height =
                                    this.ele.children("div").height() /
                                    this.editor.scale;
                            }
                    }
                }

                if (undo) {
                    undoData.data = Object.assign({}, option, {
                        height: this.height,
                    });
                    eve("undo_redo", null, {
                        type: "updateHandle",
                        data: undoData,
                    });
                }

                this._opacity = null;
                this.changeStyle({ sync: true });
                eve("sprite.update", null, { data: option });
            },
            showHideHandle: function (bol) {
                // 显示或隐藏handle
                if (bol) {
                    this.helpEle.addClass("active");
                    this.opHelper.showHideEle(true);
                } else {
                    this.helpEle.removeClass("active");
                    this.opHelper.showHideEle(false);
                }
            },
            updateEle: function () {
                this.ele = $("#sprite-" + this.uuid);
                this.helpEle = $("#sprite-help-" + this.uuid);
                this.opHelper.retrieveEle();
            },
            getThumbnail: function (name) {
                var dom = $("<div></div>"),
                    childDom = this.ele.children().clone();
                switch (this.type) {
                    case "Text":
                        if (name) {
                            dom.html("<div>" + this.text + "</div>");
                        } else {
                            dom.html(
                                "<span>" + this.text.slice(0, 3) + "</span>"
                            );
                        }
                        break;
                    case "RichText":
                        if (name) {
                            dom.append(childDom);
                        } else {
                            dom.html("<div>" + this.text + "</div>");
                        }
                        break;
                    case "Frame":
                        if (name) {
                            dom.append(this.getDomDiffId(name).children());
                            dom.append(childDom[3]);
                        } else {
                            dom.append(childDom[2]);
                        }
                        break;
                    case "Image":
                        if (this.cropType) {
                            childDom = this.getDomDiffId(name).children();
                        } else {
                            childDom.css({
                                width: "100%",
                                height: "100%",
                                maxWidth: "",
                            });
                        }
                        dom.append(childDom);
                        break;
                    case "Svg":
                        dom.append(this.getDomDiffId("setPath").children());
                        break;
                    case "Lottie":
                        childDom.find("mask").attr({
                            id: "",
                        });
                        dom.append(childDom);
                        break;
                    case "Gif":

                        childDom.show().attr("src", this.getNumUrl(0));
                        dom.append(childDom);
                        break;
                    default:
                        dom.append(childDom);
                }

                return dom;
            },
            removeSprite: function () {
                // 关闭动画监听事件
                // eve.off('playByFrame', this.onShow);
                this.editor.eve.off("play_" + this.scenesId, this.onPlay);
                // 移除dom结构
                this.ele.remove();
                // this.ele = null;
                this.helpEle.remove();
                // this.helpEle = null;
                // 删除元素后 删除元素在播放层的对象
                var editor = this.editor,
                    player = editor.player;
                if (player.spritesDict[this.id]) {
                    player.spritesDict[this.id].ele.remove();
                }
                player.spritesDict[this.id] = null;

                if (this.hand instanceof $) {
                    this.hand.remove();
                    this.hand = null;
                }
            },
            _start: function (action, pos, centerPos) {
                switch (action) {
                    case "flip":
                        this.flipStyle();
                        break;
                    case "delete":
                        this.editor.removeSprite(this.id);
                        return;
                    case "unlock":
                        this.setLocked(false);
                        this.showHideHandle(true);
                        // 数据埋点（也就是无实际用途代码）
                        _hmt &&
                            _hmt.push([
                                "_trackEvent",
                                "material_setting",
                                "click_delocking",
                                "素材设置_解锁",
                            ]);
                        return;
                }
                if (
                    (this.effect.pathAnim && this.effect.pathAnim.end) ||
                    this.locked
                )
                    return;
                // mousedown事件调用
                this.action = action;
                // pos为鼠标位置对象(x:0,y:0)
                this.mpos = pos;
                this.mpos.width = +this.width;
                this.mpos.height = +this.height;
                this.mpos.minScale =
                    20 /
                    this.editor.scale /
                    (this.mpos.width <= this.mpos.height
                        ? this.mpos.width
                        : this.mpos.height);
                this.mpos.maxScale =
                    (10 * this.editor.option.width) / this.mpos.width;
                if (
                    this.mpos.maxScale >
                    (10 * this.editor.option.height) / this.mpos.height
                ) {
                    this.mpos.maxScale =
                        (10 * this.editor.option.height) / this.mpos.height;
                }
                this.mpos.left = this.positionLeft;
                this.mpos.top = this.positionTop;
                this.mpos.cx = this.positionLeft + this.width / 2;
                this.mpos.cy = this.positionTop + this.height / 2;
                this.mpos.rotate = +this.rotate;
                this.mpos.deg = this._levelDeg(
                    this.mpos.x,
                    this.mpos.y,
                    this.mpos.cx,
                    this.mpos.cy
                );
                this.mpos.mdeg = this.mpos.deg;
                this.mpos.direction = true;
                this.mpos.box = this._getBBox();
                this.mpos.cos = Math.abs(
                    Math.cos((Math.PI / 180) * this.rotate)
                );
                this.mpos.sin = Math.abs(
                    Math.sin((Math.PI / 180) * this.rotate)
                );
            },
            _process: function (pos) {
                if (
                    (this.effect.pathAnim && this.effect.pathAnim.end) ||
                    this.locked
                )
                    return;
                // mousemove事件调用
                // TODO
                var mpos = this.mpos,
                    position = {},
                    size = {
                        width: 0,
                        height: 0,
                    },
                    scaleSize = 0,
                    info = null,
                    adsorb =
                        this.editor.adsorb &&
                        this.editor.selectedSprite.length === 1;

                switch (this.action) {
                    case "e":
                        // 右
                        size.width = Math.abs(
                            mpos.width +
                                this._changeLength(
                                    pos.x,
                                    pos.y,
                                    mpos.x,
                                    mpos.y,
                                    mpos.cx,
                                    mpos.cy
                                )
                        );
                        if (this.type !== "Text" && this.type !== "RichText") {
                            if (size.width >= this.editor.option.width * 10) {
                                this.width = this.editor.option.width * 10;
                                break;
                            } else if (size.width <= 20 / this.editor.scale) {
                                this.width = 20 / this.editor.scale;
                                break;
                            }
                        }
                        this.width = size.width;
                        if (this.type === "Text" || this.type === "RichText") {
                            if (this.width < this.minWidth + 4) {
                                this.width = this.minWidth + 4;
                            }
                            this.ele
                                .children("div")
                                .width(this.width * this.editor.scale);
                            this.height =
                                this.ele.children("div").height() /
                                this.editor.scale;
                        }
                        position = this._rotSize(
                            this.width,
                            this.height,
                            mpos.width,
                            mpos.height,
                            mpos.left,
                            mpos.top,
                            this.rotate,
                            "top-left"
                        );
                        this.positionLeft = position.left;
                        this.positionTop = position.top;
                        if (
                            adsorb &&
                            this.type !== "Text" &&
                            this.type !== "RichText"
                        ) {
                            this.adsorbData = this._getAdsorbPosPo(
                                "non",
                                this.rotate,
                                1
                            );
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "non",
                                mpos
                            );
                            if (typeof info.w === "number") {
                                this.width = info.w + mpos.width;
                                position = this._rotSize(
                                    this.width,
                                    this.height,
                                    mpos.width,
                                    mpos.height,
                                    mpos.left,
                                    mpos.top,
                                    this.rotate,
                                    "top-left"
                                );
                                this.positionLeft = position.left;
                                this.positionTop = position.top;
                            }
                        }
                        break;
                    case "s":
                        // 下
                        size.height = Math.abs(
                            mpos.height +
                                this._changeLength(
                                    pos.x,
                                    pos.y,
                                    mpos.x,
                                    mpos.y,
                                    mpos.cx,
                                    mpos.cy
                                )
                        );
                        if (this.type !== "Text" && this.type !== "RichText") {
                            if (size.height >= this.editor.option.height * 10) {
                                this.height = this.editor.option.height * 10;
                                break;
                            } else if (size.height <= 20 / this.editor.scale) {
                                this.height = 20 / this.editor.scale;
                                break;
                            }
                        }
                        this.height = size.height;
                        if (this.type === "Text" || this.type === "RichText") {
                            if (this.height < this.minWidth + 4) {
                                this.height = this.minWidth + 4;
                            }
                            this.ele
                                .children("div")
                                .height(this.height * this.editor.scale);
                            this.width =
                                this.ele.children("div").width() /
                                this.editor.scale;
                        }
                        position = this._rotSize(
                            this.width,
                            this.height,
                            mpos.width,
                            mpos.height,
                            mpos.left,
                            mpos.top,
                            this.rotate,
                            "top-left"
                        );
                        this.positionLeft = position.left;
                        this.positionTop = position.top;
                        if (
                            adsorb &&
                            this.type !== "Text" &&
                            this.type !== "RichText"
                        ) {
                            this.adsorbData = this._getAdsorbPosPo(
                                "non",
                                this.rotate,
                                2
                            );
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "non",
                                mpos
                            );
                            if (typeof info.h === "number") {
                                this.height = info.h + mpos.height;
                                position = this._rotSize(
                                    this.width,
                                    this.height,
                                    mpos.width,
                                    mpos.height,
                                    mpos.left,
                                    mpos.top,
                                    mpos.rotate,
                                    "top-left"
                                );
                                this.positionLeft = position.left;
                                this.positionTop = position.top;
                            }
                        }
                        break;
                    case "w":
                        // 左
                        size.width = Math.abs(
                            mpos.width +
                                this._changeLength(
                                    pos.x,
                                    pos.y,
                                    mpos.x,
                                    mpos.y,
                                    mpos.cx,
                                    mpos.cy
                                )
                        );
                        if (this.type !== "Text" && this.type !== "RichText") {
                            if (size.width >= this.editor.option.width * 10) {
                                this.width = this.editor.option.width * 10;
                                break;
                            } else if (size.width <= 20 / this.editor.scale) {
                                this.width = 20 / this.editor.scale;
                                break;
                            }
                        }
                        this.width = size.width;
                        if (this.type === "Text" || this.type === "RichText") {
                            if (this.width < this.minWidth + 4) {
                                this.width = this.minWidth + 4;
                            }
                            this.ele
                                .children("div")
                                .width(this.width * this.editor.scale);
                            this.height =
                                this.ele.children("div").height() /
                                this.editor.scale;
                        }
                        position = this._rotSize(
                            this.width,
                            this.height,
                            mpos.width,
                            mpos.height,
                            mpos.left,
                            mpos.top,
                            this.rotate,
                            "top-right"
                        );
                        this.positionLeft = position.left;
                        this.positionTop = position.top;
                        if (
                            adsorb &&
                            this.type !== "Text" &&
                            this.type !== "RichText"
                        ) {
                            this.adsorbData = this._getAdsorbPosPo(
                                "non",
                                this.rotate,
                                3
                            );
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "non",
                                mpos
                            );
                            if (typeof info.w === "number") {
                                this.width = info.w + mpos.width;
                                position = this._rotSize(
                                    this.width,
                                    this.height,
                                    mpos.width,
                                    mpos.height,
                                    mpos.left,
                                    mpos.top,
                                    this.rotate,
                                    "top-right"
                                );
                                this.positionLeft = position.left;
                                this.positionTop = position.top;
                            }
                        }
                        break;
                    case "n":
                        // 上
                        size.height = Math.abs(
                            mpos.height +
                                this._changeLength(
                                    pos.x,
                                    pos.y,
                                    mpos.x,
                                    mpos.y,
                                    mpos.cx,
                                    mpos.cy
                                )
                        );
                        if (this.type !== "Text" && this.type !== "RichText") {
                            if (size.height >= this.editor.option.height * 10) {
                                this.height = this.editor.option.height * 10;
                                break;
                            } else if (size.height <= 20 / this.editor.scale) {
                                this.height = 20 / this.editor.scale;
                                break;
                            }
                        }
                        this.height = size.height;
                        if (this.type === "Text" || this.type === "RichText") {
                            if (this.height < this.minWidth + 4) {
                                this.height = this.minWidth + 4;
                            }
                            this.ele
                                .children("div")
                                .height(this.height * this.editor.scale);
                            this.width =
                                this.ele.children("div").width() /
                                this.editor.scale;
                        }
                        position = this._rotSize(
                            this.width,
                            this.height,
                            mpos.width,
                            mpos.height,
                            mpos.left,
                            mpos.top,
                            this.rotate,
                            "bottom-right"
                        );
                        this.positionLeft = position.left;
                        this.positionTop = position.top;
                        if (
                            adsorb &&
                            this.type !== "Text" &&
                            this.type !== "RichText"
                        ) {
                            this.adsorbData = this._getAdsorbPosPo(
                                "non",
                                this.rotate,
                                0
                            );
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "non",
                                mpos
                            );
                            if (typeof info.h === "number") {
                                this.height = info.h + mpos.height;
                                position = this._rotSize(
                                    this.width,
                                    this.height,
                                    mpos.width,
                                    mpos.height,
                                    mpos.left,
                                    mpos.top,
                                    mpos.rotate,
                                    "bottom-right"
                                );
                                this.positionLeft = position.left;
                                this.positionTop = position.top;
                            }
                        }
                        break;
                    case "se":
                        // 右下
                        scaleSize = Math.abs(
                            this._scaleSize(
                                pos.x,
                                pos.y,
                                mpos.x,
                                mpos.y,
                                mpos.cx,
                                mpos.cy
                            )
                        );
                        if (scaleSize <= mpos.minScale) {
                            scaleSize = mpos.minScale;
                        } else if (scaleSize >= mpos.maxScale) {
                            scaleSize = mpos.maxScale;
                        }
                        this.width = mpos.width * scaleSize;
                        this.height = mpos.height * scaleSize;
                        position = this._rotSize(
                            this.width,
                            this.height,
                            mpos.width,
                            mpos.height,
                            mpos.left,
                            mpos.top,
                            this.rotate,
                            "top-left"
                        );
                        this.positionLeft = position.left;
                        this.positionTop = position.top;
                        if (adsorb) {
                            this.adsorbData = this._getAdsorbPosPo(
                                "ratio",
                                this.rotate,
                                1
                            );
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "ratio",
                                mpos
                            );
                            if (typeof info.s === "number") {
                                info.s = Math.abs(info.s);
                                this.width = mpos.width * info.s;
                                this.height = mpos.height * info.s;
                                position = this._rotSize(
                                    this.width,
                                    this.height,
                                    mpos.width,
                                    mpos.height,
                                    mpos.left,
                                    mpos.top,
                                    mpos.rotate,
                                    "top-left"
                                );
                                this.positionLeft = position.left;
                                this.positionTop = position.top;
                            }
                        }
                        break;
                    case "sw":
                        // 左下
                        scaleSize = Math.abs(
                            this._scaleSize(
                                pos.x,
                                pos.y,
                                mpos.x,
                                mpos.y,
                                mpos.cx,
                                mpos.cy
                            )
                        );
                        if (scaleSize <= mpos.minScale) {
                            scaleSize = mpos.minScale;
                        } else if (scaleSize >= mpos.maxScale) {
                            scaleSize = mpos.maxScale;
                        }
                        this.width = mpos.width * scaleSize;
                        this.height = mpos.height * scaleSize;
                        position = this._rotSize(
                            this.width,
                            this.height,
                            mpos.width,
                            mpos.height,
                            mpos.left,
                            mpos.top,
                            this.rotate,
                            "top-right"
                        );
                        this.positionLeft = position.left;
                        this.positionTop = position.top;
                        if (adsorb) {
                            this.adsorbData = this._getAdsorbPosPo(
                                "ratio",
                                this.rotate,
                                2
                            );
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "ratio",
                                mpos
                            );
                            if (typeof info.s === "number") {
                                info.s = Math.abs(info.s);
                                this.width = mpos.width * info.s;
                                this.height = mpos.height * info.s;
                                position = this._rotSize(
                                    this.width,
                                    this.height,
                                    mpos.width,
                                    mpos.height,
                                    mpos.left,
                                    mpos.top,
                                    mpos.rotate,
                                    "top-right"
                                );
                                this.positionLeft = position.left;
                                this.positionTop = position.top;
                            }
                        }
                        break;
                    case "nw":
                        // 左上
                        scaleSize = Math.abs(
                            this._scaleSize(
                                pos.x,
                                pos.y,
                                mpos.x,
                                mpos.y,
                                mpos.cx,
                                mpos.cy
                            )
                        );
                        if (scaleSize <= mpos.minScale) {
                            scaleSize = mpos.minScale;
                        } else if (scaleSize >= mpos.maxScale) {
                            scaleSize = mpos.maxScale;
                        }
                        this.width = mpos.width * scaleSize;
                        this.height = mpos.height * scaleSize;
                        position = this._rotSize(
                            this.width,
                            this.height,
                            mpos.width,
                            mpos.height,
                            mpos.left,
                            mpos.top,
                            this.rotate,
                            "bottom-right"
                        );
                        this.positionLeft = position.left;
                        this.positionTop = position.top;
                        if (adsorb) {
                            this.adsorbData = this._getAdsorbPosPo(
                                "ratio",
                                this.rotate,
                                3
                            );
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "ratio",
                                mpos
                            );
                            if (typeof info.s === "number") {
                                info.s = Math.abs(info.s);
                                this.width = mpos.width * info.s;
                                this.height = mpos.height * info.s;
                                position = this._rotSize(
                                    this.width,
                                    this.height,
                                    mpos.width,
                                    mpos.height,
                                    mpos.left,
                                    mpos.top,
                                    mpos.rotate,
                                    "bottom-right"
                                );
                                this.positionLeft = position.left;
                                this.positionTop = position.top;
                            }
                        }
                        break;
                    case "ne":
                        // 右上
                        scaleSize = Math.abs(
                            this._scaleSize(
                                pos.x,
                                pos.y,
                                mpos.x,
                                mpos.y,
                                mpos.cx,
                                mpos.cy
                            )
                        );
                        if (scaleSize <= mpos.minScale) {
                            scaleSize = mpos.minScale;
                        } else if (scaleSize >= mpos.maxScale) {
                            scaleSize = mpos.maxScale;
                        }
                        this.width = mpos.width * scaleSize;
                        this.height = mpos.height * scaleSize;
                        position = this._rotSize(
                            this.width,
                            this.height,
                            mpos.width,
                            mpos.height,
                            mpos.left,
                            mpos.top,
                            this.rotate,
                            "bottom-left"
                        );
                        this.positionLeft = position.left;
                        this.positionTop = position.top;
                        if (adsorb) {
                            this.adsorbData = this._getAdsorbPosPo(
                                "ratio",
                                this.rotate,
                                0
                            );
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "ratio",
                                mpos
                            );
                            if (typeof info.s === "number") {
                                info.s = Math.abs(info.s);
                                this.width = mpos.width * info.s;
                                this.height = mpos.height * info.s;
                                position = this._rotSize(
                                    this.width,
                                    this.height,
                                    mpos.width,
                                    mpos.height,
                                    mpos.left,
                                    mpos.top,
                                    mpos.rotate,
                                    "bottom-left"
                                );
                                this.positionLeft = position.left;
                                this.positionTop = position.top;
                            }
                        }
                        break;
                    case "spin":
                        degree = this._levelDeg(pos.x, pos.y, mpos.cx, mpos.cy);
                        if (degree >= mpos.mdeg) {
                            if (mpos.direction == false) {
                                mpos.direction = true;
                                mpos.rotate = this.rotate;
                                mpos.deg = degree;
                            }
                        } else {
                            if (mpos.direction == true) {
                                mpos.direction = false;
                                mpos.rotate = this.rotate;
                                mpos.deg = degree;
                            }
                        }
                        mpos.mdeg = degree;
                        this.rotate = (mpos.rotate + degree - mpos.deg) % 360;
                        if (
                            this.editor.adsorb &&
                            this.editor.selectedSprite.length === 1
                        ) {
                            var remainder =
                                this.rotate - Math.round(this.rotate / 45) * 45;
                            if (
                                (remainder > 0 && remainder <= 4) ||
                                (remainder < 0 && remainder >= -4)
                            ) {
                                this.rotate = Math.round(this.rotate / 45) * 45;
                            }
                        }
                        break;
                    case "move":
                        this.positionLeft = mpos.left + pos.x - mpos.x;
                        this.positionTop = mpos.top + pos.y - mpos.y;
                        // 目前的吸附只是支持移动（后续拓展请看下面思路）
                        if (adsorb) {
                            this.adsorbData = this._getAdsorbPos();
                            info = this._setAdsorbPos(
                                this.adsorbData,
                                "move",
                                mpos
                            );
                            if (typeof info.x === "number")
                                this.positionLeft = info.x;
                            if (typeof info.y === "number")
                                this.positionTop = info.y;
                        }
                        break;
                }

                if (this.opMatting && this.opMatting.isMattingStatus === 2) {
                    this.opMatting.updateMattingEl({
                        width: this.width,
                        height: this.height,
                    });
                }

                if (this.action !== "move") {
                    this.changeStyle(null, true);
                    this.setBorderRadius();
                    return;
                }
                this.changeStyle();
            },
            _end: function () {
                // mouseup事件调用
                if (!this.effect) return;
                if (
                    (this.effect.pathAnim && this.effect.pathAnim.end) ||
                    this.locked
                )
                    return;
                if (this.type === "Text" || this.border) {
                    // 文字改变宽度后手写不会改变的BUG，后期有待优化
                    this.effect.init(true);
                }

                this.action = null;
                this.mpos = null;
                this.opHelper.setCursor(this.rotate);

                var eleCss = {
                    width: this.width,
                    height: this.height,
                    top: this.positionTop,
                    left: this.positionLeft,
                    transform:
                        "rotate(" +
                        this.rotate +
                        "deg)" +
                        (this.flip ? " scaleX(-1)" : ""),
                    zIndex: (this.index + 1) * 5,
                };

                // 若该sprite在player层存在相对应的元素，则同步两者状态
                if (this.effect.playerSprite) {
                    var font =
                        this.type === "Text"
                            ? this.ele.children("[autofocus]").css("font")
                            : null;
                    this.effect.syncSprite(eleCss, font);
                }

                if (this.effect.animFrame) {
                    this.effect.animFrame.stay = AnimEditor.initStayData(this);
                }
            },
            _angle: function (x1, y1, x2, y2, x3, y3) {
                // 求以(x3，y3)为顶点的角度
                var deg =
                    this._levelDeg(x1, y1, x3, y3) -
                    this._levelDeg(x2, y2, x3, y3);
                if (deg < 0) {
                    deg = 360 + deg;
                }
                return deg;
            },
            _changeLength: function (x1, y1, x2, y2, x3, y3) {
                // 计算元素宽高应该增加为多少？(x3, y3)为元素的中心点
                return (
                    this._len(x1, y1, x3, y3) *
                        Math.cos(
                            (this._angle(x1, y1, x2, y2, x3, y3) * Math.PI) /
                                180
                        ) -
                    this._len(x2, y2, x3, y3)
                );
            },
            _scaleSize: function (x1, y1, x2, y2, x3, y3) {
                // 计算斜对角放大的倍数(参数参考 _angle函数参数)
                var len = this._changeLength(x1, y1, x2, y2, x3, y3);

                return 1 + len / this._len(x2, y2, x3, y3) / 2;
            },
            _len: function (x1, y1, x2, y2) {
                // 计算点点之间的距离
                return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
            },
            _rotSize(nw, nh, ow, oh, left, top, angle, type) {
                // 固定四个点不动的方法
                var deg = (angle * Math.PI) / 180,
                    sin = Math.sin(deg),
                    cos = Math.cos(deg),
                    nt,
                    nl;

                switch (type) {
                    case "top-left":
                        nt =
                            (nw / 2) * sin +
                            (nh / 2) * cos -
                            nh / 2 -
                            (ow / 2) * sin -
                            (oh / 2) * cos +
                            top +
                            oh / 2;
                        nl =
                            (nw / 2) * cos -
                            (nh / 2) * sin -
                            nw / 2 -
                            (ow / 2) * cos +
                            (oh / 2) * sin +
                            left +
                            ow / 2;
                        break;
                    case "top-right":
                        nt =
                            (-nw / 2) * sin +
                            (nh / 2) * cos -
                            nh / 2 +
                            (ow / 2) * sin -
                            (oh / 2) * cos +
                            top +
                            oh / 2;
                        nl =
                            (-nw / 2) * cos -
                            (nh / 2) * sin -
                            nw / 2 +
                            (ow / 2) * cos +
                            (oh / 2) * sin +
                            left +
                            ow / 2;
                        break;
                    case "bottom-left":
                        nt =
                            (nw / 2) * sin -
                            (nh / 2) * cos -
                            nh / 2 -
                            (ow / 2) * sin +
                            (oh / 2) * cos +
                            top +
                            oh / 2;
                        nl =
                            (nw / 2) * cos +
                            (nh / 2) * sin -
                            nw / 2 -
                            (ow / 2) * cos -
                            (oh / 2) * sin +
                            left +
                            ow / 2;
                        break;
                    case "bottom-right":
                        nt =
                            (-nw / 2) * sin -
                            (nh / 2) * cos -
                            nh / 2 +
                            (ow / 2) * sin +
                            (oh / 2) * cos +
                            top +
                            oh / 2;
                        nl =
                            (-nw / 2) * cos +
                            (nh / 2) * sin -
                            nw / 2 +
                            (ow / 2) * cos -
                            (oh / 2) * sin +
                            left +
                            ow / 2;
                        break;
                }

                return { top: nt, left: nl };
            },
            _levelDeg: function (x1, y1, cx, cy) {
                var dx = x1 - cx,
                    dy = y1 - cy,
                    deg = (360 * Math.atan2(dy, dx)) / (2 * Math.PI);
                if (dx > 0 && dy == 0) {
                    // x轴正方向上
                    deg = 0;
                } else if (dx < 0 && dy == 0) {
                    // x轴负方向
                    deg = 180;
                } else if (dy > 0 && dx == 0) {
                    // y轴正方向
                    deg = 90;
                } else if (dy < 0 && dx == 0) {
                    // y轴负方向
                    deg = 270;
                } else if (dx != 0 && dy < 0) {
                    deg = 360 + deg;
                }

                return deg;
            },
            /**
             * @method _rotateWithPoint
             * @description 元素围绕o点旋转deg(顺时针)角度后的位置
             */
            _rotateWithPoint: function (o, rotate, old) {
                var a = {
                    x: old.x + this.width / 2,
                    y: old.y + this.height / 2,
                };
                var b = {};
                var deg = (Math.PI / 180) * rotate;
                b.x =
                    (a.x - o.x) * Math.cos(deg) -
                    (a.y - o.y) * Math.sin(deg) +
                    o.x;
                b.y =
                    (a.x - o.x) * Math.sin(deg) +
                    (a.y - o.y) * Math.cos(deg) +
                    o.y;
                return {
                    top: b.y - this.height / 2,
                    left: b.x - this.width / 2,
                    rotate: rotate + old.rotate,
                };
            },
            // sprite宽高超过画布时的处理
            scaleSprite: function (width, height) {
                var editor = this.editor;
                var whr = width / height;
                var w = editor.clientWidth / 2;
                return {
                    w: w,
                    h: width > height ? w * whr : w / whr,
                };
            },
            // forId 为了获取有id值的json
            toJson: function (forId) {
                var effect = this.effect,
                    entrance = effect.entranceAnim,
                    exit = effect.exitAnim,
                    stay = effect.stayAnim,
                    path = effect.pathAnim,
                    border = null,
                    data;
                if (this.border) {
                    border = Object.assign({}, this.border);
                    border.radius = [].concat(this.border.radius);
                    delete border.dom;
                }
                var getEasingNum = function (name) {
                    var map = {
                        linear: 0,
                        easeOutExpo: 1,
                        easeOutQuint: 2,
                    };
                    return map[name] == null ? 1 : map[name];
                };
                var getHand = function (sprite, force) {
                    var entrance = sprite.effect.entranceAnim;
                    var writehandData;
                    var code = force || effect.code;
                    switch (code) {
                        case "Write":
                            writehandData = entrance.writehand || "defaults";
                            if (writehandData === "defaults") {
                                return null;
                            }
                            return Object.assign({}, writehandData, {
                                url: unhandleAssetsUrl(
                                    writehandData.url ||
                                        sprite.editor.option.assets.writeHand
                                ),
                            });
                        default:
                            if (
                                !entrance.hand ||
                                (entrance.hand && !entrance.hand.url)
                            ) {
                                return null;
                            }
                            return {
                                anchorPointX: entrance.hand.x,
                                anchorPointY: entrance.hand.y,
                                url: unhandleAssetsUrl(entrance.hand.url),
                            };
                    }
                };
                var pathEasingMap = {
                    linear: 0,
                    easeInOutQuad: 1,
                    easeOutQuint: 2,
                };
                data = {
                    trackingType: this.option.trackingType || "",
                    type: this.type,
                    fileType: this.option.fileType,
                    resourceId: this.option.resourceId,
                    zIndex: this.index,
                    category: "",
                    outward: {
                        x: this.positionLeft,
                        y: this.positionTop,
                        width: this.width,
                        height: this.height,
                        rotation: this.rotate,
                        opacity: this.opacity,
                        isFlipped: this.flip,
                    },
                    startTime: entrance.start / 1000,
                    enterEffect: {
                        type: effect.code,
                        duration: (entrance.end - entrance.start) / 1000,
                        direction: effect.direction || "",
                        easing: getEasingNum(effect.easing),
                        hand: getHand(this, "noWrite"),
                        writehand: getHand(this),
                    },
                    stayEffect: {
                        type: "None",
                        duration: (exit.start - entrance.end) / 1000,
                        animationGraphs: path.end
                            ? [
                                  {
                                      type: path.type || "Path",
                                      startTime: 0,
                                      easing: path.easing
                                          ? pathEasingMap[path.easing]
                                          : 1,
                                      loop:
                                          path.loop === undefined
                                              ? false
                                              : path.loop,
                                      duration: (path.end - path.start) / 1000,
                                      toBounds: {
                                          x: path.target.x,
                                          y: path.target.y,
                                          width: path.target.w,
                                          height: path.target.h,
                                      },
                                      info: {
                                          width: path.info.width,
                                          height: path.info.height,
                                          rotate: path.info.rotate || 0,
                                          ccw:
                                              typeof path.info.ccw === "number"
                                                  ? path.info.ccw
                                                  : 0,
                                          close: path.info.close || false,
                                          points: $.extend(
                                              true,
                                              [],
                                              path.info.points
                                          ),
                                          freePathType:
                                              path.info.freePathType || "",
                                      },
                                      path:
                                          path.type === "Ellipse"
                                              ? []
                                              : [].concat(path.info.path),
                                      toRotation:
                                          typeof path.target.rotate === "number"
                                              ? path.target.rotate
                                              : this.rotate,
                                      toOpacity:
                                          typeof path.target.opacity ===
                                          "number"
                                              ? path.target.opacity
                                              : this.opacity,
                                      toFillColor:
                                          path.target.fillColor || null,
                                      toTextColor:
                                          path.target.textColor || null,
                                  },
                              ]
                            : null,
                        attachAnim:
                            stay.type !== "None"
                                ? [
                                      {
                                          type: stay.type,
                                          data: JSON.stringify(
                                              stay,
                                              function (k, v) {
                                                  if (k === "type") {
                                                      return undefined;
                                                  }
                                                  return v;
                                              }
                                          ),
                                      },
                                  ]
                                : null,
                        hand: null,
                    },
                    exitEffect: {
                        type: exit.type,
                        duration: (exit.end - exit.start) / 1000,
                        direction: exit.direction || "",
                        easing: getEasingNum(exit.easing),
                        hand: exit.hand
                            ? {
                                  anchorPointX: exit.hand.x,
                                  anchorPointY: exit.hand.y,
                                  url: unhandleAssetsUrl(exit.hand.url),
                              }
                            : null,
                    },
                    filter: this.filter,
                    boxShadow: this.boxShadow,
                    dropShadow: this.dropShadow,
                    bgColor: this.bgColor,
                    border: border,
                    groupId: this.groupId, // 组合元素id
                    templateFree: this.option.templateFree,
                };
                if (this.sound) {
                    var soundData = {
                        url: this.sound.url,
                        volume: this.sound.volume,
                        duration: numberOunding(this.sound.duration) || null,
                    };
                    data.sound = soundData;
                }
                if (forId) {
                    data.id = this.id;
                }
                if (this.option.isUser) {
                    data.isUser = this.option.isUser;
                }
                if (this.FT) data.FT = this.FT;
                // if (!data.resourceId) {
                //     this.option.resourceId = generateUUID();
                //     data.resourceId = this.option.resourceId;
                // }
                return data;
            },
            _scaleArr: function (arr, scale) {
                if (!arr) return;
                for (var i = 0; i < arr.length; i++) {
                    arr[i] *= scale;
                }
                return arr;
            },
            _scaleArrTwo: function (arr, scale) {
                if (!arr) return;
                for (var i = 0; i < arr.length; i++) {
                    arr[i].forEach(function (v, j) {
                        arr[i][j] = v *= scale;
                    });
                }
                return arr;
            },
            syncPathOffset: function (time, init) {
                // 路径动画的当前时间的位置
                if (init) {
                    var eleCss, helpCss;
                    eleCss = {
                        left: this.positionLeft,
                        top: this.positionTop,
                        width: this.width,
                        height: this.height,
                        opacity: this.opacity,
                        transform:
                            "rotate(" +
                            this.rotate +
                            "deg)" +
                            (this.flip ? " scaleX(-1)" : ""),
                    };

                    helpCss = {
                        left: this.positionLeft,
                        top: this.positionTop,
                        width: this.width,
                        height: this.height,
                        transform: "rotate(" + this.rotate + "deg)",
                    };

                    this.ele.css(eleCss);
                    this.helpEle.css(helpCss);
                    if (this.option.fill) {
                        AnimEditor.changeSvgFillColor(this.ele[0], this.fill);
                    }
                    this.handleCrop2 && this.handleCrop2();
                    return;
                }
                if (!this.effect.pathAnim.end || !this.effect.isInit) return;
                var frame = Math.ceil(time * 60),
                    frameOff = 0,
                    pathAnim = this.effect.pathAnim,
                    af = this.effect.animFrame,
                    move,
                    eleCss,
                    helpCss;

                var ccw = 0;

                if (
                    !pathAnim.loop &&
                    frame >= af.path.start &&
                    frame <= af.exit.start
                ) {
                    if (frame <= af.path.end) {
                        frameOff = frame - af.path.start;
                    } else {
                        frameOff = af.path.end - af.path.start;
                    }
                } else if (
                    pathAnim.loop &&
                    frame >= af.path.start &&
                    frame <= af.exit.start
                ) {
                    frameOff =
                        (frame - af.path.start) % (af.path.end - af.path.start);
                    if (pathAnim.type !== "Ellipse") {
                        ccw =
                            parseInt(
                                (frame - af.path.start) /
                                    (af.path.end - af.path.start)
                            ) % 2;
                    }
                } else {
                    return;
                }

                pathAnim.type === "Ellipse" && (ccw = pathAnim.info.ccw || 0);

                move = AnimEditor.pathOffsetCalc(this, af.path, frameOff, ccw);

                eleCss = {
                    left: move.left,
                    top: move.top,
                    width: move.width,
                    height: move.height,
                    opacity: move.opacity,
                    transform:
                        "rotate(" +
                        move.rotate +
                        "deg)" +
                        (this.flip ? " scaleX(-1)" : ""),
                };

                helpCss = {
                    left: move.left,
                    top: move.top,
                    width: move.width,
                    height: move.height,
                    transform: "rotate(" + move.rotate + "deg)",
                };

                this.ele.css(eleCss);
                this.helpEle.css(helpCss);

                if (move.fillColor) {
                    AnimEditor.changeSvgFillColor(this.ele[0], move.fillColor);
                }

                if (move.textColor) {
                    this.ele.children().css({
                        color: move.textColor,
                    });
                }

                this.cropType === "free" && this.handleCrop2();
            },
            playSyncContent: function () {
                this.effect.playerSprite &&
                    this.effect.playerSprite.ele.css({
                        top: this.positionTop,
                        left: this.positionLeft,
                        width: this.width,
                        height: this.height,
                        transform:
                            "rotate(" +
                            this.rotate +
                            "deg)" +
                            (this.flip ? " scaleX(-1)" : ""),
                        opacity: this.opacity,
                    });
            },
            // 设置有声素材
            setSound: function (data) {
                if (!this.sound) {
                    var judgeType = false,
                        _this = this;
                    switch (this.type) {
                        case "Lottie":
                        case "Gif":
                            judgeType = true;
                            break;
                    }
                    if (!data || !judgeType) return;
                    data.volume = "volume" in data ? data.volume : 50;
                    var audio = document.createElement("audio");
                    audio.src = handleAssetsUrl(data.url);
                    if (data.url) audio.load();
                    this.sound = {
                        url: data.url,
                        volume: data.volume !== undefined ? data.volume : 50,
                    };
                    audio.addEventListener("loadedmetadata", function () {
                        _this.sound.duration = audio.duration;
                        audio = null;
                        return Promise.resolve();
                    });
                    audio.addEventListener("error", function () {
                        audio = null;
                        //return Promise.reject('加载失败')
                    });
                } else {
                    for (var dataAttr in data) {
                        this.sound[dataAttr] = data[dataAttr];
                    }
                    return Promise.resolve();
                }
            },
            getSound: function () {
                if (!this.sound) return null;

                var scenesList = this.editor.sprites,
                    preTime = 0,
                    spriteJson = this.toJson(),
                    startTime,
                    endTime;

                var spriteTime = spriteJson.stayEffect.duration - 0,
                    frameRate = this.frameRate,
                    totalFrames = this.totalFrames;
                if (!this.isLoop) {
                    var addTime =
                        (totalFrames / frameRate) * (this.numberOfLoops - 0);

                    spriteTime = addTime > spriteTime ? spriteTime : addTime;
                }
                for (var i = 0; i < scenesList.length; i++) {
                    if (scenesList[i].id !== this.scenesId) {
                        preTime += scenesList[i].getDuration() / 1000;
                    } else if (scenesList[i].id == this.scenesId) {
                        break;
                    }
                }

                startTime =
                    spriteJson.startTime +
                    preTime +
                    spriteJson.enterEffect.duration;
                endTime = spriteTime + startTime;
                return {
                    url: this.sound.url,
                    volume: this.sound.volume,
                    startTime: startTime,
                    endTime: endTime,
                    duration: this.sound.duration,
                    aduration: totalFrames / frameRate,
                };
            },
            _getBBox() {
                var r = (Math.PI / 180) * this.rotate,
                    t = {
                        cos: Math.abs(Math.cos(r)),
                        sin: Math.abs(Math.sin(r)),
                    },
                    box = {
                        w: this.width * t.cos + this.height * t.sin,
                        h: this.width * t.sin + this.height * t.cos,
                        cx: this.positionLeft + this.width / 2,
                        cy: this.positionTop + this.height / 2,
                    };
                box.t = box.cy - box.h / 2;
                box.b = box.cy + box.h / 2;
                box.l = box.cx - box.w / 2;
                box.r = box.cx + box.w / 2;
                return box;
            },
            _getAdsorbData() {
                // 获取外接矩形的信息
                var box = this._getBBox();
                // 分别是top, right, bottom, left, centerY, chenterX
                return [box.t, box.r, box.b, box.l, box.cy, box.cx];
            },
            _getAdsorbPos() {
                var adsorb = this._getAdsorbData(),
                    adsorbArr = this.editor.selectedScenes.adsorbArr,
                    arr = [[], []],
                    data = [{}, {}, {}, {}, {}, {}];

                for (var i in adsorbArr) {
                    arr[i % 2].push(adsorbArr[i]);
                }

                for (var j in adsorb) {
                    var index = j % 2;
                    for (var k in arr[index]) {
                        if (Math.abs(adsorb[j] - arr[index][k]) <= 5) {
                            data[j].k = adsorb[j];
                            data[j].v = arr[index][k];
                            data[j].arr = adsorb;
                        }
                    }
                }
                return data;
            },
            _getAdsorbPosPo(action, deg, start) {
                // 缩放吸附位置计算（0上，1右，2下，3左，4中，5竖）
                var adsorb = this._getAdsorbData(),
                    adsorbArr = this.editor.selectedScenes.adsorbArr,
                    step = (deg > 0 ? deg : 360 + deg) / 90,
                    arr = [[], []],
                    data = [{}, {}, {}, {}, {}, {}],
                    need = {
                        // 应该吸附的对应位置
                        ratio: [],
                        non: [],
                    };

                for (var i in adsorbArr) {
                    arr[i % 2].push(adsorbArr[i]);
                }

                // 每隔90度需要吸附的对应边会变1
                if (step - Math.floor(step)) {
                    step = Math.floor(step);
                    start = (start + step) % 4;
                    need.non[0] = start;
                    start = (start + 1) % 4;
                    need.ratio[0] = start;
                    need.non[1] = start;
                } else {
                    start = (start + step) % 4;
                    need.ratio[0] = start;
                    need.non[0] = start;
                    start = (start + 1) % 4;
                    need.ratio[1] = start;
                }

                for (var j in adsorb) {
                    // 判断是否需要对应边是否需要吸附
                    if (j != need[action][0] && j != need[action][1]) continue;
                    var index = j % 2;
                    for (var k in arr[index]) {
                        if (Math.abs(adsorb[j] - arr[index][k]) <= 5) {
                            data[j].k = adsorb[j];
                            data[j].v = arr[index][k];
                            data[j].arr = adsorb;
                        }
                    }
                }
                return data;
            },
            _setAdsorbPos(data, action, mpos) {
                var info = {},
                    b = mpos.box;
                if (action === "move") {
                    data.forEach((v, i) => {
                        if (v.v) {
                            if (i % 2 === 0) {
                                info.y =
                                    v.v - v.arr[i] + v.arr[4] - mpos.height / 2;
                            } else {
                                info.x =
                                    v.v - v.arr[i] + v.arr[5] - mpos.width / 2;
                            }
                        }
                    });
                } else if (action === "ratio") {
                    data.forEach((v, i) => {
                        if (v.v) {
                            if (i === 0) info.s = (v.v - b.b) / b.h;
                            if (i === 1) info.s = (v.v - b.l) / b.w;
                            if (i === 2) info.s = (v.v - b.t) / b.h;
                            if (i === 3) info.s = (v.v - b.r) / b.w;
                        }
                    });
                } else if (action === "non") {
                    data.forEach((v, i) => {
                        if (v.v) {
                            if (i === 0) {
                                info.w = (b.t - v.v) / mpos.sin;
                                info.h = (b.t - v.v) / mpos.cos;
                            } else if (i === 1) {
                                info.w = (v.v - b.r) / mpos.cos;
                                info.h = (v.v - b.r) / mpos.sin;
                            } else if (i === 2) {
                                info.w = (v.v - b.b) / mpos.sin;
                                info.h = (v.v - b.b) / mpos.cos;
                            } else if (i === 3) {
                                info.w = (b.l - v.v) / mpos.cos;
                                info.h = (b.l - v.v) / mpos.sin;
                            }
                        }
                    });
                }
                return info;
            },
            _getTimeDom(time) {
                var ss = this.effect.entranceAnim.end;
                var se = this.effect.exitAnim.start;
                var dom = null;
                if (time >= ss && time <= se) {
                    if (this.getDomDiffId) {
                        dom = this.getDomDiffId("forPlay");
                    } else {
                        dom = this.ele.clone();
                    }
                    dom.show().attr({
                        id: null,
                    });
                }
                return dom;
            },
            setFilter: function (data) {
                if (data) {
                    //this.effect.playerSprite.ele
                    this.filter = Object.assign({}, this.filter);
                    for (var arr in data) {
                        switch (arr) {
                            case "blur": // 模糊    (Height / 22 * blur * 0.01）
                                this.filter.blur = data.blur;
                                break;
                            case "brightness": // 亮度    (0 —1— 10）
                                this.filter.brightness =
                                    data.brightness <= 0
                                        ? 0
                                        : data.brightness <= 10
                                        ? data.brightness
                                        : 10;
                                break;
                            case "contrast": // 对比度  (0 —1— 10）
                                this.filter.contrast =
                                    data.contrast <= 0
                                        ? 0
                                        : data.contrast <= 10
                                        ? data.contrast
                                        : 10;
                                break;
                            case "saturate": // 饱和度  (0 —1— 10）
                                this.filter.saturate =
                                    data.saturate <= 0
                                        ? 0
                                        : data.saturate <= 10
                                        ? data.saturate
                                        : 10;
                                break;
                            case "grayscale": // 灰度    (0 —— 1）
                                this.filter.grayscale =
                                    data.grayscale <= 0
                                        ? 0
                                        : data.grayscale <= 1
                                        ? data.grayscale
                                        : 1;
                                break;
                            case "hueRotate": // 色相    (0deg —— 360deg）
                                this.filter.hueRotate =
                                    data.hueRotate <= 0
                                        ? 0
                                        : data.hueRotate <= 360
                                        ? data.hueRotate
                                        : 360;
                                break;
                            case "invert": // 反色    (0 —— 1）
                                this.filter.invert =
                                    data.invert <= 0
                                        ? 0
                                        : data.invert <= 1
                                        ? data.invert
                                        : 1;
                                break;
                            case "sepia": // 加温    (0 —— 1）
                                this.filter.sepia =
                                    data.sepia <= 0
                                        ? 0
                                        : data.sepia <= 1
                                        ? data.sepia
                                        : 1;
                                break;
                        }
                    }
                }
                this.setFilterCss();
            },
            setFilterCss: function () {
                var filterCss = [];
                for (var item in this.filter) {
                    switch (item) {
                        case "blur":
                            var height = this.height;
                            var temp = (height / 22) * this.filter.blur * 0.01;
                            filterCss.push("blur(" + temp + "px)");
                            break;
                        case "brightness":
                            filterCss.push(
                                "brightness(" + this.filter.brightness + ")"
                            );
                            break;
                        case "contrast":
                            filterCss.push(
                                "contrast(" + this.filter.contrast + ")"
                            );
                            break;
                        case "saturate":
                            filterCss.push(
                                "saturate(" + this.filter.saturate + ")"
                            );
                            break;
                        case "grayscale":
                            filterCss.push(
                                "grayscale(" + this.filter.grayscale + ")"
                            );
                            break;
                        case "hueRotate":
                            filterCss.push(
                                "hue-rotate(" + this.filter.hueRotate + "deg)"
                            );
                            break;
                        case "invert":
                            filterCss.push(
                                "invert(" + this.filter.invert + ")"
                            );
                            break;
                        case "sepia":
                            filterCss.push("sepia(" + this.filter.sepia + ")");
                            break;
                    }
                }
                // 滤镜
                if (this.dropShadow)
                    filterCss.push(
                        "drop-shadow(" + this.getShadowCss("dropShadow") + ")"
                    );

                this.ele.children(":not(.sprite-border)").css({
                    "-webkit-filter": filterCss.join(" "),
                    filter: filterCss.join(" "),
                });

                // 同步播放层
                var playEle = $("#player-sprite-" + this.id).children();
                if (playEle.length) {
                    for (let j = 0; j < playEle.length; j++) {
                        var id = playEle[j].id;
                        if (id.indexOf("write-hand-wrapper") < 0) {
                            $(playEle[j]).css({
                                "-webkit-filter": filterCss.join(" "),
                                filter: filterCss.join(" "),
                            });
                        }
                    }
                }
            },
            setClipPath: function (val) {
                if (!this.croppedFlag) {
                    return;
                }
                this.ele.css({
                    "clip-path": val,
                });
                $("#player-sprite-" + this.ele.id).css({
                    "clip-path": val,
                });
            },
            setLocked(bol) {
                this.locked = bol;
                this.helpEle.css({
                    zIndex: bol ? -1 : (this.index + 1) * 5,
                });
            },
            setShadow(data, type) {
                if (!type) type = "boxShadow";
                if (data && data.color) {
                    this[type] = {
                        x: data.x,
                        y: data.y,
                        blur: data.blur,
                        spread: data.spread,
                        color: data.color,
                    };
                } else {
                    this[type] = null;
                }

                this.changeStyle();
                this.effect.init();
            },
            getShadowCss(type) {
                var shadow = "";
                var ratio = this.editor.scale;
                if (this.type === "Text" || this.type === "RichText") {
                    ratio = 1;
                }
                for (var i in this[type]) {
                    if (i !== "color") {
                        // drop-shadow不支持扩散属性
                        if (i === "spread" && type === "dropShadow") continue;
                        shadow += this[type][i] / ratio + "px ";
                    } else {
                        shadow += this[type][i];
                    }
                }
                return shadow || "unset";
            },
            setBorder(data) {
                if (data) {
                    if (!this.border) {
                        this.border = {
                            dom: $('<span class="sprite-border"></span>'),
                            width: 0,
                            style: "solid",
                            color: "#88888",
                            radius: [0, 0, 0, 0],
                        };
                        this.border.dom.appendTo(this.ele);
                    }
                    Object.assign(this.border, data);
                    this.border.radius = [].concat(this.border.radius);
                    this.border.dom.css({
                        borderWidth:
                            (this.border.width * 2) / this.editor.scale + "px",
                        borderStyle: this.border.style,
                        borderColor: this.border.color,
                    });
                    this.setBorderRadius();
                } else {
                    if (!this.border) return;
                    this.border.dom.remove();
                    this.border = null;
                    this.ele.css({
                        borderRadius: "",
                        overflow: this.croppedFlag ? "hidden" : "",
                    });
                }
                this.effect.init(true);
            },
            setBorderRadius() {
                if (this.border) {
                    var str = "",
                        radius = [],
                        hasRadius = 0,
                        ratio =
                            this.width > this.height ? this.width : this.height;
                    for (i in this.border.radius) {
                        hasRadius += this.border.radius[i];
                        radius.push((this.border.radius[i] * ratio) / 100);
                    }
                    str = radius.join("px ") + "px";
                    this.ele.css({
                        borderRadius: str,
                        overflow:
                            this.border.width || this.croppedFlag || hasRadius
                                ? "hidden"
                                : "",
                    });
                    this.border.dom.css({
                        borderRadius: str,
                    });
                    if (this.type === "Video") {
                        this.ele.children().css({
                            borderRadius: str,
                        });
                    }
                } else {
                    this.ele.css({
                        borderRadius: "",
                        overflow: this.croppedFlag ? "hidden" : "",
                    });
                }
            },
            setBgColor(color) {
                this.bgColor = color || "";
                this.ele.css({
                    backgroundColor: this.bgColor,
                });
                this.effect.init(true);
            },
            loadFailedImg() {
                this.loadFailed = true;
                var image = $("<img>", {
                    src: this.failedImgUrl,
                }).css({
                    width: "100%",
                    height: "100%",
                });
                return image;
            },
        });

    //图片元素
    var ImageSprite = SpriteEle.extend(function (type, ele, editor, option) {
        this.option = Object.assign({}, option);
        this.cropType = option.cropType || "";
        this.cropBoxData = option.cropBoxData || null;
        this.cropUrl = "";
        this.draw = null;
        this.bbox = null;
        this.cancelCropData = null;
        this.img = null;
        this.opMatting = null; // 图片抠图属性
    }).methods({
        _load: function (url) {
            var _this = this;
            return ImageLoader.load(url)
                .then(function (img) {
                    var image = $("<img>", {
                        src: img.src,
                    }).css({
                        width: "100%",
                        height: "100%",
                    });
                    _this.img = image;
                    _this.ele.empty();
                    _this.ele.append(image);

                    _this.initData.width = img.width;
                    _this.initData.height = img.height;
                    _this.initData.scale = _this.editor.scale;

                    return _this;
                })
                .catch(function (err) {
                    if (_this.option.allowFailed) {
                        _this.ele.empty();
                        _this.ele.append(_this.loadFailedImg());
                        return _this;
                    } else {
                        throw "Error:" + err;
                    }
                });
        },
        setOption: function () {
            var _this = this;
            return this.supr(_this.option).then(function () {
                if (_this.option && _this.option.url) {
                    result = _this._load(_this.option.url);
                } else {
                    result = Promise.resolve();
                }
                return result;
            });
        },
        getImage: function () {
            // 获取image的DOM对象
            var img = new Image();
            if (this.cropType === "free") {
                img.width = this.cropBoxData.originWidth;
                img.height = this.cropBoxData.originHeight;
            } else {
                img.width = this.width;
                img.height = this.height;
            }
            img.src = !this.loadFailed
                ? handleAssetsUrl(this.option.url)
                : this.failedImgUrl;
            return img;
        },
        /**
         * 更新裁剪的图片
         * @param {jQuery} wrapper 图片容器
         * @param {jQuery} image 图片元素
         * @param {SpriteEle} sprite 素材
         * @param {Object} options 选项
         */
        handleCrop: function (wrapper, image, sprite, options) {
            var cropBoxData = (sprite || {}).cropBoxData;
            if (!cropBoxData || this.cropType !== "free") return;

            options = options || {};
            var nextW = options.nextW || wrapper.width() || sprite.width;
            var nextH = options.nextH || wrapper.height() || sprite.height;
            var ratioH = nextH / cropBoxData.height;
            var ratioW = nextW / cropBoxData.width;
            var ro = sprite.rotate;
            if (cropBoxData.deltaRotation == null) {
                var dRo = cropBoxData.innerRotation - ro;
                dRo %= 360;
                if (dRo > 180) {
                    dRo -= 360;
                }
                if (dRo <= -180) {
                    dRo += 360;
                }
            } else {
                dRo = cropBoxData.deltaRotation;
                cropBoxData.innerRotation = dRo + ro;
            }

            var nextCrop = {
                width: nextW,
                height: nextH,
                top: cropBoxData.top * ratioH,
                left: cropBoxData.left * ratioW,
                originWidth: cropBoxData.originWidth * ratioW, // 内容图宽
                originHeight: cropBoxData.originHeight * ratioH, // 内容图高
                deltaX: cropBoxData.deltaX * ratioW,
                deltaY: cropBoxData.deltaY * ratioH,
                rotation: ro,
                deltaRotation: dRo,
                innerRotation: cropBoxData.innerRotation,
            };

            image.show();
            wrapper.find(".crop-inner-ref").remove();

            wrapper.css({
                width: nextW,
                height: nextH,
                overflow: "hidden",
            });

            image.css({
                position: "absolute",
                left: nextW / 2 + nextCrop.deltaX - nextCrop.originWidth / 2,
                top: nextH / 2 + nextCrop.deltaY - nextCrop.originHeight / 2,
                width: nextCrop.originWidth,
                height: nextCrop.originHeight,
                maxWidth: nextCrop.originWidth,
                transform: "rotate(" + nextCrop.deltaRotation + "deg)",
            });

            if (wrapper === this.ele) {
                this.cropBoxData = nextCrop;
                // this.originWidth = nextCrop.originWidth;
                // this.originHeight = nextCrop.originHeight;
            }
        },
        handleCrop2: function () {
            // 素材样式改变时，调用此方法更新裁剪的图片
            if (this.loadFailed) return;
            if (this.cropType === "free") {
                this.handleCrop(
                    this.ele,
                    this.ele.children("svg, img").eq(0),
                    this
                );
                var pEle = this.effect.playerSprite.ele;
                this.handleCrop(pEle, pEle.children("svg, img").eq(0), this, {
                    nextW: this.width,
                    nextH: this.height,
                });
            }
        },
        handleOldCrop: function (obj) {
            // fromJson 时，兼容旧项目
            if (obj == null) {
                return obj;
            }
            let isNewCrop = obj.deltaX != null && obj.deltaY != null;
            if (isNewCrop) {
                return obj;
            }
            let props = {
                deltaRotation: 0,
                rotation: 0,
                innerRotation: 0,
            };
            let l = obj.left;
            let t = obj.top;
            let cropCenter = {
                x: l + obj.width / 2,
                y: t + obj.height / 2,
            };
            let imageCenter = {
                x: obj.originWidth / 2,
                y: obj.originHeight / 2,
            };
            props.deltaX = imageCenter.x - cropCenter.x;
            props.deltaY = imageCenter.y - cropCenter.y;
            return Object.assign({}, obj, props);
        },
        /**
         * 设置图片裁剪
         * @param {Object} params 裁剪图片的信息
         * @param {Object} options
         * @param {Rect} options.rect 裁剪后素材的 BoundingClientRect
         * @param {Boolean} options.croppedFlag 素材已裁剪的标记
         * @param {Boolean} options.isResize 设置裁剪时，是否同时更新素材截图尺寸
         *
         */
        setCropBoxData: function (params, options) {
            if (this.loadFailed) {
                this.cropBoxData = params;
                this.cropType = options.cropType;
                return;
            }
            var _this = this;
            var sprite = this;
            options = options || {};
            if (options.croppedFlag === void 0) {
                options.croppedFlag = false;
            }
            var rect = options.rect;
            if (!params) {
                return;
            }

            var oldRect = this.ele[0].getBoundingClientRect();
            if (options.undo) {
                var undoData = {};
                var defaultCropBoxData = {
                    top: 0,
                    left: 0,
                    width: _this.width,
                    height: _this.height,
                    originWidth: _this.width,
                    originHeight: _this.height,
                    rotation: 0,
                    innerRotation: 0,
                    deltaRotation: 0,
                    deltaX: 0,
                    deltaY: 0,
                };
                undoData.data = {
                    cropBoxData: Object.assign(
                        {},
                        this.cropBoxData || defaultCropBoxData
                    ),
                    // rect: rect && {top: rect.top, left: rect.left},
                    rect: oldRect && {
                        top: oldRect.top,
                        left: oldRect.left,
                        width: oldRect.width,
                        height: oldRect.height,
                    },
                    croppedFlag: this.croppedFlag,
                    cropType: this.cropType,
                    url: this.cropUrl,
                    cancelCropData: Object.assign({}, this.cancelCropData, {
                        width: this.width,
                        height: this.height,
                        positionLeft: this.positionLeft,
                        positionTop: this.positionTop,
                        rotation: this.rotate,
                    }),
                };
                undoData.reData = {
                    cropBoxData: Object.assign({}, params),
                    rect: rect && {
                        top: rect.top,
                        left: rect.left,
                        width: rect.width,
                        height: rect.height,
                    },
                    croppedFlag: options.croppedFlag,
                    cropType: options.cropType,
                };
                undoData.id = this.id;
                eve("undo_redo", null, { type: "cropImage", data: undoData });
            }

            let svg = sprite.ele.find("svg");
            if (svg.length) {
                let img = $("<img>").appendTo(sprite.ele);
                let svg = sprite.ele.find("svg");
                img[0].src = handleAssetsUrl(sprite.option.url);
                img[0].style = (svg[0] || {}).style;
                svg.remove();
                let uuid = sprite.id;
                $(`#player-sprite-${uuid}`).find("svg").remove();
            }

            var isResize = options.isResize;
            // var isCropped = !!this.cropBoxData;

            this.cropBoxData = params;
            this.ele.css({
                overflow: "hidden",
            });
            // var imgEl = this.ele.find('img');
            // imgEl.hide();

            if (isResize) {
                return;
            }

            this.width = params.width;
            this.height = params.height;
            this.positionTop = params.top;
            this.positionLeft = params.left;
            this.rotate =
                params.rotation == null ? this.rotate : params.rotation;
            var ro = this.rotate;
            if (params.deltaRotation == null) {
                var dRo = params.innerRotation - ro;
                dRo %= 360;
                if (dRo > 180) {
                    dRo -= 360;
                }
                if (dRo <= -180) {
                    dRo += 360;
                }
                params.deltaRotation = dRo;
            }
            // if (/* isCropped &&  */rect) {
            //     var c1 = getCenterPoint(rect);
            //     // var c2 = getCenterPoint(oldRect);
            //     var contentRect = this.editor.content[0].getBoundingClientRect();
            //     this.positionTop = (c1.y - params.height / 2) - contentRect.top;
            //     this.positionLeft = (c1.x - params.width / 2) - contentRect.left;

            // } else {
            //     this.positionTop += params.top;
            //     this.positionLeft += params.left;
            // }

            this.croppedFlag = options.croppedFlag;

            _this.changeStyle({ sync: true });
            _this.setCropContent(params, this.ele);
            _this.setCropContent(params, this.effect.playerSprite.ele);
            this.cropType = options.cropType;
            if (!this.cropType) {
                let sprite = this;
                sprite.cropBoxData = null;
                let uuid = sprite.id;
                sprite.ele.children("img").show();
                sprite.ele.find(".crop-inner-ref").remove();
                let t = $(`[data-id="flag-${uuid}"].flag-content`).find("img");
                t.show();
                $(`#player-sprite-${uuid}`)
                    .children("img")
                    .add(sprite.ele.children("img"))
                    .add(t)
                    .css({
                        position: "relative",
                        top: 0,
                        left: 0,
                        transform: "none",
                        width: "100%",
                        height: "100%",
                        "max-width": "100%",
                    });
            }
            _this.opHelper.toggleFourPoints();
            _this.effect.init(true);

            function getCenterPoint(rect) {
                return {
                    x: rect.left + rect.width / 2,
                    y: rect.top + rect.height / 2,
                };
            }
        },
        /**
         * 设置裁剪框中的截图
         * @param {Object} cropBoxData 裁剪图片的信息
         * @param {jQuery} container 图片容器
         */
        setCropContent: function (cropBoxData, container) {
            let img = container.children("img");
            img.css({
                position: "absolute",
                left:
                    cropBoxData.width / 2 +
                    cropBoxData.deltaX -
                    cropBoxData.originWidth / 2,
                top:
                    cropBoxData.height / 2 +
                    cropBoxData.deltaY -
                    cropBoxData.originHeight / 2,
                width: cropBoxData.originWidth,
                height: cropBoxData.originHeight,
                maxWidth: cropBoxData.originWidth,
                transform: "rotate(" + cropBoxData.deltaRotation + "deg)",
            });
        },
        changeStyle: function (option) {
            return this.supr(option).then(() => {
                if (!this.cancelCropData) {
                    this.cancelCropData = {
                        width: this.width,
                        height: this.height,
                        positionLeft: this.positionLeft,
                        positionTop: this.positionTop,
                        rotation: this.rotate,
                    };
                }
                this.handleCrop2();
            });
        },
        setSvgCrop: function (data, url, undo) {
            if (undo) {
                var undoData = {};
                undoData.data = {
                    cropBoxData: Object.assign({}, this.cropBoxData),
                    cropType: this.cropType,
                    url: url,
                    cancelCropData: Object.assign({}, this.cancelCropData, {
                        width: this.width,
                        height: this.height,
                        positionLeft: this.positionLeft,
                        positionTop: this.positionTop,
                        rotation: this.rotate,
                    }),
                };
                undoData.reData = {
                    cropBoxData: Object.assign({}, data),
                    cropType: "svg",
                    url: url,
                };
                undoData.id = this.id;
                eve("undo_redo", null, { type: "cropImage", data: undoData });
            }
            this.croppedFlag = true;
            this.cropType = "svg";
            this.cropUrl = url;
            this.cropBoxData = Object.assign({}, this.cropBoxData, data);
            this.width = this.cropBoxData.width;
            this.height = this.cropBoxData.height;
            this.positionLeft = this.cropBoxData.left;
            this.positionTop = this.cropBoxData.top;
            this.rotate = data.rotate;
            this.changeStyle();
            return this.initSVGDom();
        },
        cropSvgData: function (data) {
            var rW = this.width / data.width;
            var rH = this.height / data.height;
            var box = this.cropBoxData;
            this.cropUrl = data.url;
            box.width = this.width;
            box.height = this.height;
            box.originWidth = data.originWidth * rW;
            box.originHeight = data.originHeight * rH;
            box.deltaX = data.deltaX * rW;
            box.deltaY = data.deltaY * rH;
            if (this.loadFailed) {
                return;
            }
            return this.initSVGDom();
        },
        initSVGDom: function () {
            let _this = this;
            const borderEle = this.ele.children('span').last();
            this.ele.empty();
            let result = _fetch(this.cropUrl)
                .then(function (res) {
                    return res.text();
                })
                .then(function (txt) {
                    let draw = SVG(_this.ele[0]);
                    let maskId = _this.uuid + "-crop-svg";
                    let reg = /<path(.)*?id="lhImageFrame"(.)*?class="(.)*?"/;
                    txt = txt.replace(
                        reg,
                        '<path class="imageHolderMaskPath" fill="none" '
                    );
                    draw.svg(txt);
                    let bbox = draw
                        .select("svg")
                        .members[0].attr("viewBox")
                        .split(" ");
                    _this.bbox = {
                        w: +bbox[2],
                        h: +bbox[3],
                    };
                    let maskPathDom = draw.select(".imageHolderMaskPath");
                    draw.clear().attr({
                        viewBox: `0 0 ${_this.cropBoxData.width} ${_this.cropBoxData.height}`,
                        preserveAspectRatio: "none",
                        overflow: "hidden",
                    });
                    draw.defs()
                        .clip()
                        .attr({
                            id: maskId,
                            transform: `scale(${
                                _this.cropBoxData.width / bbox[2]
                            }, ${_this.cropBoxData.height / bbox[3]})`,
                        })
                        .add(maskPathDom.members[0]);
                    draw.group()
                        .attr("clip-path", `url(#${maskId})`)
                        .image(handleAssetsUrl(_this.option.url))
                        .attr("preserveAspectRatio", "none")
                        .size(
                            _this.cropBoxData.originWidth,
                            _this.cropBoxData.originHeight
                        )
                        .move(
                            _this.cropBoxData.deltaX,
                            _this.cropBoxData.deltaY
                        );
                    _this.draw = draw;

                    if (borderEle.length) {
                        _this.ele.append(borderEle)
                    }
                    _this.setFilterCss();
                    // 加载先后问题，不然无法触发动画初始化
                    _this.effect.init(true);
                });
            return result;
        },
        getDomDiffId: function (name) {
            var cloneEle = this.ele.clone();
            if (this.cropType === "svg") {
                var diffId = this.id + "-" + (name || "diff") + "-crop-svg";
                cloneEle.find("clipPath").attr({
                    id: diffId,
                });
                cloneEle.find("g").attr({
                    "clip-path": "url(#" + diffId + ")",
                });
            }

            return cloneEle;
        },
        cancelCrop: function (data, undo) {
            if (undo) {
                var undoData = {};
                undoData.data = {
                    cropBoxData: Object.assign({}, this.cropBoxData),
                    cancelCropData: this.cancelCropData
                        ? Object.assign({}, this.cancelCropData)
                        : {
                              width: this.width,
                              height: this.height,
                              positionTop: this.positionTop,
                              positionLeft: this.positionLeft,
                          },
                    cropType: this.cropType,
                    url: this.cropUrl,
                };
                undoData.reData = {
                    cancelCropData: Object.assign({}, data),
                    cropType: "",
                };
                undoData.id = this.id;
                eve("undo_redo", null, { type: "cropImage", data: undoData });
            }
            var image = $("<img>", {
                src: handleAssetsUrl(this.option.url),
            }).css({
                width: "100%",
                height: "100%",
            });
            const borderEle = this.ele.children('span').last();
            this.ele.empty();
            this.ele.append(image);
            if (borderEle.length) {
                this.ele.append(borderEle)
            }
            this.cropType = "";
            this.cropBoxData = null;
            this.cropUrl = "";
            this.draw = null;
            this.bbox = null;
            this.cancelCropData = data ? data : this.cancelCropData;
            if (data) {
                this.width = data.width;
                this.height = data.height;
                this.positionLeft = data.positionLeft;
                this.positionTop = data.positionTop;
                this.rotate =
                    data.rotation == null ? this.rotate : data.rotation;
                this.changeStyle();
            }
            this.effect.init(true);
        },
        toJson: function (forId) {
            var d = this.cropBoxData || {};
            return Object.assign({}, this.supr(forId), {
                url: this.option.url,
                cropType: this.cropType,
                cropData: this.cropType
                    ? {
                          url: this.cropUrl,
                          width: d.width,
                          height: d.height,
                          originWidth: d.originWidth,
                          originHeight: d.originHeight,
                          deltaX: d.deltaX,
                          deltaY: d.deltaY,
                          innerRotation: d.innerRotation,
                      }
                    : null,
            });
        },
        mattingPicture: function () {
            const { width, height, helpEle } = this;
            this.opHelper.showHideEle(false);
            if (!this.opMatting) {
                this.opMatting = new OpMatting({ width, height, ele: helpEle });
                return;
            }
            this.opMatting.initEle({ width, height, ele: helpEle });
        },
        finishApiMatting: function ({ data }) {
            if (this.opMatting && this.opMatting.isMattingStatus === 2) {
                this.opMatting.finishMatting({
                    option: this.option,
                    url: data,
                    img: this.img,
                    id: this.id,
                });
            }
        },
    });

    //gif元素
    var GifSprite = SpriteEle.extend(function (type, ele, editor, option) {
        this.editor = editor;
        this.option = Object.assign({ isLoop: true }, option);
        this.isLoop = this.option.isLoop =
            typeof option.isLoop === "boolean" ? option.isLoop : true;
        this.numberOfLoops = this.option.numberOfLoops =
            option.numberOfLoops === undefined ? 5 : option.numberOfLoops;
        this.frames = [];
        this.pixelBuffer = null;
        this.canvas = document.createElement("canvas");
        this.imageData = null;
        this.frameRate = 0;
        this.totalFrames = 0;
    }).methods({
        _load: function (url) {
            return ImageLoader.load(url)
                .then((img) => {
                    var image = $("<img>", {
                        src: img.src,
                    }).css({
                        width: "100%",
                        height: "100%",
                    });
                    this.ele.empty();
                    this.ele.append(image.hide());

                    this.initData.width = img.width;
                    this.initData.height = img.height;
                    this.initData.scale = this.editor.scale;

                    // canvas初始化宽高
                    this.canvas.width = img.width;
                    this.canvas.height = img.height;
                    this.canvas.style.transformOrigin = "0 0";
                    this.canvas.style.float = "left";
                    this.canvas.getContext("2d").setTransform(1, 0, 0, 1, 0, 0);

                    if (this.isApngFilename(img.src)) {
                        this.contentCanvas = this.canvas.cloneNode(true);
                        this.contentCanvas.style.width = '100%';
                        this.contentCanvas.style.height = '100%';
                        this.ele.append(this.contentCanvas);
                    }
                    return this;
                })
                .catch((err) => {
                    if (this.option.allowFailed) {
                        this.ele.empty();
                        this.ele.append(this.loadFailedImg());
                        return this;
                    } else {
                        throw "Error:" + err;
                    }
                });
        },

        setOption: function (option) {
            return this.supr(this.option).then(() => {
                return this._load(handleAssetsUrl(option.url)).then(() => {
                    var parse = this.parseGif.bind(this);
                    if (this.isApngFilename(option.url)) {
                        parse = this.parseApng.bind(this);
                    }
                    return parse().then(() => {
                        this.ele.find("img").show();

                        if (this.option.fileType === 118) {
                            const dur = this.frames[this.frames.length - 1] / 60 * 1000;
                            setTimeout(() => {
                                const src = this.ele.find("img")[0].src;
                                this.ele.find("img")[0].src = src.replace(/\.gif$/, 'nail.png');
                            }, dur);
                        }

                        if (this.isApngFilename(option.url)) {
                            const apng = this.apng;

                            const _canvas = document.createElement('canvas');
                            _canvas.width = apng.width
                            _canvas.height = apng.height
                            _canvas.style.width = '100%';
                            _canvas.style.height = '100%';
                            _canvas.style.position = 'absolute';
                            _canvas.style.top = 0;
                            _canvas.style.left = 0;

                            apng.getPlayer(_canvas.getContext('2d')).then(p => {
                                const player = p

                                this.ele.find("img").hide();
                                this.ele.append(_canvas);
                                console.log(`Turbo ~ apng.getPlayer ~ _canvas`, _canvas)
                                player.play();

                                const dur = this.frames[this.frames.length - 1] / 60 * 1000;
                                setTimeout(() => {
                                    _canvas.remove();
                                    this.ele.find("img").show();
                                }, dur);

                            });
                        }

                        return this;
                    });
                });
            });
        },

        parseGif: function () {
            return new Promise((resolve, reject) => {
                let _this = this;
                let src = handleAssetsUrl(this.option.url);
                let h = new XMLHttpRequest();
                h.open("GET", src, true);
                h.responseType = "arraybuffer";
                h.onload = function () {
                    if (this.status != 200) {
                        reject("加载失败");
                        return;
                    }
                    for (let i = 0; i < SpriteEle.gifBuffer.length; i++) {
                        let v = SpriteEle.gifBuffer[i];
                        if (
                            _this.option.resourceId &&
                            v.id === _this.option.resourceId
                        ) {
                            v.index++;
                            _this.pixelBuffer = v.pixelBuffer;
                            _this.frames = v.frames;
                            _this.totalFrames = v.frames.length;
                            _this.frameRate =
                                v.frames[_this.totalFrames - 1] /
                                _this.totalFrames;
                            return resolve();
                        }
                    }
                    let reader = new GifReader(new Uint8Array(this.response));
                    if (reader.errorCode > 0 ) {
                        reject("解析失败")
                        return;
                    }
                    let frames = reader.frames;
                    let [width, height] = [reader.width, reader.height];
                    let pixelBuffer = new Uint8ClampedArray(
                        frames.length * width * height * 4
                    );
                    let frameArr = new Uint8ClampedArray(width * height * 4);
                    let last = { disposal: 0 };
                    let rate = _this.editor.option.frameRate;

                    _this.frames[0] = ((frames[0].delay || 10) / 100) * rate;
                    for (let i = 0; i < frames.length; i++) {
                        if (i !== 0) {
                            _this.frames[i] =
                                ((frames[i].delay || 10) / 100) * rate +
                                _this.frames[i - 1];
                            last = frames[i - 1];
                        }
                        if (last.disposal === 2) {
                            if (
                                !last.x &&
                                !last.y &&
                                last.width === width &&
                                last.height === height
                            ) {
                                frameArr = new Uint8ClampedArray(
                                    width * height * 4
                                );
                            } else {
                                let arrB = new Uint8ClampedArray(
                                    last.width * 4
                                );
                                for (let j = 0; j < last.height; j++) {
                                    frameArr.set(
                                        arrB,
                                        ((last.y + j) * width + last.x) * 4
                                    );
                                }
                            }
                        } else if (last.disposal === 3) {
                            frameArr = new Uint8ClampedArray(
                                width * height * 4
                            );
                        }
                        reader.decodeAndBlitFrameRGBA(i, frameArr);
                        pixelBuffer.set(frameArr, i * width * height * 4);
                    }
                    frameArr = null;
                    _this.pixelBuffer = pixelBuffer;
                    SpriteEle.gifBuffer.push({
                        id: _this.option.resourceId,
                        index: 0,
                        pixelBuffer: pixelBuffer,
                        frames: _this.frames,
                    });
                    _this.totalFrames = _this.frames.length;
                    _this.frameRate =
                        _this.frames[_this.totalFrames - 1] / _this.totalFrames;
                    reader = null;
                    h = null;
                    resolve();
                };
                h.onerror = function () {
                    reject("加载失败");
                };
                h.send();
            });
        },

        isApngFilename: function (url) {
            return /\.apng$/i.test(url || this.option.url);
        },

        parseApng: function () {
            return new Promise((resolve, reject) => {
                let _this = this;
                let src = handleAssetsUrl(this.option.url);
                let h = new XMLHttpRequest();
                h.open("GET", src, true);
                h.responseType = "arraybuffer";
                h.onload = function () {
                    if (this.status != 200) {
                        reject("加载失败");
                        return;
                    }

                    parseAPNG = window['apng-js'].default;
                    var apng = parseAPNG(this.response);
                    _this.apng = apng;
                    let frames = apng.frames;
                    let rate = _this.editor.option.frameRate;
                    for (let i = 0; i < frames.length; i++) {
                        if (i !== 0) {
                            _this.frames[i] =
                                ((frames[i].delay || 100) / 1000) * rate +
                                _this.frames[i - 1];

                        } else {
                            _this.frames[0] = ((frames[0].delay || 100) / 1000) * rate;
                        }
                    }
                    apng.createImages().then(() => {

                        const canvas = _this.canvas;
                        canvas.width = apng.width
                        canvas.height = apng.height

                        apng.getPlayer(canvas.getContext('2d')).then(p => {
                          _this.apngPlayer = p;
                          const player = p
                          player.play();
                          resolve();
                        });
                    });

                };

                h.onerror = function () {
                    reject("加载失败");
                };
                h.send();
            });
        },

        getNumUrl: function (i) {
            if (this.loadFailed) return;
            if (this.isApngFilename()) {
                return handleAssetsUrl(this.option.url);
            }
            let ctx = this.canvas.getContext("2d");
            let [w, h] = [this.initData.width, this.initData.height];
            let imageData = ctx.createImageData(w, h);
            imageData.data.set(
                this.pixelBuffer.subarray(i * w * h * 4, (+i + 1) * w * h * 4)
            );
            ctx.putImageData(imageData, 0, 0);
            imageData = null;
            return this.canvas.toDataURL();
        },

        initEffect: function (ps) {
            if (!this.frames.length) return;
            let [w, h] = [this.initData.width, this.initData.height];
            if (!this.isApngFilename()) {
                this.imageData = this.canvas.getContext("2d").createImageData(w, h);
            }
            this.canvas.style.transform = `scale(${this.width / w}, ${
                this.height / h
            })`;
            ps.empty().append($(this.canvas));
            if (this.border) ps.append(this.border.dom.clone());
            this.setFilter(this.filter);
        },

        sync_first: function () {
            if (this.imageData) {
                this.imageData.data.set(
                    this.pixelBuffer.subarray(
                        0,
                        this.initData.width * this.initData.height * 4
                    )
                );
                this.canvas.getContext("2d").putImageData(this.imageData, 0, 0);
            }
        },

        // 逐帧播放
        play: function (frame, contentCanvas, imageData) {
            if (this.isApngFilename()) {
                return this.playAPNG(frame);
            }
            imageData = imageData || this.imageData;
            if (!this.frames.length || !imageData) return;
            var total = this.frames.length - 1;
            var n = frame / this.frames[total];
            var frame = frame % this.frames[total];
            for (var i in this.frames) {
                if (frame < this.frames[i]) break;
            }
            if (!this.option.isLoop && this.numberOfLoops < n) {
                i = total;
            }
            let [w, h] = [this.initData.width, this.initData.height];
            imageData.data.set(
                this.pixelBuffer.subarray(i * w * h * 4, (+i + 1) * w * h * 4)
            );
            var canvas = contentCanvas || this.canvas;
            canvas.getContext("2d").putImageData(imageData, 0, 0);
        },

        playAPNG: function (frame) {
            var total = this.frames.length - 1;
            var n = frame / this.frames[total];
            var frame = frame % this.frames[total];
            for (var i in this.frames) {
                if (frame < this.frames[i]) break;
            }
            if (!this.option.isLoop && this.numberOfLoops < n) {
                i = total;
            }
            this.apngPlayer.jumpFrame(i);
        },

        setLoop: function (val, undo) {
            if (undo) {
                var undoData = {};
                undoData.reData = {
                    val: this.option.isLoop ? true : this.numberOfLoops,
                };
                undoData.sceneId = this.sceneId;
                undoData.id = this.id;
                undoData.data = {
                    val: val,
                };
                eve("undo_redo", null, { type: "setLoop", data: undoData });
            }
            if (typeof val === "boolean") {
                this.isLoop = this.option.isLoop = val;
            } else if (typeof val === "number") {
                this.option.isLoop = false;
                val = val > 10 ? 10 : val;
                this.numberOfLoops = val;
            }
        },

        getLoop: function () {
            return {
                isLoop: this.option.isLoop,
                numberOfLoops: this.numberOfLoops,
            };
        },

        toJson: function (forId) {
            return Object.assign({}, this.supr(forId), {
                url: this.option.url,
                isLoop: this.option.isLoop,
                numberOfLoops: this.numberOfLoops,
            });
        },

        removeSprite: function () {
            this.supr();
            this.effect = null;
            this.imageData = null;
            this.pixelBuffer = null;
            this.canvas = null;
            for (var i = 0; i < SpriteEle.gifBuffer.length; i++) {
                var v = SpriteEle.gifBuffer[i];
                if (v.id === this.option.resourceId) {
                    v.index--;
                    if (v.index < 0) {
                        v.pixelBuffer = null;
                        SpriteEle.gifBuffer.splice(i, 1);
                    }
                    break;
                }
            }
        },
    });

    var VirtualCharacterSprite = SpriteEle.extend(function (type, ele, editor, option) {
        this.editor = editor;
        this.option = Object.assign({ isLoop: true }, option);
        this.isLoop = this.option.isLoop =
            typeof option.isLoop === "boolean" ? option.isLoop : true;
        this.numberOfLoops = this.option.numberOfLoops =
            option.numberOfLoops === undefined ? 5 : option.numberOfLoops;
        this.frames = [];
        this.pixelBuffer = null;
        this.canvas = document.createElement("canvas");
        this.imageData = null;
        this.frameRate = 0;
        this.totalFrames = 0;
        this.parseAPNG = window['apng-js'].default;
        this.type = 'Gif';
    }).methods({
        _load: function (url) {
            return ImageLoader.load(url)
                .then((img) => {
                    var image = $("<img>", {
                        src: img.src,
                    }).css({
                        width: "100%",
                        height: "100%",
                    });
                    this.ele.empty();
                    this.ele.append(image.hide());

                    this.initData.width = img.width;
                    this.initData.height = img.height;
                    this.initData.scale = this.editor.scale;

                    // canvas初始化宽高
                    this.canvas.width = img.width;
                    this.canvas.height = img.height;
                    this.canvas.style.transformOrigin = "0 0";
                    this.canvas.style.float = "left";
                    this.canvas.getContext("2d").setTransform(1, 0, 0, 1, 0, 0);

                    return this;
                })
                .catch((err) => {
                    if (this.option.allowFailed) {
                        this.ele.empty();
                        this.ele.append(this.loadFailedImg());
                        return this;
                    } else {
                        throw "Error:" + err;
                    }
                });
        },
        setOption: function (option) {
            return this.supr(this.option).then(() => {
                return this._load(handleAssetsUrl(option.url)).then(() => {

                    return this.parseImage().then(() => {
                        this.ele.find("img").show();

                        const apng = this.apng;
                        const _canvas = document.createElement('canvas');
                        _canvas.width = apng.width
                        _canvas.height = apng.height
                        _canvas.style.width = '100%';
                        _canvas.style.height = '100%';
                        _canvas.style.position = 'absolute';
                        _canvas.style.top = 0;
                        _canvas.style.left = 0;

                        apng.getPlayer(_canvas.getContext('2d')).then(p => {
                            const player = p

                            this.ele.find("img").hide();
                            this.ele.append(_canvas);
                            console.log(`Turbo ~ apng.getPlayer ~ _canvas`, _canvas)
                            player.play();

                            const dur = this.frames[this.frames.length - 1] / 60 * 1000;
                            setTimeout(() => {
                                _canvas.remove();
                                this.ele.find("img").show();
                            }, dur);

                        });

                        return this;
                    });
                });
            });
        },

        parseImage () {
            return new Promise((resolve, reject) => {
                let _this = this;
                let src = handleAssetsUrl(this.option.url);
                let h = new XMLHttpRequest();
                h.open("GET", src, true);
                h.responseType = "arraybuffer";
                h.onload = function () {
                    if (this.status != 200) {
                        reject("加载失败");
                        return;
                    }

                    var apng = _this.parseAPNG(this.response);
                    _this.apng = apng;
                    let frames = apng.frames;
                    let rate = _this.editor.option.frameRate;
                    for (let i = 0; i < frames.length; i++) {
                        if (i !== 0) {
                            _this.frames[i] =
                                ((frames[i].delay || 100) / 1000) * rate +
                                _this.frames[i - 1];

                        } else {
                            _this.frames[0] = ((frames[0].delay || 100) / 1000) * rate;
                        }
                    }
                    apng.createImages().then(() => {

                        const canvas = _this.canvas;
                        canvas.width = apng.width
                        canvas.height = apng.height

                        apng.getPlayer(canvas.getContext('2d')).then(p => {
                          _this.apngPlayer = p;
                          const player = p
                          player.play();
                          resolve();
                        });
                      })

                };
                h.onerror = function () {
                    reject("加载失败");
                };
                h.send();
            }).catch(e => {

            });
        },

        getNumUrl: function (i) {
            // if (this.loadFailed) return;
            // let ctx = this.canvas.getContext("2d");
            // let [w, h] = [this.initData.width, this.initData.height];
            // let imageData = ctx.createImageData(w, h);
            // imageData.data.set(
            //     this.pixelBuffer.subarray(i * w * h * 4, (+i + 1) * w * h * 4)
            // );
            // ctx.putImageData(imageData, 0, 0);
            // imageData = null;
            // return this.canvas.toDataURL();
            return handleAssetsUrl(this.option.url);
        },

        initEffect: function (ps) {
            // if (!this.frames.length) return;
            let [w, h] = [this.initData.width, this.initData.height];
            this.imageData = this.canvas.getContext("2d").createImageData(w, h);
            this.canvas.style.transform = `scale(${this.width / w}, ${
                this.height / h
            })`;
            ps.empty().append($(this.canvas));
            if (this.border) ps.append(this.border.dom.clone());
            this.setFilter(this.filter);
        },

        sync_first: function () {
            // if (this.imageData) {
            //     this.imageData.data.set(
            //         this.pixelBuffer.subarray(
            //             0,
            //             this.initData.width * this.initData.height * 4
            //         )
            //     );
            //     this.canvas.getContext("2d").putImageData(this.imageData, 0, 0);
            // }
        },

        // 逐帧播放
        play: function (frame) {
            // imageData = imageData || this.imageData;
            // if (!this.frames.length || !imageData) return;
            var total = this.frames.length - 1;
            var n = frame / this.frames[total];
            var frame = frame % this.frames[total];
            for (var i in this.frames) {
                if (frame < this.frames[i]) break;
            }
            if (!this.option.isLoop && this.numberOfLoops < n) {
                i = total;
            }

            // const framesPerMillisecond = 60 / 1000;
            this.apngPlayer.jumpFrame(i);

            // let [w, h] = [this.initData.width, this.initData.height];
            // imageData.data.set(
            //     this.pixelBuffer.subarray(i * w * h * 4, (+i + 1) * w * h * 4)
            // );
            // var canvas = contentCanvas || this.canvas;
            // canvas.getContext("2d").putImageData(imageData, 0, 0);
        },

        setLoop: function (val, undo) {
            if (undo) {
                var undoData = {};
                undoData.reData = {
                    val: this.option.isLoop ? true : this.numberOfLoops,
                };
                undoData.sceneId = this.sceneId;
                undoData.id = this.id;
                undoData.data = {
                    val: val,
                };
                eve("undo_redo", null, { type: "setLoop", data: undoData });
            }
            if (typeof val === "boolean") {
                this.isLoop = this.option.isLoop = val;
            } else if (typeof val === "number") {
                this.option.isLoop = false;
                val = val > 10 ? 10 : val;
                this.numberOfLoops = val;
            }
        },

        getLoop: function () {
            return {
                isLoop: this.option.isLoop,
                numberOfLoops: this.numberOfLoops,
            };
        },

        toJson: function (forId) {
            return Object.assign({}, this.supr(forId), {
                url: this.option.url,
                isLoop: this.option.isLoop,
                numberOfLoops: this.numberOfLoops,
            });
        },

        removeSprite: function () {
            this.supr();
            this.effect = null;
            this.imageData = null;
            this.pixelBuffer = null;
            this.canvas = null;
            for (var i = 0; i < SpriteEle.gifBuffer.length; i++) {
                var v = SpriteEle.gifBuffer[i];
                if (v.id === this.option.resourceId) {
                    v.index--;
                    if (v.index < 0) {
                        v.pixelBuffer = null;
                        SpriteEle.gifBuffer.splice(i, 1);
                    }
                    break;
                }
            }
        }
    });

    //文字元素
    var TextSprite = SpriteEle.extend(function (type, ele, editor, option) {
        option.id;
        this.text = option.text || "";
        this.artType = option.artType;
        this.font = Object.assign(
            {
                color: "#5779fa",
                fontSize: 24,
                fontFamilyUrl: "2018-5-16/1526467728442.TTF",
                fontStretch: "normal",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                textAlign: "left",
                wordBreak: "break-word",
                title: "方正黑体简体",
                id: "e629e28b-df72-4767-a6d3-695c50c841e7",
            },
            this.font,
            option.font
        );

        this.versionAnyway = option.versionAnyway || "Horizontal"; // Vertical -- 竖版
        switch (
            option.versionAnyway // 横竖版
        ) {
            case "Vertical": // 竖版
                this.font.writingMode = "vertical-rl";
                break;
            default:
                this.font.writingMode = "inherit";
        }

        this.artStyle = AnimEditor.getArtStyle(
            option.artType,
            this.font.color,
            this.font.fontSize
        );
        if (option.width) {
            this.width = option.width;
        }
        if (option.height) {
            this.height = option.height;
        }
        this.opacity = option.opacity || 1;
        if (option.positionTop) {
            this.positionTop = option.positionTop;
        }
        if (option.positionLeft) {
            this.positionLeft = option.positionLeft;
        }
        this.lineHeight = option.lineHeight || 1;
        this.letterSpacing = option.letterSpacing || 0;

        //this.updateEffect({code: 'write'});
    })
        .statics({
            MIN_FONTSIZE: 6,
            MAX_FONTSIZE: 500,
            // 添加文本的样式继承上次的样式
            fontId: "",
            font: {
                color: "#303233",
                fontFamilyUrl: "2018-5-16/1526467728442.TTF",
                fontSize: 50,
                fontStretch: "normal",
                fontStyle: "normal",
                fontWeight: "normal",
                textAlign: "center",
                textDecoration: "none",
                wordBreak: "break-word",
            },
            versionAnyway: "Horizontal",
        })
        .methods({
            setOption: function (option) {
                var _this = this;
                return this.supr().then(function () {
                    var artStyle = AnimEditor.getArtStyle(
                        option.artType,
                        _this.font.color,
                        _this.font.fontSize
                    );
                    if (artStyle && artStyle.color) {
                        _this.font.color =
                            _this.artType === "Inset"
                                ? artStyle.backgroundColor
                                : artStyle.color;
                        option.artType !== "Inset" &&
                            delete _this.artStyle.color;
                        option.artType !== "Inset" && delete artStyle.color;
                    }
                    var textBox = $("<div autofocus></div>")
                        .css(_this.font)
                        .css(
                            "fontFamily",
                            '"' +
                                _this.font.fontFamilyUrl.split("/").pop() +
                                '"'
                        )
                        .css({ "white-space": "pre-wrap" })
                        .css({ lineHeight: _this.lineHeight })
                        .css({
                            letterSpacing:
                                _this.letterSpacing *
                                    ~~(parseInt(_this.font.fontSize) / 10) +
                                "px",
                        })
                        .css(artStyle || {})
                        .css({
                            "-webkit-background-clip": "text",
                        });
                    if (_this.text) {
                        textBox.html(_this.text);
                        _this.ele.empty().append(textBox);
                    }
                    _this.initData.width = option.width || textBox.width();
                    _this.initData.height = option.height || textBox.height();
                    _this.initData.rotate = option.rotate || 0;

                    switch (
                        _this.versionAnyway // 横竖版
                    ) {
                        case "Vertical": // 竖版
                            !option.height && (_this.initData.height *= 1.5);
                            textBox.css({
                                width: "auto",
                                height: _this.initData.height + "px",
                                transform:
                                    "scale(" + 1 / _this.editor.scale + ")",
                                transformOrigin: "0px 0px 0px",
                            });
                            break;
                        default:
                            !option.width &&
                                (_this.initData.width +=
                                    60 * 2 * _this.editor.scale);
                            textBox.css({
                                height: "auto",
                                width: _this.initData.width + "px",
                                transform:
                                    "scale(" + 1 / _this.editor.scale + ")",
                                transformOrigin: "0px 0px 0px",
                            });
                    }
                    // 最小拉伸宽度等于最大单个文字宽度
                    _this.minWidth = _this.font.fontSize / _this.editor.scale;

                    _this.initData.scale = _this.editor.scale;

                    if (_this.positionTop) {
                        _this.positionTop = _this.positionTop;
                    }
                    if (_this.positionLeft) {
                        _this.positionLeft = _this.positionLeft;
                    }
                    TextSprite.font = JSON.parse(JSON.stringify(_this.font));
                    TextSprite.fontId = _this.option.resourceId;
                    TextSprite.versionAnyway = _this.versionAnyway;
                    return Promise.resolve(_this);
                });
            },
            updateSprite: function (option) {
                var _this = this;
                option.resourceId &&
                    (this.option.resourceId = option.resourceId);
                // 组合素材的切换字体会去掉groupId防止用户免费使用付费字体
                if (
                    option.font &&
                    option.font.fontFamilyUrl &&
                    this.font.fontFamilyUrl !== option.font.fontFamilyUrl
                ) {
                    this.groupId = false;
                }
                return this.supr().then(function () {
                    switch (
                        _this.versionAnyway // 横竖版
                    ) {
                        case "Vertical": // 竖版
                            if (_this.font.textDecoration) {
                                _this.font.textDecoration = "none";
                                _this.option.font.textDecoration = "none";
                            }
                            if (_this.font["text-decoration"]) {
                                _this.font["text-decoration"] = "none";
                                _this.option.font["text-decoration"] = "none";
                            }
                            _this.artSetting({});
                            break;
                    }
                    _this.text = option.text || _this.text;
                    _this.font = Object.assign({}, _this.font, option.font);
                    _this.artStyle = AnimEditor.getArtStyle(
                        _this.artType,
                        _this.font.color,
                        _this.font.fontSize
                    );
                    _this.positionLeft =
                        parseFloat(option.positionLeft) || _this.positionLeft;
                    _this.positionTop =
                        parseFloat(option.positionTop) || _this.positionTop;
                    _this.lineHeight =
                        option.lineHeight || _this.lineHeight || 1;
                    _this.letterSpacing =
                        typeof option.letterSpacing === "number"
                            ? option.letterSpacing
                            : _this.letterSpacing;
                    var textBox = _this.ele
                        .children("div")
                        .css(_this.font)
                        .css(
                            "fontFamily",
                            '"' +
                                _this.font.fontFamilyUrl.split("/").pop() +
                                '"'
                        )
                        .css({ lineHeight: _this.lineHeight })
                        .css({
                            letterSpacing:
                                _this.letterSpacing *
                                    ~~(parseInt(_this.font.fontSize) / 10) +
                                "px",
                        });

                    if (_this.artStyle) {
                        textBox = _this.ele.children("div").css(_this.artStyle);
                    }

                    if (_this.artStyle && _this.artStyle.color) {
                        _this.font.color =
                            _this.artType === "Inset"
                                ? _this.artStyle.backgroundColor
                                : _this.artStyle.color;
                        _this.artType !== "Inset" &&
                            delete _this.artStyle.color;
                    }
                    textBox.empty().html(_this.text);
                    switch (
                        _this.versionAnyway // 横竖版
                    ) {
                        case "Vertical": // 竖版
                            _this.font.writingMode = "vertical-rl";
                            textBox.css({
                                width: "auto",
                                height:
                                    _this.height * _this.editor.scale + "px",
                                "writing-mode": "vertical-rl",
                            });
                            break;
                        default:
                            _this.font.writingMode = "inherit";
                            textBox.css({
                                width: _this.width * _this.editor.scale + "px",
                                height: "auto",
                                "writing-mode": "inherit",
                            });
                    }
                    _this.minWidth = _this.font.fontSize / _this.editor.scale;
                    _this.ele.show();

                    _this.width = textBox.width() / _this.editor.scale;
                    _this.height = textBox.height() / _this.editor.scale;

                    _this.changeStyle({ sync: true });
                    // _this.showHideHandle(true);
                    _this.editor.disabled = false;
                    TextSprite.fontId = _this.option.resourceId;
                    TextSprite.font = JSON.parse(JSON.stringify(_this.font));
                    eve("changeTextOption", null, _this);
                    return _this;
                });
            },

            toJson: function (forId) {
                return Object.assign({}, this.supr(forId), {
                    artType: this.artType || "",
                    artStyle: this.artStyle,
                    text: this.text,
                    font: this.font,
                    characterSpacing: this.letterSpacing || 0,
                    lineSpacing: this.lineHeight || 1,
                    versionAnyway: this.versionAnyway,
                    fileType: 15,
                });
            },

            setversionAnyway: function (data) {
                let datas = data || "Horizontal";
                if (datas == this.versionAnyway) return;

                var textBox = this.ele.children("div");
                switch (data) {
                    case "Vertical":
                        this.versionAnyway = "Vertical"; // Vertical -- 竖版
                        this.height = textBox.width() / this.editor.scale;
                        this.width = textBox.height() / this.editor.scale;
                        break;
                    case "Horizontal":
                    default:
                        this.versionAnyway = "Horizontal"; // Vertical -- 竖版
                        this.width = textBox.height() / this.editor.scale;
                        this.height = textBox.width() / this.editor.scale;
                        break;
                }
                this.helpEle.empty();
                this.opHelper = new OpHelper(this.helpEle, this, {});

                switch (this.versionAnyway) {
                    case "Vertical": // 竖版
                        this.font.writingMode = "vertical-rl";
                        break;
                    default:
                        this.font.writingMode = "inherit";
                }
                TextSprite.versionAnyway = this.versionAnyway;
                this.updateSprite({});
                if (this.effect.code !== "None") {
                    this.effect.init(true);
                }
            },
            initEffect: function (ps) {
                // 绑定播放层的image标签
                if (!this.artType) return;
                this.artControl = [];
                AnimEditor.artTextInit(this.artType, ps, this.artControl);
                this.dropShadow &&
                    this.artControl.push(
                        "drop-shadow(" + this.getShadowCss("dropShadow") + ")"
                    );
            },
            play: function (frame) {
                if (!this.artType) return;
                var data = {
                    editorScale: this.editor.scale,
                    size: this.font.fontSize,
                    color: this.font.color,
                };
                var frameRate = this.editor.option.frameRate;
                AnimEditor.artTextPlay(
                    this.artType,
                    data,
                    this.artControl,
                    frame,
                    frameRate
                );
            },
            artSetting: function (data, undo) {
                // 艺术字切换，取消
                if (undo) {
                    var undoData = {};
                    undoData.scenesId = this.scenesId;
                    undoData.id = this.id;
                    undoData.reData = {
                        artType: this.artType,
                        artStyle: Object.assign({}, this.artStyle, {
                            color: this.font.color,
                        }),
                    };
                    undoData.data = $.extend(true, {}, data);
                    eve("undo_redo", null, {
                        type: "artSetting",
                        data: undoData,
                    });
                }
                this.ele.children("div").css({
                    "text-shadow": "none",
                    background: "transparent",
                    // 'filter'      : 'none',
                    "-webkit-background-clip": "text",
                    color: this.font.color,
                });
                if (!data.artType) {
                    this.artType = "";
                    this.artStyle = {};
                    if (this.artControl) {
                        for (var i = 0; i < this.artControl.length; i++) {
                            this.artControl[i].remove();
                        }
                        this.artControl = [];
                    }
                    if (data.artStyle && data.artStyle.color) {
                        this.ele
                            .children("div")
                            .css({ color: data.artStyle.color });
                        this.font.color = data.artStyle.color;
                    }
                } else {
                    // 组合素材的切换艺术字会去掉groupId防止用户免费使用付费艺术字
                    if (this.artType !== data.artType) {
                        this.groupId = false;
                    }
                    this.artType = data.artType;
                    this.artStyle = AnimEditor.getArtStyle(
                        data.artType,
                        this.font.color,
                        this.font.fontSize
                    );
                    if (this.artType === "Inset")
                        this.artStyle.color = "transparent";
                    this.ele.children("div").css(this.artStyle);
                    if (this.artStyle.color) {
                        this.font.color =
                            this.artType === "Inset"
                                ? this.artStyle.backgroundColor
                                : this.artStyle.color;
                        this.artType !== "Inset" && delete this.artStyle.color;
                    }
                }

                this.effect.init(true);
            },
            playSyncContent: function () {
                this.supr();
                this.ele.children().css({
                    color: this.font.color,
                });
            },
        });

    // 图表类
    var ChartSprite = SpriteEle.extend(function (type, ele, editor, option) {
        this.width = option.width || 600;
        this.height = option.height || 300;
        this.chartOption = Object.assign(
            {},
            this.chartOption,
            option.chartOption
        );
    })
        .statics({
            chartBoxId: 0,
            chartFromJson: function (option) {
                var newOption = {};
                switch (option.chartType) {
                    case "BarChart":
                        newOption.chartOption = {
                            title: {
                                show: option.data.isShowTitle,
                                text: option.data.title || "图表标题",
                                left: "center",
                                top: "top",
                                textStyle: {
                                    fontFamily:
                                        option.style.titleFormat.fontFamily,
                                    fontSize: option.style.titleFormat.fontSize,
                                    color: option.style.titleFormat.foreground,
                                    fontWeight: option.style.titleFormat.isBold
                                        ? "bold"
                                        : "normal",
                                },
                            },
                            color: option.style.colorSpace,
                            legend: {
                                show: option.data.isShowLegend,
                                orient:
                                    option.data.legendPosition === 0
                                        ? "vertical"
                                        : "horizontal",
                                left:
                                    option.data.legendPosition === 0
                                        ? "right"
                                        : "center",
                                top:
                                    option.data.legendPosition === 0
                                        ? "middle"
                                        : "bottom",
                                align: "left",
                                textStyle: {
                                    fontFamily:
                                        option.style.legendStyle.labelFormat
                                            .fontFamily,
                                    fontSize:
                                        option.style.legendStyle.labelFormat
                                            .fontSize,
                                    color: option.style.legendStyle.labelFormat
                                        .foreground,
                                    fontWeight: option.style.legendStyle
                                        .labelFormat.isBold
                                        ? "bold"
                                        : "normal",
                                },
                                itemWidth:
                                    option.style.legendStyle.colorBlockWidth,
                                itemHeight:
                                    option.style.legendStyle.colorBlockHeight,
                                data: [],
                            },
                            grid: {
                                bottom:
                                    option.data.legendPosition === 0 ? 30 : 50,
                                // height: option.style.axisStyle.dataAreaHeight
                            },
                            animation: false,
                            xAxis: {
                                type: "category",
                                boundaryGap: [0, 0.01],
                                // name: '商品名称',
                                // nameGap: 30,
                                // nameLocation: 'center',
                                data: [],
                                axisLabel: {
                                    show: option.data.isShowGroupLabels,
                                    interval: 0,
                                    fontFamily:
                                        option.style.groupLabelFormat
                                            .fontFamily,
                                    fontSize:
                                        option.style.groupLabelFormat.fontSize,
                                    color: option.style.groupLabelFormat
                                        .foreground,
                                    fontWeight: option.style.groupLabelFormat
                                        .isBold
                                        ? "bold"
                                        : "normal",
                                },
                                axisLine: {
                                    onZero: false,
                                    symbol: ["none", "arrow"],
                                    symbolSize: [
                                        option.style.axisStyle.arrowWidth,
                                        option.style.axisStyle.arrowHeight,
                                    ],
                                    lineStyle: {
                                        width: option.style.axisStyle.lineWidth,
                                        color: option.style.axisStyle.lineColor,
                                    },
                                },
                                axisTick: {
                                    show: false,
                                    alignWithLabel: true,
                                },
                            },
                            yAxis: {
                                type: "value",
                                axisLabel: {
                                    interval: 0,
                                    fontFamily:
                                        option.style.axisStyle.valueMarkerFormat
                                            .fontFamily,
                                    fontSize:
                                        option.style.axisStyle.valueMarkerFormat
                                            .fontSize,
                                    color: option.style.axisStyle
                                        .valueMarkerFormat.foreground,
                                    fontWeight: option.style.axisStyle
                                        .valueMarkerFormat.isBold
                                        ? "bold"
                                        : "normal",
                                },
                                axisLine: {
                                    symbol: ["none", "arrow"],
                                    symbolSize: [
                                        option.style.axisStyle.arrowWidth,
                                        option.style.axisStyle.arrowHeight,
                                    ],
                                    lineStyle: {
                                        width: option.style.axisStyle.lineWidth,
                                        color: option.style.axisStyle.lineColor,
                                    },
                                },
                                axisTick: {
                                    inside: true,
                                    lineStyle: {
                                        width: option.style.axisStyle
                                            .valueMarkerLineLength,
                                    },
                                },
                                splitLine: {
                                    show: false,
                                },
                            },
                            series: [],
                        };
                        option.data.data[0].forEach(function (value, index) {
                            if (value) {
                                newOption.chartOption.xAxis.data.push(
                                    option.data.groupLabels[index]
                                );
                            }
                        });
                        option.data.legendItemLabels.forEach(function (
                            serie,
                            index
                        ) {
                            if (!option.data.data[index]) {
                                return;
                            }
                            if (option.data.data[index][0]) {
                                newOption.chartOption.legend.data.push({
                                    name: serie,
                                    icon: "rect",
                                });
                                newOption.chartOption.series.push({
                                    type: "bar",
                                    data: option.data.data[index],
                                    name: serie,
                                    label: {
                                        show: option.data.isShowDataValues,
                                        position: "insideTop",
                                        color: option.style.dataLabelFormat
                                            .foreground,
                                        fontSize:
                                            option.style.dataLabelFormat
                                                .fontSize,
                                        fontWeight: option.style.dataLabelFormat
                                            .isBold
                                            ? "bold"
                                            : "normal",
                                        fontFamily:
                                            option.style.dataLabelFormat
                                                .fontFamily,
                                    },
                                    itemStyle: {
                                        borderWidth:
                                            option.style.barBorderWidth,
                                        borderColor:
                                            option.style.barBorderColor,
                                    },
                                    barMaxWidth: option.style.barMaxWidth,
                                    barGap: "20%",
                                    barCategoryGap: "30%",
                                });
                            }
                        });
                        break;
                    case "LineChart":
                        newOption.chartOption = {
                            title: {
                                show: option.data.isShowTitle,
                                text: option.data.title || "图表标题",
                                left: "center",
                                top: "top",
                                textStyle: {
                                    fontFamily:
                                        option.style.titleFormat.fontFamily,
                                    fontSize: option.style.titleFormat.fontSize,
                                    color: option.style.titleFormat.foreground,
                                    fontWeight: option.style.titleFormat.isBold
                                        ? "bold"
                                        : "normal",
                                },
                            },
                            color: option.style.colorSpace,
                            legend: {
                                show: option.data.isShowLegend,
                                orient:
                                    option.data.legendPosition === 0
                                        ? "vertical"
                                        : "horizontal",
                                left:
                                    option.data.legendPosition === 0
                                        ? "right"
                                        : "center",
                                top:
                                    option.data.legendPosition === 0
                                        ? "middle"
                                        : "bottom",
                                align: "left",
                                textStyle: {
                                    fontFamily:
                                        option.style.legendStyle.labelFormat
                                            .fontFamily,
                                    fontSize:
                                        option.style.legendStyle.labelFormat
                                            .fontSize,
                                    color: option.style.legendStyle.labelFormat
                                        .foreground,
                                    fontWeight: option.style.legendStyle
                                        .labelFormat.isBold
                                        ? "bold"
                                        : "normal",
                                },
                                itemWidth:
                                    option.style.legendStyle.colorBlockWidth,
                                itemHeight:
                                    option.style.legendStyle.colorBlockHeight,
                                data: [],
                            },
                            grid: {
                                bottom:
                                    option.data.legendPosition === 0 ? 30 : 50,
                                // width: option.style.dataAreaWidth,
                                // height: option.style.axisStyle.dataAreaHeight
                            },
                            animation: false,
                            xAxis: {
                                type: "category",
                                boundaryGap: [0, 0.01],
                                // name: '商品名称',
                                // nameGap: 30,
                                // nameLocation: 'center',
                                data: [],
                                axisLabel: {
                                    show: option.data.isShowGroupLabels,
                                    interval: 0,
                                    fontFamily:
                                        option.style.groupLabelFormat
                                            .fontFamily,
                                    fontSize:
                                        option.style.groupLabelFormat.fontSize,
                                    color: option.style.groupLabelFormat
                                        .foreground,
                                    fontWeight: option.style.groupLabelFormat
                                        .isBold
                                        ? "bold"
                                        : "normal",
                                },
                                axisLine: {
                                    onZero: false,
                                    symbol: ["none", "arrow"],
                                    symbolSize: [
                                        option.style.axisStyle.arrowWidth,
                                        option.style.axisStyle.arrowHeight,
                                    ],
                                    lineStyle: {
                                        width: option.style.axisStyle.lineWidth,
                                        color: option.style.axisStyle.lineColor,
                                    },
                                },
                                axisTick: {
                                    show: false,
                                    alignWithLabel: true,
                                },
                            },
                            yAxis: {
                                type: "value",
                                axisLabel: {
                                    interval: 0,
                                    fontFamily:
                                        option.style.axisStyle.valueMarkerFormat
                                            .fontFamily,
                                    fontSize:
                                        option.style.axisStyle.valueMarkerFormat
                                            .fontSize,
                                    color: option.style.axisStyle
                                        .valueMarkerFormat.foreground,
                                    fontWeight: option.style.axisStyle
                                        .valueMarkerFormat.isBold
                                        ? "bold"
                                        : "normal",
                                },
                                axisLine: {
                                    symbol: ["none", "arrow"],
                                    symbolSize: [
                                        option.style.axisStyle.arrowWidth,
                                        option.style.axisStyle.arrowHeight,
                                    ],
                                    lineStyle: {
                                        width: option.style.axisStyle.lineWidth,
                                        color: option.style.axisStyle.lineColor,
                                    },
                                },
                                axisTick: {
                                    inside: true,
                                    lineStyle: {
                                        width: option.style.axisStyle
                                            .valueMarkerLineLength,
                                    },
                                },
                                splitLine: {
                                    show: false,
                                },
                            },
                            series: [],
                        };
                        option.data.data[0].forEach(function (value, index) {
                            if (value) {
                                newOption.chartOption.xAxis.data.push(
                                    option.data.groupLabels[index]
                                );
                            }
                        });
                        option.data.legendItemLabels.forEach(function (
                            serie,
                            index
                        ) {
                            if (!option.data.data[index]) {
                                return;
                            }
                            if (option.data.data[index][0]) {
                                newOption.chartOption.legend.data.push({
                                    name: serie,
                                    icon: "rect",
                                });
                            }
                            newOption.chartOption.series.push({
                                type: "line",
                                symbol:
                                    option.style.dotShape === 0
                                        ? "circle"
                                        : option.style.dotShape === 1
                                        ? "triangle"
                                        : "rect",
                                symbolSize: [
                                    option.style.dotSizeWidth,
                                    option.style.dotSizeHeight,
                                ],
                                data: option.data.data[index],
                                name: serie,
                                label: {
                                    show: option.data.isShowDataValues,
                                    position: "bottom",
                                    color: option.style.dataLabelFormat
                                        .foreground,
                                    fontSize:
                                        option.style.dataLabelFormat.fontSize,
                                    fontWeight: option.style.dataLabelFormat
                                        .isBold
                                        ? "bold"
                                        : "normal",
                                    fontFamily:
                                        option.style.dataLabelFormat.fontFamily,
                                },
                                lineStyle: {
                                    width: option.style.lineWidth,
                                },
                            });
                        });
                        // option.data.groupLabels.forEach(function (index, category) {
                        // });
                        break;
                    case "PieChart":
                        newOption.chartOption = {
                            title: {
                                show: option.data.isShowTitle,
                                text: option.data.title || "图表标题",
                                left: "center",
                                top: "top",
                                textStyle: {
                                    fontFamily:
                                        option.style.titleFormat.fontFamily,
                                    fontSize: option.style.titleFormat.fontSize,
                                    color: option.style.titleFormat.foreground,
                                    fontWeight: option.style.titleFormat.isBold
                                        ? "bold"
                                        : "normal",
                                },
                            },
                            color: option.style.colorSpace,
                            animation: false,
                            legend: {
                                show: option.data.isShowLegend,
                                orient:
                                    option.data.legendPosition === 0
                                        ? "vertical"
                                        : "horizontal",
                                left:
                                    option.data.legendPosition === 0
                                        ? "right"
                                        : "center",
                                top:
                                    option.data.legendPosition === 0
                                        ? "middle"
                                        : "bottom",
                                align: "left",
                                textStyle: {
                                    fontFamily:
                                        option.style.legendStyle.labelFormat
                                            .fontFamily,
                                    fontSize:
                                        option.style.legendStyle.labelFormat
                                            .fontSize,
                                    color: option.style.legendStyle.labelFormat
                                        .foreground,
                                    fontWeight: option.style.legendStyle
                                        .labelFormat.isBold
                                        ? "bold"
                                        : "normal",
                                },
                                itemWidth:
                                    option.style.legendStyle.colorBlockWidth,
                                itemHeight:
                                    option.style.legendStyle.colorBlockHeight,
                                data: [],
                            },
                            series: [
                                {
                                    name: option.data.legendItemLabels[0],
                                    type: "pie",
                                    // radius: '70%',
                                    // radius: option.style.radius,
                                    radius: "70%",
                                    center: ["50%", "50%"],
                                    data: [],
                                    label: {
                                        show: option.data.isShowDataValues,
                                        position: "inside",
                                        color: option.style.dataLabelFormat
                                            .foreground,
                                        fontSize:
                                            option.style.dataLabelFormat
                                                .fontSize,
                                        fontWeight: option.style.dataLabelFormat
                                            .isBold
                                            ? "bold"
                                            : "normal",
                                        fontFamily:
                                            option.style.dataLabelFormat
                                                .fontFamily,
                                        formatter: "{d}%",
                                    },
                                    itemStyle: {
                                        borderWidth:
                                            option.style.borderWidth || 2,
                                        borderColor: option.style.borderColor,
                                    },
                                },
                            ],
                        };
                        option.data.data[0].forEach(function (value, index) {
                            if (value) {
                                newOption.chartOption.series[0].data.push({
                                    value: value,
                                    name: option.data.groupLabels[index],
                                });
                                newOption.chartOption.legend.data.push({
                                    name: option.data.groupLabels[index],
                                    icon: "rect",
                                });
                            }
                        });
                        break;
                    default:
                        break;
                }

                return newOption.chartOption;
            },
        })
        .methods({
            // 在document中插入canvas，然后生成图片插入ele
            setOption: function () {
                var _this = this;
                return this.supr().then(function () {
                    var chartBox = $("<div></div>")
                        .css({ width: _this.width, height: _this.height })
                        .attr("id", "chartBox-" + ChartSprite.chartBoxId++);
                    $("body").append(chartBox);
                    if (_this.chartOption) {
                        // 基于准备好的dom，初始化echarts实例
                        chartBox.css({
                            width: _this.width,
                            height: _this.height,
                        });
                        // 2018.5.24 echarts4.1.0rc2版本使用svg渲染柱状图时label有bug，暂时使用canvas渲染
                        _this.myChart = echarts.init(chartBox[0], null, {
                            renderer: "canvas",
                        });

                        // 指定图表的配置项和数据

                        // 使用刚指定的配置项和数据显示图表。
                        _this.myChart.clear();
                        _this.myChart.setOption(_this.chartOption);
                    }
                    chartBox.hide();
                    // 在ele中插入刚生成的图表的图片
                    _this.ele.append(
                        $("<img>")
                            .attr("src", _this.myChart.getDataURL())
                            .css({ width: "100%", height: "100%" })
                    );

                    _this.initData.scale = _this.editor.scale;

                    if (_this.positionTop) {
                        _this.positionTop =
                            _this.positionTop -
                            (_this.height * (_this.editor.scale - 1)) /
                                2 /
                                _this.editor.scale;
                    } else {
                        _this.positionTop =
                            (_this.editor.clientHeight - _this.height) / 2;
                    }
                    if (_this.positionLeft) {
                        _this.positionLeft =
                            _this.positionLeft -
                            (_this.width * (_this.editor.scale - 1)) /
                                2 /
                                _this.editor.scale;
                    } else {
                        _this.positionLeft =
                            (_this.editor.clientWidth - _this.width) / 2;
                    }
                    return _this;
                });
            },
            updateSprite: function (option) {
                var _this = this;
                _this.option = Object.assign(_this.option, option);
                _this.chartOption = Object.assign({}, _this.option.chartOption);
                return this.supr().then(function () {
                    _this.width = _this.ele.width();
                    _this.height = _this.ele.height();
                    _this.myChart.clear();
                    _this.myChart.setOption(_this.option.chartOption);
                    _this.changeStyle();
                    _this.myChart.resize({
                        width: _this.width,
                        height: _this.height,
                    });
                    _this.ele
                        .empty()
                        .append(
                            $("<img>")
                                .attr("src", _this.myChart.getDataURL())
                                .css({ width: "100%", height: "100%" })
                        );

                    return _this;
                });
            },
            // 导出图表为图片
            getPNG: function (color) {
                var img = new Image();
                img.src = this.myChart.getDataURL({
                    pixelRatio: 2,
                    backgroundColor: color ? color : "#fff",
                });
                return img;
            },
            getImage: function (color) {
                var img = new Image();
                img.src = this.myChart.getDataURL({
                    pixelRatio: 2,
                    backgroundColor: color ? color : "#fff",
                });
                return img;
            },
            // 转换数据
            toJson: function (forId) {
                var obj = {};
                obj.style = JSON.stringify(this.option.style);
                obj.data = JSON.stringify(this.option.data);
                obj.chartType = this.option.chartType;

                return Object.assign({}, this.supr(forId), obj);
            },
        });

    // lottie类型的sprite
    var LottieSprite = SpriteEle.extend(function (type, ele, editor, option) {
        this.isLoop = typeof option.isLoop === "boolean" ? option.isLoop : true;
        this.numberOfLoops =
            option.numberOfLoops === undefined ? 5 : option.numberOfLoops;
        this.option = Object.assign({}, option);
        this.lottieOptions = Object.assign(
            {
                container: document.getElementById("svg"), // wapper，DOM对象，存放lottie动画的容器，必须
                renderer: "svg",
                loop: 0,
                autoplay: true,
                path: "", // lottie动画json文件路径
                animationData: "", // lottie动画json数据
            },
            option.lottieOptions
        );
        this.playInstance = null;
        this.isAcitie = null;
        this.frameRate = 0;
        this.totalFrames = 0;
    }).methods({
        /**
         * 加载lottie DOM
         * @param {object} instance 一个lottie实例
         * @return {Promise} 返回一个Promise
         */
        _loadLottieDOM: function (instance) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                instance.addEventListener("DOMLoaded", function () {
                    _this.ele.show();
                    resolve(instance.renderer.svgElement);
                });
            });
        },

        setOption: function (option) {
            var _this = this;
            // 合并lottie默认参数
            var lo = Object.assign(
                {},
                this.lottieOptions,
                option.lottieOptions
            );
            lo.container = this.ele[0].parentNode;

            return this.supr(option).then(function () {
                var result;
                // 注册动画
                $(_this.ele[0])
                    .attr({
                        "data-animation-path": handleAssetsUrl(lo.path),
                        "data-anim-type": "svg",
                        "data-anim-autoplay": lo.autoplay,
                        "data-anim-loop": lo.loop,
                        "data-anim-prerender": true,
                    })
                    .hide();

                var instance = lottie.registerAnimation(_this.ele[0]);

                instance.addEventListener("DOMLoaded", function () {
                    instance.isDOMLoaded = true;
                    _this.frameRate = instance.frameRate;
                    _this.totalFrames = instance.totalFrames;
                });
                // instance.frameRate = _this.editor.option.frameRate;
                // 演示播放完成后，销毁该实例对象
                instance.addEventListener("complete", function () {
                    instance.setCurrentRawFrameValue(instance.totalFrames / 2);
                    // _this.lottie = null;
                    // instance.stop();
                    // instance.destroy();
                    if (instance.isDOMLoaded) instance = null;
                });

                result = _this._loadLottieDOM(instance).then(function (ele) {
                    var $svg = $(instance.renderer.svgElement);
                    // lottie可以拉伸
                    $svg.attr("preserveAspectRatio", "none");

                    // 初始化宽高
                    _this.initData.width = $svg.attr("width");
                    _this.initData.height = $svg.attr("height");
                    _this.initData.scale = _this.editor.scale;
                    // 演示播放
                    // lo.autoplay && instance.play();
                    // var error = null;
                    if (lo.autoplay) {
                        instance.play();
                    } else {
                        try {
                            instance.setCurrentRawFrameValue(
                                instance.totalFrames / 2
                            );
                        } catch (err) {
                            console.log("lottie error: ", lo.path, err);
                            //    error = err;
                        }
                    }

                    // if (error) return Promise.reject(error);
                    // 挂载控制实例
                    // _this.lottie = instance;
                    _this.option.url = lo.path;

                    return Promise.resolve(_this);
                });
                return result;
            });
        },

        toJson: function (forId) {
            this.option.url = this.option.url.replace(
                "https://resources.laihua.com/",
                ""
            );
            return Object.assign({}, this.supr(forId), {
                url: this.option.url,
                // data: this.option.url,
                isLoop: this.isLoop,
                numberOfLoops: this.numberOfLoops,
            });
        },

        setLoop: function (val, undo) {
            if (undo) {
                var undoData = {};
                undoData.reData = {
                    val: this.isLoop ? true : this.numberOfLoops,
                };
                undoData.sceneId = this.sceneId;
                undoData.id = this.id;
                undoData.data = {
                    val: val,
                };
                eve("undo_redo", null, { type: "setLoop", data: undoData });
            }
            if (typeof val === "boolean") {
                this.isLoop = val;
            } else if (typeof val === "number") {
                this.isLoop = false;
                val = val > 10 ? 10 : val;
                this.numberOfLoops = val;
            }
        },

        getLoop: function () {
            return {
                isLoop: this.isLoop,
                numberOfLoops: this.numberOfLoops,
            };
        },

        // 初始化到第0帧
        initialFrame: function () {
            if (this.effect.playerSprite && this.effect.playerSprite.lottie) {
                this.effect.playerSprite.lottie.setCurrentRawFrameValue(0);
            }
        },
        activeAnimation: function (force) {
            let sprite = this,
                editor = sprite.editor,
                player = editor.player,
                effect = sprite.effect;

            if (force) {
                sprite.unActiveAnimation();
            }
            if (sprite.isAcitie != null) {
                return sprite.isAcitie;
            }
            sprite.isAcitie = new Promise((resolve, reject) => {
                if (!sprite.playInstance) {
                    var ps = sprite.ele.clone();
                    var scenes = editor.getScenesIdData(sprite.scenesId),
                        sceneEle = player.scenesDict[scenes.uuid].eleC;

                    if (player.spritesDict[sprite.id]) {
                        sceneEle
                            .children("#player-sprite-" + sprite.id)
                            .remove();
                    }
                    ps.appendTo(sceneEle);
                    var sid = "player-sprite-" + sprite.uuid;
                    ps.attr({ id: sid });
                    player.spritesDict[sprite.uuid] = {
                        ele: ps,
                        sprite: sprite,
                        id: sid,
                    };

                    ps.empty(); // 清空原dom,重新注册动画并挂载lottie对象
                    sprite.playInstance = lottie.registerAnimation(ps[0]);
                    player.spritesDict[sprite.uuid].lottie =
                        sprite.playInstance;
                    ps.css("opacity", 1);

                    effect.playerSprite = player.spritesDict[sprite.uuid];

                    sprite.playInstance.addEventListener(
                        "DOMLoaded",
                        function () {
                            //sprite.playInstance.removeEventListener('DOMLoaded', this[0]);
                            //console.log(this)
                            effect.isInit = true;
                            ps.children("svg").attr(
                                "preserveAspectRatio",
                                "none"
                            );
                            sprite.setFilter();
                            if (sprite.border)
                                ps.append(sprite.border.dom.clone());
                            //console.log("init lottie");
                            resolve(effect.isInit);
                        }
                    );
                    //_this.isInit = true;
                } else {
                    resolve(effect.isInit);
                }
            });
            return sprite.isAcitie;
        },
        unActiveAnimation: function () {
            var sprite = this,
                editor = sprite.editor,
                player = editor.player,
                effect = sprite.effect;
            sprite.isAcitie = null;
            if (player.spritesDict[sprite.id]) {
                var scenes = editor.getScenesIdData(sprite.scenesId);
                var sceneEle = player.scenesDict[scenes.uuid].eleC;
                sceneEle.children("#player-sprite-" + sprite.id).remove();
            }

            if (player.spritesDict[sprite.uuid]) {
                if (sprite.playInstance) {
                    sprite.playInstance.stop();
                    sprite.playInstance.destroy();
                    sprite.playInstance = null;
                    //console.log("unInit lottie")
                }
                player.spritesDict[sprite.uuid] = null;
                effect.playerSprite = null;
                effect.isInit = false;
            }
        },
    });

    // SVG精灵。用来实现SVG在编辑器的表示。
    var SvgSprite = SpriteEle.extend(function (type, ele, editor, option) {
        this.fill = option.fill || ""; // svg中全部形状的填充颜色
        this.stroke = option.stroke || ""; // svg中全部形状的边框颜色
        this.isEditable = this.getIsEditable();
    }).methods({
        getIsEditable() {
            return this.option.fileType === 28 || this.option.fileType === 29;
        },
        _basicAttr: function (e) {
            // 获取和SVG绘制相关的属性
            var node = e.node;
            var result = {
                stroke: node.getAttribute("stroke"),
                "stroke-width": node.getAttribute("stroke-width"),
                "stroke-miterlimit": node.getAttribute("stroke-miterlimit"),
                "stroke-linecap": node.getAttribute("stroke-linecap"),
                "stroke-linejoin": node.getAttribute("stroke-linejoin"),
                fill:
                    node.getAttribute("fill") || this._getStyle(e.node, "fill"),
                transform: node.getAttribute("transform"),
            };

            if (result.stroke === "none" || !result.stroke)
                result.stroke = this._getStyle(e.node, "stroke");
            var attrFill = this._getStyle(e.node, "fill");
            if (attrFill === "none") {
                result.fill = attrFill;
            } else if (this.fill && this.isEditable) {
                result.fill = this.fill;
            }
            // if (result.fill === 'none' /* || !result.fill */) result.fill = this._getStyle(e.node, "fill");
            if (!result["stroke-width"])
                result["stroke-width"] = this._getStyle(e.node, "stroke-width");

            return result;
        },

        _getStyle: function (el, styleProp) {
            // 获取属性值，包括css和inline。
            var value,
                defaultView = (el.ownerDocument || document).defaultView;
            // W3C standard way:
            if (defaultView && defaultView.getComputedStyle) {
                // sanitize property name to css notation
                // (hypen separated words eg. font-Size)
                styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
                return defaultView
                    .getComputedStyle(el, null)
                    .getPropertyValue(styleProp);
            } else if (el.currentStyle) {
                // IE
                // sanitize property name to camelCase
                styleProp = styleProp.replace(
                    /\-(\w)/g,
                    function (str, letter) {
                        return letter.toUpperCase();
                    }
                );
                value = el.currentStyle[styleProp];
                // convert other units to pixels on IE
                if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
                    return (function (value) {
                        var oldLeft = el.style.left,
                            oldRsLeft = el.runtimeStyle.left;
                        el.runtimeStyle.left = el.currentStyle.left;
                        el.style.left = value || 0;
                        value = el.style.pixelLeft + "px";
                        el.style.left = oldLeft;
                        el.runtimeStyle.left = oldRsLeft;
                        return value;
                    })(value);
                }
                return value;
            }
        },

        _parse: function (svg) {
            var draw = SVG("sprite-" + this.uuid);
            draw.svg(svg);

            // 由请求到的文件生成svg元素，附加到上一级
            // 再删除中间成生的svg（svg.js真是蛋疼……）
            var svgid = "sprite-svg-" + this.uuid;
            var svg = draw.select("svg").members[0];
            $(svg.node)
                .appendTo(this.ele)
                .attr("id", svgid)
                .css("float", "left");
            draw.remove();
            draw = null;
            svg = SVG(svgid);

            //id去重
            this._id2unique(svg);
            // 添加行内样式
            this._style2cssinline(svg);

            return svg;
        },

        setOption: function (option) {
            var _this = this;

            return this.supr(option).then(function () {
                var result = _fetch(option.url)
                    .then(function (res) {
                        return res.text();
                    })
                    .then(function (svg) {
                        var svgBox = _this._parse(svg);
                        svgBox.attr({
                            preserveAspectRatio: "none",
                            width: "100%",
                            height: "100%",
                        });

                        _this.svg = svgBox;

                        // 将特殊形状的元素转为path形式

                        // 圆形
                        svgBox.select("circle").members.forEach(function (e) {
                            var r = e.attr("r"),
                                s = SVG.format(
                                    "M{cx} {cy}m-{r},0a{r},{r} 0 1,0 {r2},0a{r},{r} 0 1,0 -{r2},0",
                                    {
                                        cx: e.attr("cx"),
                                        cy: e.attr("cy"),
                                        r: r,
                                        r2: r * 2,
                                    }
                                );
                            var o = _this._basicAttr(e);
                            if (e.node.style.fill.indexOf("url(") > -1) {
                                o.fill = e.node.style.fill;
                            }
                            var el = svgBox.path(s).attr(o);
                            e.after(el).remove();
                        });

                        // 椭圆
                        svgBox.select("ellipse").members.forEach(function (e) {
                            var cx = e.attr("cx"),
                                rx = e.attr("rx"),
                                s = SVG.format(
                                    "M{cxrx},{cy}a{rx},{ry} 0 1,0 {rx2},0a{rx},{ry} 0 1,0 -{rx2},0",
                                    {
                                        cxrx: cx - rx,
                                        rx2: rx * 2,
                                        cx: cx,
                                        cy: e.attr("cy"),
                                        rx: rx,
                                        ry: e.attr("ry"),
                                    }
                                ),
                                el = e
                                    .parent()
                                    .path(s)
                                    .attr(_this._basicAttr(e));
                            e.after(el).remove();
                        });

                        // 折线/多边形
                        svgBox
                            .select("polyline, polygon")
                            .members.forEach(function (e) {
                                var tagName = e.node.tagName.toLowerCase();
                                var points = e
                                    .attr("points")
                                    .trim()
                                    .split(/\s+/);

                                // if (points.length > 1) {
                                //     var d = [];
                                //     for (var i = 0, len = points.length; i < len; i++) {
                                //         d.push((i === 0 ? 'M' : 'L') + (points[i] || 0));
                                //     }
                                //     if (tagName === 'polygon') {
                                //         d.push('Z')
                                //     }
                                //     d = d.join('');
                                //     el = e.parent().path(SVG.format(d)).attr(_this._basicAttr(e));
                                // }

                                points = {
                                    type: tagName,
                                    points: e.attr("points").trim(),
                                };

                                var d = SVGPoints.toPath(points);
                                var s = SVG.format(d);
                                var o = _this._basicAttr(e);
                                var el = svgBox.path(s).attr(o);

                                e.after(el).remove();
                            });

                        svgBox.select("rect").members.forEach(function (e) {
                            var shape = {
                                type: "rect",
                                height: 20,
                                width: 50,
                                x: 10,
                                y: 10,
                                rx: 2,
                                ry: 2,
                            };
                            $.each(shape, function (k, v) {
                                if (k === "type") return;
                                shape[k] = e.attr(k);
                            });
                            var d = SVGPoints.toPath(shape);
                            var s = SVG.format(d);
                            // var s = SVG.format("M{x} {y} l{width} 0 l0 {height} l-{width} 0 l0 -{height}", {
                            //         x: e.attr('x'),
                            //         y: e.attr('y'),
                            //         width: e.attr('width'),
                            //         height: e.attr('height'),
                            //     });
                            var o = _this._basicAttr(e);
                            if (e.node.style.fill.indexOf("url(") > -1) {
                                o.fill = e.node.style.fill;
                            }
                            var el = svgBox.path(s).attr(o);
                            e.after(el).remove();
                        });

                        // 直线
                        svgBox.select("line").members.forEach(function (e) {
                            var s = SVG.format("M{x1},{y1}L{x2},{y2}", {
                                    x1: e.attr("x1") || 0,
                                    y1: e.attr("y1") || 0,
                                    x2: e.attr("x2") || 0,
                                    y2: e.attr("y2") || 0,
                                }),
                                el = e
                                    .parent()
                                    .path(s)
                                    .attr(_this._basicAttr(e));

                            e.after(el).remove();
                        });

                        // 将所有path上通过class设置的样式转为inline样式
                        svgBox.select("path").members.forEach(function (e) {
                            var cls = [],
                                attr = _this._basicAttr(e);
                            for (
                                var i = 0, len = e.node.classList.length;
                                i < len;
                                i++
                            ) {
                                cls.push(e.node.classList[i]);
                            }

                            for (var j = 0, leng = cls.length; j < leng; j++) {
                                e.node.classList.remove(cls[i]);
                            }

                            if (
                                SvgSprite.urlFillRE.test(e.node.style.fill) ||
                                SvgSprite.urlFillRE.test(
                                    e.node.getAttribute("fill")
                                )
                            ) {
                                attr.fill =
                                    e.node.getAttribute("fill") ||
                                    e.node.style.fill;
                            }
                            e.attr(attr);
                        });

                        //原始宽高, 若原始宽高大于画布，则缩放相应比例
                        var animVal = svgBox.node.viewBox.animVal;
                        _this.initData.width = animVal.width;
                        _this.initData.height = animVal.height;
                        _this.initData.scale = _this.editor.scale;
                        var isEditable = /^(28|29)$/.test(
                            _this.option.fileType
                        );
                        if (
                            option.fill ||
                            option.stroke ||
                            option.strokeWidth
                        ) {
                            isEditable && _this.updateSprite(option);
                        } else {
                            isEditable && _this.updateSprite({});
                        }

                        return Promise.resolve(_this);
                    });
                return result;
            });
        },

        /**
         * 通过 AnimEditor.updateSprite 调用
         * 注意: 直接调用此方法会导致player层素材被清除
         *
         * @param {Object} [option]
         * @param {String} option.fill fill color
         * @param {String} option.stroke stroke color
         * @param {String} option.strokeWidth
         *
         * @param {Boolean} [type] 使用调用初始化进出场动画
         * @param {Object} [nowSize] 当前尺寸，用来计算线宽
         * @param {Boolean} [noSupr] 不执行父类方法 SpriteEle.updateSprite
         * @param {SvgElement} [svgELe] 传入一个svg元素，给它添加样式；而不是加工当前实例中的svg元素
         */
        updateSprite: function (option, type, nowSize, noSupr, svgELe) {
            nowSize = nowSize || { width: 0, height: 0 };
            var _this = this;
            //   var re = /rgb\(0,\s*0,\s*0\)/;

            option = Object.assign(
                {
                    fill: _this.fill,
                    stroke: _this.stroke,
                },
                _this.option,
                option
            );

            return (noSupr ? Promise.resolve() : this.supr()).then(function () {
                var svgContainer = _this.ele[0];
                // var prevDisplay = svgContainer.style.display;
                var svg = svgELe || _this.ele[0].querySelector("svg");

                // 注意
                svgELe || _this.ele.show();

                _this.updateStyle(svg, option, svgContainer, nowSize);
                // _this.updateStyle(_this.effect.playerSprite.ele.find('svg').get(0), {strokeWidth: option.strokeWidth});

                if (!svgELe) {
                    _this.option = option;
                    _this.fill = option.fill;
                    _this.stroke = option.stroke;
                }

                // svgContainer.style.display = prevDisplay;

                // if(type){
                // }
                _this.effect.init();
                eve("svg.updateSprite");
                return _this;
            });
        },

        /**
         *
         * @param {SvgElement} svg 传入一个svg元素，给它添加样式
         * @param {Object} option
         * @param {Element} container
         */
        updateStyle: function (svg, option, container, nowSize) {
            var _this = this;
            if (!option || !svg) {
                return;
            }
            nowSize = nowSize || { width: 0, height: 0 };
            var nodeList = [].slice.call(svg.querySelectorAll("*"), 1);

            function rgb2hex(rgb) {
                var old = rgb;
                rgb = rgb.split(/[^0-9\.]+/).filter(function (v) {
                    return v !== "";
                });
                return rgb && (rgb.length === 3 || rgb.length === 4)
                    ? "#" +
                          ("0" + parseInt(rgb[0], 10).toString(16)).slice(-2) +
                          ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                          ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2)
                    : old;
            }

            nodeList.forEach(function (el) {
                var $el = $(el);
                var attrFill = $el.css("fill"); //el.getAttribute('fill');
                var attrStroke = $el.css("stroke"); //el.getAttribute('fill');
                var _attrFill = el.getAttribute("fill");
                var _attrStroke = el.getAttribute("stroke");
                var urlFillRE = /url\(.*#.*\)/;
                // var attrSW = $el.css('stroke-width');
                if (urlFillRE.test(attrFill) || urlFillRE.test(_attrFill)) {
                    var isUrlFill = true;
                }
                if (
                    (attrFill &&
                        attrFill !== "none" &&
                        attrFill !== "transparent" &&
                        el.tagName != "defs" &&
                        el.tagName != "style" &&
                        !isUrlFill) ||
                    (_attrFill && _attrFill !== "none")
                ) {
                    option.fill && el.setAttribute("fill", option.fill);
                    option.fill && $el.css("fill", option.fill);
                    option.fill &&
                        el.tagName === "stop" &&
                        $el.css("stopColor", option.fill);
                    if (!option.fill) {
                        // init color, not svg color
                        option.fill = rgb2hex(attrFill);
                        el.tagName === "PATH" &&
                            $el.css("fill", rgb2hex(attrFill));
                    }
                }

                if (
                    attrStroke &&
                    attrStroke !== "none" &&
                    attrStroke !== "transparent"
                ) {
                    option.stroke && el.setAttribute("stroke", option.stroke);
                    option.stroke && $el.css("stroke", option.stroke);
                    if (!option.stroke) {
                        option.stroke = rgb2hex(attrStroke);
                        $el.css("stroke", rgb2hex(attrStroke));
                    }
                    if (option.strokeWidth == null) {
                        option.strokeWidth = 4; // parseInt($el.css('strokeWidth'));
                    }

                    container && container.offsetWidth; // reflow
                    $el.css(
                        "strokeWidth",
                        ((option.strokeWidth *
                            Math.min(
                                // 1,
                                svg.viewBox.animVal.width /
                                    (nowSize.width || svg.width.animVal.value),
                                svg.viewBox.animVal.height /
                                    (nowSize.height || svg.height.animVal.value)
                            )) /
                            _this.editor.scale) *
                            1.626
                    );

                    /* console.log({
                        // w: option.strokeWidth,
                        // css: $el.css('strokeWidth'),
                        scale: _this.editor.scale,
                        viewBox: svg.viewBox.animVal.width,
                        svgW: svg.width.animVal.value,
                        ratio: Math.min(
                            svg.viewBox.animVal.width/(nowSize.width || svg.width.animVal.value), svg.viewBox.animVal.height/(nowSize.height || svg.height.animVal.value)
                        )
                    }) */
                }
            });
        },

        changeStyle: function (option) {
            option = option || {};
            var _this = this;
            _this.supr(option).then(function () {
                var sprite = _this;
                var isEditable = /^(28|29)$/.test(sprite.option.fileType);
                if (sprite.type === "Svg" && isEditable) {
                    if (option.isLoadEditableSvg) {
                        sprite.editor.updateSprite &&
                            sprite.editor.updateSprite(sprite.id, {});
                    } else {
                        // sprite.updateSprite
                        //     && sprite.updateSprite(null, null, null, true);

                        var svgContainer = _this.ele[0];
                        var svg = svgContainer.querySelector("svg");
                        _this.updateStyle(
                            svg,
                            { strokeWidth: _this.option.strokeWidth },
                            svgContainer
                        );
                        _this.updateStyle(
                            _this.effect.playerSprite.ele.find("svg").get(0),
                            { strokeWidth: _this.option.strokeWidth }
                        );

                        // 更新涂抹动画中的`getImage`图片
                        _this.effect._init && _this.effect._init();

                        // _this.effect.init();
                    }
                }
            });
        },

        isUrlFill: function (styleValue) {
            return SvgSprite.urlFillRE.test(styleValue);
        },

        hasFill: function () {
            var _this = this;
            var svg = _this.ele[0];
            var nodeList = [].slice.call(svg.querySelectorAll("*"), 1);
            return nodeList.some(function (el) {
                var $el = $(el);
                var cssFill = $el.css("fill");
                return cssFill && cssFill !== "none";
            });
        },

        hasStroke() {
            if (this.hasStrokeProp) {
                return this.hasStrokeProp;
            }
            var $el = this.ele;
            var flag = false;
            $el.find("svg *").each(function (i, el) {
                if (el.tagName === "DEFS" || el.tagName === "MASK") {
                    return;
                }
                var _attrStroke = el.getAttribute("stroke");
                if (_attrStroke && _attrStroke !== "none") {
                    flag = true;
                    this.hasStrokeProp = flag;
                }
            });

            return flag;
        },

        // 将style标签样式转为css inline样式
        _style2cssinline: function (svg) {
            var styletag = svg.select("style").members[0];
            if (!styletag) return;

            // 兼容firefox和chrome
            var _html = styletag.node.innerHTML || styletag.node.textContent;
            var styleObj = this._getStyleObj(_html);

            svg.select("*").each(function () {
                var classname = this.attr("class");
                if (!classname) return;
                var cls = classname.split(" "),
                    _this = this;
                cls.forEach(function (c) {
                    var cobj = styleObj[c.trim()],
                        style = _this.style() || "";
                    if (cobj) {
                        _this.attr("style", style ? style + ";" + cobj : cobj);
                    }
                });
                this.attr("class", null);
            });
        },

        // 将style标签内的字符串转换为对象
        _getStyleObj: function (str) {
            var arr = str ? str.match(/[\S\s]+?\}/g) : [],
                classobj = {};
            arr.forEach(function (a) {
                var split = a.split("{");
                var sname = split[0].trim(),
                    content = split[1].split("}")[0].replace(/\n/g, "").trim();

                // 有逗号分隔的情况
                if (sname.indexOf(",") !== -1) {
                    var c = sname.split(",");
                    c.forEach(function (i) {
                        i = i.trim();
                        var attr = i.substr(1);
                        if (i[0] === ".") {
                            classobj[attr] = classobj[attr]
                                ? (classobj[attr] += ";" + content)
                                : content;
                        }
                    });
                } else {
                    // class obj
                    var attr = sname.substr(1);
                    if (sname[0] === ".") {
                        classobj[attr] = classobj[attr]
                            ? (classobj[attr] += ";" + content)
                            : content;
                    }
                }
            });
            return classobj;
        },

        toJson: function (forId) {
            var data = this.supr(forId);
            data.enterEffect.drawDuration =
                (this.effect.drawingDuration || 0) / 1000;
            return Object.assign({}, data, {
                url: this.option.url,
                color: this.option.fill || this.fill,
                stroke: this.option.stroke || this.stroke,
                strokeWidth: this.option.strokeWidth,
            });
        },

        playSyncContent: function () {
            this.supr();
            if (this.option.fileType === 28 && this.effect.playerSprite) {
                AnimEditor.changeSvgFillColor(
                    this.effect.playerSprite.ele[0],
                    this.fill
                );
            }
        },

        _makeid: function () {
            var text = "";
            var possible =
                "123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

            for (var i = 0; i < 5; i++)
                text += possible.charAt(
                    Math.floor(Math.random() * possible.length)
                );
            return text + "-o";
        },

        // id去重
        _id2unique: function (svg) {
            var _this = this;
            //select => querySelectorAll
            svg.select("[id]").each(function () {
                var new_id = _this._makeid();
                var old_id = this.attr('id');
                //g,style,mask,defs,symbol,pattern,path
                svg.select("style,defs,symbol,pattern,use,g,mask,path").each(function () {
                    var reg = new RegExp(old_id, "g");
                    this.node.innerHTML = this.node.innerHTML.replace(
                        reg,
                        new_id
                    );
                });
            });

        },

        getDifferentEle: function () {
            var _this = this;
            var handleID = function (id, str) {
                var t = _this._makeid();
                var after = id + "_" + t;
                return str.replace(new RegExp(id, "gm"), after);
            };
            var $clone = this.ele.clone();
            var strHTML = $clone.prop("outerHTML");
            var $gList = $clone.find("linearGradient, radialGradient, pattern");
            $gList.each(function (i, el) {
                strHTML = handleID(el.id || "none", strHTML);
            });

            return $(strHTML);
        },

        getDomDiffId: function () {
            return this.getDifferentEle();
        },

        getImage: function () {
            var svgEl = this.ele.find("svg")[0];
            // 防止filter属性叠加
            svgEl.style.filter = "";
            var s = new XMLSerializer().serializeToString(svgEl);
            var encodedData = window.btoa(unescape(encodeURIComponent(s)));
            var img = new Image();
            var rect = svgEl.getBoundingClientRect();
            img.width = rect.width;
            img.height = rect.height;
            img.src = "data: image/svg+xml;base64, " + encodedData;

            return img;
        },
    });
    SvgSprite.urlFillRE = /url\(.*#.*\)/;

    // 相框元素
    var FrameSprite = SpriteEle.extend(function (type, ele, editor, option) {
        (this.frameData = {}), // 相框数据集合
            (this.picData = {}), // 图片数据集合
            (this.isGif = false),
            (this.frames = []);
        this.pixelBuffer = null;
        this.canvas = document.createElement("canvas");
    }).methods({
        setOption: function (option) {
            var _this = this;
            this.isGif = option.picFileType === 34;
            return this.supr(option).then(function () {
                if (!option.url)
                    option.url =
                        "https://resources.laihua.com/2019-2-25/xiangkuang.svg";
                var result = _fetch(option.url)
                    .then(function (res) {
                        return res.text();
                    })
                    .then(function (svg) {
                        var domC = _this._initDom(svg);
                        if (!domC) {
                            return Promise.reject("相框格式错误");
                        }
                        if (option.picUrl) {
                            let info = {
                                url: option.picUrl,
                                fileType: option.picFileType,
                                resourceId: option.picResourceId,
                            };
                            info.matrix = option.matrix
                                ? _this.matrixTran(option.matrix, false)
                                : null;
                            return _this.loadPic(info);
                        } else {
                            return Promise.resolve(_this);
                        }
                    });
                return result;
            });
        },
        _initDom: function (svg) {
            var reg = /<path(.)*?id="lhImageFrame"(.)*?class="(.)*?"/;
            svg = svg.replace(
                reg,
                '<path class="imageHolderMaskPath" fill="none" '
            );
            // 初始化content层的DOM结构
            var frameData = this.frameData;
            var svgMask = $('<div class="frame-mask"></div>');
            var imgContent = $('<div class="frame-image"></div>');
            var frameContent = $('<div class="frame-content"></div>');

            this.ele.append(svgMask, imgContent, frameContent);

            var draw = SVG(frameContent[0]);
            draw.svg(svg);

            // 相框svg元素
            var frameSvg = draw.select("svg").members[0];
            var svgId = "sprite-svg-" + this.uuid;
            var maskId = "frame-" + this.uuid + "-clip-path";
            $(frameSvg.node).appendTo(frameContent).attr("id", svgId);
            draw.remove();
            draw = null;
            frameSvg = SVG(svgId);

            this._id2unique(frameSvg);
            this._style2cssinline(frameSvg);

            // 相框的各种属性赋值
            var animVal = frameSvg.node.viewBox.animVal;
            var viewBox = frameSvg.attr("viewBox");
            var maskPathDom = frameSvg.select(".imageHolderMaskPath");

            frameData.viewBox = viewBox.split(" ");
            if (!maskPathDom.members[0]) {
                return false;
            }
            frameData.bbox = maskPathDom.members[0].node.getBBox();
            if (maskPathDom.members[0].attr("transform")) {
                var matrix = maskPathDom.members[0].transform("matrix");
                frameData.bbox.x = matrix.e;
                frameData.bbox.y = matrix.f;
            }
            frameData.bbox.ratio = frameData.bbox.width / frameData.bbox.height;

            // clip-path的SVG
            var maskDom = SVG(svgMask[0]).attr({
                viewBox: viewBox,
                x: 0,
                y: 0,
                width: "100%",
                height: "100%",
            });
            // 在maskDom 中生成clipPath元素
            var clipPath = maskDom.defs().clip().attr({
                id: maskId,
            });
            clipPath.add(maskPathDom.clone().members[0]);

            // 图片的SVG
            var imgContentDom = SVG(imgContent[0])
                .attr({
                    viewBox: viewBox,
                    x: 0,
                    y: 0,
                })
                .style("overflow", "hidden");
            var picContent = imgContentDom
                .group()
                .attr("clip-path", "url(#" + maskId + ")");
            this.picData.picContent = picContent;
            // jquery 生成的元素无效果，于是在此处生成
            // imgContentDom.clip().rect()

            // 元素的原始宽高
            this.initData.width = animVal.width;
            this.initData.height = animVal.height;
            this.initData.scale = this.editor.scale;
            return true;
        },
        /**
         * 相框载入图片
         * @param {object} info url-图片的地址,fileType, resourceId
         * @param {boolean} init 是否重置位置
         */
        loadPic: function (info, init, undo) {
            if (undo) {
                var undoData = {
                    scenesId: this.scenesId,
                    id: this.id,
                };
                undoData.reData = {
                    fileType: this.option.picFileType,
                    url: this.option.picUrl,
                    resourceId: this.option.picResourceId,
                    matrix: this.picData.matrix
                        ? Object.assign({}, this.picData.matrix)
                        : null,
                };
                undoData.data = Object.assign({}, info);
            }
            var _this = this;
            var picData = this.picData;
            var frameData = this.frameData;
            this.isGif = info.fileType === 34;
            this.option.picFileType = info.fileType;
            this.option.picUrl = info.url;
            this.option.picResourceId = info.resourceId;

            picData.picContent.clear();
            picData.picDom = null;

            if (!info.url) {
                picData.matrix = null;
                picData.picSize = null;
                this.playPicDom && this.playPicDom.remove();
                this.playPicDom = null;
                return;
            }
            return new Promise(function (resolve, reject) {
                var picDom = _this.picData.picContent
                    .image(handleAssetsUrl(info.url))
                    .loaded(function (loader) {
                        picData.picSize = {
                            width: loader.width,
                            height: loader.height,
                            ratio: loader.ratio,
                        };

                        if (init || !info.matrix) {
                            picData.matrix = _this._initPicMatrix(
                                picData.picSize,
                                frameData.bbox
                            );
                        } else {
                            picData.matrix = Object.assign({}, info.matrix);
                        }
                        picData.picDom = picDom;
                        picDom.attr(_this._calcMatrix(picData.matrix));

                        undo &&
                            eve("undo_redo", null, {
                                type: "frameLoadPic",
                                data: undoData,
                            });

                        if (info.fileType === 34) {
                            _this.canvas.width = loader.width;
                            _this.canvas.height = loader.height;
                            _this.canvas
                                .getContext("2d")
                                .setTransform(1, 0, 0, 1, 0, 0);
                            _this.parseGif().then(function () {
                                _this.effect.init(true);
                            });
                        }
                        _this.effect.init(true);
                        return resolve(_this);
                    })
                    .error(function (err) {
                        reject(err);
                    });
            });
        },
        parseGif: function () {
            return new Promise((resolve, reject) => {
                let _this = this;
                let src = handleAssetsUrl(this.option.picUrl);
                let h = new XMLHttpRequest();
                h.open("GET", src, true);
                h.responseType = "arraybuffer";
                h.onload = function () {
                    if (this.status != 200) {
                        reject("加载失败");
                    }
                    for (let i = 0; i < SpriteEle.gifBuffer.length; i++) {
                        let v = SpriteEle.gifBuffer[i];
                        if (v.id === _this.option.picResourceId) {
                            v.index++;
                            _this.pixelBuffer = v.pixelBuffer;
                            _this.frames = v.frames;
                            return resolve();
                        }
                    }
                    let reader = new GifReader(new Uint8Array(this.response));
                    if (reader.errorCode > 0 ) {
                        reject("解析失败")
                        return;
                    }
                    let frames = reader.frames;
                    let [width, height] = [reader.width, reader.height];
                    let pixelBuffer = new Uint8ClampedArray(
                        frames.length * width * height * 4
                    );
                    let frameArr = new Uint8ClampedArray(width * height * 4);
                    let last = { disposal: 0 };
                    let rate = _this.editor.option.frameRate;
                    _this.frames = [];
                    _this.frames[0] = ((frames[0].delay || 10) / 100) * rate;
                    for (let i = 0; i < frames.length; i++) {
                        if (i !== 0) {
                            _this.frames[i] =
                                ((frames[i].delay || 10) / 100) * rate +
                                _this.frames[i - 1];
                            last = frames[i - 1];
                        }
                        if (last.disposal === 2) {
                            if (
                                !last.x &&
                                !last.y &&
                                last.width === width &&
                                last.height === height
                            ) {
                                frameArr = new Uint8ClampedArray(
                                    width * height * 4
                                );
                            } else {
                                let arrB = new Uint8ClampedArray(
                                    last.width * 4
                                );
                                for (let j = 0; j < last.height; j++) {
                                    frameArr.set(
                                        arrB,
                                        ((last.y + j) * width + last.x) * 4
                                    );
                                }
                            }
                        } else if (last.disposal === 3) {
                            frameArr = new Uint8ClampedArray(
                                width * height * 4
                            );
                        }
                        reader.decodeAndBlitFrameRGBA(i, frameArr);
                        pixelBuffer.set(frameArr, i * width * height * 4);
                    }
                    frameArr = null;
                    reader = null;
                    h = null;
                    _this.pixelBuffer = pixelBuffer;
                    SpriteEle.gifBuffer.push({
                        id: _this.option.picResourceId,
                        index: 0,
                        pixelBuffer: pixelBuffer,
                        frames: _this.frames,
                    });
                    resolve();
                };
                h.onerror = function () {
                    reject("加载失败");
                };
                h.send();
            });
        },
        getNumUrl: function (i, noUrl) {
            if (!this.pixelBuffer) return;
            let ctx = this.canvas.getContext("2d");
            let [w, h] = [
                this.picData.picSize.width,
                this.picData.picSize.height,
            ];
            let imageData = ctx.createImageData(w, h);
            imageData.data.set(
                this.pixelBuffer.subarray(i * w * h * 4, (+i + 1) * w * h * 4)
            );
            ctx.putImageData(imageData, 0, 0);
            imageData = null;
            return noUrl && this.canvas.toDataURL();
        },
        _initPicMatrix: function (picSize, frameSize) {
            // 初始加载时图片的matrix获得
            var matrix = {};

            if (picSize.ratio > frameSize.ratio) {
                matrix.height = frameSize.height;
                matrix.width = frameSize.height * picSize.ratio;
                matrix.y = frameSize.y;
                matrix.x = frameSize.x - (matrix.width - frameSize.width) / 2;
                matrix.rotate = 0;
            } else {
                matrix.width = frameSize.width;
                matrix.height = frameSize.width / picSize.ratio;
                matrix.x = frameSize.x;
                matrix.y = frameSize.y - (matrix.height - frameSize.height) / 2;
                matrix.rotate = 0;
            }

            return matrix;
        },
        play: function (frame) {
            // 相框中gif播放方法
            if (this.option.picFileType !== 34 || !this.canvas) return;
            var frame = frame % this.frames[this.frames.length - 1];
            for (var i in this.frames) {
                if (frame < this.frames[i]) break;
            }

            this.getNumUrl(i);
        },
        sync_first: function () {
            this.isGif && this.playPicDom && this.getNumUrl(0);
        },
        setPicMatrix: function (matrix, undo) {
            // 设置图片的位置信息
            if (undo) {
                var undoData = {};
                undoData.scenesId = this.scenesId;
                undoData.id = this.id;
                undoData.reData = Object.assign({}, this.picData.matrix);
                undoData.data = Object.assign({}, matrix);
                eve("undo_redo", null, {
                    type: "framePicMatrix",
                    data: undoData,
                });
            }
            this.picData.matrix = matrix;
            var mx = this._calcMatrix(matrix);
            this.picData.picDom.attr(mx);
            this.playPicDom && this.playPicDom.attr(mx);
            this.canvas.style.transform = `scale(${
                mx.width / this.picData.picSize.width
            }, ${mx.height / this.picData.picSize.height})`;
            // png图片的clipPath中的rect不需要旋转信息
            // this.pngMaskDom && this.pngMaskDom.attr(mx).attr('transform', '');
        },
        _calcMatrix: function (m) {
            var mx = Object.assign({}, m);
            if (m.rotate && !m.transform) {
                mx.transform =
                    "rotate(" +
                    m.rotate +
                    " " +
                    (m.width / 2 + m.x) +
                    " " +
                    (m.height / 2 + m.y) +
                    ")";
            } else if (m.rotate === 0) {
                mx.transform = "rotate(0)";
            }
            return mx;
        },
        // 将style标签样式转为css inline样式
        _style2cssinline: function (svg) {
            var styletag = svg.select("style").members[0];
            if (!styletag) return;

            // 兼容firefox和chrome
            var _html = styletag.node.innerHTML || styletag.node.textContent;
            var styleObj = this._getStyleObj(_html);

            svg.select("*").each(function () {
                var classname = this.attr("class");
                if (!classname || classname === "imageHolderMaskPath") return;
                var cls = classname.split(" "),
                    _this = this;
                cls.forEach(function (c) {
                    var cobj = styleObj[c.trim()],
                        style = _this.style() || "";
                    if (cobj) {
                        _this.attr("style", style ? style + ";" + cobj : cobj);
                    }
                });
                this.attr("class", null);
            });
        },
        // 将style标签内的字符串转换为对象
        _getStyleObj: function (str) {
            var arr = str ? str.match(/[\S\s]+?\}/g) : [],
                classobj = {};
            arr.forEach(function (a) {
                var split = a.split("{");
                var sname = split[0].trim(),
                    content = split[1].split("}")[0].replace(/\n/g, "").trim();

                // 有逗号分隔的情况
                if (sname.indexOf(",") !== -1) {
                    var c = sname.split(",");
                    c.forEach(function (i) {
                        i = i.trim();
                        var attr = i.substr(1);
                        if (i[0] === ".") {
                            classobj[attr] = classobj[attr]
                                ? (classobj[attr] += ";" + content)
                                : content;
                        }
                    });
                } else {
                    // class obj
                    var attr = sname.substr(1);
                    if (sname[0] === ".") {
                        classobj[attr] = classobj[attr]
                            ? (classobj[attr] += ";" + content)
                            : content;
                    }
                }
            });
            return classobj;
        },
        _makeid: function () {
            var text = "";
            var possible =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

            for (var i = 0; i < 5; i++)
                text += possible.charAt(
                    Math.floor(Math.random() * possible.length)
                );
            return text;
        },
        // id去重
        _id2unique: function (svg) {
            var _this = this;
            svg.select("[id]").each(function () {
                var new_id = _this._makeid();
                var old_id = this.attr("id");
                svg.select("g,style,mask,defs").each(function () {
                    var reg = new RegExp(old_id, "g");
                    this.node.innerHTML = this.node.innerHTML.replace(
                        reg,
                        new_id
                    );
                });
            });
        },
        getDomDiffId: function (name) {
            var cloneEle = this.ele.clone();
            var diffId = this.id + "_" + name + "_clip_path";
            cloneEle.find(".frame-mask clipPath").attr({
                id: diffId,
            });
            cloneEle.find(".frame-image g").attr({
                "clip-path": "url(#" + diffId + ")",
            });
            if (!this.picData.picDom) return cloneEle;
            let mx = this._calcMatrix(this.picData.matrix);
            if (this.isGif) {
                if (name === "play") {
                    let [w, h] = [
                        this.picData.picSize.width,
                        this.picData.picSize.height,
                    ];
                    cloneEle.find(
                        ".frame-image g"
                    )[0].innerHTML = `<foreignObject><canvas></canvas></foreignObject>`;
                    this.playPicDom = cloneEle.find("foreignObject").attr(mx);
                    this.canvas = cloneEle
                        .find("canvas")
                        .attr({
                            width: w,
                            height: h,
                        })
                        .css({
                            transformOrigin: "0 0",
                            float: "left",
                            transform: `scale(${mx.width / w}, ${
                                mx.height / h
                            })`,
                        })[0];
                } else {
                    cloneEle
                        .find(".frame-image image")
                        .attr("href", this.getNumUrl(0, true));
                }
            } else {
                if (name === "play") {
                    this.playPicDom = cloneEle
                        .find(".frame-image image")
                        .attr(mx);
                }
            }

            return cloneEle;
        },
        toJson: function (forId) {
            var matrix = this.matrixTran(this.picData.matrix, true);
            return Object.assign({}, this.supr(forId), {
                url: this.option.url,
                type: "ImageFrame",
                fillContent: this.option.picUrl
                    ? {
                          url: unhandleAssetsUrl(this.option.picUrl),
                          resourceId: this.option.picResourceId,
                          fileType: this.option.picFileType,
                          offsetX: matrix.x,
                          offsetY: matrix.y,
                          width: matrix.width,
                          height: matrix.height,
                          rotation: matrix.rotate,
                          isFilp: false,
                          startTime: 0,
                          duration: 0.5,
                          isLoop: false,
                          numberOfLoops: 1,
                      }
                    : null,
            });
        },
        matrixTran: function (m, bol) {
            if (!m) return {};
            var newM = Object.assign({}, m);
            var bbox = this.frameData.bbox;
            if (bol) {
                newM.x = m.width / 2 + m.x - bbox.width / 2 - bbox.x;
                newM.y = m.height / 2 + m.y - bbox.height / 2 - bbox.y;
            } else {
                newM.x = m.x + bbox.width / 2 + bbox.x - m.width / 2;
                newM.y = m.y + bbox.height / 2 + bbox.y - m.height / 2;
            }
            return newM;
        },
        removeSprite: function () {
            this.supr();
            this.effect = null;
            this.playPicDom = null;
            this.pixelBuffer = null;
            this.canvas = null;
            for (var i = 0; i < SpriteEle.gifBuffer.length; i++) {
                var v = SpriteEle.gifBuffer[i];
                if (v.id === this.option.picResourceId) {
                    v.index--;
                    if (v.index < 0) {
                        v.pixelBuffer = null;
                        SpriteEle.gifBuffer.splice(i, 1);
                    }
                    break;
                }
            }
        },
    });

    //视频元素
    var VideoSprite = SpriteEle.extend(function (type, ele, editor, option) {
        this.video = Object.assign(
            {
                startTime: 0,
                duration: 0,
                cutDuration: 0,
                maxCutDuration: 20,
                showDuration: 0,
                muted: false,
                volume: 50,
                loop: false,
                repeatTimes: 3,
                currRepeat: 0,
                poster: "",
                effectReady: false,
            },
            option.video
        );

        // eve.on('timeline_play_scenes', this.onVideoPlayChange.bind(this));
        this.editor.eve.on(
            "timeline_play_scenes",
            this.onVideoPlayChange.bind(this)
        );
    }).methods({
        _load: function (url, attempt) {
            var done;
            var doneReject;
            var _this = this;
            url = handleAssetsUrl(url);
            var cutStart = _this.video.startTime;
            var cutEnd = _this.video.startTime + _this.video.cutDuration;
            var video = $("<video></video>", {
                src: url + "#t=" + cutStart + "," + cutEnd,
                // muted: true,
                volume: 0,
                crossOrigin: true,
            }).css({
                width: "100%",
                height: "100%",
            });

            testBuffered(video, "videoSpriteC");

            video.addClass("video-sprite-video");

            _this.ele.empty();
            _this.ele.append(video);
            video[0].style.visibility = "hidden";

            _this.initData.scale = _this.editor.scale;

            function errHandler() {
                if (video[0].error) {
                    _this.initData.width = 480;
                    _this.initData.height = 270;
                    _this.video.video = video;
                    _this.video.duration = 10;
                    doneReject && doneReject(video[0].error, _this);
                }
            }

            return new Promise(function (resolve, reject) {
                done = resolve;
                doneReject = reject;
                video.on("loadedmetadata", function (e) {
                    if (!window.abc) {
                        window.abc = { intervalCount: 0 };
                    }
                    clearInterval(window.abc.timer);
                    window.abc.intervalCount = 0;
                    window.abc.timer = setInterval(() => {
                        const abc = video[0].webkitAudioDecodedByteCount;
                        window.abc.intervalCount += 1;
                        if (abc > 0 || window.abc.intervalCount === 8) {
                            clearInterval(window.abc.timer);
                            _this.video.hasAudio = abc > 0;
                            if (!_this.video.hasAudio) {
                                _this.video.volume = 0;
                            }

                            video[0].style.visibility = "visible";
                            done(_this);
                        }
                    }, 300);
                    var width = this.videoWidth;
                    var height = this.videoHeight;

                    _this.initData.width = width;
                    _this.initData.height = height;
                    _this.video.video = video;
                    _this.video.duration = this.duration;
                    _this.option.video.attempt = false;

                    // video[0].style.visibility = 'visible';
                    // done(_this);
                });

                if (attempt === false || !_this.option.video.attempt) {
                    video.on("error", function (e) {
                        if (_this.option.video.attempt) {
                            errHandler();
                        } else {
                            doneReject(e);
                        }
                    });
                    return;
                }

                let _count = 5;
                setTimeout(function () {
                    if (!_this.option.video.attempt) {
                        return;
                    }
                    // errHandler();
                    var tid = setInterval(function () {
                        video.prop({
                            src: _this.option.url,
                        });
                        setTimeout(function () {
                            if (!video[0].error) {
                                if (!_this.option.video.attempt) {
                                    clearInterval(tid);
                                }
                                video.off("loadedmetadata");
                                video.on("loadedmetadata", function (e) {
                                    var width = this.videoWidth,
                                        height = this.videoHeight;

                                    _this.initData.width = width;
                                    _this.initData.height = height;
                                    _this.video.video = video;
                                    _this.video.duration = this.duration;
                                    _this.option.video.attempt = false;

                                    _this.setOption(false);
                                });
                                video.off("error");
                                video.on("error", () => {
                                    if (_count < 1) {
                                        errHandler();
                                        clearInterval(tid);
                                    }
                                });
                            }
                            _count--;
                        }, 1000);
                    }, 1000);
                }, 6000);
            });
        },
        setOption: function (attempt) {
            var _this = this;
            return _this.supr(_this.option).then(function () {
                _this.video.poster =
                    _this.video.poster || _this.option.thumbnailUrl;
                if (_this.option && _this.option.url) {
                    result = _this
                        ._load(_this.option.url, attempt)
                        .catch(function (err) {
                            if (_this.option.allowFailed) {
                                _this.ele.append(
                                    _this.loadFailedImg().css({
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                    })
                                );
                                return _this;
                            } else {
                                throw "Error:" + err;
                            }
                        });
                } else {
                    result = Promise.resolve();
                }
                return result;
            });
        },
        updateTimeOffset: function (startOffset, endOffset) {
            var delta = endOffset - startOffset;
            this.video.showDuration = delta;
            this.video.startOffset = startOffset;
            this.video.endOffset = endOffset;
        },
        updateVideoDuration: function (startOffset, endOffset) {
            var _this = this;
            var delta = endOffset - startOffset;
            this.video.showDuration = delta;
            this.video.startOffset = startOffset;
            this.video.endOffset = endOffset;
            this.video.cutDuration =
                this.video.cutDuration ||
                Math.min(this.video.maxCutDuration, this.video.duration);
            // || Math.min(delta, this.video.duration);

            this.handleVideoUrl();

            if (!this.effectReady) {
                this.updateCurrentTimeBySec(this.editor.selectedScenes.nowTime);
                this.effectReady = true;
                // setTimeout(function () {
                //     testBuffered((this.video || {}).pVideo, 'videoSpriteP', 'timeupdate');
                // }, 3000)
            }
        },
        toJson: function (forId) {
            return Object.assign({}, this.supr(forId), {
                url: this.option.url,
                userId: this.option.userId,
                isLoop: this.video.loop,
                numberOfLoops: this.video.repeatTimes,
                videoStartTime: this.video.startTime,
                videoDuration: this.video.cutDuration,
                volume: this.video.volume,
                poster: this.video.poster,
                actionType: this.option.actionType
            });
        },

        updateCurrentTime: function (frame, videoEl, options) {
            options = options || {};
            if (this.editor.isVideoSpritePlay || this.loadFailed) {
                return;
            }

            var videoInfo = this.video;
            var $video = this.video.video;
            var $pVideo = (this.video.pVideo = $(
                "#player-sprite-" + this.id
            ).find("video"));
            var frameRate = this.editor.option.frameRate;
            var sec = frame / frameRate;
            var startSec = this.effect.animFrame.entrance.end / frameRate;
            var endSec = this.effect.animFrame.exit.start / frameRate;
            var videoSec = this.getVideoSec(sec);

            if (videoEl) {
                videoEl.currentTime = videoSec;
                return;
            }

            this.video.currentTime = videoSec;
            requestAnimationFrame(function () {
                $pVideo.prop("currentTime", videoSec);
            });
            $video[0].currentTime = videoSec;

            if (!options.isSyncMode) {
                eve("videoSprite.updateCurrentTime", null);
            }
        },

        updateCurrentTimeBySec: function (sec, videoEl) {
            var fps = this.editor.option.frameRate;
            var f = sec * fps;
            return this.updateCurrentTime(f);
        },

        syncCurrentTime: function (videoEl) {
            if (videoEl === false) {
                return;
            }
            return this.updateCurrentTime(
                this.editor.selectedScenes.nowTime *
                    this.editor.option.frameRate,
                videoEl,
                {
                    isSyncMode: true,
                }
            );
        },

        onVideoPlayChange: function (data) {
            var _this = this;
            var videoInfo = _this.video;
            var videoEle = this.video.video[0];
            var $pVideo = (this.video.pVideo = $(
                "#player-sprite-" + this.id
            ).find("video"));
            var videoEleP = $pVideo[0];
            var frameRate = this.editor.option.frameRate;
            // var startOffset = this.effect.animFrame.entrance.end / frameRate;
            // var endOffset = this.effect.animFrame.exit.start / frameRate;
            var sceneDuration = this.editor.selectedScenes.duration / 1000;

            if (!videoEleP || this.editor.selectedScenes.id !== this.scenesId) {
                return;
            }

            if (data.isPlay) {
                this.editor.isVideoSpritePlay = true;

                var sceneSec = this.editor.selectedScenes.nowTime;
                var scenePlayTime =
                    data.nowTime != null
                        ? data.nowTime
                        : (data.time || 0) / 1000;
                var videoSec = this.getVideoSec(scenePlayTime);

                intervalCheck();
                clearInterval(this.videoTimer);
                this.videoTimer = setInterval(function () {
                    intervalCheck();
                }, 1);

                videoEleP.currentTime = videoSec;
                videoEleP.loop = false;
                $pVideo.prop(
                    "volume",
                    this.video.volume > 1
                        ? this.video.volume / 100
                        : this.video.volume
                );

                videoEleP.onTimeUpdate = videoEleP.onTimeUpdate || onTimeUpdate;
                videoInfo.currRepeat =
                    (Math.max(sceneSec - videoInfo.startOffset, 0) /
                        videoInfo.cutDuration) |
                    0;
                if (sceneDuration === sceneSec) {
                    videoInfo.currRepeat = 0;
                }

                videoEleP.removeEventListener(
                    "timeupdate",
                    videoEleP.onTimeUpdate
                );
                videoEleP.addEventListener(
                    "timeupdate",
                    videoEleP.onTimeUpdate
                );
            } else {
                clearInterval(this.videoTimer);
                videoEleP.removeEventListener(
                    "timeupdate",
                    videoEleP.onTimeUpdate
                );
                videoEleP.pause();

                this.editor.isVideoSpritePlay = false;
                this.updateCurrentTime(
                    this.editor.selectedScenes.nowTime * frameRate
                );
                videoInfo.currRepeat = 0;
            }

            function getCurrRepeat() {
                return (
                    (Math.max(
                        _this.editor.selectedScenes.nowTime -
                            videoInfo.startOffset,
                        0
                    ) /
                        videoInfo.cutDuration) |
                    0
                );
            }

            function onTimeUpdate(ev) {
                let sceneSec = _this.editor.selectedScenes.nowTime;
                let videoSec = videoEleP.currentTime;

                // clearInterval(_this.videoTimer);
                // 素材退场了
                if (sceneSec >= videoInfo.endOffset) {
                    videoSec = _this.getVideoSec(sceneSec);
                    videoEleP.pause();
                    videoEleP.currentTime = videoSec;
                    videoEleP.removeEventListener(
                        "timeupdate",
                        videoEleP.onTimeUpdate
                    );
                    return;
                }

                if (videoInfo.loop) {
                    if (
                        videoSec >=
                        videoInfo.cutDuration +
                            videoInfo.startTime -
                            (1 / 60) * 2
                    ) {
                        videoSec = videoInfo.startTime;
                        videoEleP.currentTime = videoSec;
                        videoEleP.offsetWidth;
                    }
                } else if (videoInfo.repeatTimes === 1) {
                    if (
                        videoSec >=
                        videoInfo.cutDuration + videoInfo.startTime
                    ) {
                        videoEleP.pause();
                        videoSec = videoInfo.cutDuration + videoInfo.startTime;
                        videoEleP.currentTime = videoSec;
                        videoEleP.removeEventListener(
                            "timeupdate",
                            videoEleP.onTimeUpdate
                        );
                    }
                } else if (videoInfo.repeatTimes > 1) {
                    videoInfo.currRepeat = getCurrRepeat();

                    if (
                        videoSec >=
                        videoInfo.cutDuration + videoInfo.startTime - 1 / 60
                    ) {
                        if (videoInfo.currRepeat >= videoInfo.repeatTimes) {
                            videoEleP.pause();
                            videoSec =
                                videoInfo.cutDuration + videoInfo.startTime;
                            videoEleP.currentTime = videoSec;
                            videoEleP.removeEventListener(
                                "timeupdate",
                                videoEleP.onTimeUpdate
                            );
                            // clearInterval(_this.videoTimer);
                        } else {
                            videoSec = videoInfo.startTime;
                            // videoInfo.currRepeat += 1;
                            videoEleP.currentTime = videoSec;
                            videoEleP.addEventListener("ended", function h() {
                                videoEleP.removeEventListener("ended", h);
                                videoEleP.play();
                            });
                        }
                    }
                }

                // if (videoSec !== videoEleP.currentTime) {
                // videoEleP.currentTime = videoSec
                // }
            }

            function intervalCheck() {
                // var sec = _this.getVideoSec(_this.editor.selectedScenes.nowTime);
                // if (sec >= videoInfo.startTime && sec < videoInfo.startTime + videoInfo.cutDuration * videoInfo.repeatTimes - 0.5 && videoEleP.paused) {
                //     videoEleP.play().catch();
                // }
                // if (sec < videoInfo.startTime && !videoEleP.paused) {
                //     videoEleP.currentTime = videoInfo.startTime;
                //     videoEleP.pause();
                // }
                // if (sec >= videoInfo.startTime + videoInfo.cutDuration && !videoEleP.paused) {
                //     videoEleP.currentTime = videoInfo.startTime + videoInfo.cutDuration;
                //     videoEleP.pause();
                // }

                var sceneSec = _this.editor.selectedScenes.nowTime;
                var videoInfo = _this.video;
                if (
                    sceneSec >= videoInfo.startOffset &&
                    sceneSec < videoInfo.endOffset
                ) {
                    videoEleP.currentTime = _this.getVideoSec(sceneSec);
                    videoEleP.play().catch();
                    clearInterval(_this.videoTimer);
                }
            }
        },

        getVideoSec(sceneNowSec) {
            var videoInfo = this.video;
            var frameRate = this.editor.option.frameRate;
            var startOffset = this.effect.animFrame.entrance.end / frameRate;
            var endOffset = this.effect.animFrame.exit.start / frameRate;
            var beforeCutSec = this.video.startTime;
            var deltaSec = sceneNowSec - startOffset;
            // var videoSec = deltaSec + beforeCutSec;

            // if (deltaSec < 0) {
            //     deltaSec = 0
            // }
            if (deltaSec > videoInfo.showDuration) {
                deltaSec = videoInfo.showDuration;
            }

            if (videoInfo.loop) {
                if (deltaSec > videoInfo.cutDuration) {
                    deltaSec = deltaSec % videoInfo.cutDuration;
                }
            } else if (videoInfo.repeatTimes === 1) {
                // 不超出剪辑范围
                if (deltaSec > videoInfo.cutDuration) {
                    deltaSec = videoInfo.cutDuration;
                }
            } else if (videoInfo.repeatTimes > 1) {
                if (deltaSec > videoInfo.cutDuration * videoInfo.repeatTimes) {
                    deltaSec = videoInfo.cutDuration;
                } else if (deltaSec > videoInfo.cutDuration) {
                    deltaSec = deltaSec % videoInfo.cutDuration;
                }
            }

            return deltaSec + beforeCutSec;
        },

        toggleMuted: function (flag) {
            // this.video.muted = flag;
            if (flag) {
                this.setVolume(0, true);
            } else {
                this.setVolume(50, true);
            }
        },

        setVolume: function (v, undo) {
            if (undo) {
                var undoData = {};
                undoData.id = this.id;
                undoData.reData = {
                    volume: this.video.volume,
                };
                undoData.data = {
                    volume: v,
                };
                eve("undo_redo", null, {
                    type: "setVideoSpriteVolume",
                    data: undoData,
                });
            }

            this.video.volume = v;
        },

        /**
         * @param {Object} obj
         * @param {Number} obj.startTime
         * @param {Number} obj.cutDuration
         *
         */
        setCutDuration: function (obj, undo) {
            obj = obj || {};
            if (undo) {
                var undoData = {};
                undoData.id = this.id;
                undoData.reData = {
                    startTime: this.video.startTime,
                    cutDuration: this.video.cutDuration,
                    endOffset: this.video.endOffset,
                    startOffset: this.video.startOffset,
                };
                undoData.data = Object.assign({}, obj);
                eve("undo_redo", null, {
                    type: "videoSprite.setCutDuration",
                    data: undoData,
                });
            }
            this.video = Object.assign(this.video, obj);
            if (this.video.cutDuration > 20) {
                this.video.cutDuration = 20;
            }
            if (
                this.video.cutDuration >
                this.video.duration - this.video.startTime
            ) {
                this.video.cutDuration =
                    this.video.duration - this.video.startTime;
            }
            if (this.video.cutDuration < 0.5) {
                this.video.cutDuration = 0.5;
            }

            this.updateEffect({
                exitAnim: {
                    start: this.video.endOffset * 1000,
                    end: this.video.endOffset * 1000 + 500,
                },
            });

            this.updateCurrentTime(
                this.editor.selectedScenes.nowTime *
                    this.editor.option.frameRate
            );

            this.handleVideoUrl();
        },

        setLoop: function (flag, undo) {
            if (undo) {
                var undoData = {};
                undoData.id = this.id;
                undoData.reData = {
                    loop: this.video.loop,
                };
                undoData.data = {
                    loop: flag,
                };
                eve("undo_redo", null, {
                    type: "videoSprite.setLoop",
                    data: undoData,
                });
            }
            this.video.loop = flag;
        },

        setRepeatTimes: function (num, undo) {
            if (undo) {
                var undoData = {};
                undoData.id = this.id;
                undoData.reData = {
                    repeatTimes: this.video.repeatTimes,
                };
                undoData.data = {
                    repeatTimes: num,
                };
                eve("undo_redo", null, {
                    type: "videoSprite.setRepeatTimes",
                    data: undoData,
                });
            }
            if (num > 10) {
                num = 10;
            }
            //  else if (num < 1) {
            //     num = 1
            // }
            this.video.repeatTimes = num;
            this.video.loop = false;
        },

        getLoop: function () {
            return {
                isLoop: this.video.loop,
                numberOfLoops: this.video.repeatTimes,
            };
        },

        handleVideoUrl() {
            var _this = this;
            var url = _this.option.url;
            url = handleAssetsUrl(url);
            var video = _this.video.video;
            var pVideo = _this.video.pVideo;
            var cutStart = _this.video.startTime;
            var cutEnd = _this.video.startTime + _this.video.cutDuration;
            url = url + "#t=" + cutStart + "," + cutEnd;
            video.prop({
                src: url,
            });
            pVideo.prop({
                src: url,
            });
        },
    });

    //富文本元素
    var RichTextSprite = SpriteEle.extend(function (type, ele, editor, option) {
        this.html = option.html || "<p></p>";
        this.versionAnyway = option.versionAnyway || "Horizontal"; // Vertical -- 竖版
        if (option.width) {
            this.width = option.width;
        }
        if (option.height) {
            this.height = option.height;
        }
        this.fontList = option.fontList || [];
        this.resourceIds = option.resourceIds || [];
        this.lineHeight = option.lineHeight || 1;
        this.minWidth = 18;
    }).methods({
        setOption: function (option) {
            var _this = this;
            return this.supr().then(function () {
                let initData = _this.initDom(option);
                _this.initData.width = initData.width;
                _this.initData.height = initData.height;
                _this.initData.rotate = initData.rotate;

                _this.initData.scale = _this.editor.scale;

                if (_this.positionTop) {
                    _this.positionTop = _this.positionTop;
                }
                if (_this.positionLeft) {
                    _this.positionLeft = _this.positionLeft;
                }
                return Promise.resolve(_this);
            });
        },
        initDom: function (option) {
            var textBox = $("<div autofocus></div>").css({
                whiteSpace: "pre-wrap",
                fontSize: "40px",
                fontFamily: '"1526467728442.TTF"',
                lineHeight: this.lineHeight,
                transformOrigin: "0px 0px 0px",
                wordBreak: "break-word",
                textAlign: "center",
            });
            if (this.html) {
                textBox.html(this.html);
                this.ele.empty().append(textBox);
            }
            let initData = {
                width: option.width || textBox.width(),
                height: option.height || textBox.height(),
                rotate: option.rotate || 0,
            };
            this.text = option.text || "选中文";
            // 最小拉伸宽度等于最大单个文字宽度
            this.minWidth = (option.maxSize || 60) / this.editor.scale;

            if (this.versionAnyway === "Vertical") {
                // 竖版
                !option.height && (initData.height *= 1.5);
                textBox.css({
                    width: "auto",
                    height: initData.height + "px",
                    writingMode: "vertical-rl",
                    transform: "scale(" + 1 / this.editor.scale + ")",
                });
            } else {
                !option.width && (initData.width *= 1.5);
                textBox.css({
                    height: "auto",
                    width: initData.width + "px",
                    writingMode: "inherit",
                    transform: "scale(" + 1 / this.editor.scale + ")",
                });
            }
            return initData;
        },
        edited: function (data, undo) {
            this.html = data.html;
            this.lineHeight = data.lineHeight;
            this.width = data.width / this.editor.scale;
            this.height = data.height / this.editor.scale;
            this.text = data.text;
            this.fontList = data.fontList || [];
            this.resourceIds = data.resourceIds || [];
            this.option.resourceIds = data.resourceIds || [];
            if (
                data.versionAnyway &&
                data.versionAnyway !== this.versionAnyway
            ) {
                this.versionAnyway = data.versionAnyway;
                this.helpEle.empty();
                this.opHelper = new OpHelper(this.helpEle, this, {});
            }
            var data = this.initDom(data);
            this.height = data.height / this.editor.scale;
            this.changeStyle({ sync: true });
        },
        toJson: function (forId) {
            return Object.assign({}, this.supr(forId), {
                html: this.html,
                lineSpacing: this.lineHeight || 1,
                versionAnyway: this.versionAnyway,
                fontList: [].concat(this.fontList),
                resourceIds: [].concat(this.resourceIds),
                fileType: 15,
            });
        },
    });

    // 精灵工厂。根据类型创建不同的精灵。
    var SpriteLoader = klass(function (ele, type, editor, option) {
        // 精灵工厂。根据类型创建不同的精灵。
        this.ele = ele;
        this.type = type;
        this.editor = editor;
        this.option = option;
    }).methods({
        load: async function () {
            var _this = this,
                sprite = null;
            if (this.option.source == 5 && !this.option.url) {
                var resp = await laihuaApi(
                    `/user/sheTuWang/materialData?type=17&id=${this.option.resourceId}`
                );
                resp = await resp.json();
                this.option.url = ((resp || {}).data || {}).url;
            }
            if (this.option.source == 5) {
                var picRE = /\.(png|jpg|jpeg)$/i;
                var gifRE = /\.gif/i;
                if (picRE.test(this.option.url)) {
                    this.type = "Image";
                    this.option.fileType = 3;
                }
                if (gifRE.test(this.option.url)) {
                    this.type = "Gif";
                    this.option.fileType = 32;
                }
            }
            switch (this.type) {
                case "Text":
                    this.option.effectCode = this.option.effectType || "Write";
                    sprite = new TextSprite(
                        "Text",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case "Image":
                    sprite = new ImageSprite(
                        "Image",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case "Lottie":
                    sprite = new LottieSprite(
                        "Lottie",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case "Svg":
                    sprite = new SvgSprite(
                        "Svg",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case 'VirtualCharacter':
                    sprite = new VirtualCharacterSprite(
                        "Gif",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case "Gif":
                    sprite = new GifSprite(
                        "Gif",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case "Frame":
                    sprite = new FrameSprite(
                        "Frame",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case "Video":
                    sprite = new VideoSprite(
                        "Video",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case "RichText":
                    sprite = new RichTextSprite(
                        "RichText",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                case "Chart":
                    sprite = new ChartSprite(
                        "Chart",
                        this.ele,
                        this.editor,
                        this.option
                    );
                    break;
                default:
                    return new Promise(function (resolve, reject) {
                        reject("not implemented");
                    });
            }

            if (sprite != null) {
                return sprite
                    .setOption(this.option)
                    .then(function (s) {
                        if (s) {
                            s.effect.init(); // 初始化动画

                            // 视频素材特有
                            var pVideo =
                                s.editor.player.spritesDict[s.id].ele.find(
                                    "video"
                                );
                            if (pVideo.length) {
                                s.video.pVideo = pVideo;
                                s.video.pEle =
                                    s.editor.player.spritesDict[s.id].ele;
                            }
                        }

                        return Promise.resolve(s);
                    })
                    .catch(function (err) {
                        if (this.loadFailed) {
                            return Promise.resolve(err);
                        } else {
                            _this.editor.removeSprite(sprite.id);
                            sprite = null;
                            return Promise.reject(err);
                        }
                    }); //创建元素时创建元素的结构
            }
        },
    });

    var OpHelper = klass(function (el, sprite, style) {
        this.el = el;
        this.sprite = sprite;
        this.style = Object.assign({}, style);
        this.handlePoint = [];
        this.handlePointEle = $('<div class="handle-point-ele"></div>');
        this.handleSvip = null;
        this.isSvip = false; // 判断是否显示vip 角标以及种类
        this.cursorArr = [];
        this.lockDom = null;

        this.updateData();
        this.updateEle();
        this.addBtn();
    }).methods({
        updateData: function () {
            // 8个小正方形，从正下方逆时针排序
            this.handlePoint = [].concat([
                {
                    pt: { left: "calc(50% - 4px)", bottom: "-4px" },
                    action: "s",
                },
                { pt: { left: "-6px", bottom: "-6px" }, action: "sw" },
                { pt: { left: "-3.5px", top: "calc(50% - 4px)" }, action: "w" },
                { pt: { left: "-6px", top: "-6px" }, action: "nw" },
                { pt: { left: "calc(50% - 4px)", top: "-4px" }, action: "n" },
                { pt: { right: "-6px", top: "-6px" }, action: "ne" },
                {
                    pt: { right: "-3.5px", top: "calc(50% - 4px)" },
                    action: "e",
                },
                {
                    pt: {
                        right: "-6px",
                        bottom: "-6px",
                        left: "auto",
                        top: "auto",
                    },
                    action: "se",
                },
                { pt: { right: "-20px", bottom: "-20px" }, action: "spin" },
            ]);

            this.cursorArr = [
                "s-resize",
                "sw-resize",
                "w-resize",
                "nw-resize",
                "n-resize",
                "ne-resize",
                "e-resize",
                "se-resize",
            ];

            if (
                this.sprite.type === "Text" ||
                this.sprite.type === "RichText"
            ) {
                switch (
                    this.sprite.versionAnyway // 横竖版
                ) {
                    case "Vertical": // 竖版
                        this.handlePoint = [].concat([
                            {
                                pt: {
                                    left: "calc(50% - 4px)",
                                    bottom: "-6px",
                                    width: "12px",
                                    height: "12px",
                                },
                                action: "s",
                            },
                            {
                                pt: {
                                    left: "calc(50% - 4px)",
                                    top: "-6px",
                                    width: "12px",
                                    height: "12px",
                                },
                                action: "n",
                            },
                            {
                                pt: { right: "-20px", bottom: "-20px" },
                                action: "spin",
                            },
                        ]);
                        break;
                    default:
                        this.handlePoint = [].concat([
                            {
                                pt: {
                                    left: "-6px",
                                    top: "calc(50% - 6px)",
                                    width: "12px",
                                    height: "12px",
                                },
                                action: "w",
                            },
                            {
                                pt: {
                                    right: "-6px",
                                    top: "calc(50% - 6px)",
                                    width: "12px",
                                    height: "12px",
                                },
                                action: "e",
                            },
                            {
                                pt: { right: "-20px", bottom: "-20px" },
                                action: "spin",
                            },
                        ]);
                }
            } else if (
                this.sprite.type === "Lottie" ||
                this.sprite.type === "Frame" ||
                this.sprite.type === "Video" ||
                this.sprite.type === "multiSelect" ||
                this.sprite.croppedFlag
            ) {
                this.handlePoint = [].concat([
                    { pt: { left: "-6px", bottom: "-6px" }, action: "sw" },
                    { pt: { left: "-6px", top: "-6px" }, action: "nw" },
                    { pt: { right: "-6px", top: "-6px" }, action: "ne" },
                    {
                        pt: {
                            right: "-6px",
                            bottom: "-6px",
                            left: "auto",
                            top: "auto",
                        },
                        action: "se",
                    },
                    { pt: { right: "-20px", bottom: "-20px" }, action: "spin" },
                ]);
            }
        },
        updateEle: function () {
            this.handlePointEle = $('<div class="handle-point-ele"></div>');
            // 生产DOM结构
            for (var i = 0; i < this.handlePoint.length; i++) {
                this.handlePoint[i].ele = $("<div></div>").addClass(
                    "op-handle-point op-handle-" + this.handlePoint[i].action
                );
                var styleObject = Object.assign({}, this.handlePoint[i].pt);
                this.handlePoint[i].ele.css(styleObject);
                this.handlePoint[i].ele.attr({
                    "data-id": this.sprite.id,
                    "data-action": this.handlePoint[i].action,
                });
                this.handlePointEle.append(this.handlePoint[i].ele);
            }

            this.setCursor(0);

            this.lockDom = $('<div class="handle-lock-ele"></div>')
                .attr({
                    "data-id": this.sprite.id,
                    "data-action": "unlock",
                })
                .hide();

            this.el.children().remove();
            this.el.addClass("active");
            this.el.append(this.handlePointEle);
            this.el.append(this.lockDom);
        },
        showHideEle: function (bol) {
            if (bol) {
                this.toggleFourPoints();
                this.handlePointEle.show();
                if (this.sprite.locked) {
                    this.handlePointEle.hide();
                    this.helpBtn && this.helpBtn.hide();
                    this.lockDom.show();
                } else {
                    this.handlePointEle.show();
                    this.helpBtn && this.helpBtn.show();
                    this.lockDom.hide();
                }
            } else {
                this.handlePointEle.hide();
                this.lockDom.hide();
            }
            this.showHideSvip(bol);
        },
        retrieveEle: function () {
            this.handlePointEle =
                this.sprite.helpEle.children(".handle-point-ele");
        },
        setCursor: function (deg) {
            // 选择角度对应的cursor变化
            if (!this.handlePoint[0].ele) return;
            var showClassArr = [],
                sliceIndex = 0;

            if (!deg) {
                deg = this.sprite.rotate;
            }

            if (deg < -22.5) {
                deg = deg + 360;
            } else if (deg > 347.5) {
                deg = deg - 360;
            }

            // 每隔45° 数组变化一次，将第一个数据放入到最后
            sliceIndex = parseInt((deg + 22.5) / 45);
            showClassArr = this.cursorArr
                .slice(sliceIndex)
                .concat(this.cursorArr.slice(0, sliceIndex));

            if (this.handlePoint.length === 3) {
                for (var i = 0; i < this.handlePoint.length - 1; i++) {
                    this.handlePoint[i].ele.css({
                        cursor: showClassArr[
                            i * 4 +
                                (this.sprite.versionAnyway === "Vertical"
                                    ? 0
                                    : 2)
                        ],
                    });
                }
            } else if (this.handlePoint.length === 5) {
                for (var i = 0; i < this.handlePoint.length - 1; i++) {
                    this.handlePoint[i].ele.css({
                        cursor: showClassArr[i * 2 + 1],
                    });
                }
            } else {
                for (var i = 0; i < this.handlePoint.length - 1; i++) {
                    this.handlePoint[i].ele.css({
                        cursor: showClassArr[i],
                    });
                }
            }
        },
        addSvip: function (label, name) {
            // if (this.handleSvip) return;
            if (this.handleSvip) {
                this.handleSvip.remove();
            }
            var vipHtml = label || "VIP";
            var className = name || "handle-svip";
            this.handleSvip = $("<div></div>")
                .addClass(className)
                .html(vipHtml)
                .attr({
                    "data-id": this.sprite.id,
                })
                .css({
                    "-webkit-user-select": "none",
                    "user-select": "none",
                });
            this.handlePointEle.append(this.handleSvip);
        },
        showHideSvip: function (bol, type, action) {
            // 添加svip元素
            if (!this.handleSvip) return;
            if (bol) {
                this.handleSvip.show();
            } else {
                if (action) {
                    var handDom = this.handleSvip[0].parentElement;
                    handDom.removeChild(this.handleSvip[0]);
                    this.handleSvip = false;
                } else {
                    this.handleSvip.hide();
                }
                if (type) {
                    this.handlePointEle.css({
                        opacity: "0",
                        visibility: "hidden",
                    });
                }
            }
        },
        addBtn: function () {
            var _this = this;
            if (this.sprite.type !== "Frame") {
                return;
            }

            var elRef = _this.handlePointEle.parent();

            var el = $("<div></div>").addClass("handle-btn--frame");
            el.css({
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                margin: "auto",
                width: "64px",
                height: "64px",
                color: "#9692A9",
                "background-color": "rgba(255, 255, 255, 0.9)",
                "box-shadow": "0px 0px 4px 0px rgba(102, 111, 158, 0.38)",
                "border-radius": "50%",
                cursor: "pointer",
            });
            el.hide();
            !_this.sprite.picData.picSize && el.show();

            var img = $("<img/>");
            var svgUrl = _this.sprite.picData.picSize
                ? "/static/svg/pen.svg"
                : "/static/svg/add-pic.svg";
            img.prop("src", svgUrl).css({
                width: "30%",
                height: "30%",
                marginTop: "20%",
            });
            var text = $("<div>添加</div>");

            img.appendTo(el);
            text.appendTo(el);
            el.appendTo(elRef);

            var picSizePrev;
            function updateContent(hover) {
                let icons = {
                    pen: "/static/svg/pen.svg",
                    add: "/static/svg/add-pic.svg",
                };
                let hoverIcons = {
                    pen: "/static/svg/pen-active.svg",
                    add: "/static/svg/add-pic-active.svg",
                };
                let targetIcons = hover ? hoverIcons : icons;
                el.css({
                    color: hover ? "" : "#9692A9",
                });

                text.text(_this.sprite.picData.picSize ? "编辑" : "添加");
                var svgUrl = _this.sprite.picData.picSize
                    ? targetIcons.pen
                    : targetIcons.add;
                img.prop("src", svgUrl);
                picSizePrev = _this.sprite.picData.picSize;
            }

            var tid;

            elRef.on("mouseenter", function () {
                updateContent();
                tid = setInterval(function () {
                    if (picSizePrev === _this.sprite.picData.picSize) {
                        return;
                    }

                    updateContent();
                }, 1000);
                !_this.sprite.locked && el.show();
                if (64 >= elRef.width()) {
                    var len = elRef.width() / 4;
                    el.css({
                        // width: len,
                        // height: len,
                        left: "100%",
                    });
                } else {
                    el.css({
                        width: 64,
                        height: 64,
                        left: 0,
                    });
                }
            });

            elRef.on("mouseleave", function () {
                _this.sprite.picData.picSize && el.hide();
                clearInterval(tid);
            });

            el.on("click", function (ev) {
                ev.stopPropagation();
                _this.sprite.editor.selectSprite([_this.sprite]);
                // _this.sprite.setSelected(true);
                eve("helpBtnClicked", null, {
                    sprite: _this.sprite,
                });
                _this.sprite.action = "editFrame";
            });

            el.on("dbclick", function (ev) {
                ev.stopPropagation();
            });

            el.on("mouseover", function () {
                updateContent(true);
            });

            el.on("mouseout", function () {
                updateContent(false);
            });

            _this.helpBtn = el;
        },
        // showHideBtn: function (bool) {
        //     var _this = this;
        //     if (this.sprite.type !== 'Frame') {
        //         return;
        //     }
        //     var svgUrl = _this.sprite.picData.picSize
        //         ? '/static/svg/pen-active.svg'
        //         : '/static/svg/add-pic-active.svg'
        //     _this.helpBtn.find('img').prop('src', svgUrl);
        // }
        _toggleFourPoints: function (flag) {
            var points = this.handlePointEle.find(
                ".op-handle-s, .op-handle-w, .op-handle-n, .op-handle-e"
            );
            if (flag) {
                points.show();
            } else {
                points.hide();
            }
        },
        toggleFourPoints: function () {
            if (
                this.sprite.cropType === "free" &&
                Math.abs(this.sprite.cropBoxData.deltaRotation) > 1
            ) {
                this._toggleFourPoints(false);
            } else {
                this._toggleFourPoints(true);
            }
        },
    });

    var OpMatting = klass(function ({ width, height, ele }) {
        this.mattingEl,
            this.mattingBtns,
            this.mattingLoading,
            this.mattingMask,
            this.finishBtn,
            (this.cancelBtn = null);
        this.ele = ele;
        this.isMattingStatus = 1; // 1 未抠图 2 抠图中 3 抠图api完成 4.保留抠图后的图片
        this.initEle({ width, height, ele });
    }).methods({
        finishMatting: function ({ option, url, img, id }) {
            img.off("load");
            img.on("load", () => {
                this.mattingLoading.remove();
                this.mattingMask.remove();
                this.mattingEl.css({ height: 0 });
                this.isMattingStatus = 3;
                this.finishBtn.removeClass("gray").addClass("normal");
                this.finishBtn.mousedown((e) => {
                    e.stopPropagation();
                    let slidePlay = $(`#player-sprite-${id} img`);
                    let data = {
                        img,
                        spriteOption: option,
                        url,
                        oldUrl: option.url,
                        slidePlay,
                    };
                    eve("undo_redo", null, { type: "finishMatting", data });
                    option.url = url;
                    this.mattingEl.remove();
                    this.isMattingStatus = 4;
                    slidePlay.attr("src", handleAssetsUrl(url));
                });
                this.cancelBtn.mousedown((e) => {
                    e.stopPropagation();
                    img.attr("src", handleAssetsUrl(option.url));
                    this.isMattingStatus = 1;
                    this.mattingEl.remove();
                });
                $(`:not(#${this.ele.attr("id")})`).mousedown((e) => {
                    if (this.isMattingStatus === 3) {
                        this.finishBtn.mousedown();
                    }
                });
            });
            img.attr("src", handleAssetsUrl(url));
        },
        updateMattingEl: function (style) {
            let wH = Math.min(style.width, style.height);
            let tScale = Math.min(wH, 40) / 40;
            this.mattingLoading.css({ transform: `scale(${tScale})` });
            this.mattingEl.css(style);
        },
        initEle: function ({ width, height, ele }) {
            let wH = Math.min(width, height);
            let tScale = Math.min(wH, 40) / 40;
            this.ele.children(".matting-control-el") &&
                this.ele.children(".matting-control-el").remove();
            this.mattingEl = $(`<div class="matting-control-el"></div>`);
            this.mattingBtns = $(
                `<div class="matting-btns"><div class="btn cancel">取消</div><div class="btn gray finish">完成</div></div>`
            );
            this.mattingMask = $('<div class="matting-shelter"></div>');
            this.mattingLoading = $(
                `<div class="loadEffect"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div>`
            );
            this.mattingEl.css({ width, height });
            this.mattingEl.append(this.mattingBtns);
            this.mattingEl.append(this.mattingMask);
            this.mattingEl.append(this.mattingLoading);
            this.mattingLoading.css({ transform: `scale(${tScale})` });
            ele.append(this.mattingEl);
            this.isMattingStatus = 2; // 抠图中
            this.finishBtn = this.mattingBtns.children(".finish");
            this.cancelBtn = this.mattingBtns.children(".cancel");
            this.cancelBtn.mousedown((e) => {
                e.stopPropagation();
                this.mattingEl.remove();
                this.isMattingStatus = 1;
            });
        },
    });
    // 缓动动画算法
    var EasingAnim = klass(function () {}).statics({
        /* 缓动动画函数接收的4个参数：
         * t: currentIteration 当前的迭代计数（可以视为time或frame）
         * b: startValue 初始值
         * c: changeInValue 变化值（最终值与初始值之差）
         * d: totalIteration 总迭代次数（可视为duration）
         */

        // 情绪稳定
        linear: function (t, b, c, d) {
            return c * (t / d) + b;
        },

        // 情绪逐渐失控
        easeOutCubic: function (t, b, c, d) {
            return c * (t /= d) * t * t + b;
        },

        // 情绪剧烈失控
        easeOutExpo: function (t, b, c, d) {
            return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
        },

        // 情绪强烈波动
        easeOutElastic: function (t, b, c, d) {
            var s = 1.70158;
            var p = 0;
            var a = c;
            if (t == 0) return b;
            if ((t /= d) == 1) return b + c;
            if (!p) p = d * 0.3;
            if (a < Math.abs(c)) {
                a = c;
                var s = p / 4;
            } else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
            return (
                a *
                    Math.pow(2, -10 * t) *
                    Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
                c +
                b
            );
        },

        // 适合pop动画
        easeOutBack: function (t, b, c, d, s) {
            if (s == undefined) s = 1.70158;
            return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
        },

        easeInBack: function (t, b, c, d, s) {
            if (s == undefined) s = 1.70158;
            return c * (t /= d) * t * ((s + 1) * t - s) + b;
        },

        // 适合路径动画
        easeInOutQuad: function (t, b, c, d) {
            if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
            return (-c / 2) * (--t * (t - 2) - 1) + b;
        },

        easeOutQuint: function (t, b, c, d) {
            return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
        },
    });

    EasingAnim[0] = EasingAnim.linear;
    EasingAnim[1] = EasingAnim.easeOutExpo;
    EasingAnim[2] = EasingAnim.easeOutQuint;

    // 动画实现----------------------------------V
    var Effect = klass(function (sprite, option) {
        this.code = option.code || "LeftIn"; //手势还是移动
        this.sprite = sprite;

        this.frameRate = sprite.editor.option.frameRate || 60; // 默认帧率

        // 入场动画
        this.entranceAnim = Object.assign(
            { start: 500, end: 1000 },
            option.entranceAnim
        );

        // 停留动画
        this.stayAnim = option.stayAnim || {
            type: "None",
        };

        // 路径动画
        // this.pathAnim = option.pathAnim || {},
        this.pathAnim = Object.assign(
            { type: "Path" },
            this.pathAnim,
            option.pathAnim
        );
        if (!this.pathAnim.scale) this.pathAnim.scale = sprite.editor.scale;

        // 退场动画
        this.exitAnim = Object.assign(
            { start: this.getScenesDuration(), end: this.getScenesDuration() },
            option.exitAnim
        );
        !this.exitAnim.type && (this.exitAnim.type = "None");
        this.exitAnim.type === "None" &&
            (this.exitAnim.end = this.exitAnim.start);

        // this.hand = option.hand;
        // 是否init
        this.isInit = false;
    })
        .statics({
            DEFAULT_EASING: "easeOutExpo", // 默认缓动动画函数
            WRITE_HAND_SCALE: 1.8,
        })
        .methods({
            toJson: function () {},
            // todo 获取状态
            getStage: function () {},
            // todo 获取最后的状态
            getLastStage: function () {},

            getCode: function () {
                return this.code;
            },

            getSprite: function () {
                return this.sprite;
            },

            // 获取组动画时间轴时长
            getScenesDuration: function () {
                var scense = this.sprite.editor.getScenesIdData(
                    this.sprite.scenesId
                );
                return scense.getDuration();
            },

            getPathAnim: function () {
                if (!this.pathAnim.end) return;
                var data = {};
                data.type = this.pathAnim.type;
                data.easing = this.pathAnim.easing;
                data.end = this.pathAnim.end;
                data.start = this.pathAnim.start;
                data.info = $.extend(true, {}, this.pathAnim.info);
                data.target = Object.assign({}, this.pathAnim.target);
                return data;
            },

            // 设置手势
            _setEffectHand: function (hand) {
                if (!(this.hand instanceof $)) return;
                this.hand.empty();
                // 手势的DOM结构
                var sprite = this.sprite,
                    player = sprite.editor.player,
                    enter = this.entranceAnim, // 入场手势
                    exit = this.exitAnim; // 出场手势

                if (enter.hand) {
                    enter.hand.ele = $("<div></div>")
                        .attr({
                            id: "sprite-enter-hand-" + sprite.uuid,
                        })
                        .css({
                            display: "none",
                            position: "absolute",
                            zIndex: 9999,
                            // transform: sprite.type === 'Text' ? 'scale(' + 1/sprite.editor.scale + ')' : null,
                            // transformOrigin: enter.hand.x + 'px ' + enter.hand.y + 'px'
                        })
                        .append(
                            $("<img>")
                                .attr({
                                    src: enter.hand.url,
                                    width: enter.hand.width,
                                    height: enter.hand.height,
                                })
                                .css({ "max-width": "none" })
                        )
                        .appendTo(this.hand);
                }

                if (exit.hand) {
                    exit.hand.ele = $("<div></div>")
                        .attr({
                            id: "sprite-exit-hand-" + sprite.uuid,
                        })
                        .css({
                            display: "none",
                            position: "absolute",
                            zIndex: 9999,
                        })
                        .append(
                            $("<img>")
                                .attr({
                                    src: exit.hand.url,
                                    width: exit.hand.width,
                                    height: exit.hand.height,
                                })
                                .css({ "max-width": "none" })
                        )
                        .appendTo(this.hand);
                }
                // var $hand = $('<div></div>').attr({
                //     id: 'sprite-hand-' + sprite.uuid
                // }).css({
                //     display: 'none',
                //     position: 'absolute',
                //     zIndex: 9999
                // }).append($('<img>').attr({
                //     src: hand.url,
                //     width: hand.width,
                //     height: hand.height
                // }));

                // 追加到播放层sprite的后面
                //player.spritesDict[sprite.uuid].ele.after($hand);

                // 挂载手势对象
                // this.hand = Object.assign({}, {
                //     x: 0,
                //     y: 0,
                //     ele: $hand
                // }, hand);
            },
            // 初始化动画
            init: function (force) {
                // 将元素加入播放层(player)
                var sprite = this.sprite,
                    editor = sprite.editor,
                    player = editor.player;
                if (!player.spritesDict[sprite.uuid] || force) {
                    var scenes = editor.getScenesIdData(sprite.scenesId),
                        sceneEle = player.scenesDict[scenes.uuid].eleC;

                    if (player.spritesDict[sprite.id]) {
                        sceneEle
                            .children("#player-sprite-" + sprite.id)
                            .remove();
                    }

                    var ps = null;
                    if (!sprite.loadFailed) {
                        if (
                            sprite.type === "Frame" ||
                            sprite.type === "Image"
                        ) {
                            ps = sprite.getDomDiffId("play");
                        } else if (sprite.type === "Svg") {
                            ps = sprite.getDomDiffId();
                        } else {
                            ps = sprite.ele.clone();
                        }
                    } else {
                        ps = sprite.ele.clone();
                    }
                    ps.appendTo(sceneEle);
                    var sid = "player-sprite-" + sprite.uuid;
                    ps.attr({ id: sid });
                    player.spritesDict[sprite.uuid] = {
                        ele: ps,
                        sprite: sprite,
                        id: sid,
                    };

                    // 手势
                    if ($("#sprite-hand-" + sprite.uuid).length === 0) {
                        this.hand = $("<div></div>").attr({
                            id: "sprite-hand-" + sprite.uuid,
                        });
                        ps.after(this.hand);
                    } else {
                        this.hand = $("#sprite-hand-" + sprite.uuid);
                    }

                    if (this.entranceAnim.hand || this.exitAnim.hand) {
                        this._setEffectHand();
                    } else {
                        if (!this.entranceAnim.hand) {
                            this.hand
                                .find('[id^="sprite-enter-hand-"]')
                                .remove();
                        }
                        if (!this.exitAnim.hand) {
                            this.hand
                                .find('[id^="sprite-exit-hand-"]')
                                .remove();
                        }
                    }

                    // lottie动画处理
                    if (!sprite.loadFailed) {
                        if (sprite.type === "Lottie") {
                            ps.empty(); // 清空原dom,重新注册动画并挂载lottie对象
                            var l = lottie.registerAnimation(ps[0]);
                            sprite.playInstance = l;
                            player.spritesDict[sprite.uuid].lottie = l;
                            ps.css("opacity", 1);

                            l.addEventListener("DOMLoaded", function () {
                                ps.children("svg").attr(
                                    "preserveAspectRatio",
                                    "none"
                                );
                                sprite.setFilter();
                                if (sprite.border)
                                    ps.append(sprite.border.dom.clone());
                            });
                        }

                        sprite.initEffect && sprite.initEffect(ps);
                    }
                }
                if (this.exitAnim.effect) {
                    this.exitAnim.effect = false;
                }
                // 直接挂载到effect上, 6.13添加
                this.playerSprite = player.spritesDict[sprite.uuid];

                // this.playerSprite.lottie && this.playerSprite.lottie.setCurrentRawFrameValue(1);

                // 计算各动画时间的起始帧及结束帧
                this.animFrame = {
                    // 入场
                    entrance: {
                        start: this.ms2fps(this.entranceAnim.start),
                        end: this.ms2fps(this.entranceAnim.end),
                    },

                    // 出场
                    exit: {
                        start: this.ms2fps(this.exitAnim.start),
                        end: this.ms2fps(this.exitAnim.end),
                    },

                    // 路径
                    path: AnimEditor.initPathData(this.sprite),

                    stay: null,
                };

                // 停留
                this.animFrame.stay = AnimEditor.initStayData(this.sprite);
                // this.sprite.updateVideoDuration
                //     && this.sprite.updateVideoDuration(
                //         this.entranceAnim.end / 1000,
                //         this.exitAnim.start / 1000
                //     );
                this.sprite.updateTimeOffset &&
                    this.sprite.updateTimeOffset(
                        this.entranceAnim.end / 1000,
                        this.exitAnim.start / 1000
                    );
                return Promise.resolve();
            },

            /**
             * 所有特效的show方法必须继承之
             */
            show: function (frame) {
                if (!this.isInit) return;

                // 视频素材
                if (this.sprite.updateCurrentTime) {
                    this.sprite.updateCurrentTime(frame);
                }

                var sprite = this.sprite,
                    editor = sprite.editor;

                if (!this.playerSprite) return;

                var playerSprite = this.playerSprite;
                playerEle = playerSprite.ele;

                var exitEnd = this.animFrame.exit.end,
                    enStart = this.animFrame.entrance.start,
                    enEnd = this.animFrame.entrance.end,
                    exitStart = this.animFrame.exit.start;

                var sceneBgData = editor.selectedScenes.background.data;

                // 元素播放时间段外
                if (frame > exitEnd || frame < enStart) {
                    // 隐藏元素
                    playerEle.hide();
                    // 退场动画为pop时引发的小bug
                    if (frame < exitStart) this.clearPopFadeExit(playerEle);
                    this.outAnimFn(frame, playerEle);
                } else {
                    playerEle.show();
                }

                // 擦出动画还原
                if (this.exitAnim.type === "Smear") {
                    playerEle.css({
                        "-webkit-mask-position": "",
                        "-webkit-mask-image": "",
                        "-webkit-mask-size": "",
                    });
                }
                // 手势隐藏
                this.entranceAnim.hand &&
                    this.entranceAnim.hand.ele &&
                    this.entranceAnim.hand.ele.hide();
                this.exitAnim.hand &&
                    this.exitAnim.hand.ele &&
                    this.exitAnim.hand.ele.hide();

                // 入场阶段
                if (frame >= enStart && frame <= enEnd) {
                    // 路径动画初始化
                    if (
                        sprite.effect.pathAnim.end ||
                        sprite.effect.stayAnim.type !== "None"
                    ) {
                        playerSprite.ele.css({
                            opacity: sprite.opacity,
                            width: sprite.width,
                            height: sprite.height,
                            top: sprite.positionTop,
                            left: sprite.positionLeft,
                            transform:
                                "rotate(" +
                                sprite.rotate +
                                "deg)" +
                                (sprite.flip ? " scaleX(-1)" : ""),
                        });
                        if (
                            sprite.type === "Svg" &&
                            sprite.option.fileType === 28
                        ) {
                            AnimEditor.changeSvgFillColor(
                                playerSprite.ele[0],
                                sprite.fill
                            );
                        }
                    }

                    sprite.initialFrame && sprite.initialFrame(0);
                    sprite.sync_first && sprite.sync_first();

                    this.enterAnimFn(frame, playerEle);
                }

                // 停留阶段
                if (frame >= enEnd && frame < exitStart) {
                    playerEle.css({
                        "-webkit-mask-image": "none",
                    });
                    if (this.animFrame.path) {
                        // 路径动画
                        this.showPathAnim(frame);
                    } else {
                        playerEle.css({
                            display: "block",
                            left: sprite.positionLeft,
                            top: sprite.positionTop,
                            opacity: sprite.opacity,
                            transform: this._getTransform(),
                        });
                    }
                    // gif和lottie播放 动态效果设置为0的时候 不播放
                    sprite.play && sprite.play(frame - enEnd);
                    this.showLottie && this.showLottie(frame);
                    // 其它动画拓展函数
                    this.stayAnimFn(frame, playerEle);
                }

                // 退场阶段
                if (frame > exitStart && frame <= exitEnd) {
                    this.exitAnimFn(frame, playerEle);
                }

                // stroke width
                var s = this.sprite;
                var isEditable = /^(28|29)$/.test(s.option.fileType);
                if (
                    s.type === "Svg" &&
                    isEditable &&
                    s.effect.code !== "Draw"
                ) {
                    //
                    if (
                        s.ele
                            .find('path[stroke^="#"]')
                            .eq(0)
                            .css("strokeWidth") !==
                        playerSprite.ele
                            .find("svg")
                            .find('path[stroke^="#"]')
                            .eq(0)
                            .css("strokeWidth")
                    ) {
                        s.updateStyle(playerSprite.ele.find("svg").get(0), {
                            strokeWidth: s.option.strokeWidth,
                        });
                    }
                }

                // 显示player层
                var $mList = $(".Tool .mask-blur").filter(function (index, el) {
                    return $(el).find("video").length;
                });
                $mList.each(function (index, el) {
                    $(el).data("bgi", $(el).css("backgroundImage"));
                });
                $mList.css({ backgroundImage: "none" });
                editor.player.ele.show();
                if (sceneBgData.type === "Video") {
                    editor.content.css({ overflow: "hidden" });
                } else {
                    editor.content.css({ overflow: "hidden", opacity: 0 });
                }

                if (
                    sceneBgData.data.opacity < 1 &&
                    sceneBgData.type === "Video"
                ) {
                    editor.content.css({
                        opacity: 0,
                        transitionDuration: "200ms",
                    });
                    editor.player.ele.css({ backgroundColor: "transparent" });
                } else if (sceneBgData.data.opacity < 1) {
                    editor.content.css({
                        opacity: 0,
                        transitionDuration: "0ms",
                    });
                    editor.player.ele.css({ backgroundColor: "transparent" });
                }

                // 同步content层
                this._syncContent(frame);
            },

            outAnimFn: function (frame, playerEle) {
                // 子类拓展
            },

            enterAnimFn: function (frame, playerEle) {
                // 子类拓展
            },

            stayAnimFn: function (frame, playerEle) {
                // 子类拓展
                if (this.stayAnim.type !== "None") {
                    var sprite = this.sprite,
                        frameRate = sprite.editor.option.frameRate || 60,
                        move;
                    var bbox = {
                        w: sprite.width,
                        h: sprite.height,
                        x: sprite.positionLeft,
                        y: sprite.positionTop,
                        rotate: sprite.rotate,
                        tH: sprite.editor.clientHeight,
                    };
                    var frameCalc = frame - this.animFrame.entrance.end;
                    move = AnimEditor.stayOffsetCalc(
                        bbox,
                        this.stayAnim,
                        frameCalc,
                        frameRate
                    );
                    if (!move) return;
                    playerEle.css({
                        left: move.left,
                        top: move.top,
                        transform:
                            "rotate(" +
                            move.rotate +
                            "deg)" +
                            (sprite.flip ? " scaleX(-1)" : ""),
                    });
                }
            },

            exitAnimFn: function (frame, playerEle) {
                var pathTarget = this.animFrame.path;
                var stayTarget = this.animFrame.stay;

                if (pathTarget) {
                    playerEle.css({
                        left: pathTarget.target.left,
                        top: pathTarget.target.top,
                        transform: this._getTransform(pathTarget.target.rotate),
                    });
                }

                if (stayTarget) {
                    playerEle.css({
                        left: stayTarget.left,
                        top: stayTarget.top,
                        transform: this._getTransform(stayTarget.rotate),
                    });
                }

                this.showExitAnim(frame);
            },

            /**
             * player同步sprite状态
             */
            syncSprite: function (style, font) {
                var ps = this.playerSprite.ele,
                    sprite = this.sprite;
                ps.css(style);
                if (font) {
                    ps.find("[autofocus]").css({
                        font: font,
                        width: style.width * sprite.editor.scale,
                    });
                }
                // 同步图表内的图片
                if (sprite.type === "Chart") {
                    ps.find("img").attr(
                        "src",
                        sprite.ele.find("img").attr("src")
                    );
                } else if (sprite.type === "RichText") {
                    ps.children().css({
                        width: style.width * sprite.editor.scale,
                    });
                } else if (sprite.type === "Gif") {
                    sprite.canvas.style.transform = `scale(${
                        style.width / sprite.initData.width
                    }, ${style.height / sprite.initData.height})`;
                }
            },

            /**
             * 同步content层的元素状态
             * @param frame {int} 当前帧数
             */
            _syncContent: function (frame) {
                var af = this.animFrame,
                    sprite = this.sprite,
                    editor = sprite.editor;

                if (!af) return;
                if (frame < af.entrance.end) {
                    // 进场及进场动画完成前不显示
                    //sprite.ele.hide();
                    sprite.showHideSprite(false);
                } else if (frame >= af.entrance.end && frame <= af.exit.start) {
                    // 进场完成，出场之前，显示
                    sprite.showHideSprite(true);
                } else if (frame > af.exit.start) {
                    // 出场及出场之后，不显示
                    // sprite.ele.hide();
                    sprite.showHideSprite(false);
                }
            },

            /**
             * 计算sprite每帧偏移值
             * 2018-9-27 改为计算easing动画后的值
             * @param off {object} 偏移后的xy坐标
             * @param origin {object} 原始坐标
             */
            offsetCalc: function (off, origin, easing) {
                var sprite = this.sprite;
                easing = easing || "linear";

                // 若没有origin，则取sprite的初始位置
                var _origin = origin || {
                    x: sprite.positionLeft,
                    y: sprite.positionTop,
                };

                //x轴及y轴距离
                var distanceX = _origin.x - off.x,
                    distanceY = _origin.y - off.y;

                // 入场及退场都在0.5秒内完成，设移动距离为d，则每帧移动 d / 500 * ms个单位
                // var r = {};
                // r.x = distanceX ? distanceX / 500 * ms : 0;
                // r.y = distanceY ? distanceY / 500 * ms : 0;
                // return r;

                var r = {};
                r.x = off.x
                    ? EasingAnim[easing](
                          this.frameOff,
                          off.x,
                          distanceX,
                          0.5 * this.frameRate
                      )
                    : _origin.x;
                r.y = off.y
                    ? EasingAnim[easing](
                          this.frameOff,
                          off.y,
                          distanceY,
                          0.5 * this.frameRate
                      )
                    : _origin.y;
                return r;
            },

            /**
             *  计算path动画时每帧的偏移值
             *  @param off {object} 各种偏移量: 位置，宽高，角度
             *  @param t {int} 动画完成时间
             */
            _pathOffsetCalc: function (off, t) {
                var sprite = this.sprite;
                // var ms = 1000 / this.frameRate; // 每帧需要的时间

                var efunc = EasingAnim["easeInOutQuad"];

                // 位置
                var distanceX = off.x - sprite.positionLeft,
                    distanceY = off.y - sprite.positionTop;

                // 宽高
                // var diffW = sprite.width - off.w,
                //     diffH = sprite.height - off.h;

                // // 角度
                // var diffR = sprite.rotate - off.rotate;

                var total = (t / 1000) * this.frameRate;

                var left = efunc(
                        this.frameOff,
                        sprite.positionLeft,
                        distanceX,
                        total
                    ),
                    top = efunc(
                        this.frameOff,
                        sprite.positionTop,
                        distanceY,
                        total
                    ),
                    diffW = efunc(
                        this.frameOff,
                        sprite.width,
                        off.w - sprite.width,
                        total
                    ),
                    diffH = efunc(
                        this.frameOff,
                        sprite.height,
                        off.h - sprite.height,
                        total
                    ),
                    diffR = efunc(
                        this.frameOff,
                        sprite.rotate,
                        off.rotate - sprite.rotate,
                        total
                    );

                return {
                    left: left,
                    top: top,
                    width: diffW,
                    height: diffH,
                    rotate: diffR,
                };
            },

            // 计算手势中心位置
            _calcHandPosition: function (x, y, hand, center) {
                var sprite = this.sprite,
                    cx = center
                        ? x + sprite.width / 2
                        : x + sprite.positionLeft,
                    cy = center
                        ? y + sprite.height / 2
                        : y + sprite.positionTop;
                return {
                    x: cx - hand.x,
                    y: cy - hand.y,
                };
            },

            // 根据当前动画时间求出当前帧
            ms2fps: function (ms) {
                var t = 1000 / this.frameRate; // 每帧需要的时间
                return Math.ceil(ms / t);
            },

            // 获取transofrm属性
            _getTransform: function (rotate) {
                var sprite = this.sprite;
                var transform = "";
                transform += sprite.rotate
                    ? " rotate(" + (rotate || sprite.rotate) + "deg) "
                    : "";
                transform += sprite.flip
                    ? " scaleX(" + (sprite.flip ? -1 : 1) + ") "
                    : "";

                return transform;
            },

            // Pop和Fade的退场特效影响消除
            clearPopFadeExit: function (ele) {
                if ("PopOut" === this.exitAnim.type) {
                    ele.css("transform", this._getTransform());
                } else if ("FadeOut" === this.exitAnim.type) {
                    ele.css("opacity", this.sprite.opacity);
                }
            },

            /**
             *  lottie动画的播放
             *  @param frame 当前帧
             */
            showLottie: function (frame) {
                if (this.sprite.loadFailed) return;
                var sprite = this.sprite,
                    player = sprite.editor.player;
                var f = frame - this.animFrame.entrance.end;
                var lottie = (player.spritesDict[sprite.uuid] || {}).lottie;
                if (!lottie) return false;
                f = f < 0 ? 0 : f;

                var _rate = sprite.editor.option.frameRate / lottie.frameRate,
                    frameCalc = (f / _rate) % lottie.totalFrames;
                // -1 为了那些在最后一帧会消失的Lottie

                if (
                    !sprite.isLoop &&
                    f / _rate > sprite.numberOfLoops * lottie.totalFrames
                )
                    frameCalc = lottie.totalFrames - 1;
                if (!sprite.isLoop && f && !frameCalc)
                    frameCalc = lottie.totalFrames - 1;
                if (!sprite.isLoop && sprite.numberOfLoops === 0) {
                    frameCalc = 0;
                }
                try {
                    lottie.setCurrentRawFrameValue(frameCalc);
                } catch (err) {
                    console.log("lottie error", err);
                }
            },

            /**
             * 统一的退场动画
             * @param frame 当前帧
             */
            showExitAnim: function (frame) {
                var type = this.exitAnim.type,
                    sprite = this.sprite,
                    editor = sprite.editor,
                    af = this.animFrame.path,
                    pathAnim = this.pathAnim;

                var player = editor.player.spritesDict[sprite.uuid].ele;

                var movex, movey;
                this.frameOff = frame - this.ms2fps(this.exitAnim.start);

                // 退场时的起始点，若有路径动画，则从路径动画的终点开始退场
                var s_left, s_top, s_width, s_height, s_rotate;
                if (pathAnim.start) {
                    s_left = af.target.left;
                    s_top = af.target.top;
                    s_width = af.target.width || sprite.width;
                    s_height = af.target.height || sprite.height;
                    s_rotate = af.target.rotate;
                } else {
                    s_left = sprite.positionLeft;
                    s_top = sprite.positionTop;
                    s_width = sprite.width;
                    s_height = sprite.height;
                    s_rotate = sprite.rotate;
                }

                if (!type || "None" === type) {
                    player.hide();
                } else {
                    // 水平移出
                    if (type === "LeftOut" || type === "RightOut") {
                        var offX =
                            type === "LeftOut" ? -s_width : editor.clientWidth;
                        movex = this.offsetCalc(
                            { x: s_left, y: s_top },
                            {
                                x: offX,
                                y: 0,
                            },
                            this.exitAnim.easing
                        ).x;
                        player.css({ left: movex });
                    } else if (type === "UpOut" || type === "DownOut") {
                        // 垂直移出
                        var offY =
                            type === "UpOut" ? -s_height : editor.clientHeight;
                        movey = this.offsetCalc(
                            { x: s_left, y: s_top },
                            {
                                y: offY,
                                x: 0,
                            },
                            this.exitAnim.easing
                        ).y;

                        player.css({ top: movey });
                    } else if (type === "PopOut") {
                        var _scale = EasingAnim[PopEffect.DEFAULT_OUT_EASING](
                            this.frameOff,
                            1,
                            -1,
                            0.5 * this.frameRate
                        );

                        player.css({
                            display: "block",
                            transform:
                                "rotate(" +
                                s_rotate +
                                "deg) " +
                                " scaleX(" +
                                (sprite.flip ? -1 : 1) +
                                ") " +
                                "scale(" +
                                _scale +
                                ") ",
                        });
                    } else if (type === "FadeOut") {
                        var _scale = EasingAnim.linear(
                            this.frameOff,
                            sprite.opacity,
                            0 - sprite.opacity,
                            0.5 * this.frameRate
                        );
                        player.css({
                            display: "block",
                            opacity: _scale,
                        });
                    } else {
                        // 外部拓展的特效
                        if (AnimEditor.effects[type]) {
                            return AnimEditor.effects[type].exitAnim.call(
                                sprite,
                                frame
                            );
                        }
                        player.hide();
                    }
                }

                // 手势
                if (this.exitAnim.hand && this.exitAnim.hand.ele) {
                    var p = this._calcHandPosition(
                        movex || s_left,
                        movey || s_top,
                        this.exitAnim.hand,
                        true
                    );
                    this.exitAnim.hand.ele.css({
                        display: "block",
                        left: p.x,
                        top: p.y,
                    });
                }
            },

            /**
             * 路径动画
             * @param frame 当前帧
             */
            showPathAnim: function (frame) {
                var sprite = this.sprite,
                    af = this.animFrame;
                // 没有路径动画，不再停留时间直接退出
                if (
                    !sprite.effect.pathAnim.end ||
                    frame < af.path.start ||
                    frame > af.exit.start
                )
                    return;

                var editor = sprite.editor,
                    pathAnim = this.pathAnim,
                    player = editor.player.spritesDict[sprite.uuid].ele,
                    ccw = pathAnim.info.ccw || 0, // ccw为逆时针，0就是顺，1就是逆
                    move;
                // 是否循环
                if (!pathAnim.loop) {
                    if (frame <= af.path.end) {
                        this.frameOff = frame - af.path.start;
                    } else {
                        // 减少一点计算量
                        move = af.path.target;
                    }
                } else if (pathAnim.loop) {
                    this.frameOff =
                        (frame - af.path.start) % (af.path.end - af.path.start);
                    if (pathAnim.type !== "Ellipse") {
                        // 不是圆的话，ccw会一直改变
                        ccw =
                            parseInt(
                                (frame - af.path.start) /
                                    (af.path.end - af.path.start)
                            ) % 2;
                    }
                }

                // 每帧偏移量
                !move &&
                    (move = AnimEditor.pathOffsetCalc(
                        sprite,
                        af.path,
                        this.frameOff,
                        ccw
                    ));

                player.css({
                    left: move.left,
                    top: move.top,
                    width: move.width,
                    height: move.height,
                    opacity: move.opacity,
                    transform:
                        "rotate(" +
                        move.rotate +
                        "deg)" +
                        (sprite.flip ? " scaleX(-1)" : ""),
                });

                move.fillColor &&
                    AnimEditor.changeSvgFillColor(player[0], move.fillColor);
                move.textColor &&
                    player.children().css({
                        color: move.textColor,
                    });
                if (sprite.type === "Gif") {
                    sprite.canvas.style.transform = `scale(${
                        move.width / sprite.initData.width
                    }, ${move.height / sprite.initData.height})`;
                }

                if (sprite.cropType === "free") {
                    sprite.handleCrop(player, player.children().eq(0), sprite);
                    sprite.handleCrop(
                        sprite.ele,
                        sprite.ele.children().eq(0),
                        sprite,
                        {
                            nextW: player.width(),
                            nextH: player.height(),
                        }
                    );
                }
            },
        });

    // 移入动画
    var MoveEffect = Effect.extend(function (sprite, option) {
        this.type = option.code || "LeftIn"; //默认是从左移入
        this.easing = option.easing || "easeOutExpo"; // 缓动效果
    }).methods({
        init: function () {
            var _this = this;
            return this.supr(true)
                .then(function () {
                    _this.isInit = true;
                    return Promise.resolve();
                })
                .catch(function (err) {
                    throw "Error: " + err;
                });
        },

        enterAnimFn: function (frame, playerEle) {
            this.supr(frame, playerEle);
            var sprite = this.sprite,
                editor = sprite.editor;
            var move;
            // 计算起始帧与当前帧的差
            this.frameOff = frame - this.animFrame.entrance.start;
            // 水平移动（从左从右）
            if (this.type === "LeftIn" || this.type === "RightIn") {
                var offX =
                    this.type === "LeftIn" ? -sprite.width : editor.clientWidth;
                move = this.offsetCalc({ x: offX, y: 0 }, null, this.easing);
                // movex = offX + offsetPerFrame.x * this.frameOff;
                // movey = sprite.positionTop;
                playerEle.css({ left: move.x, top: move.y });
            } else {
                // 垂直移动
                var offY =
                    this.type === "DownIn"
                        ? editor.clientHeight
                        : -sprite.height;
                move = this.offsetCalc({ x: 0, y: offY }, null, this.easing);
                //movey = offY + offsetPerFrame.y * this.frameOff;
                //movex = sprite.positionLeft;
                playerEle.css({ top: move.y, left: move.x });
            }

            // 手势
            if (this.entranceAnim.hand) {
                var p = this._calcHandPosition(
                    move.x,
                    move.y,
                    this.entranceAnim.hand,
                    true
                );
                this.entranceAnim.hand.ele.css({
                    display: "block",
                    left: p.x,
                    top: p.y,
                });
            }
        },
    });

    // 手绘动画
    var HandEffect = Effect.extend(function (sprite, option) {
        this.type = option.code || "Hand"; //默认是从左移
        this.START_MS = 500;
        this.drawingDuration =
            option.drawingDuration || this.handleDrawingDuration();
        this.handleDrawingDuration();
        this.noArea = false;
    }).methods({
        handleDrawingDuration: function () {
            let duration = this.exitAnim.start - this.entranceAnim.end;
            let dd = duration <= 2000 ? duration : duration / 2;
            let step = 500;
            let count = (dd / step) | 0;
            let remain = dd % 500;
            if (remain < step / 2) {
                dd = count * step;
            } else {
                dd = count * step + step;
            }
            return dd;
        },
        // 初始化位图的手绘路径
        _initImage: function () {
            var sprite = this.sprite,
                image = sprite.getImage(),
                attr = ImageLoader.constructAnimPath(image),
                editor = sprite.editor,
                player = editor.player, // 播放层
                playerSprite = player.spritesDict[sprite.uuid];

            // 添加svg dom
            var id = playerSprite.ele.empty().attr("id");
            if (sprite.border)
                playerSprite.ele.append(sprite.border.dom.clone());
            var svg = SVG(id)
                .style({
                    position: "absolute",
                    top: 0,
                    left: 0,
                })
                .attr({
                    id: "anim-path-helper-" + sprite.id,
                    preserveAspectRatio: "none",
                });

            var path = svg
                .group()
                .path()
                .attr(Object.assign(attr, { opacity: 0 }));
            svg.attr({
                viewBox: "0 0 " + image.width + " " + image.height,
            });

            // 添加一个group层，作为mask背景，生成一个svg的image元素
            var svgg = svg.group().style({
                mask: "url(#" + sprite.id + "-mask)",
            });
            svgg.image($(image).attr("src"), image.width, image.height).attr({
                preserveAspectRatio: "none meet", // 设置宽高时允许变形
            });

            // 挂载svg对象
            this.svg = svg;
            this.playerSvgGroup = svgg;
        },

        // 初始化数据
        _initData: function () {
            var sprite = this.sprite,
                editor = sprite.editor,
                player = editor.player,
                _this = this;

            var playerSvg, pssvg, pssvgg;

            if ("Image" === sprite.getType()) {
                // 位图
                this._initImage(); // 初始化位图的手绘路径
                pssvg = this.svg;
                pssvgg = this.playerSvgGroup;
            } else {
                // 普通svg图
                this.svg = sprite.svg;
                (playerSvg =
                    player.spritesDict[sprite.uuid].ele.children("svg")),
                    (pssvg = SVG(playerSvg[0]).clear());
                pssvgg = pssvg.group();
            }

            var mask = pssvg.mask().attr({
                id: sprite.id + "-mask",
            });

            this.maskId = sprite.id + "-mask";
            // pssvgg.style('mask', 'url(#' + this.maskId + ')');

            this.items = [];

            var paths = this.svg.select("path").members;
            var hasStroke = paths.some(function (p) {
                var css = $(p.node).css("stroke") || "none";
                var attr = p.attr("stroke") || "none";
                return css !== "none" || attr !== "none";
            });
            var _onePathBBox = paths[0].node.getBBox();
            if (
                paths.length > 1 ||
                _onePathBBox.width * _onePathBBox.height > 0
            ) {
                pssvgg.style("mask", "url(#" + this.maskId + ")");
            }
            var noArea =
                paths.length === 1 &&
                _onePathBBox.width * _onePathBBox.height === 0;
            if (noArea) {
                $(mask.node).hide();
                this.noArea = noArea;
            }

            paths.forEach(function (p) {
                let $g = $(p.node).closest("g");
                if ($g.length && $g.attr("transform")) {
                    var bb = $g[0].getBBox();
                }
                p = p.clone();
                // 坑爹的事情发生了，svg.js默认会给没有stroke的path加上一个私有的stroke，值为#000000
                // 因此还是使用其node上的属性值比较靠谱
                var stroke = p.node.getAttribute("stroke");
                if (
                    (!stroke || stroke === "none") &&
                    // && (sprite.option.fileType !== 28 && sprite.option.fileType !== 29)
                    !hasStroke
                ) {
                    // stroke = p.node.getAttribute('fill') || '#fff';
                    // if (stroke.indexOf('url') > -1) {
                    //     stroke = '#fff';
                    // }

                    if ($(p).closest("mask")[0]) {
                        stroke = "#fff";
                    } else {
                        stroke = "#999";
                        $(p).addClass("custom-stroke");
                    }
                    // if (sprite.option.stroke && (sprite.option.fileType === 28 || sprite.option.fileType === 29)) {
                    //     stroke = sprite.option.stroke
                    // }
                    p.node.setAttribute("stroke", stroke);
                    p.node.setAttribute("stroke-width", "1px");
                } else if (
                    stroke &&
                    (sprite.option.fileType === 28 ||
                        sprite.option.fileType === 29)
                ) {
                    // p.node.setAttribute('stroke', '#fff');
                    // p.node.setAttribute('stroke-width', '1px');
                    if (noArea) {
                        $(p.node).css("stroke", sprite.option.stroke);
                    }
                }

                // 获取每条path的长度
                // --
                if (!stroke || stroke !== "none" || p.hasClass("force-draw")) {
                    _this.items.push({
                        el: p,
                        length: !stroke || stroke !== "none" ? p.length() : 0,
                        matrix: _this.getNodeMatrix(p.node),
                        transform: bb || null,
                    });
                }

                pssvgg.add(p);
            });

            var groups = $(sprite.svg.node)
                .find("g")
                .filter(function (i, el) {
                    var hasTransform = $(el).attr("transform");
                    var $chs = $(el).children();
                    var hasPath = false;
                    $chs.each(function (i, ch) {
                        return ch.tagName === "path" && (hasPath = true);
                    });
                    return hasPath && hasTransform;
                });
            var _count = 0;
            groups.length && pssvgg.clear();
            groups.each(function (i, el) {
                var g = pssvg.group().clear();
                var len = $(el).find("path").length;
                var part = _this.items.slice(_count, len);
                _count = len;
                part.map(function (v, i) {
                    g.add(v.el);
                });

                $(g.node).attr("transform", $(el).attr("transform"));
                pssvgg.add(g);
            });

            var totalLength = 0;
            // 获取总长度
            for (var i = 0, len = this.items.length; i < len; i++) {
                totalLength += this.items[i].length;
            }

            var ms = this.START_MS;
            if (this.sprite.type !== "Svg") {
                ms = 0;
            }
            for (var i = 0, len = this.items.length; i < len; i++) {
                var item = this.items[i];
                // console.log("TCL: item.el", item.el, item.el.parent())
                item.el = item.el.clone();

                item.start = ms;

                var t =
                    this.sprite.type === "Svg"
                        ? Math.max(_this.drawingDuration - 500, 500)
                        : 500;
                // 每条路径的播放结束时间
                item.end =
                    item.length > 0 ? ms + (item.length / totalLength) * t : ms;

                ms = item.end;

                // mask.add({node: item.el.node.cloneNode(true)});
                mask.add(item.el);
                if (noArea) {
                    $(pssvgg.node).empty().append(item.el.node);
                }

                if (item.length > 0) {
                    item.fill = item.el.attr("fill");
                    item.el
                        .attr({
                            opacity: 1,
                            "stroke-width": Math.max(
                                parseFloat(item.el.attr("stroke-width")),
                                1
                            ),
                            "stroke-dasharray": item.length + " " + item.length,
                            "stroke-dashoffset": -item.length,
                        })
                        .style({ stroke: "white", fill: "none" });
                } else {
                    item.el.attr("opacity", 0);
                }
            }

            _count = 0;
            groups.length && mask.clear();
            groups.each(function (i, el) {
                var g = pssvg.group().clear();
                var len = $(el).find("path").length;
                var part = _this.items.slice(_count, len);
                _count = len;
                part.map(function (v, i) {
                    g.add(v.el);
                });
                $(g.node).attr("transform", $(el).attr("transform"));
                mask.add(g);
            });

            // 重置mask dom至plyaer层并挂载mask
            // pssvgg.add(mask);
            this.mask = mask;

            this.playerSvg = pssvg;
            $(this.playerSvg.node).addClass("_my-hand-player-svg");
            this.playerSvgGroup = pssvgg;
            this.paths = paths;

            var _s = $(_this.playerSvg.node);

            var _c = _s.siblings().filter("svg");
            if (_c.length) {
                _c.remove();
                _c = _this.sprite.getDomDiffId().find("svg");
                _s.after(_c);
            }
        },

        _init: function () {
            // if (!this.mask) {
            this._initData();
            // }
            var _this = this;

            var totalLength = 0;
            for (var i = 0, len = this.items.length; i < len; i++) {
                totalLength += this.items[i].length;
            }

            var ms = this.START_MS;
            for (var i = 0, len = this.items.length; i < len; i++) {
                var item = this.items[i];
                item.start = ms;
                // 每条path画完需要的时间(ms)
                // var t = this.entranceAnim.end - this.entranceAnim.start;
                var t =
                    this.sprite.type === "Svg"
                        ? Math.max(_this.drawingDuration - 500, 500)
                        : 500;
                item.end =
                    item.length > 0 ? ms + (item.length / totalLength) * t : ms;

                ms = item.end;

                if (item.length > 0) {
                    item.el.attr({
                        "stroke-dasharray": item.length + " " + item.length,
                        "stroke-dashoffset": -item.length,
                    });
                } else {
                    item.el.attr("opacity", 0);
                }
            }

            this.isInit = true;

            return Promise.resolve();
        },

        init: function (start, index) {
            var _this = this;
            return this.supr(start)
                .then(function () {
                    return _this._init();
                })
                .catch(function (err) {
                    console.log("error: ", err);
                });
        },

        // 重置播放路径
        reset: function () {
            // todo...
        },

        // 计算手势笔/指尖位置
        // _calcHandPosition: function (point, hand) {
        //     var sprite = this.sprite,
        //         x = sprite.positionLeft + point.x,
        //         y = sprite.positionTop + point.y;
        //     return {
        //         x: x - hand.x,
        //         y: y - hand.y
        //     }
        // },

        // 计算手势中心位置
        _calcHandPosition: function (x, y, hand, center) {
            var v = this.handlePenPoint(x, y);
            var cx = v.x;
            var cy = v.y;
            return {
                x: cx - hand.x,
                y: cy - hand.y,
            };
        },

        _setHandPosition: function (length, progress, item) {
            if (!this.entranceAnim.hand) {
                return;
            }
            var point = item.el.pointAt(length);
            point = this.getPointByTransform(
                point,
                item.el.node,
                item.matrix,
                item.transform
            );
            if (item.transform) {
                point.x -= item.transform.x;
                point.y -= item.transform.y;
            }
            var vb = this.svg.viewbox();
            var ratioW = vb.width / this.sprite.ele.width();
            var ratioH = vb.height / this.sprite.ele.height();
            point.x = (point.x - vb.x) / ratioW;
            point.y = (point.y - vb.y) / ratioH;
            var p = this._calcHandPosition(
                point.x,
                point.y,
                this.entranceAnim.hand
            );

            // 从下方移入
            // var h = this.sprite.editor.clientHeight;
            // var distance = h - p.y;
            // var delta = (1 - progress) * distance;

            var hand = this.entranceAnim.hand;
            var transformOrigin = hand.x + "px " + hand.y + "px";

            // 随旋转移入
            // var distance = hand.ele.height() - hand.y;
            var distance = this.sprite.editor.clientHeight - point.y;
            var v1 = {
                x: 0,
                y: distance * (1 - progress),
            };
            var angle = rad(this.sprite.rotate);
            var v1r = {
                x: v1.x * Math.cos(angle) - v1.y * Math.sin(angle),
                y: v1.x * Math.sin(angle) + v1.y * Math.cos(angle),
            };
            var v2 = {
                x: p.x + v1r.x,
                y: p.y + v1r.y,
            };

            function rad(deg) {
                return (deg * Math.PI) / 180;
            }

            this.entranceAnim.hand.ele.css({
                display: "block",
                left: v2.x,
                top: v2.y,
                transform:
                    "rotate(" +
                    this.sprite.rotate +
                    "deg) scale(" +
                    1 / this.sprite.editor.scale / 0.625 +
                    ")",
                transformOrigin: transformOrigin,
            });
        },

        show: function (frame) {
            this.supr(frame);
            if (this.sprite.type !== "Svg") {
                return;
            }

            if (!this.isInit) return;

            var sprite = this.sprite,
                _this = this;

            var player = this.playerSprite.ele;
            var playerEle = player;

            var animFrame = this.animFrame,
                entrance = animFrame.entrance,
                exit = animFrame.exit;

            var frameOff = frame - this.animFrame.entrance.start;
            var fadeFrames = _this.frameRate / 2;

            this.playerSvg.show();

            // 入场恢复初始位置
            if (
                playerEle.css("left") !== sprite.positionLeft ||
                playerEle.css("top") !== sprite.positionTop
            ) {
                playerEle.css({
                    left: sprite.positionLeft,
                    top: sprite.positionTop,
                });
            }

            $(_this.playerSvg.node).next().hide();

            // 设置mask
            this.playerSvgGroup.style({
                mask: "url(#" + this.maskId + ")",
                display: "block",
            });

            // 退场
            if (frame > exit.start && frame <= exit.end) {
                var _s = $(_this.playerSvg.node);
                _s.hide();
                _s.next().find("path").css({ fillOpacity: 1 });
                _s.next().show();
                _s.siblings().filter("span").show();
                return _this.showExitAnim(frame);
            }
            // 退场后隐藏
            if (frame > exit.end) {
                return player.hide();
            }

            if (frame >= entrance.start) {
                player.show();
                var _s = $(_this.playerSvg.node);
                _s.siblings().filter("span").show();
                for (var i = 0; i < this.items.length; i++) {
                    var item = this.items[i];

                    var endFrame = this.ms2fps(item.end),
                        startFrame = this.ms2fps(item.start);
                    if (endFrame < frameOff) {
                        item.el.attr({ "stroke-dashoffset": 0, opacity: 1 });
                    } else if (startFrame < frameOff) {
                        var length =
                            (item.length * (frameOff - startFrame)) /
                            Math.max(endFrame - startFrame, 0);
                        item.el.attr(
                            "stroke-dashoffset",
                            Math.max(0, item.length - length)
                        );

                        // 同步可编辑svg的颜色
                        if (
                            sprite.option.stroke &&
                            (sprite.option.fileType === 28 ||
                                sprite.option.fileType === 29)
                        ) {
                            $(item.el.node)
                                .parent()
                                .children()
                                .css({
                                    stroke: _this.noArea
                                        ? sprite.option.stroke
                                        : "#fff",
                                });
                        }

                        // 手势
                        if (this.entranceAnim.hand) {
                            var point = item.el.pointAt(length);
                            point = this.getPointByTransform(
                                point,
                                item.el.node,
                                item.matrix,
                                item.transform
                            );
                            if (item.transform) {
                                point.x -= item.transform.x;
                                point.y -= item.transform.y;
                            }
                            var vb = this.svg.viewbox();
                            var ratioW = vb.width / sprite.ele.width();
                            var ratioH = vb.height / sprite.ele.height();
                            point.x = (point.x - vb.x) / ratioW;
                            point.y = (point.y - vb.y) / ratioH;
                            var p = this._calcHandPosition(
                                point.x,
                                point.y,
                                this.entranceAnim.hand
                            );

                            var hand = this.entranceAnim.hand;
                            var transformOrigin =
                                hand.x + "px " + hand.y + "px";

                            this.entranceAnim.hand.ele.css({
                                display: "block",
                                left: p.x,
                                top: p.y,
                                transform:
                                    "rotate(" +
                                    _this.sprite.rotate +
                                    "deg) scale(" +
                                    1 / _this.sprite.editor.scale / 0.625 +
                                    ")",
                                transformOrigin: transformOrigin,
                            });
                        }
                    } else if (0 < frameOff) {
                        i === 0 &&
                            this._setHandPosition(
                                0,
                                frameOff / (this.frameRate / 2),
                                item
                            );
                        item.el.attr("stroke-dashoffset", -item.length);
                    } else {
                        item.el.attr("stroke-dashoffset", -item.length);
                    }
                }

                var ref =
                    entrance.end +
                    (_this.drawingDuration / 1000) * _this.frameRate -
                    _this.frameRate / 2;
                ref = Math.max(ref, fadeFrames + entrance.end);
                var isShort = _this.drawingDuration <= 500;
                if (frame > ref) {
                    var _d = frame - ref;
                    var _s = $(_this.playerSvg.node);
                    _s.addClass("_my-hand-player-svg");

                    this.entranceAnim.hand &&
                        !isShort &&
                        (this.entranceAnim.hand.ele.hide(), _s.hide());

                    if (
                        (_s.next().length && _s.next()[0].tagName === "SPAN") ||
                        !_s.next().length
                    ) {
                        var _c = this.sprite.getDomDiffId().find("svg");
                        _c.css({
                            position: "absolute",
                            left: 0,
                            top: 0,
                        });
                        _s.after(_c);
                    }
                    _s.next().css({
                        position: "absolute",
                        left: 0,
                        top: 0,
                    });
                    if (isShort) {
                        _s.hide();
                        _s.next().find("path").css({ fillOpacity: 1 });
                        _s.next().show();
                    } else {
                        let _o = Math.min(_d / (_this.frameRate / 2), 1);
                        _s.next().find("path").css({ fillOpacity: _o });
                        _s.next().show();

                        if (_o >= 1) {
                            _s.hide();
                        }
                    }
                } else if (frame >= ref + _this.frameRate / 2) {
                    _s = $(_this.playerSvg.node);
                    _s.next().find("path").css({ fillOpacity: 1 });
                    _s.next().show();
                    _s.hide();
                }
            } else {
                this.items.forEach(function (item, i) {
                    item.el.attr("stroke-dashoffset", -item.length);
                });

                this.entranceAnim.hand && this.entranceAnim.hand.ele.hide();
            }
        },

        _getExitDuration: function (sprite) {
            var exitAnim = sprite.effect.exitAnim;
            if (exitAnim) {
                var end = exitAnim.end || 0;
                var start = exitAnim.start || 0;
                return end - start;
            }
            return 0;
        },

        handlePenPoint: function (x, y, angle) {
            var sprite = this.sprite;
            angle = rad(this.sprite.rotate);
            var spriteCenter = {
                x: sprite.positionLeft + sprite.width / 2,
                y: sprite.positionTop + sprite.height / 2,
            };
            var vTopLeft = {
                x: -sprite.width / 2,
                y: -sprite.height / 2,
            };
            var v1 = {
                x: vTopLeft.x + x,
                y: vTopLeft.y + y,
            };
            var v1r = {
                x: v1.x * Math.cos(angle) - v1.y * Math.sin(angle),
                y: v1.x * Math.sin(angle) + v1.y * Math.cos(angle),
            };

            function rad(deg) {
                return (deg * Math.PI) / 180;
            }

            var v2 = {
                x: v1r.x + spriteCenter.x,
                y: v1r.y + spriteCenter.y,
            };

            return v2;
        },

        getPointByTransform: function (origin, node, matrix, transform) {
            // if (transform) {
            //     origin.x = transform.x
            //     origin.y = transform.y
            // }
            if (!matrix) {
                return origin;
            }

            var p = new SVG.Point(origin.x, origin.y);
            var m = matrix;
            // if (!matrix) {
            //     m = node.transform.baseVal.consolidate().matrix;
            // }

            return p.transform(new SVG.Matrix(m.a, m.b, m.c, m.d, m.e, m.f));
        },

        getNodeMatrix: function (node) {
            var attr = node.getAttribute("transform");
            if (!attr) {
                return false;
            }

            return node.transform.baseVal.consolidate().matrix;
        },
    });

    // 弹出特效
    var PopEffect = Effect.extend(function (sprite, option) {
        this.code = option.code || "PopIn";
    })
        .statics({
            DEFAULT_IN_EASING: "easeOutBack",
            DEFAULT_OUT_EASING: "easeInBack",
        })
        .methods({
            init: function () {
                var _this = this;
                this.supr(true).then(function () {
                    _this.isInit = true;
                });
            },

            /**
             * 计算easing动画后的值
             */
            _offsetCalc: function (t, b, c, d) {
                return EasingAnim[PopEffect.DEFAULT_IN_EASING](t, b, c, d);
            },

            enterAnimFn: function (frame, playerEle) {
                this.supr(frame, playerEle);

                var sprite = this.sprite;
                var frameOff = frame - this.animFrame.entrance.start;
                var easingResult = this._offsetCalc(
                    frameOff,
                    0.01,
                    1,
                    0.5 * this.frameRate
                );

                this.showLottie && this.showLottie(0);

                playerEle.css({
                    display: "block",
                    transform:
                        this._getTransform() + " scale(" + easingResult + ") ",
                    width: sprite.width,
                    height: sprite.height,
                    top: sprite.positionTop,
                    left: sprite.positionLeft,
                });
            },
        });

    // 淡入特效
    var FadeEffect = Effect.extend(function (sprite, option) {
        this.code = "FadeIn";
    }).methods({
        init: function () {
            var _this = this;
            this.supr(true).then(function () {
                _this.isInit = true;
            });
        },

        enterAnimFn: function (frame, playerEle) {
            this.supr(frame, playerEle);

            var sprite = this.sprite;
            var opa = typeof sprite.opacity === "number" ? sprite.opacity : 1;
            var frameOff = frame - this.animFrame.entrance.start;
            var easingResult = EasingAnim["linear"](
                frameOff,
                0,
                opa,
                0.5 * this.frameRate
            );

            playerEle.css({
                display: "block",
                opacity: easingResult,
                top: sprite.positionTop,
                left: sprite.positionLeft,
            });
        },
    });

    // 无特效
    var NoEffect = Effect.extend(function (sprite, option) {
        this.code = option.code || "None";
    }).methods({
        init: function () {
            var _this = this;
            this.supr(true).then(function () {
                _this.isInit = true;
            });
        },
    });

    // 文字手绘
    var WriteEffect = Effect.extend(function (sprite, option) {
        this.type = option.code || "Write";
    }).methods({
        // 分割文字
        _splitText: function (sprite, player) {
            var _this = this,
                st = this._escape2Html(
                    sprite.text
                        .replace(/<div.*?>|<br.*?>/g, "")
                        .replace(/\r/g, "\n")
                );
            var $div = player.ele.children("div").eq(0).empty(); //清空原内容
            // $font = $div.children('div'); // 字体div

            this.textid = "player-text-sprite-" + sprite.uuid;
            $div.attr({ id: this.textid }).css(
                Object.assign({}, sprite.font, sprite.artStyle, {
                    fontFamily: sprite.fontFamilyUrl,
                    lineHeight: sprite.lineHeight || 1,
                })
            );

            var width = sprite.ele.width() * sprite.editor.scale, // 文本容器的宽
                height = sprite.ele.height() * sprite.editor.scale, // 文本容器的高
                $fontDiv = player.ele.children("div"),
                font = $fontDiv.css("font");

            // 兼容firefox
            if (!font) {
                font = "" + $fontDiv.css("font-style");
                font = font + " " + $fontDiv.css("font-variant");
                font = font + " " + $fontDiv.css("font-weight");
                font = font + " " + "normal";
                font = font + " " + $fontDiv.css("font-size");
                font = font + " / " + $fontDiv.css("line-height");
                font = font + " " + $fontDiv.css("font-family");
            }

            this.fontString = font;
            // 创建文字对象
            // 该对象是一个三维数组，第一维是以\n为分隔的行，
            // 第二维是以自然超出边界而分的行，
            // 第三维是每个自然行的字符信息，包括content, index和行号
            var textObj = [],
                AllLine;
            var emptyLine = 0; // 记录空行

            st.split("\n").forEach(function (part, i, st) {
                if (part === "") ++emptyLine; // 空行+1
                textObj[i] = [];
                var prev = textObj[i - 1];

                // 计算在遇到空行之前有多少个非空行
                var noEmptyLine = 0; // 记录非空行
                for (var j = 0; j < i; j++) {
                    if (part !== "") {
                        noEmptyLine += textObj[j].length || 0;
                    }
                }

                // 计算前一个段落的总行数
                var prev_lines = prev
                    ? prev[0]
                        ? prev[prev.length - 1][
                              prev[prev.length - 1].length - 1
                          ].line
                        : emptyLine + noEmptyLine
                    : 0;

                // 遍历每个段落，完成textObj的数据结构
                part.split("").reduce(function (l, t, index, arr) {
                    var subWidth, line;

                    switch (
                        sprite.versionAnyway // 横竖版
                    ) {
                        case "Vertical": // 竖版
                            subWidth = _this._getStringInfo(
                                part.slice(0, index + 1),
                                font,
                                "Vertical"
                            ).height;
                            line = Math.ceil(subWidth / height);
                            break;
                        default:
                            subWidth = _this._getStringInfo(
                                part.slice(0, index + 1),
                                font
                            ).width;
                            line = Math.ceil(subWidth / width);
                    }

                    var isEndOfLine = false; //分段的行末
                    if (index === arr.length - 1) {
                        isEndOfLine = true;
                    }

                    // 非分段行（自然换行） l < line 则上一个元素为行末
                    if (l < line) {
                        var tmp = textObj[i][line - 2];
                        if (!tmp) return;
                        tmp[tmp.length - 1].isEndOfLine = true;
                        l++;
                    }

                    if (!textObj[i][line - 1]) {
                        textObj[i][line - 1] = [
                            {
                                content: t,
                                index: index,
                                line:
                                    line +
                                    prev_lines /*+ (emptyLine ? emptyLine + 1 : 0)*/,
                                isEndOfLine: isEndOfLine,
                            },
                        ];
                    } else {
                        textObj[i][line - 1].push({
                            content: t,
                            index: index,
                            line:
                                line +
                                prev_lines /*+ (emptyLine ? emptyLine + 1 : 0)*/,
                            isEndOfLine: isEndOfLine,
                        });
                    }

                    // if (_flag && index === arr.length - 1) emptyLine = 0;
                    AllLine = line + prev_lines;
                    return l;
                }, 1);
            });

            // 处理每行文字
            textObj.forEach(function (o) {
                o.forEach(function (text) {
                    // 当前行的长度
                    // var sub = st.slice(text[0].index, text[0].index + text.length),
                    var sInfo = _this._getStringInfo(text[0].content, font);
                    var yos = (text[0].line - 1) * sInfo.height;

                    switch (
                        sprite.versionAnyway // 横竖版
                    ) {
                        case "Vertical": // 竖版
                            sInfo = _this._getStringInfo(
                                text[0].content,
                                font,
                                "Vertical"
                            );
                            yos = (AllLine - text[0].line) * sInfo.width;
                            break;
                        default:
                            yos = (text[0].line - 1) * sInfo.height;
                    }

                    var sub = [],
                        w;
                    text.forEach(function (te) {
                        sub.push(te.content);
                    });

                    sub = sub.join("");
                    w = _this._getStringInfo(sub, font).width;
                    h = _this._getStringInfo(sub, font, "Vertical").height;

                    text.reduce(
                        function (po, t, index, arr) {
                            var sInfo = _this._getStringInfo(t.content, font);
                            switch (
                                sprite.versionAnyway // 横竖版
                            ) {
                                case "Vertical": // 竖版
                                    sInfo = _this._getStringInfo(
                                        t.content,
                                        font,
                                        "Vertical"
                                    );
                                    $("<div></div>")
                                        .css({
                                            opacity: 0,
                                            backgroundColor:
                                                sprite.artType === "Inset"
                                                    ? sprite.font.color
                                                    : "",
                                            "-webkit-background-clip": "text",
                                            position: "absolute",
                                            left: yos,
                                            top: po.y,
                                            textDecoration:
                                                sprite.font.textDecoration ||
                                                "none",
                                        })
                                        .attr({
                                            "is-end-of-line": t.isEndOfLine
                                                ? "true"
                                                : null,
                                        })
                                        .text(t.content)
                                        .appendTo($div);
                                    return {
                                        x: 0,
                                        y: po.y + sInfo.height,
                                    };
                                default:
                                    $("<div></div>")
                                        .css({
                                            opacity: 0,
                                            backgroundColor:
                                                sprite.artType === "Inset"
                                                    ? sprite.font.color
                                                    : "",
                                            "-webkit-background-clip": "text",
                                            position: "absolute",
                                            left: po.x,
                                            top:
                                                po.y +
                                                (t.line - 1) * sInfo.height,
                                            textDecoration:
                                                sprite.font.textDecoration ||
                                                "none",
                                        })
                                        .attr({
                                            "is-end-of-line": t.isEndOfLine
                                                ? "true"
                                                : null,
                                        })
                                        .text(t.content)
                                        .appendTo($div);
                                    return {
                                        x: po.x + sInfo.width,
                                        y: 0,
                                    };
                            }
                        },
                        {
                            x: _this._textMakeup(sprite.font.textAlign, {
                                boxWidth: width,
                                lineWidth: w,
                            }),
                            y: _this._textMakeup(sprite.font.textAlign, {
                                boxHeight: height,
                                lineHeight: h,
                                type: sprite.versionAnyway,
                            }),
                        }
                    );
                });
            });

            this.textele = $div;

            return textObj;
        },

        // 生成手势
        _initWriteHand: function () {
            // if (this.writeHand) {
            //     // this.writeHand.ele.remove();
            // }

            var _this = this,
                sprite = this.sprite,
                editor = sprite.editor,
                player = editor.player;

            // var writehandData = _this.entranceAnim.hand || 'defaults' // sprite.option.writehandData;
            // this.updateWriteHand(writehandData);

            // 文字元素
            // var textSprite = player.spritesDict[sprite.uuid].ele;

            var $handScale = $("#write-hand-wrapper-" + sprite.uuid);
            if ($handScale.length > 0) {
                // 挂载手势及各部分jQuery对象
                this.writeHand = {
                    ele: $handScale.find("#write-hand-" + sprite.uuid),
                    wrapper: $handScale,
                    arm: $handScale.find("#arm-write-hand-" + sprite.uuid),
                    palm: $handScale.find("#palm-write-hand-" + sprite.uuid),
                    pen: $handScale.find("#pen-write-hand-" + sprite.uuid),
                };
                //return $handScale.remove();

                return this.writeHand;
            }

            $handScale = $("<div></div>")
                .css({
                    transform: "scale(" + 1 / editor.scale + ")",
                    transformOrigin: "0px 0px 0px",
                })
                .attr({ id: "write-hand-wrapper-" + sprite.uuid });

            $handScale.css({
                position: "absolute",
                left: "0px",
                top: "0px",
            });

            // 创建图片容器
            var id = "write-hand-" + sprite.uuid;
            var ele = $("<div></div>")
                .attr({
                    id: id,
                })
                .css({
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: 1024,
                    height: 576,
                    opacity: 1,
                    transform:
                        "matrix(" +
                        Effect.WRITE_HAND_SCALE +
                        ", 0, 0, " +
                        Effect.WRITE_HAND_SCALE +
                        ", 0, 0)",
                    "transform-origin": "0px 0px 0px",
                    "pointer-events": "none",
                    display: "none",
                })
                .append(
                    $("<div></div>")
                        .attr({
                            // 手腕
                            id: "arm-" + id,
                        })
                        .css({
                            position: "absolute",
                            left: 136.7,
                            top: 328.5,
                            width: 254.4,
                            height: 355.7,
                            "transform-origin": "50% 0px 0px",
                            // transform: null,
                            background:
                                "url(" +
                                editor.option.assets.writeHand +
                                ") -408.5px 0px no-repeat",
                        })
                )
                .append(
                    $("<div></div>")
                        .attr({
                            // 手掌
                            id: "palm-" + id,
                        })
                        .css({
                            position: "absolute",
                            width: 266.7,
                            height: 385.1,
                            left: 0,
                            top: 0,
                            "transform-origin": "75% 90% 0px",
                            // transform: 'matrix(1, 0, 0, 1, 0, 0)',
                            background:
                                "url(" +
                                editor.option.assets.writeHand +
                                ") 0px 0px no-repeat",
                        })
                        .append(
                            $("<div></div>")
                                .attr({
                                    // 笔
                                    id: "pen-" + id,
                                })
                                .css({
                                    position: "absolute",
                                    width: 140.8,
                                    height: 149.8,
                                    left: 32,
                                    top: 84.3,
                                    // transform: 'matrix(1, 0, 0, 1, 0, 0)',
                                    "transform-origin": "15% 15% 0px",
                                    background:
                                        "url(" +
                                        editor.option.assets.writeHand +
                                        ") -267.2px 0px no-repeat",
                                })
                        )
                );

            ele.appendTo($handScale);

            // $handScale.appendTo(textSprite);

            // 挂载手势及各部分jQuery对象
            this.writeHand = {
                ele: ele,
                wrapper: $handScale,
                arm: ele.find("#arm-" + id),
                palm: ele.find("#palm-" + id),
                pen: ele.find("#pen-" + id),
            };
        },

        updateWriteHand: function (data) {
            var editor = this.sprite.editor;
            var defHand = {
                url: editor.option.assets.writeHand,
                armLeft: 136.7,
                armTop: 328.5,
            };

            var writehandData = data;

            // this.sprite.option.writehandData = writehandData;
            this.entranceAnim.writehand = writehandData;
            if (!writehandData || !writehandData.url) {
                writehandData = defHand;
            }

            this.writeHand.arm[0].offsetWidth;

            this.writeHand.arm.css({
                left: +writehandData.armLeft,
                top: +writehandData.armTop,
                background:
                    "url(" + writehandData.url + ") -408.5px 0px no-repeat",
            });
            this.writeHand.palm.css({
                background: "url(" + writehandData.url + ") 0px 0px no-repeat",
            });
            this.writeHand.pen.css({
                background:
                    "url(" + writehandData.url + ") -267.2px 0px no-repeat",
            });
        },

        /**
         * 获取字符的长宽等信息
         * @param {string} s 字符
         * @param {string} font 字体
         * @returns {object}
         */
        _getStringInfo: function (s, font, type) {
            var f = font || "12px arial",
                o = $("<div></div>")
                    .text(s)
                    .css({
                        position: "absolute",
                        float: "left",
                        visibility: "hidden",
                        "white-space": "pre",
                        font: f,
                        letterSpacing:
                            parseFloat(
                                this.sprite.letterSpacing *
                                    ~~(
                                        parseInt(this.sprite.font.fontSize) / 10
                                    ) || 0
                            ) + "px",
                    })
                    .appendTo($("body"));

            if (type && type == "Vertical") {
                o.css({
                    "writing-mode": "vertical-rl",
                });
            }
            var result = {
                width: o.width(),
                height: o.height(),
            };

            o.remove();

            return result;
        },

        /**
         * 排版算法（居中，居左，居右）
         * @param {String} type 类型，有'center', 'left', 'right'
         * @param {Object} w 对象，包含文本框宽度及当前行文字宽度
         * @return {number} 返回第一个字符的left值
         */
        _textMakeup: function (type, w) {
            var result;
            if (w && w.type) {
                switch (
                    w.type // 横竖版
                ) {
                    case "Vertical": // 竖版
                        switch (type) {
                            case "left":
                                result = 0;
                                break;
                            case "right":
                                result = w.boxHeight - w.lineHeight;
                                break;
                            case "center":
                            default:
                                result = (w.boxHeight - w.lineHeight) / 2;
                                break;
                        }
                        break;
                    default:
                        result = 0;
                }
            } else {
                switch (type) {
                    case "left":
                        result = 0;
                        break;
                    case "right":
                        result = w.boxWidth - w.lineWidth;
                        break;
                    case "center":
                    default:
                        result = (w.boxWidth - w.lineWidth) / 2;
                        break;
                }
            }
            return result;
        },

        // 将html实体转义为html标签
        _escape2Html: function (str) {
            var arrEntities = {
                lt: "<",
                gt: ">",
                nbsp: " ",
                amp: "&",
                quot: '"',
            };
            return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
                return arrEntities[t];
            });
        },

        /**
         * 文字透明度
         * @param {number} f 需要f帧完成渐变
         * @param {number} current 当前帧数
         */
        _opacityShow: function (f, current) {
            var result = (1 / f) * current;
            return result > 1 ? 1 : result <= 0 ? 0 : result;
        },

        /**
         * 当前手势位置
         */
        _setHandPosition: function (item, frame, i) {
            var _this = this;

            var ms2f = (500 / 1000) * this.frameRate,
                p = this.handPosition;

            // 入场之前， 隐藏元素
            if (0 === i && frame < item.start) {
                this.writeHand.ele.hide();
            }

            // 入场时间 第一个元素入场前500ms内
            if (0 === i && frame >= item.start - ms2f && frame < item.start) {
                // 从画布下方位置移入 下方位置为画布高度
                this.writeHand.ele.css({
                    display: "block",
                    left: p.first.x - 30 * Effect.WRITE_HAND_SCALE,
                    top:
                        p.out -
                        ((p.out + 70 * Effect.WRITE_HAND_SCALE) / ms2f) *
                            (frame - (item.start - ms2f)),
                });

                return;
            }

            // 退场时间 第后一个元素退场后500ms内
            if (
                i === this.item.length - 1 &&
                frame > item.end &&
                frame <= item.end + ms2f
            ) {
                this.writeHand.ele.css({
                    display: "block",
                    left: p.last.x - 30 * Effect.WRITE_HAND_SCALE,
                    top:
                        p.last.y +
                        ((p.out + 70 * Effect.WRITE_HAND_SCALE) / ms2f) *
                            (frame - item.end),
                });

                return;
            }

            // 退场时间以外，隐藏手势
            if (i === this.item.length - 1 && frame > item.end + ms2f) {
                this.writeHand.ele.hide();
                return;
            }

            // 落在字符动画区间时
            if (frame >= item.start && frame < item.end) {
                var position = {
                        x: parseFloat(item.ele.css("left")),
                        y:
                            parseFloat(item.ele.css("top")) +
                            item.ele.height() / 2,
                    },
                    f = item.end - item.start;

                var current = frame - item.start,
                    r = position.x + (item.ele.width() / f) * current;
                this.writeHand.ele.css({
                    display: "block",
                    left: r - 30 * Effect.WRITE_HAND_SCALE,
                    top: position.y - 70 * Effect.WRITE_HAND_SCALE,
                });

                // 手掌及笔的摆动
                // 手掌最小摆动5度，最大20度，
                // 笔杆最大幅度2度，手掌最大幅度10
                // 字体最大限制为300，故比例为300 / 20 = 15 / 1

                var arm_range = this.sprite.font.fontSize / 15;
                arm_range = arm_range > 20 ? 20 : arm_range < 5 ? 5 : arm_range;
                if (i % 2 === 0) {
                    this.writeHand.palm.css({
                        transform:
                            "rotate(" + (arm_range / f) * current + "deg)",
                    });
                    this.writeHand.pen.css({
                        transform:
                            "rotate(" + (0.5 - 0.5 / f) * current + "deg)",
                    });
                } else {
                    this.writeHand.palm.css({
                        transform:
                            "rotate(" +
                            (arm_range - (arm_range / f) * current) +
                            "deg)",
                    });
                    this.writeHand.pen.css({
                        transform: "rotate(" + (0.5 / f) * current + "deg)",
                    });
                }
            } else {
                // 落在非字符动画区间时，则判断目前是处于哪个行末，找出下行起始的位置
                this.newlines.forEach(function (line, i) {
                    if (frame > line.start && frame <= line.end) {
                        var offx = line.ox - line.tx,
                            offy = line.oy - line.ty,
                            offframe = line.end - line.start,
                            cframe = frame - line.start;

                        var x = line.ox - (offx / offframe) * cframe,
                            y = line.oy - (offy / offframe) * cframe;
                        _this.writeHand.ele.css({
                            display: "block",
                            left: x - 30 * Effect.WRITE_HAND_SCALE,
                            top: y - 70 * Effect.WRITE_HAND_SCALE,
                        });
                    }
                });
            }
        },

        /**
         * 计算文字绘制时间
         * @param {jQuery} div 文字框对象
         * @return {number} 返回单个字符绘制的时间
         */
        _getTextAnimTime: function (textDiv) {
            // 动画总时间
            var entrance = this.entranceAnim,
                exit = this.exitAnim,
                total = exit.start - entrance.start;

            // 换行次数
            var stringEles = textDiv.children("div");
            (textNum = stringEles.length), (newLine = 0);
            for (var i = 0; i < textNum; i++) {
                var currentEle = stringEles.eq(i);
                if (
                    currentEle.attr("is-end-of-line") &&
                    i !== stringEles.length - 1
                ) {
                    newLine++;
                }
            }

            // 每换行一次，视为增加两个字符的长度
            var t = 100 * (textNum + newLine * 2) + 1000;

            if (t > total) {
                // 超出长度，重新计算单个字符绘制时间
                return (total - 1000) / (textNum + newLine * 2);
            } else {
                return 100;
            }
        },

        init: function () {
            var _this = this,
                sprite = this.sprite,
                editor = sprite.editor;

            return this.supr(true)
                .then(function () {
                    var playerSprite = editor.player.spritesDict[sprite.uuid];
                    // 分割字符串，生成div串
                    _this._splitText(sprite, playerSprite);

                    var textDiv = playerSprite.ele.children(
                            "div#" + _this.textid
                        ),
                        $text = textDiv.children("div"),
                        textNum = $text.length,
                        msPerString = _this._getTextAnimTime(textDiv),
                        framePerString = (msPerString / 1000) * _this.frameRate, // 特定帧内每个字符需要的帧数
                        entrance = _this.animFrame.entrance;

                    // 为每个字符分配起始和结束帧
                    // 默认每字字符在100ms内显示完成，若超过动画入场退场的总时间，则再加快
                    // 规则：第一个字符入场前留500ms给手势入场，最后一个字符结束后留500ms给手势退场
                    // 中间遇到换行，下一行起始时间往后顺延两个字符时间单位
                    _this.item = [];
                    for (var i = 0; i < textNum; i++) {
                        var currentEle = $text.eq(i),
                            isEndOfLine = currentEle.attr("is-end-of-line")
                                ? true
                                : null,
                            _start = entrance.start + 0.5 * _this.frameRate, // 前500ms 留作入场
                            _end = _start + framePerString;

                        if (_this.item[i - 1]) {
                            (_start = _this.item[i - 1].end),
                                (_end = _start + framePerString);
                        }

                        // 若上一行是行末，则本行的起始时间和结束时间往右延两个单位
                        if (
                            _this.item[i - 1] &&
                            _this.item[i - 1].isEndOfLine
                        ) {
                            _start = _this.item[i - 1].end + framePerString * 2;
                            _end = _start + framePerString;
                        }

                        _this.item.push({
                            ele: currentEle,
                            isEndOfLine: isEndOfLine,
                            start: _start,
                            end: _end,
                        });
                    }

                    // 画布下方位置、第一个字符位置、最后一个字符位置
                    var $sprite = playerSprite.ele;
                    _this.handPosition = {
                        out:
                            (editor.clientHeight -
                                parseFloat($sprite.css("top"))) *
                            editor.scale,
                        first: {
                            x: parseFloat($text.eq(0).css("left")),
                            y: parseFloat($text.eq(0).css("top")),
                        },
                        last: {
                            x: parseFloat($text.eq(textNum - 1).css("left")),
                            y: parseFloat($text.eq(textNum - 1).css("top")),
                        },
                    };

                    // 找出换行帧及换行后的起始位置
                    _this.newlines = [];
                    _this.item.forEach(function (it, i, arr) {
                        //var nextItem = arr[i + i];
                        if (it.isEndOfLine && arr[i + 1]) {
                            _this.newlines.push({
                                start: it.end,
                                end: arr[i + 1].start,
                                ox:
                                    parseFloat(it.ele.css("left")) +
                                    _this._getStringInfo(
                                        it.ele.text(),
                                        _this.fontString
                                    ).width,
                                oy: parseFloat(it.ele.css("top")),
                                tx: parseFloat(arr[i + 1].ele.css("left")),
                                ty: parseFloat(arr[i + 1].ele.css("top")),
                            });
                        }
                    });

                    // 生成手势元素
                    if (!_this.writeHand) {
                        _this._initWriteHand();
                        var writehandData =
                            _this.entranceAnim.writehand || "defaults"; // sprite.option.writehandData;
                        _this.updateWriteHand(writehandData);
                    }
                    _this.writeHand.wrapper
                        .css({
                            transform: "scale(" + 1 / editor.scale + ")",
                        })
                        .appendTo($sprite);

                    _this.isInit = true;
                    _this.playerSprite = playerSprite; // 2018-8-15
                })
                .catch(function (err) {
                    console.error(err);
                });
        },

        // show方法
        show: function (frame) {
            this.supr(frame);

            if (!this.isInit) return;

            var sprite = this.sprite,
                _this = this;

            var player = this.playerSprite.ele;
            // textDiv = player.children('div');

            var animFrame = this.animFrame,
                entrance = animFrame.entrance,
                exit = animFrame.exit;

            // 进场后播放
            if (frame >= entrance.start) {
                player.show();
                this.item.forEach(function (item, i) {
                    item.ele.css({
                        opacity: _this._opacityShow(
                            item.end - item.start,
                            frame - item.start
                        ),
                    });

                    // 手势
                    _this._setHandPosition(item, frame, i);
                });

                if (frame < exit.start) this.clearPopFadeExit(player);
                // 退场前，校正位置
                if (
                    frame <= exit.start &&
                    player.css("top") !== sprite.positionTop
                ) {
                    player.css({
                        top: sprite.positionTop,
                        left: sprite.positionLeft,
                    });
                }

                // 退场
                if (frame > exit.start && frame <= exit.end) {
                    _this.showExitAnim(frame);
                }
                // 退场后隐藏
                if (frame > exit.end) {
                    player.hide();
                }
            } else {
                this.item.forEach(function (item, i) {
                    item.ele.css({
                        opacity: 0,
                    });
                });
                this.writeHand.ele.hide();
            }
        },
    });

    // 文字逐行显示
    var Appear = Effect.extend(function (sprite, option) {
        this.type = option.code || "Appear";
    }).methods({
        // 分割文字
        _splitTextLine: function (sprite, player) {
            var _this = this,
                st = this._escape2Html(sprite.text);

            var $div = player.ele.children("div").eq(0).empty(); //清空原内容
            if (player.ele.children("div")[1]) {
                player.ele
                    .children("div")
                    .remove("#write-hand-wrapper-" + sprite.uuid);
            }

            this.textid = "player-text-sprite-" + sprite.uuid;
            $div.attr({ id: this.textid }).css(
                Object.assign({}, sprite.font, sprite.artStyle, {
                    fontFamily: sprite.fontFamilyUrl,
                    lineHeight: sprite.lineHeight || 1,
                })
            );

            var width = Math.ceil(sprite.ele.width() * sprite.editor.scale), // 文本容器的宽
                height = Math.ceil(sprite.ele.height() * sprite.editor.scale), // 文本容器的高
                $fontDiv = player.ele.children("div"),
                font = $fontDiv.css("font");

            // 兼容firefox
            if (!font) {
                font = "" + $fontDiv.css("font-style");
                font = font + " " + $fontDiv.css("font-variant");
                font = font + " " + $fontDiv.css("font-weight");
                font = font + " " + "normal";
                font = font + " " + $fontDiv.css("font-size");
                font = font + " / " + $fontDiv.css("line-height");
                font = font + " " + $fontDiv.css("font-family");
            }

            this.fontString = font;
            // 创建文字对象
            // 该对象是一个三维数组，第一维是以\n为分隔的行，
            // 第二维是以自然超出边界而分的行，
            // 第三维是每个自然行的字符信息，包括content, index和行号
            var textObj = [],
                AllLine;
            var emptyLine = 0; // 记录空行

            st.split("\n").forEach(function (part, i, st) {
                if (part === "") ++emptyLine; // 空行+1
                textObj[i] = [];
                var prev = textObj[i - 1];

                // 计算在遇到空行之前有多少个非空行
                var noEmptyLine = 0; // 记录非空行
                for (var j = 0; j < i; j++) {
                    if (part !== "") {
                        noEmptyLine += textObj[j].length || 0;
                    }
                }

                // 计算前一个段落的总行数
                var prev_lines = prev
                    ? prev[0]
                        ? prev[prev.length - 1][
                              prev[prev.length - 1].length - 1
                          ].line
                        : emptyLine + noEmptyLine
                    : 0;

                // 遍历每个段落，完成textObj的数据结构
                part.split("").reduce(function (l, t, index, arr) {
                    var subWidth, line;

                    switch (
                        sprite.versionAnyway // 横竖版
                    ) {
                        case "Vertical": // 竖版
                            subWidth = _this._getStringInfo(
                                part.slice(0, index + 1),
                                font,
                                "Vertical"
                            ).height;
                            line = Math.ceil(subWidth / height);
                            break;
                        default:
                            subWidth = _this._getStringInfo(
                                part.slice(0, index + 1),
                                font
                            ).width;
                            line = Math.ceil(subWidth / width);
                    }

                    var isEndOfLine = false; //分段的行末
                    if (index === arr.length - 1) {
                        isEndOfLine = true;
                    }

                    // 非分段行（自然换行） l < line 则上一个元素为行末
                    if (l < line) {
                        var tmp = textObj[i][line - 2];
                        if (!tmp) return;
                        tmp[tmp.length - 1].isEndOfLine = true;
                        l++;
                    }

                    if (!textObj[i][line - 1]) {
                        textObj[i][line - 1] = [
                            {
                                content: t,
                                index: index,
                                line:
                                    line +
                                    prev_lines /*+ (emptyLine ? emptyLine + 1 : 0)*/,
                                isEndOfLine: isEndOfLine,
                            },
                        ];
                    } else {
                        textObj[i][line - 1].push({
                            content: t,
                            index: index,
                            line:
                                line +
                                prev_lines /*+ (emptyLine ? emptyLine + 1 : 0)*/,
                            isEndOfLine: isEndOfLine,
                        });
                    }

                    // if (_flag && index === arr.length - 1) emptyLine = 0;

                    AllLine = line + prev_lines;
                    return l;
                }, 1);
            });
            // 处理每行文字
            textObj.forEach(function (o) {
                o.forEach(function (text, index) {
                    var sInfo = _this._getStringInfo(text[0].content, font);
                    var yos = (text[0].line - 1) * sInfo.height,
                        $lineText;

                    switch (
                        sprite.versionAnyway // 横竖版
                    ) {
                        case "Vertical": // 竖版
                            sInfo = _this._getStringInfo(
                                text[0].content,
                                font,
                                "Vertical"
                            );
                            yos = (AllLine - text[0].line) * sInfo.width;
                            $lineText = $("<div></div>")
                                .css({
                                    opacity: 0,
                                    position: "absolute",
                                    left: yos,
                                    top: 0,
                                    height: "100%",
                                    width: sInfo.height,
                                })
                                .attr({
                                    // "is-end-of-line": text.isEndOfLine ? 'true' : null
                                    "is-end-of-line": "true",
                                })
                                .appendTo($div);
                            break;
                        default:
                            yos = (text[0].line - 1) * sInfo.height;
                            $lineText = $("<div></div>")
                                .css({
                                    opacity: 0,
                                    position: "absolute",
                                    left: 0,
                                    top: yos,
                                    width: "100%",
                                    height: sInfo.height,
                                })
                                .attr({
                                    // "is-end-of-line": text.isEndOfLine ? 'true' : null
                                    "is-end-of-line": "true",
                                })
                                .appendTo($div);
                    }

                    var sub = [],
                        w;
                    text.forEach(function (te) {
                        sub.push(te.content);
                    });

                    sub = sub.join("");
                    w = _this._getStringInfo(sub, font).width;
                    h = _this._getStringInfo(sub, font, "Vertical").height;

                    text.reduce(
                        function (po, t, index, arr) {
                            var TsInfo = _this._getStringInfo(t.content, font);

                            switch (
                                sprite.versionAnyway // 横竖版
                            ) {
                                case "Vertical": // 竖版
                                    TsInfo = _this._getStringInfo(
                                        t.content,
                                        font,
                                        "Vertical"
                                    );
                                    $("<div></div>")
                                        .css({
                                            position: "absolute",
                                            backgroundColor:
                                                sprite.artType === "Inset"
                                                    ? sprite.font.color
                                                    : "",
                                            "-webkit-background-clip": "text",
                                            left: 0,
                                            top: po.y,
                                            textDecoration:
                                                sprite.font.textDecoration ||
                                                "none",
                                        })
                                        .attr({})
                                        .text(t.content)
                                        .appendTo($lineText);
                                    return {
                                        x: 0,
                                        y: po.y + TsInfo.height,
                                    };
                                default:
                                    $("<div></div>")
                                        .css({
                                            position: "absolute",
                                            backgroundColor:
                                                sprite.artType === "Inset"
                                                    ? sprite.font.color
                                                    : "",
                                            "-webkit-background-clip": "text",
                                            left: po.x,
                                            top: 0,
                                            textDecoration:
                                                sprite.font.textDecoration ||
                                                "none",
                                        })
                                        .attr({})
                                        .text(t.content)
                                        .appendTo($lineText);
                                    return {
                                        x: po.x + TsInfo.width,
                                        y: 0,
                                    };
                            }
                        },
                        {
                            x: _this._textMakeup(sprite.font.textAlign, {
                                boxWidth: width,
                                lineWidth: w,
                            }),
                            y: _this._textMakeup(sprite.font.textAlign, {
                                boxHeight: height,
                                lineHeight: h,
                                type: sprite.versionAnyway,
                            }),
                        }
                    );
                });
            });

            this.textele = $div;
            return textObj;
        },

        /**
         * 获取字符的长宽等信息
         * @param {string} s 字符
         * @param {string} font 字体
         * @param {string} type 横竖版类型
         * @returns {object}
         */
        _getStringInfo: function (s, font, type) {
            var f = font || "12px arial",
                o = $("<div></div>")
                    .text(s)
                    .css({
                        position: "absolute",
                        float: "left",
                        visibility: "hidden",
                        "white-space": "pre",
                        font: f,
                        letterSpacing:
                            parseFloat(
                                this.sprite.letterSpacing *
                                    ~~(
                                        parseInt(this.sprite.font.fontSize) / 10
                                    ) || 0
                            ) + "px",
                    })
                    .appendTo($("body"));

            if (type && type == "Vertical") {
                o.css({
                    "writing-mode": "vertical-rl",
                });
            }
            var result = {
                width: o.width(),
                height: o.height(),
            };

            o.remove();

            return result;
        },

        // 将html实体转义为html标签
        _escape2Html: function (str) {
            var arrEntities = {
                lt: "<",
                gt: ">",
                nbsp: " ",
                amp: "&",
                quot: '"',
            };
            return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
                return arrEntities[t];
            });
        },

        /**
         * 排版算法（居中，居左，居右）
         * @param {String} type 类型，有'center', 'left', 'right'
         * @param {Object} w 对象，包含文本框宽度及当前行文字宽度
         * @return {number} 返回第一个字符的left值
         */
        _textMakeup: function (type, w) {
            var result;
            if (w && w.type) {
                switch (
                    w.type // 横竖版
                ) {
                    case "Vertical": // 竖版
                        switch (type) {
                            case "left":
                                result = 0;
                                break;
                            case "right":
                                result = w.boxHeight - w.lineHeight;
                                break;
                            case "center":
                            default:
                                result = (w.boxHeight - w.lineHeight) / 2;
                                break;
                        }
                        break;
                    default:
                        result = 0;
                }
            } else {
                switch (type) {
                    case "left":
                        result = 0;
                        break;
                    case "right":
                        result = w.boxWidth - w.lineWidth;
                        break;
                    case "center":
                    default:
                        result = (w.boxWidth - w.lineWidth) / 2;
                        break;
                }
            }
            return result;
        },

        /**
         * 计算文字绘制时间
         * @param {jQuery} div 文字框对象
         * @return {number} 返回单个字符绘制的时间
         */
        _getTextAnimTime: function (textDiv) {
            // 动画总时间
            var entrance = this.entranceAnim,
                exit = this.exitAnim,
                total = exit.start - entrance.start;
            // 换行次数
            var stringEles = textDiv.children("div");
            (textNum = stringEles.length), (newLine = 0);
            for (var i = 0; i < textNum; i++) {
                var currentEle = stringEles.eq(i);
                if (
                    currentEle.attr("is-end-of-line") &&
                    i !== stringEles.length - 1
                ) {
                    newLine++;
                }
            }

            // 每换行一次，视为增加两个字符的长度
            var t = 300 * (textNum + newLine * 2) + 1000;

            if (t > total) {
                // 超出长度，重新计算单个字符绘制时间
                return (total - 1000) / (textNum + newLine * 2);
            } else {
                return 300;
            }
        },

        _opacityShow: function (f, current) {
            var result = (1 / f) * current;
            return result > 1 ? 1 : result <= 0 ? 0 : result;
        },

        init: function () {
            var _this = this,
                sprite = this.sprite,
                editor = sprite.editor;

            return this.supr()
                .then(function () {
                    var playerSprite = editor.player.spritesDict[sprite.uuid];
                    // 分割字符串，生成div串
                    _this._splitTextLine(sprite, playerSprite);

                    var textDiv = playerSprite.ele.children(
                            "div#" + _this.textid
                        ),
                        $text = textDiv.children("div"),
                        textNum = $text.length,
                        msPerString = _this._getTextAnimTime(textDiv),
                        framePerString =
                            ((msPerString / 1000) * _this.frameRate).toFixed(
                                2
                            ) - 0, // 特定帧内每行文字
                        entrance = _this.animFrame.entrance;

                    framePerString = framePerString >= 0 ? framePerString : 0;
                    // 为每行文字分配起始和结束帧
                    // 默认每行文字在100ms内显示完成，若超过动画入场退场的总时间，则再加快
                    _this.item = [];
                    for (var i = 0; i < textNum; i++) {
                        var currentEle = $text.eq(i),
                            isEndOfLine = currentEle.attr("is-end-of-line")
                                ? true
                                : null,
                            _start = entrance.start, // 前500ms 留作入场
                            _end = _start + framePerString;

                        if (_this.item[i - 1]) {
                            (_start = _this.item[i - 1].end),
                                (_end = _start + framePerString);
                        }

                        _this.item.push({
                            ele: currentEle,
                            isEndOfLine: isEndOfLine,
                            start: _start,
                            end: _end,
                        });
                    }

                    _this.isInit = true;
                    _this.playerSprite = playerSprite; // 2018-8-15
                })
                .catch(function (err) {
                    console.error(err);
                });
        },

        // show方法
        show: function (frame) {
            this.supr(frame);

            if (!this.isInit) return;

            var sprite = this.sprite,
                _this = this;

            var player = this.playerSprite.ele;
            // textDiv = player.children('div');

            var animFrame = this.animFrame,
                entrance = animFrame.entrance,
                exit = animFrame.exit;

            // 进场后播放
            if (frame >= entrance.start && frame <= exit.end) {
                player.show();
                this.item.forEach(function (item, i) {
                    item.ele.css({
                        opacity: _this._opacityShow(
                            item.end - item.start,
                            frame - item.start
                        ),
                    });
                });

                if (frame < exit.start) this.clearPopFadeExit(player);
                // 退场前，校正位置
                if (
                    frame <= exit.start &&
                    player.css("top") !== sprite.positionTop
                ) {
                    player.css({
                        top: sprite.positionTop,
                        left: sprite.positionLeft,
                    });
                }

                // 退场
                if (frame > exit.start && frame <= exit.end) {
                    _this.showExitAnim(frame);
                }
                // 退场后隐藏
                if (frame > exit.end) {
                    player.hide();
                }
            } else {
                this.item.forEach(function (item, i) {
                    item.ele.css({
                        opacity: 0,
                    });
                });
            }
        },
    });

    // 场景动画
    var SceneEffect = klass(function (scene, option) {
        this.scene = scene;
        this.code = option.code || "UpIn";
        this.frameRate = scene.editor.option.frameRate || 60;
        this.isInit = false;
        this.optimized = scene.editor.optimized;
    }).methods({
        // 根据当前动画时间求出当前帧
        _ms2frame: function (ms) {
            var t = 1000 / this.frameRate; // 每帧需要的时间
            return Math.ceil(ms / t);
        },

        // 缓动
        easeOutExpo: function (t, b, c, d) {
            return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
        },

        linear: function (t, b, c, d) {
            return c * (t / d) + b;
        },

        easeOutQuart: function (t, b, c, d) {
            return -c * ((t = t / d - 1) * t * t * t - 1) + b;
        },

        easeInCubic: function (t, b, c, d) {
            return c * (t /= d) * t * t + b;
        },

        // 初始化
        init: function (startAt, force) {
            var scene = this.scene,
                editor = scene.editor,
                promiseArr = [];

            this.optimized = editor.optimized;

            // 检查上一个场景及下一个场景
            var index = scene.index;
            this.prevs = editor.sprites[index - 1];
            this.nexts = editor.sprites[index + 1];

            // 前一个场景的code决定了当前场景的入场时间
            var prevs_code = this.prevs ? this.prevs.effect.code : "None";
            // 场景在此区间完成入场
            this.entrance = {
                start: 0,
                end:
                    prevs_code === "None"
                        ? 0
                        : this.frameRate *
                          (this.prevs.effect.duration -
                              this.prevs.effect.startAt),
            };
            // 场景在此区间完成出场
            var ms = scene.getDuration();
            this.exit = {
                start: this._ms2frame(
                    ms - (this.code === "None" ? 0 : startAt * 1000 || 250)
                ),
                end: this._ms2frame(ms),
            };

            this.matrix = {
                width: editor.clientWidth,
                height: editor.clientHeight,
                top: 0,
                left: 0,
            };

            // 不同比例下的宽高和定位信息
            if (this.optimized === "Vertical") {
                (this.matrix.width = (editor.clientHeight * 9) / 16),
                    (this.matrix.left =
                        (editor.clientWidth - this.matrix.width) / 2);
            }

            this.totalFrame = this.frameRate * this.duration;

            force && this.clearMask();
            if (!this.isInit || force) {
                // 初始化dom结构
                promiseArr.push(this.initDom());
            }

            this.isInit = true;

            scene.camera && scene.camera.init();

            promiseArr[promiseArr.length] = new Promise(function (
                resolve,
                reject
            ) {
                var playerVideo;
                var bg = scene.background;
                try {
                    playerVideo = bg.element.playerVideo[0];
                } catch (e) {
                    playerVideo = null;
                }
                if (bg.data && bg.data.type === "Video" && playerVideo) {
                    playerVideo.load();
                    playerVideo.addEventListener(
                        "loadeddata",
                        function () {
                            resolve();
                        },
                        false
                    );
                } else if (bg.data && bg.data.type === "Image") {
                    var _img = new Image();
                    _img.src = handleAssetsUrl(bg.data.data.url);
                    _img.onload = function () {
                        return resolve();
                    };
                    _img.onerror = function () {
                        return resolve();
                    };
                } else {
                    return resolve();
                }
            });

            return Promise.all(promiseArr);
        },

        show: function (frame) {
            // 让遮罩层保持在最顶层
            this.scene.editor.player.maskEle.css({
                zIndex: 9999,
            });

            // 视频背景
            this.scene.updateImageBgInPlayer();
            this.scene.updateBgVideo(frame);
            this.scene.updateBgZoomTick(frame);
        },

        showFirst: function (frame) {
            //衔接上一个场景页的动画(统一)
            if (this.prevs) {
                var prev_ele = this.prevs.element.player; // player层中的上一个场景

                // 让上一个场景页显示
                prev_ele.show();
                // 调用上一个场景页的方法（虽然在本场景页，但由上一个场景页提供动画）
                this.prevs.effect.showNext(frame);

                return;
            }
            // 如果不存在上一个场景页，本场景页s位置不会有动画
            this.scene.effect.reset();
            if (this.nexts) {
                this.nexts.effect.reset();
                return this.nexts.hide();
            }
        },

        showMiddle: function () {
            // 动画区间外，隐藏其它元素，恢复位置(本场景页)
            var scene = this.scene,
                editor = scene.editor;

            scene.effect.reset();
            this.maskEle && this.maskEle.hide();

            if (this.prevs) {
                // 隐藏上一个场景页的遮罩
                this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();
                this.prevs.hide();
            }
            this.nexts && this.nexts.hide();

            // 隐藏其它场景页
            for (var i = 0; i < editor.sprites.length; i++) {
                if (editor.sprites[i].id !== scene.id) {
                    editor.player.scenesDict[editor.sprites[i].id].ele.hide();
                    editor.sprites[i].effect.reset &&
                        editor.sprites[i].effect.reset();
                }
            }
        },

        hideMask: function () {
            this.maskEle && this.maskEle.hide();
        },

        reset: function () {
            // 将本场景页调整到最正常状态
            this.scene.element.player.css({
                top: 0,
                left: 0,
                transform: "",
                zIndex: this.scene.index * 5,
                filter: "",
                clipPath: "",
                opacity: "",
            });
        },

        clearMask: function () {
            return;
        },
        initDom: function () {
            return;
        },
    });
    // 动画实现----------------------------------n

    // 镜头动画
    var Camera = klass(function (scene, option) {
        this.scene = scene;
        this.frameRate = scene.editor.option.frameRate || 60;
        this.maxWidth = scene.editor.clientWidth;
        this.maxHeight = scene.editor.clientHeight;
        this.cameras = []; // 镜头数组
        this.playData = [];
        this.playDom = null;
    }).methods({
        _setOption: function () {
            var m = null,
                scale = this.scene.editor.clientWidth / this.maxWidth;
            for (var i = 0; i < this.cameras.length; i++) {
                m = this.cameras[i].matrix;
                m.w *= scale;
                m.h *= scale;
                m.x *= scale;
                m.y *= scale;
            }
            this.maxWidth = this.scene.editor.clientWidth;
            this.maxHeight = this.scene.editor.clientHeight;
        },
        // 根据当前动画时间求出当前帧
        _ms2frame: function (ms) {
            var t = 1000 / this.frameRate; // 每帧需要的时间
            return Math.ceil(ms / t);
        },
        linear: function (t, b, c, d) {
            return c * (t / d) + b;
        },
        init: function () {
            this.playData.length = 0;
            this.playDom = this.scene.element.playerC;
            this.playDom.css({
                transform: "scale(1)",
                top: 0,
                left: 0,
            });
            // 先粗糙的处理了
            this.scene.effect.cameraDom &&
                this.scene.effect.cameraDom.css({
                    transform: "scale(1)",
                    top: 0,
                    left: 0,
                });
            for (var i in this.cameras) {
                this.cameras[i].scale =
                    this.maxWidth / this.cameras[i].matrix.w;
                var t1 = this._ms2frame(
                    this.cameras[i].animations.delay * 1000
                );
                var t2 =
                    t1 +
                    this._ms2frame(this.cameras[i].animations.duration * 1000);
                this.playData.push(t1, t2);
            }
        },
        _defaultC: function () {
            this.cameras = [];
            var item = {
                matrix: {
                    w: this.maxWidth,
                    h: this.maxHeight,
                    x: 0,
                    y: 0,
                    r: 0,
                },
                animations: {
                    duration: 0,
                    delay: 0,
                },
                easing: "linear",
                scale: 1,
            };
            this.cameras.push(item);
        },
        addCamera: function (obj, index, noInit) {
            // obj必须要有animations属性
            var item = {
                // id: uuid.generate(), 暂时没有必要
                matrix: {
                    w: this.maxWidth / 2,
                    h: this.maxHeight / 2,
                    x: this.maxWidth / 4,
                    y: this.maxHeight / 4,
                    r: 0,
                },
                easing: "linear",
            };
            $.extend(true, item, obj);
            item.scale = this.maxWidth / item.matrix.w;
            if (index) {
                this.cameras.splice(index, 0, item);
            } else {
                this.cameras.push(item);
            }
            !noInit && this.init();
        },
        delCamera: function (index) {
            this.cameras.splice(index, 1);
            this.playDom.css({
                transform: "scale(1)",
                top: 0,
                left: 0,
            });
            this.init();
        },
        play: function (frame, scenesId) {
            var num = -1,
                index = 0,
                transform = "",
                top = 0,
                left = 0;
            for (var i = 0; i < this.playData.length; i++) {
                if (frame > this.playData[i]) {
                    num++;
                } else {
                    break;
                }
            }
            index = parseInt(num / 2);
            var now = this.cameras[index];
            if (index <= 0 || num % 2) {
                transform = "scale(" + now.scale + ")";
                top = now.matrix.y * now.scale;
                left = now.matrix.x * now.scale;
            } else {
                if (frame > this.playData[num + 1])
                    frame = this.playData[num + 1];
                var offrame = frame - this.playData[num];
                var prevs = this.cameras[index - 1];
                var off = {
                    time: this.playData[num + 1] - this.playData[num],
                    scale: now.scale - prevs.scale,
                    top:
                        now.matrix.y * now.scale - prevs.matrix.y * prevs.scale,
                    left:
                        now.matrix.x * now.scale - prevs.matrix.x * prevs.scale,
                };
                transform =
                    "scale(" +
                    this.linear(offrame, prevs.scale, off.scale, off.time) +
                    ")";
                top = this.linear(
                    offrame,
                    prevs.matrix.y * prevs.scale,
                    off.top,
                    off.time
                );
                left = this.linear(
                    offrame,
                    prevs.matrix.x * prevs.scale,
                    off.left,
                    off.time
                );
            }
            this.playDom.css({
                transform: transform,
                top: -top,
                left: -left,
            });
            // 先粗糙的处理了
            this.scene.effect.cameraDom &&
                this.scene.effect.cameraDom.css({
                    transform: transform,
                    top: -top,
                    left: -left,
                });
        },
        updateCamera: function (index, option) {
            if (index >= 0) {
                $.extend(true, this.cameras[index], option);
                this.init();
            }
        },
        fromJson: function (json, scale) {
            let data = JSON.parse(JSON.stringify(json));
            this.cameras = [];
            for (var i in data) {
                data[i].matrix.w *= scale;
                data[i].matrix.h *= scale;
                data[i].matrix.x *= scale;
                data[i].matrix.y *= scale;
                this.addCamera(data[i], i, true);
                if (i === "0") {
                    this.cameras[0].animations.duration = 0;
                }
            }
        },
    });

    //编辑器画布的类
    var AnimEditor = klass(function (id, option, style) {
        this.id = id;
        this.targetPlatform = "Web"; //项目的目标平台:Web App
        this.option = option || {};
        this.sprites = []; // 分组精灵数组
        this.optimized = option.optimized; // 预览适配   0:Horizontal（16:9） 1:Square(1:1) 2:Vertical(9:16)
        this.ele = $("#" + id); // editor元素
        this.scenesId = 0; // 显示的scenes
        this.selectedScenes = null; // 选中的scenes
        this.selectedSprite = []; // 选中的元素
        this.disabled = false; // 控制是否不可操作
        this.drag = false; // 控制拖动
        this.opHelper = null; // 帮助
        this.sound = null; // 全局音乐
        this.soundRecord = null; // 全局录音
        this.soundRecordMode = null; // 'global' 表示当前使用全局录音 or 'scene'
        this.setOption(option); // 设置所有页面位置
        this.limitTime = null; // 总时长限制
        this.adsorb = true; // 吸附功能是否打开(默认开启)

        this.fontList = [];

        this.loading = {
            // 加载中对象
            type: "",
            status: "",
            text: "",
        };

        if (!this.option.width || !this.option.height) {
            throw (
                "Error: You should specify width and height of container #" + id
            );
        }

        // 事件对象
        this.eve = new EventEmitter();

        this.option.frameRate = this.option.frameRate || 60;

        // 静态图片资源
        this.option.assets = Object.assign(
            {
                diagonal: "/static/animengine/img/diagonal.png",
                writeHand: "/static/animengine/img/writehand.png",
            },
            this.option.assets
        );

        // player    z-index: 0;
        this.player = {
            uuid: uuid.generate(),
            ele: $("<div></div>"),
            maskEle: $("<div></div>"),
            scenesDict: {},
            spritesDict: {},
        };

        this.player.maskEle
            .attr({
                id: "player_mask_" + this.player.uuid,
            })
            .css({
                position: "absolute",
                top: "0px",
                left: "0px",
                width: this.clientWidth + "px",
                height: this.clientHeight + "px",
                "z-index": 9999,
                overflow: "hidden",
            })
            .appendTo(this.player.ele);

        this.player.ele
            .attr({
                id: "player_" + this.player.uuid,
            })
            .css({
                position: "absolute",
                top: this.fixTop + "px",
                left: this.fixLeft + "px",
                width: this.clientWidth + "px",
                height: this.clientHeight + "px",
                "z-index": 9999,
                display: "none",
                overflow: "hidden",
            })
            .appendTo(this.ele);

        // content  z-index: 20;
        this.content = "content_" + uuid.generate();
        this.content = $("<div></div>")
            .attr({
                id: this.content,
            })
            .css({
                position: "absolute",
                top: this.fixTop + "px",
                left: this.fixLeft + "px",
                width: this.clientWidth + "px",
                height: this.clientHeight + "px",
                "z-index": 20,
            })
            .appendTo(this.ele);
        // content 元素盒子
        this.contentBody = "contentBody_" + uuid.generate();
        this.contentBody = $("<div></div>")
            .attr({
                id: this.contentBody,
            })
            .css({
                position: "absolute",
                top: "0px",
                left: "0px",
                width: this.clientWidth + "px",
                height: this.clientHeight + "px",
            })
            .appendTo(this.content);
        // content 斜线区
        this.contentMask = {
            right: $("<div></div>"),
            left: null,
            playerRight: $("<div></div>"),
            playerLeft: null,
        };
        this.contentMask.right.css({
            background: "url(" + this.option.assets.diagonal + ")",
            position: "absolute",
            top: 0,
            right: 0,
            width: this.fixLeft + "px",
            "height:": this.clientHeight + "px",
            "z-index": 100,
            opacity: 0.6,
        });
        this.contentMask.left = this.contentMask.right
            .clone()
            .css({ left: 0, right: "" });
        this.content.append(this.contentMask.right, this.contentMask.left);
        // 播放层黑色遮罩
        this.contentMask.playerRight.css({
            background: "#000000",
            position: "absolute",
            top: 0,
            right: 0,
            width: this.fixLeft + "px",
            "height:": this.clientHeight + "px",
            "z-index": 10000,
            opacity: 1,
        });
        this.contentMask.playerLeft = this.contentMask.playerRight
            .clone()
            .css({ left: 0, right: "" });
        this.player.ele.append(
            this.contentMask.playerRight,
            this.contentMask.playerLeft
        );
        this.subtitlePlayer = $('<div id="subtitle-player-9999"></div>').css({
            position: "absolute",
            top: "0px",
            left: "0px",
            width: this.clientWidth + "px",
            height: this.clientHeight + "px",
            "z-index": 9999,
            overflow: "hidden",
            "background-color": "#00000000",
        });
        this.player.ele.append(this.subtitlePlayer);

        // handle    z-index: 30;
        this.handle = "handle_" + uuid.generate();
        this.handle = $("<div></div>")
            .attr({
                id: this.handle,
            })
            .css({
                position: "absolute",
                top: this.fixTop + "px",
                left: this.fixLeft + "px",
                width: this.clientWidth + "px",
                height: this.clientHeight + "px",
                "z-index": 100,
            })
            .appendTo(this.ele);
        // handle
        this.handleBody = "handleBody_" + uuid.generate();
        this.handleBody = $("<div></div>")
            .attr({
                id: this.handleBody,
            })
            .css({
                position: "absolute",
                top: 0 + "px",
                left: 0 + "px",
                width: this.clientWidth + "px",
                height: this.clientHeight + "px",
                "z-index": 20,
                "box-shadow": "#d8dee9 0px 0px 5px 0px",
                "border-radius": "3px",
            })
            .appendTo(this.handle);
        // 拖拽多选-->选中框
        this.multiSelect = {
            id: "multiSelect_" + uuid.generate(),
            action: false,
            type: "multiSelect",
            isShow: false,
            add: false,
            disabled: false,
            opHelper: null,
            css: {},
        };
        this.multiSelectEle = $("<div></div>").attr({
            id: this.multiSelect.id,
            "data-id": "multiSelect",
            class: "sprite-help-content sprite-help-content-dashed active",
        });
        this.multiSelect.opHelper = new OpHelper(
            this.multiSelectEle,
            this.multiSelect,
            {}
        );

        this.mask = "mask_" + uuid.generate();
        this.mask = $("<div></div>")
            .attr({
                id: this.mask,
            })
            .css({
                position: "absolute",
                top: 0,
                left: 0,
                width: this.option.width + "px",
                height: this.option.height + "px",
                "z-index": 50,
                display: "none",
            })
            .appendTo(this.ele);

        // 页面操作事件
        var _this = this,
            undoData = null; // 为撤销提供的数据对象
        this.moveData = null; // 点击为移动保存提供数据

        this.isCtrlKey = false; // 防止单个ctrl多选和取消多选冲突
        this.ele.mousedown(function (e) {
            // 鼠标按下事件
            if (_this.disabled) return;
            document.addEventListener("mousemove", documentMousemove);
            document.addEventListener("mouseup", documentMouseUp);
            // 有效防止播放层没有隐藏而选不中元素
            _this.cancelPlay();
            // 为撤销提供的数据对象
            undoData = {
                oldVal: [],
                val: [],
                scale: _this.scale,
            };
            // 为移动提供的数据
            _this.moveData = {
                x: e.pageX - _this.PfixLeft,
                y: e.pageY - _this.PfixTop,
            };
            // 选中元素
            var mouseupData = e.target.dataset,
                ctrlKey = e.ctrlKey || e.metaKey || e.shiftKey;
            if ("id" in mouseupData) {
                var sprite, arr;
                if (mouseupData.id !== "multiSelect") {
                    sprite = _this.getSpriteIdData(mouseupData.id);
                    if (sprite && !sprite.disabled) {
                        arr = [sprite];
                        if (ctrlKey) {
                            _this.isCtrlKey = true;
                            var isPush = true; // 影响多选
                            arr = [].concat(_this.selectedSprite);
                            // 去掉已经选中的元素
                            for (var i = 0; i < arr.length; i++) {
                                if (arr[i].id === sprite.id) {
                                    arr.splice(i, 1);
                                    isPush = false;
                                    break;
                                }
                            }
                            // 路径动画(锁定)不予许多选
                            if (
                                (sprite.effect.pathAnim &&
                                    sprite.effect.pathAnim.info) ||
                                sprite.locked
                            )
                                isPush = false;
                            if (arr[0] && arr[0].locked) isPush = false;
                            isPush && arr.push(sprite);
                        }
                        _this.selectSprite(arr);
                        arr = null;
                    }
                }
                if (_this.selectedSprite.length > 1) {
                    for (var i = 0; i < _this.selectedSprite.length; i++) {
                        var outward = {};
                        outward.id = _this.selectedSprite[i].id;
                        outward.width = _this.selectedSprite[i].width;
                        outward.height = _this.selectedSprite[i].height;
                        outward.positionLeft =
                            _this.selectedSprite[i].positionLeft;
                        outward.positionTop =
                            _this.selectedSprite[i].positionTop;
                        outward.rotate = _this.selectedSprite[i].rotate;
                        outward.fontSize = _this.selectedSprite[i].font
                            ? _this.selectedSprite[i].font.fontSize
                            : 0;
                        undoData.oldVal.push(outward);
                        mouseupData.id === "multiSelect" &&
                            _this.selectedSprite[i]._start("move", {
                                x: _this.moveData.x,
                                y: _this.moveData.y,
                            });
                    }
                    if (mouseupData.id === "multiSelect") {
                        // 多选移动
                        if (_this.adsorb) _this.selectedScenes._getAdsorbArr();
                        // 告诉鼠标移动函数，执行多个元素移动
                        _this.moveData.moveAction = "multiMove";
                        _this.moveData.css = Object.assign(
                            {},
                            _this.multiSelect.css
                        );

                        if (e.which === 3) {
                            // 禁止右键事件
                            eve("editor.FeaturesPop", _this, {
                                // 弹窗事件定义
                                type: 1, // 弹窗的类型 1级弹窗 < 2级弹窗
                                name: "sprite_right_key",
                                sprite: null,
                                posx: e.pageX, // 弹窗的定位
                                posy: e.pageY,
                                actionType: "multiSelect",
                            });
                            e.stopPropagation();
                        }
                    }
                    if (mouseupData.action) {
                        // 多选缩放的开始
                        // 用于判断多选元素的vue部分的按钮部分的显示和隐藏
                        _this.multiSelect.action = true;
                        // 将多选框当成一个新的元素
                        _this.moveData.moveAction = "multiCss";
                        _this.moveData.css = Object.assign(
                            {},
                            _this.multiSelect.css
                        );
                        _this.moveData.action = mouseupData.action;
                    }
                } else if (_this.selectedSprite.length === 1) {
                    // 单个元素的操作
                    _this.moveData.moveAction = "oneCss";
                    _this.moveData.action = mouseupData.action || "move";
                    if (!mouseupData.action && e.which === 3) {
                        // 禁止右键事件
                        e.stopPropagation();
                        eve("editor.FeaturesPop", _this, {
                            // 弹窗事件定义
                            type: 1, // 弹窗的类型 1级弹窗 < 2级弹窗
                            name: "sprite_right_key",
                            sprite: sprite,
                            posx: e.pageX, // 弹窗的定位
                            posy: e.pageY,
                            actionType: "sprite",
                        });
                    }
                    sprite._start(_this.moveData.action, {
                        x: _this.moveData.x,
                        y: _this.moveData.y,
                    });

                    // 记录变化开始的位置信息（单个）
                    var outward = {};
                    outward.id = sprite.id;
                    outward.width = sprite.width;
                    outward.height = sprite.height;
                    outward.positionLeft = sprite.positionLeft;
                    outward.positionTop = sprite.positionTop;
                    outward.rotate = sprite.rotate;
                    undoData.oldVal.push(outward);
                }
            } else {
                if (!ctrlKey) _this.selectSprite();
                // 关闭多选框
                _this.updateMultiSelect(false);
                _this.multiSelect.opHelper.showHideEle(false);

                if (e.which === 3) {
                    // 禁止右键事件
                    eve("editor.FeaturesPop", _this, {
                        // 弹窗事件定义
                        type: 1, // 弹窗的类型 1级弹窗 < 2级弹窗
                        name: "sprite_right_key",
                        sprite: null,
                        posx: e.pageX, // 弹窗的定位
                        posy: e.pageY,
                        actionType: "tool",
                    });
                    e.stopPropagation();
                }
            }
            _this.drag = true;

            undoData.mousemove = false; // 每次mousedown 重置为false
        });

        var documentMousemove = function (e) {
            // 鼠标拖动事件
            if (!_this.drag || !_this.moveData) return;
            var ctrlKey = e.ctrlKey || e.metaKey || e.shiftKey;
            var x_y = {
                x: e.pageX - _this.PfixLeft,
                y: e.pageY - _this.PfixTop,
            };
            // 阻止默认和冒泡
            e.preventDefault();
            e.stopPropagation();

            if (_this.selectedSprite.length) {
                // 存在选中元素的情况
                if (_this.moveData.moveAction === "multiCss") {
                    // 多个元素的缩放和旋转
                    eve("SelectSprites_process", null, {
                        moveData: _this.moveData,
                        pos: x_y,
                        old: undoData.oldVal,
                    });
                } else if (_this.moveData.moveAction === "multiMove") {
                    // 多个元素的移动操作
                    _this.multiSelect.action = true;
                    // 旋转框位置设置
                    var css = {
                        top: _this.moveData.css.top - _this.moveData.y + x_y.y,
                        left:
                            _this.moveData.css.left - _this.moveData.x + x_y.x,
                    };
                    _this.updateMultiSelect(true, css);
                    if (_this.adsorb) {
                        var info = _this._setMultiAdsorb(_this.moveData.css);
                        if (typeof info.x === "number") css.left = info.x;
                        if (typeof info.y === "number") css.top = info.y;
                        _this.updateMultiSelect(true, css);
                        x_y.x =
                            css.left +
                            _this.moveData.x -
                            _this.moveData.css.left;
                        x_y.y =
                            css.top + _this.moveData.y - _this.moveData.css.top;
                    }
                    for (var i = 0; i < _this.selectedSprite.length; i++) {
                        _this.selectedSprite[i]._process(x_y);
                    }
                } else if (_this.moveData.moveAction === "oneCss") {
                    // 一个元素的移动,缩放，旋转等
                    let oSelectSprite = _this.selectedSprite[0];
                    oSelectSprite._process(x_y);
                } else {
                    if (ctrlKey) {
                        // 选中元素的情况下按住ctrl的框选
                        _this.moveData.move = true;
                        _this.calcMultiSelect("dragCalc", x_y); // 拖动并计算选框大小
                    }
                }

                if (!ctrlKey) {
                    // 单个和多个元素的拖动（后续）
                    undoData.mousemove = true;
                }
            } else {
                // 没有选中元素的框选
                _this.moveData.move = true;
                _this.calcMultiSelect("dragCalc", x_y); // 拖动并计算选框大小
            }
        };

        var documentMouseUp = function (e) {
            document.removeEventListener("mousemove", documentMousemove);
            document.removeEventListener("mouseup", documentMouseUp);
            if (_this.disabled || !_this.moveData) return;
            var ctrlKey = e.ctrlKey || e.metaKey || e.shiftKey;
            var mouseupData = e.target.dataset;
            mouseupData || (mouseupData = {});

            // 按住ctrl下的取消选中
            if (mouseupData.id === "multiSelect" && ctrlKey) {
                var mouseX = e.pageX - _this.option.surplusX - _this.fixLeft,
                    mouseY = e.pageY - _this.option.surplusY - _this.fixTop,
                    spritesCalc;
                spritesCalc = _this.unSelectSprite(mouseX, mouseY);
                if (!_this.isCtrlKey && spritesCalc) {
                    if (spritesCalc.length === 1) spritesCalc[0]._end();
                    _this.selectSprite(spritesCalc);
                    _this.isCtrlKey = false;
                    _this.drag = false;
                    _this.moveData = null;
                    return;
                }
            }
            _this.isCtrlKey = false;
            // moveData.move框选元素的判断，在mousemove中定义的
            if (_this.moveData.move) {
                var arr = _this._findMoveSelected();
                if (ctrlKey) {
                    var arrCalc = _this.selectedSprite.concat(arr),
                        arrF = [],
                        isPush = true;
                    for (var i = 0; i < arrCalc.length; i++) {
                        isPush = true;
                        for (var j = 0; j < arrCalc.length; j++) {
                            if (i !== j && arrCalc[i].id === arrCalc[j].id) {
                                isPush = false;
                                break;
                            }
                        }
                        isPush && arrCalc[i] && arrF.push(arrCalc[i]);
                    }
                    arr = arrF;
                }
                _this.selectSprite(arr);
                _this.drag = false;
                _this.moveData = null;
                return;
            }
            if (_this.selectedSprite.length) {
                for (var i = 0; i < _this.selectedSprite.length; i++) {
                    _this.selectedSprite[i]._end();
                    // 插入新位置信息
                    var outward = {};
                    outward.id = _this.selectedSprite[i].id;
                    outward.width = _this.selectedSprite[i].width;
                    outward.height = _this.selectedSprite[i].height;
                    outward.positionLeft = _this.selectedSprite[i].positionLeft;
                    outward.positionTop = _this.selectedSprite[i].positionTop;
                    outward.rotate = _this.selectedSprite[i].rotate;
                    undoData.val.push(outward);
                }
                if (undoData.mousemove) {
                    undoData.scenesId = _this.selectedSprite[0].scenesId;
                    eve("undo_redo", null, { type: "matrix", data: undoData });
                }
                eve("editor.spriteSetting", _this, {
                    scenes: _this.selectedScenes,
                });
            }
            if (_this.selectedSprite.length > 1) {
                // 多选按钮等操作
                eve("SelectSprites_process_up", null, {
                    action: _this.moveData.action || "move-all",
                });
                _this.multiSelect.action = false;
                _this.calcMultiSelect("rePaint");
            }
            _this.moveData = null;
            _this.drag = false;
        };

        window.onblur = function (e) {
            documentMouseUp(e);
            eve("windowOnblur", null, null);
        };

        this.ele.bind("contextmenu", function (e) {
            // 禁止右键事件
            return false;
        });
        this.handleBody.dblclick(function (e) {
            // 鼠标双击事件
            // 固定区域添加文字等
            if (_this.disabled) return;

            // 双击元素
            var mouseupData = e.target.dataset;
            if ("id" in mouseupData) {
                var sprite = _this.getSpriteIdData(mouseupData.id);
                if (sprite.locked) return;
                if (sprite.type === "Text") {
                    eve("editor.emitText", _this, sprite);
                    _this.disabledEditor(0);
                    sprite.showHideHandle(false);
                    sprite.ele.hide();
                }
                if (sprite.type === "Image") {
                    eve("editor.dbClickCropImage", _this, sprite);
                }
                if (sprite.type === "RichText") {
                    eve("editor.richTextEdit", _this, sprite);
                    _this.disabledEditor(0);
                    sprite.showHideHandle(false);
                    sprite.ele.hide();
                }
            } else {
                delete TextSprite.font.width;
                // 双击空白处插入文本框
                _this
                    .addSprite(
                        "Text",
                        {
                            text: "添加正文",
                            font: TextSprite.font,
                            positionTop: e.pageY - _this.PfixTop,
                            positionLeft: e.pageX - _this.PfixLeft,
                            versionAnyway: TextSprite.versionAnyway,
                            resourceId: TextSprite.fontId,
                        },
                        null,
                        true
                    )
                    .then(function (sprite) {
                        var arr = [sprite];
                        _this.selectSprite(arr);
                    });
            }
        });

        this.setOptimized(this.optimized); // 给予画布Optimized
        this._initMask(); // 初始化遮罩层

        this.svgForPath = AnimEditor.createSVGforPath();

        // 预览模式，用于项目预览，主要涉及音频加载的异步问题，以及视频播放方式
        // 2019-9-10
        this.previewMode = option.previewMode || false;

        var _this = this;
        this.eve.on("subtitle_play_all", function (data) {
            //console.log('this.eve.on(subtitle_play_all', data, _this.subtitleEditor);
            if (_this.subtitleEditor) {
                if (data.isPlay) {
                    _this.subtitleEditor.play((data.timeMS / 1000) * 60);
                } else {
                    _this.subtitleEditor.stop((data.timeMS / 1000) * 60);
                }
            }
            //if(data.)
        });
    })
        .statics({
            env: "editor", // 运行环境，默认为编辑器，在转换服务器(transform)下可进行特殊处理
            nextScenesId: 0,

            // 扩展的特效及转场特效列表 10-6
            effects: {},
            sceneEffects: {},
            ImageLoader: ImageLoader,

            // 扩展元素特效
            extendEffect: function (name, fn, methods, statics) {
                if (AnimEditor.effects[name]) {
                    throw new Error("effect exsists");
                }
                var _extend = Effect.extend(fn)
                    .methods(methods)
                    .statics(statics);
                AnimEditor.effects[name] = _extend;
            },

            // 扩展转场特效
            extendScenesEffect: function (name, fn, methods, statics) {
                if (AnimEditor.sceneEffects[name]) {
                    throw new Error("scenes effect exsists");
                }
                var _extend = SceneEffect.extend(fn)
                    .methods(methods)
                    .statics(statics);
                AnimEditor.sceneEffects[name] = _extend;
            },
            // 生成用于计算路径动画的svg
            createSVGforPath: function () {
                $('<div id="svg-path-calc"></div>').appendTo($("body")).css({
                    visibility: "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: -10,
                });
                return SVG("svg-path-calc");
            },
        })
        .methods({
            on: function (evt, cb) {
                // 监听eve事件
                eve.on("editor." + evt, cb)(1);
            },

            setOption: function (option) {
                // 设置全局 option width&height
                this.option.width = option.width;
                this.option.height = option.height;
                this.option.scale = option.scale || this.option.scale || 1;

                if (option.clientWidth && option.clientHeight) {
                    this.clientWidth = option.clientWidth;
                    this.option.width = option.clientWidth;
                    this.clientHeight = option.clientHeight;
                    this.option.height = option.clientHeight;
                } else {
                    var maxSize = 0,
                        multiple = 0.9;

                    if (this.option.width > (this.option.height * 16) / 9) {
                        maxSize = ((this.option.height * multiple) / 9) * 16;
                    } else {
                        maxSize = this.option.width * multiple;
                    }

                    maxSize = maxSize * this.option.scale;

                    this.clientWidth = maxSize;
                    this.clientHeight = (maxSize / 16) * 9;
                    // if(this.option.width > this.option.height){
                    //     if(( ( (this.option.width) / 16) * 9) >= this.option.height ){
                    //         maxSize = (this.option.height/9)*16;
                    //     }else{
                    //         if((this.option.width*0.9) > this.option.height){
                    //             maxSize =(this.option.width);
                    //         }else{
                    //             maxSize = ((this.option.width)/16)*9;
                    //         }
                    //     }
                    // }else{
                    //     maxSize = this.option.width;
                    // }
                }

                this.scale = 1920 / this.clientWidth; // 全局缩放相对比例

                if (this.option.width < this.clientWidth) {
                    this.option.width = this.clientWidth;
                }

                if (this.option.height < this.clientHeight) {
                    this.option.height = this.clientHeight;
                }

                this.ele.css({
                    width: this.option.width,
                    height: this.option.height,
                });
                this.fixTop = (this.option.height - this.clientHeight) / 2; // 位置信息
                this.fixLeft = (this.option.width - this.clientWidth) / 2;

                this.PfixTop =
                    (this.option.height - this.clientHeight) / 2 +
                    (option.surplusY || 0); // 动态点位置信息
                this.PfixLeft =
                    (this.option.width - this.clientWidth) / 2 +
                    (option.surplusX || 0);

                if (
                    this.player &&
                    this.content &&
                    this.handleBody &&
                    this.mask
                ) {
                    this._updateViewBox({
                        width: this.option.width,
                        height: this.option.height,
                    });
                }
                return Promise.resolve(this.scale);
            },

            changePfix: function (option) {
                this.PfixTop =
                    (this.option.height - this.clientHeight) / 2 +
                    (option.surplusY || 0); // 动态点位置信息
                this.PfixLeft =
                    (this.option.width - this.clientWidth) / 2 +
                    (option.surplusX || 0);
            },

            setOptimized: function (optimized) {
                // 播放比例
                var cwidth = 0;
                switch (optimized) {
                    case 0: // Horizontal（16:9)
                    case "Horizontal": // Horizontal（16:9)
                        this.optimized = "Horizontal";
                        break;
                    case 1: // Square(1:1)
                    case "Square": // Square(1:1)
                        this.optimized = "Square";
                        cwidth = (this.clientWidth - this.clientHeight) / 2;
                        break;
                    case 2: // Vertical(9:16)
                    case "Vertical": // Vertical(9:16)
                        this.optimized = "Vertical";
                        cwidth =
                            (this.clientWidth - (this.clientHeight / 16) * 9) /
                            2;
                        break;
                }
                this.contentMask.right.css({
                    width: cwidth + "px",
                    height: this.clientHeight + "px",
                });
                this.contentMask.left.css({
                    width: cwidth + "px",
                    height: this.clientHeight + "px",
                });
                this.contentMask.playerLeft.css({
                    width: cwidth + "px",
                    height: this.clientHeight + "px",
                });
                this.contentMask.playerRight.css({
                    width: cwidth + "px",
                    height: this.clientHeight + "px",
                });
                // 重新init
                for (var i = 0; i < this.sprites.length; i++) {
                    this.sprites[i].effect.init(true);
                }
            },

            getOptimized: function () {
                // 播放比例
                return this.optimized;
            },

            getOptimizedNum: function () {
                var optimized = this.optimized;
                var obj = {
                    Horizontal: 0,
                    Square: 1,
                    Vertical: 2,
                };
                return obj[optimized];
            },

            _updateViewBox: function (silent) {
                // 更新全局viewbox
                //
                this.player.ele.css({
                    width: this.clientWidth + "px",
                    height: this.clientHeight + "px",
                    top: this.fixTop + "px",
                    left: this.fixLeft + "px",
                });
                this.player.maskEle.css({
                    width: this.clientWidth + "px",
                    height: this.clientHeight + "px",
                });
                this.content.css({
                    width: this.clientWidth + "px",
                    height: this.clientHeight + "px",
                    top: this.fixTop + "px",
                    left: this.fixLeft + "px",
                });
                this.contentBody.css({
                    width: this.clientWidth + "px",
                    height: this.clientHeight + "px",
                });
                this.handle.css({
                    width: this.clientWidth + "px",
                    height: this.clientHeight + "px",
                    top: this.fixTop + "px",
                    left: this.fixLeft + "px",
                });
                this.handleBody.css({
                    width: this.clientWidth + "px",
                    height: this.clientHeight + "px",
                });
                this.mask.css({
                    width: silent.width + "px",
                    height: silent.height + "px",
                });
                this.subtitlePlayer.css({
                    width: this.clientWidth + "px",
                    height: this.clientHeight + "px",
                });
                if (this.subtitleEditor) {
                    this.subtitleEditor.setOption({
                        width: this.clientWidth,
                        height: this.clientHeight,
                    });
                }
                //console.log('_updateViewBox')
                this.setOptimized(this.optimized);
                for (var i = 0; i < this.sprites.length; i++) {
                    this.sprites[i]._setOption(silent);
                    this.sprites[i].effect.init(true);
                }
            },

            _initMask: function () {
                // 初始化遮罩
                this.mask.css("display", "none");
            },

            initScenes: function () {
                // 初始化scenes
                return this.addScenes(); // root scenes
            },

            addScenes: function (id, option, undo) {
                // 添加场景
                // var _dur = option ? option.duration : 10000;
                var _this = this,
                    option = option || {},
                    timeAll = this.getDuration();

                // 总时长的限制
                // if (this.limitTime && timeAll > this.limitTime - _dur) {
                //     eve("totalTime_danger", null, { timeAll: timeAll });
                //     // return Promise.reject('总时间过长');
                // }

                // if (this.limitTime && timeAll > this.limitTime) {
                //     eve("totalTime_danger", null, { timeAll: timeAll });
                // } else if (this.limitTime && timeAll > this.limitTime - 10000) {
                //     eve("totalTime_warning", null, { timeAll: timeAll });
                // }

                if (id) {
                    return this._addScenes(id, option).then(function (scenes) {
                        _this.moveScenesTo(
                            scenes.id,
                            _this.selectedScenes.index + 1
                        );

                        if (undo) {
                            var data = scenes.toJson();
                            eve("undo_redo", null, {
                                type: "addScenes",
                                data: data,
                            });
                        }
                        return Promise.resolve(scenes);
                    });
                } else {
                    return this._addScenes(id, option).then(function (scenes) {
                        if (undo) {
                            var data = scenes.toJson();
                            // 因为排序如果放在vue部分，zIndex没有得到及时的更改
                            _this.selectedScenes &&
                                (data.zIndex = _this.selectedScenes.index + 1);
                            eve("undo_redo", null, {
                                type: "addScenes",
                                data: data,
                            });
                        }
                        return Promise.resolve(scenes);
                    });
                }
            },

            _addScenes: function (id, option) {
                // 添加场景
                var _this = this;
                // var id    = (id !== undefined ? id : AnimEditor.nextScenesId);
                id = id || uuid.generate();
                var scenes = new ScenesSprite(id, this, option);

                this.sprites.push(scenes);

                // AnimEditor.nextScenesId = Math.max(AnimEditor.nextScenesId + 1, id + 1);
                /*
             * 完全不用调用_setOption
                var _this = this;
                return scenes._setOption({scenes: scenes}).then(function () {
                    eve("editor.scenesAdded", this, scenes);
                    _this.updateSoundRecordBackup();
                    return Promise.resolve(scenes);
                });
            */
                scenes._setOption({
                    width: this.clientWidth,
                    height: this.clientHeight,
                });
                this.updateSoundRecordBackup();
                eve("editor.scenesAdded", this, scenes);
                return Promise.resolve(scenes);
            },

            //画布添加元素方法
            addSprite: function (type, option, scenesId, undo) {
                var _this = this,
                    scenesDom = this.selectedScenes.element,
                    scenes = {};
                // 添加加载状态
                this._setLoading("addSprite");

                if (scenesId) {
                    scenes = this.getScenesIdData(scenesId);
                } else {
                    scenes = this.selectedScenes;
                }

                option = Object.assign(
                    { scenesId: scenes ? scenes.id : "" },
                    option
                );

                //通过SpriteLoader来加载元素
                var loader = new SpriteLoader(scenesDom, type, _this, option);

                return loader
                    .load()
                    .then(function (sprite) {
                        var entranceEnd = 0;
                        // console.log('adding sprite', sprite);
                        sprite.opHelper = new OpHelper(
                            sprite.helpEle,
                            sprite,
                            {}
                        );
                        // 默认隐藏帮助框
                        sprite.showHideHandle(false);
                        scenes.addSprite(sprite, scenes.id);
                        sprite.changeStyle({ init: true, sync: true });
                        var arr = [sprite];
                        sprite.setIndex(scenes.sprites.length - 1);

                        if (undo || type === "Video") {
                            if (
                                scenes.nowTime * 1000 + 500 >=
                                scenes.duration
                            ) {
                                entranceEnd = scenes.duration - 500;
                            } else {
                                entranceEnd = scenes.nowTime * 1000;
                            }
                            sprite
                                .updateEffect({
                                    entranceAnim: {
                                        start: entranceEnd - 500,
                                        end: entranceEnd,
                                    },
                                })
                                .then(function () {
                                    sprite.updateVideoDuration &&
                                        sprite.updateVideoDuration(
                                            sprite.effect.entranceAnim.end /
                                                1000,
                                            sprite.effect.exitAnim.start / 1000
                                        );
                                });
                            // 添加元素选中（用户手动添加的时候）
                            _this.selectSprite(arr);
                        }

                        _this._cancelLoading("addSprite");
                        if (undo) {
                            var data = sprite.toJson(true);
                            data.scenesId = scenes.id;
                            data.scale = _this.scale;
                            eve("undo_redo", null, {
                                type: "addSprite",
                                data: data,
                            });
                            eve("timeline_nowTime_change", null, {
                                nowTime: (entranceEnd + 500) / 1000,
                                noPlay: true,
                            });
                        }
                        if (type === "Video" && !undo) {
                            eve("timeline_nowTime_change", null, {
                                nowTime: option.isSwap
                                    ? sprite.effect.entranceAnim.end / 1000
                                    : (sprite.effect.entranceAnim.end + 500) /
                                      1000,
                                noPlay: true,
                            });
                        }
                        eve("editor.spriteAdded", this, sprite, {
                            isSwap: option.isSwap,
                        });
                        return Promise.resolve(sprite);
                    })
                    .catch(function (err) {
                        _this._cancelLoading("addSprite", "fail");
                        return Promise.reject(err);
                    });
            },

            addSpriteJson: function (jsonData) {
                var _this = this,
                    scenesId,
                    scenes,
                    scale = jsonData.scale || 1,
                    tasks = [];

                if (jsonData.id || jsonData.scenesId) {
                    scenesId = jsonData.id || jsonData.scenesId;
                    scenes = this.getScenesIdData(scenesId);
                } else {
                    scenes = this.selectedScenes;
                    scenesId = scenes.id;
                }

                return scenes
                    .fromJson(jsonData, jsonData.scale, true, true)
                    .then(function () {
                        var maxEnter = 0;
                        scenes.sprites.forEach(function (sprite) {
                            if (sprite.effect.entranceAnim.end > maxEnter) {
                                maxEnter = sprite.effect.entranceAnim.end;
                            }
                        });
                        // _this.selectSprite([scenes.sprites[scenes.sprites.length - 1]])
                        eve("timeline_nowTime_change", null, {
                            nowTime: maxEnter / 1000,
                            noPlay: true,
                        });

                        return Promise.resolve();
                    });
            },

            removeScenes: function (id, undo, needUndoInfo = {}) {
                // 删除scenes
                if (this.sprites.length >= 1) {
                    var scenesdata = this.getScenesIdData(id);
                    eve("editor.removeScenes", this, {
                        id: id,
                        data: scenesdata,
                    });
                    if (undo) {
                        var data = scenesdata.toJson(true);
                        data.scale = this.scale;
                        if (scenesdata.index - 1 < 0) {
                            data.preId = undefined;
                        } else {
                            data.preId = this.sprites[scenesdata.index - 1].id;
                        }
                        data.dubbing = needUndoInfo.dubbing;
                        data.subtitles = needUndoInfo.subtitles;

                        eve("undo_redo", null, {
                            type: "removeScenes",
                            data: data,
                        });
                    }

                    for (var t = 0; t < scenesdata.sprites.length; t++) {
                        scenesdata.sprites[t].removeSprite();
                    }

                    this.eve.off("play_" + scenesdata.id, scenesdata.onPlay);
                    scenesdata.element.player.remove();
                    scenesdata.element.content.remove();
                    scenesdata.element.handle.remove();
                    this.sprites.splice(scenesdata.index, 1);
                    for (var i = 0; i < this.sprites.length; i++) {
                        this.sprites[i].setIndex(i);
                    }
                    eve("editor.scenesRemoved", this, { id: id });
                    this.updateSoundRecordBackup();

                    return Promise.resolve(this.sprites);
                } else {
                    return Promise.resolve(false);
                }
            },

            removeSprite: function (id, undo) {
                // 删除精灵
                var sprite = this.findSpriteById(id),
                    spriteData,
                    scenes;

                spriteData = Object.assign({}, sprite);

                if (sprite != null) {
                    if (sprite.selected) {
                        this.selectSprite(null);
                    }

                    scenes = this.getScenesIdData(sprite.scenesId);

                    //去掉play层
                    if (this.player.spritesDict[id]) {
                        this.player.spritesDict[id].ele.remove();
                        $("#sprite-hand-" + id).remove();
                        this.player.spritesDict[id] = null;
                    }

                    if (undo) {
                        var data = sprite.toJson(true);
                        data.scenesId = scenes.id;
                        data.scale = this.scale;
                        eve("undo_redo", null, {
                            type: "removeSprite",
                            data: data,
                        });
                    }

                    scenes.removeSprite(sprite.id);
                    sprite && sprite.removeSprite && sprite.removeSprite();
                    sprite = null;
                }
                return Promise.resolve(spriteData);
            },

            findSpriteById: function (id) {
                var scenes = {};

                for (var i = 0; i < this.sprites.length; i++) {
                    var scenes = this.sprites[i];

                    for (var j = 0; j < scenes.sprites.length; j++) {
                        if (scenes.sprites[j].id === id) {
                            return scenes.sprites[j];
                        }
                    }
                }

                return null;
            },

            updateSprite: function (id, option, scenesId, undo) {
                var sprite = this.findSpriteById(id),
                    _this = this;
                if (sprite) {
                    this._setLoading("updateSprite");
                    if (undo) {
                        var data = sprite.toJson(true);
                        data.scenesId = sprite.scenesId;
                        data.scale = this.scale;
                        data.reData = $.extend(true, {}, sprite.option || {});
                        data.reData.resourceId = id;
                        data.reData.scale = this.scale;
                        data.data = $.extend(true, {}, option);
                    }
                    return sprite
                        .updateSprite(option)
                        .then(function () {
                            sprite.effect.init(); // effect 初始化

                            eve("editor.updateSprite", _this, sprite);

                            _this._cancelLoading("updateSprite");

                            if (undo) {
                                eve("undo_redo", null, {
                                    type: "updateSprite",
                                    data: data,
                                });
                            }
                            // return sprite;
                        })
                        .catch(function (err) {
                            _this._cancelLoading("updateSprite", "fail");
                            return Promise.reject(err);
                        });
                }
            },

            selectScenes: function (scenes) {
                // 选中场景
                if (!scenes) return Promise.resolve({});
                if (this.selectedScenes) {
                    this.selectSprite();
                    this.selectedScenes.hide();
                }
                scenes.show();
                this.selectedScenes = scenes;
                // 场景页的多选框插入
                this._changeMultiSelect();
                scenes.getSelectScenes();
                eve("editor.selectScenes", this, this.selectedScenes);
                return Promise.resolve(scenes);
            },

            selectSprite: function (sprites) {
                // 设置元素选中
                this.updateMultiSelect(false); // 关闭多选框
                // 取消所有选中元素
                for (var i = 0; i < this.selectedSprite.length; i++) {
                    i === 0 && this.selectedSprite[0].setSelected(false);
                    this.selectedSprite[i].selected = false;
                }
                this.selectedSprite = [];
                // 设置选中元素
                if (Array.isArray(sprites) && sprites.length) {
                    this.selectedSprite = sprites;

                    if (sprites.length === 1) {
                        this.selectedSprite[0].setSelected(true);
                    } else {
                        for (var j in sprites) {
                            sprites[j].selected = true;
                        }
                        this.calcMultiSelect("rePaint");
                    }
                }

                eve("editor.selectSprite", this.editor, this.selectedSprite);
            },

            calcMultiSelect: function (action, pos) {
                // 拖拽多选组合操作
                if (action === "dragCalc") {
                    // 拖动并计算选框大小
                    var css = {},
                        mpos = this.moveData;
                    // 对应方向的定位计算
                    if (pos.x < mpos.x) {
                        css.left = pos.x;
                    } else {
                        css.left = mpos.x;
                    }
                    if (pos.y < mpos.y) {
                        css.top = pos.y;
                    } else {
                        css.top = mpos.y;
                    }
                    css.width = Math.abs(pos.x - mpos.x);
                    css.height = Math.abs(pos.y - mpos.y);
                    this.updateMultiSelect(true, css);
                } else if (action === "rePaint") {
                    // 绘画选框
                    var fix = [],
                        bbox = [],
                        data = null;
                    for (var i = 0; i < this.selectedSprite.length; i++) {
                        //计算每个块的定位信息
                        bbox = this.selectedSprite[i]._getAdsorbData();

                        if (i === 0) {
                            fix = [].concat(bbox);
                        }
                        if (fix[3] > bbox[3]) fix[3] = bbox[3];
                        if (fix[0] > bbox[0]) fix[0] = bbox[0];
                        if (fix[1] < bbox[1]) fix[1] = bbox[1];
                        if (fix[2] < bbox[2]) fix[2] = bbox[2];
                    }
                    data = {
                        left: fix[3],
                        top: fix[0],
                        width: fix[1] - fix[3],
                        height: fix[2] - fix[0],
                        rotate: 0,
                    };
                    if (this.selectedSprite.length > 1) {
                        this.updateMultiSelect(true, data);
                        this.multiSelect.opHelper.showHideEle(true);
                    } else {
                        this.updateMultiSelect(false);
                    }
                }
                switch (action) {
                    case 2:
                        break;
                    case 4:
                        break;
                }
            },

            updateMultiSelect: function (bool, data) {
                // 多选框的样式更新函数
                if (!this.multiSelect.add && bool) {
                    this.multiSelectEle.appendTo(
                        this.selectedScenes.element.handle
                    );
                    this.multiSelect.add = true;
                }
                if (bool) {
                    this.multiSelectEle.show();
                    this.multiSelect.isShow = true;
                    if (data) {
                        Object.assign(this.multiSelect.css, data);
                        if (typeof data.rotate === "number")
                            Object.assign(data, {
                                transform: "rotate(" + data.rotate + "deg)",
                            });
                        this.multiSelectEle.css(data);
                    }
                } else {
                    this.multiSelectEle.hide();
                    this.multiSelect.isShow = false;
                }
            },

            _changeMultiSelect: function () {
                // 切换场景页时的多选框切换
                this.multiSelectEle.hide();
                if (this.multiSelect.add) {
                    this.multiSelectEle = this.multiSelectEle.remove();
                    this.multiSelect.add = false;
                }
                if (this.selectedScenes) {
                    this.multiSelectEle.appendTo(
                        this.selectedScenes.element.handle
                    );
                    this.multiSelect.add = true;
                }
            },

            _setMultiAdsorb: function (mpos) {
                // 多个元素拖动吸附
                var css = this.multiSelect.css,
                    adsorbArr = this.selectedScenes.adsorbArr,
                    adsorb = [
                        css.top,
                        css.left + css.width,
                        css.top + css.height,
                        css.left,
                        css.top + css.height / 2,
                        css.left + css.width / 2,
                    ],
                    arr = [[], []],
                    data = [{}, {}, {}, {}, {}, {}];
                info = {};

                for (var i in adsorbArr) {
                    arr[i % 2].push(adsorbArr[i]);
                }

                for (let j in adsorb) {
                    let index = j % 2;
                    for (let k in arr[index]) {
                        if (Math.abs(adsorb[j] - arr[index][k]) <= 5) {
                            data[j].k = adsorb[j];
                            data[j].v = arr[index][k];
                            data[j].arr = adsorb;
                        }
                    }
                }
                data.forEach((v, i) => {
                    if (v.v) {
                        if (i % 2 === 0) {
                            info.y =
                                v.v - v.arr[i] + v.arr[4] - mpos.height / 2;
                        } else {
                            info.x = v.v - v.arr[i] + v.arr[5] - mpos.width / 2;
                        }
                    }
                });
                // 辅助线
                eve("multiAdsorb", null, data);
                return info;
            },

            _findMoveSelected: function () {
                // 查找所有的被选中覆盖元素
                // p1,p2,p3,p4代表框选和元素的bbox对应的左上角与右下角
                // 只需判断(p2.y>p3.y)∧(p1.y<p4.y)∧(p2.x>p3.x)∧(p1.x<p4.x)
                var selectedSprites = [];
                var sprites = this.selectedScenes.getSprites(); // helpEle
                // 选中框位置
                var t = this.multiSelect.css.top,
                    l = this.multiSelect.css.left,
                    b = this.multiSelect.css.height + t,
                    r = this.multiSelect.css.width + l,
                    box = null;
                for (var i = 0; i < sprites.length; i++) {
                    //路径动画和锁定元素不允许多选
                    if (
                        (sprites[i].effect.pathAnim &&
                            sprites[i].effect.pathAnim.end) ||
                        sprites[i].locked ||
                        sprites[i].disabled
                    )
                        continue;
                    box = sprites[i]._getBBox();
                    if (b > box.t && t < box.b && r > box.l && l < box.r) {
                        // 判断存在选中元素
                        selectedSprites.push(sprites[i]);
                    }
                }
                return selectedSprites;
            },

            unSelectSprite: function (x, y) {
                // 单击选中的元素则取消选中
                var box = null,
                    b = null,
                    s = null;
                var sprites = [].concat(this.selectedSprite);
                for (var i = 0; i < sprites.length; i++) {
                    s = sprites[i];
                    box = s._getBBox();
                    // 让点反向旋转
                    b = Rotate({ x: x, y: y }, -s.rotate, {
                        x: box.cx,
                        y: box.cy,
                    });
                    // 判断点是否在元素内
                    if (
                        b.x > s.positionLeft &&
                        b.x < s.positionLeft + s.width &&
                        b.y > s.positionTop &&
                        b.y < s.positionTop + s.height
                    ) {
                        // 取消选中
                        sprites.splice(i, 1);
                        return sprites;
                    }
                }
            },

            getSelectScenes: function (scenes) {
                //获取选中场景
                return this.selectedScenes;
            },

            moveScenesTo: function (id, index, undo) {
                // 移动场景位置
                if (index <= this.sprites.length) {
                    var scenesdata = this.getScenesIdData(id);
                    this.sprites.splice(scenesdata.index, 1);
                    this.sprites.splice(index, 0, scenesdata);

                    if (undo) {
                        var data = {
                            index: scenesdata.index,
                            reIndex: index,
                            id: id,
                        };

                        eve("undo_redo", null, {
                            type: "moveScenesTo",
                            data: data,
                        });
                    }

                    for (var i = 0; i < this.sprites.length; i++) {
                        this.sprites[i].setIndex(i);
                    }
                    this.updateSoundRecordBackup();
                    return this.sprites;
                } else {
                    return false;
                }
            },

            moveSpriteTo: function (id, index, undo) {
                // 移动场景位置
                if (index < 0) {
                    index = 0;
                }
                var sprite = this.getSpriteIdData(id);
                var scenesdata = this.getScenesIdData(sprite.scenesId);
                var sprites = scenesdata.sprites,
                    indexSprites = 0;
                for (var i = 0; i < sprites.length; i++) {
                    if (sprites[i].id === sprite.id) {
                        indexSprites = i;
                        break;
                    }
                }
                if (index <= sprites.length) {
                    sprites.splice(indexSprites, 1);
                    sprites.splice(index, 0, sprite);

                    if (undo) {
                        eve("undo_redo", null, {
                            type: "moveSpriteTo",
                            data: {
                                id: id,
                                scenesId: sprite.scenesId,
                                index: sprite.index,
                                reIndex: index,
                            },
                        });
                    }

                    for (var i = 0; i < sprites.length; i++) {
                        sprites[i].setIndex(i);
                    }
                    return sprites;
                } else {
                    return false;
                }
            },

            getScenesIdData: function (id) {
                // 通过ID获取scenes-data
                var sprites = this.sprites;

                for (var i = 0; i < sprites.length; i++) {
                    if (sprites[i].id === id) {
                        return sprites[i];
                    }
                }

                return null;
            },

            getSpriteIdData: function (id) {
                // 通过ID获取当前选中场景的元素
                var sprites = this.selectedScenes.getSprites();
                var iteam = null;
                for (var i = 0; i < sprites.length; i++) {
                    if (sprites[i].id == id) {
                        iteam = sprites[i];
                        break;
                    }
                }
                if (!iteam) {
                    for (var t = 0; t < this.sprites.length; t++) {
                        for (
                            var h = 0;
                            h < this.sprites[t].sprites.length;
                            h++
                        ) {
                            if (this.sprites[t].sprites[h].id == id) {
                                iteam = this.sprites[t].sprites[h];
                                break;
                            }
                        }
                    }
                }

                return iteam;
            },

            disabledEditor: function (data) {
                // 禁用引擎操作
                switch (data) {
                    case 0:
                        this.disabled = true;
                        break;
                    case 1:
                        this.disabled = false;
                        break;
                }
            },

            /**
             * 返回一个包含全部场景录音的数组
             *
             * @return {Array}
             */
            getSceneRecordAll: function () {
                var _this = this;
                return (
                    this.sprites.map(function (s, i) {
                        return (
                            Array.isArray(_this.soundRecordBackup) &&
                            _this.soundRecordBackup[i]
                        );
                    }) || []
                );
            },

            /**
             * 获取全局或场景录音
             *
             */
            getSoundRecord: function () {
                if (this.soundRecordMode === "global") {
                    return this.soundRecord;
                }

                return this.selectedScenes.getSound();
            },

            getSound: function (type) {
                if (type === "record") {
                    return this.soundRecord;
                }
                if (this.sound) {
                    this.sound.endTime = Math.min(
                        this.sound.endTime,
                        this.sound.duration * 1000
                    );
                }
                return this.sound;
            },

            /**
             * 设置全局背景音乐或全局录音
             *
             * @param {*} data
             * @param {*} undo
             * @param {String} type  falsy or 'record'；默认设置全局背景音乐； 为'record'时，设置全局录音
             */
            setSound: function (data, undo, type) {
                var _this = this;
                if (!data) return;
                var isRecord = type === "record";
                if (undo && !isRecord) {
                    var undoData = {};
                    undoData.reData = Object.assign({}, this.getSound());
                    undoData.data = Object.assign({}, data);

                    eve("undo_redo", null, {
                        type: "setSound",
                        data: undoData,
                    });
                }
                var temp = {
                    title: data.url ? data.title || "未命名" : "", // 音乐标题
                    resourceId: data.resourceId || null, // 资源id 用于查询资源的信息，下同
                    fileType: data.fileType || null, // 资源type
                    url: handleAssetsUrl(data.url) || null, // 资源路径
                    startTime: data.startTime || 0, // 开始时间单位毫秒
                    endTime: data.endTime || 0, // 结束时间
                    isLoop: data.isLoop || false, // 是否循环
                    volume: data.volume === undefined ? 50 : data.volume, // 音量0-100
                    subtitle: data.subtitle || null, // 字幕（预留字段）
                    duration: data.duration || 0,
                };
                if (isRecord) {
                    this.soundRecord = temp;
                    this.soundRecord.trackingType = data.trackingType;
                    this.soundRecordMode = "global";
                    this.soundRecordBackup = [];
                    this.sprites.forEach(function (s) {
                        _this.soundRecordBackup.push(s.getSound());
                        s.clearSound();
                    });
                } else {
                    if (temp && !temp.url) {
                        _this.sound = temp;
                        return;
                    }
                    var audio = document.createElement("audio"),
                        _this = this;
                    audio.addEventListener("loadedmetadata", function () {
                        temp.duration = numberOunding(audio.duration);
                        _this.sound = temp;
                        eve("globalSoundReady", null);
                    });
                    audio.src = handleAssetsUrl(temp.url);
                    _this.sound = temp;
                    _this.sound.trackingType = data.trackingType;
                    audio.load();
                }
            },

            // 用于预览模式
            setSoundPreview: function (data) {
                if (!data) return;

                this.sound = {
                    title: data.url ? data.title || "未命名" : "", // 音乐标题
                    resourceId: data.resourceId || null, // 资源id 用于查询资源的信息，下同
                    fileType: data.fileType || null, // 资源type
                    url: handleAssetsUrl(data.url) || null, // 资源路径
                    startTime: data.startTime || 0, // 开始时间单位毫秒
                    endTime: data.endTime || 0, // 结束时间
                    isLoop: data.isLoop || false, // 是否循环
                    volume: data.volume === undefined ? 50 : data.volume, // 音量0-100
                    subtitle: data.subtitle || null, // 字幕（预留字段）
                };
            },

            /**
             *
             * @param {mode} 'global' | 'scene'
             */
            setSoundRecord: function (data, mode, undo) {
                var _this = this;
                var currMode = this.soundRecordMode;
                if (undo) {
                    var undoData = {};
                    if (currMode === "global") {
                        undoData.reData = Object.assign(
                            {},
                            this.getSoundRecord()
                        );
                    } else {
                        undoData.reData = JSON.parse(
                            JSON.stringify(this.getSceneRecordAll())
                        );
                    }
                    undoData.data = JSON.parse(JSON.stringify(data));
                    undoData.reParams = {
                        mode: currMode,
                    };
                    undoData.params = {
                        mode: mode,
                    };

                    eve("undo_redo", null, {
                        type: "setSoundRecord",
                        data: undoData,
                    });
                }
                if (mode === "global") {
                    return this.setSound(data, undo, "record");
                }

                this.soundRecordMode = "scene";
                if (Array.isArray(data)) {
                    this.soundRecordBackup = [];
                    this.sprites.forEach(function (s, i) {
                        s.setSound(data[i]);
                        _this.soundRecordBackup[i] = data[i];
                    });
                }
                this.clearSoundRecord();
            },

            clearSoundRecord: function (options) {
                options = options || {};
                if (options.undo) {
                    var undoData = {};
                    undoData.reData = this.soundRecord;

                    eve("undo_redo", null, {
                        type: "clearGlobalSoundRecord",
                        data: undoData,
                    });
                }
                if (options.undoData) {
                    this.soundRecord = options.undoData;
                    return;
                }
                this.soundRecord = null;
            },

            updateSoundRecordBackup: function () {
                var scenes = this.sprites;
                this.soundRecordBackup =
                    scenes.map(function (scene) {
                        let obj = scene.getSound();
                        return obj && obj.url ? obj : null;
                    }) || [];
            },

            getDuration: function (data) {
                var timeAll = 0;
                for (var i = 0; i < this.sprites.length; i++) {
                    timeAll += this.sprites[i].duration;
                }
                return timeAll;
            },

            // 清空画布（分组，精灵等）
            clearCanvas: function () {
                var _this = this;
                this.sprites.reduce(function (sequence, s) {
                    return sequence.then(function () {
                        return _this.removeScenes(s.id);
                    });
                }, Promise.resolve());
            },

            getTrackingType: function () {
                let trackingList = [0, 0, 0, 0];
                let hasPrivate;
                let hasPrivateSoundGlobal =
                    ((this.sound || {}).trackingType || "")[0] == 1;
                let hasPrivateSoundScene;
                let hasPrivateSprite;
                hasPrivate = hasPrivateSoundGlobal;
                if (!hasPrivate) {
                    hasPrivateSoundScene = this.sprites.some((v) => {
                        let trackingType = (v.sound || {}).trackingType || "";
                        return trackingType[0] == 1;
                    });
                    hasPrivate = hasPrivateSoundScene;
                }
                if (!hasPrivate) {
                    hasPrivateSprite = this.sprites.some((v) => {
                        return (v.sprites || []).some((vv) => {
                            trackingType = vv.option.trackingType || "";
                            return trackingType[0] == 1;
                        });
                    });
                    hasPrivate = hasPrivateSprite;
                }

                let hasAIVoice;
                let hasAIVoiceGlobal =
                    ((this.soundRecord || {}).trackingType || "")[1] == 1;
                hasAIVoice = hasAIVoiceGlobal;
                if (!hasAIVoice) {
                    let hasAIVoiceScene = this.sprites.some((v) => {
                        let trackingType = (v.sound || {}).trackingType || "";
                        return trackingType[1] == 1;
                    });
                    hasAIVoice = hasAIVoiceScene;
                }

                let hasAutoDraw;
                let hasAutoDrawBG = this.sprites.some((v) => {
                    let trackingType =
                        (v.background.data || {}).trackingType || "";
                    return trackingType[2] == 1;
                });
                hasAutoDraw = hasAutoDrawBG;
                if (!hasAutoDraw) {
                    let hasAutoDrawSprite = this.sprites.some((v) => {
                        return (v.sprites || []).some((vv) => {
                            trackingType = vv.option.trackingType || "";
                            return trackingType[2] == 1;
                        });
                    });
                    hasAutoDraw = hasAutoDrawSprite;
                }

                let hasTextCloud = this.sprites.some((v) => {
                    return (v.sprites || []).some((vv) => {
                        trackingType = vv.option.trackingType || "";
                        return trackingType[3] == 1;
                    });
                });

                if (hasPrivate) {
                    trackingList[0] = 1;
                }
                if (hasAIVoice) {
                    trackingList[1] = 1;
                }
                if (hasAutoDraw) {
                    trackingList[2] = 1;
                }
                if (hasTextCloud) {
                    trackingList[3] = 1;
                }
                return trackingList.join("");
            },

            //模版项目的 toJson
            toJson: function (type) {
                var scenes = [];
                let totalTime = 0;
                for (var i = 0, len = this.sprites.length; i < len; i++) {
                    var data = this.sprites[i].toJson();
                    if ("id" in data) {
                        data.sceneId = data.id;
                        delete data.id;
                    }
                    if ("zIndex" in data) {
                        data.index = data.zIndex;
                        delete data.zIndex;
                    }
                    scenes.push(data);
                    totalTime += data.duration;
                }
                var _sound = this.sound
                    ? Object.assign({}, this.sound, {
                          startTime: getSec(this.sound.startTime),
                          endTime: getSec(this.sound.endTime),
                      })
                    : this.sound;
                function getSec(ms) {
                    return parseInt(ms / 1000);
                }

                function getSoundArr(gMusic, gRecord) {
                    if (!gMusic && !gRecord) {
                        return null;
                    }
                    var arr = [];
                    arr[0] = gMusic
                        ? Object.assign(gMusic, {
                              url: unhandleAssetsUrl(gMusic.url),
                          })
                        : gMusic;
                    arr[1] = Object.assign({}, gRecord, {
                        url: unhandleAssetsUrl((gRecord || {}).url),
                        isRecord: true,
                    });
                    return arr.filter(function (item) {
                        let y = !!item && item.url;
                        if (y) {
                            item.url = item.url;
                        }
                        return y;
                    });
                }

                var editorJson = {
                    id: uuid.generate(),
                    title: "my works",
                    // sound: _sound ? [_sound] : null,
                    // soundRecord: this.soundRecord,
                    sound: getSoundArr(_sound, this.soundRecord),
                    soundRecordMode: this.soundRecordMode,
                    scenes: scenes,
                    resolution: {
                        width: this.clientWidth,
                        height: this.clientHeight,
                    },
                    optimized: this.optimized,
                    version: "5.4.0",
                    productionPlatform: "Web",
                    watermarkInfo: this.watermarkInfo || null,
                    isTplCommercial: this.isTplCommercial,
                    targetPlatform: this.targetPlatform,
                };
                editorJson = json2uwp(editorJson);

                if (AnimEditor.soundPlayHandle) {
                    editorJson.music =
                        AnimEditor.soundPlayHandle.toJson(totalTime);
                }

                if (this.targetPlatform == "App" || type === "App") {
                    return this.toAppJson(editorJson);
                }

                return editorJson;
            },

            toAppJson: function (jsonObj) {
                let _jsonObj = JSON.stringify(jsonObj);
                let json = JSON.parse(_jsonObj);
                json["targetPlatform"] = "App";

                let resolution = json["resolution"];
                if (json["optimized"] === "Vertical") {
                    resolution.width = 607.5;
                    resolution.height = 1080;
                }
                json.resolution = resolution;
                let sounds = [];
                if (json.sound) {
                    json.sound.forEach((item) => {
                        item.type = "Background";
                        sounds.push(item);
                    });
                }
                let scenes = json["scenes"];
                //app端支持的类型
                let svgChecklist = ["19", "35"];
                let lottieChecklist = ["5", "8", "10"];
                let textEffectChecklist = ["Appear", "Roll", "Bounce"];
                let senceEffectChecklist = [
                    "LeftIn",
                    "LeftOut",
                    "RightIn",
                    "RightOut",
                    "UpIn",
                    "UpOut",
                    "DownIn",
                    "DownOut",
                    "None",
                    "Write",
                    "Type",
                    "Draw",
                    "FadeIn",
                    "FadeOut",
                    "PopIn",
                    "PopOut",
                    "Path",
                    "Bounce",
                    "Sway",
                    "Beating",
                    "SwayTop",
                    "HorizontalFlip",
                    "VerticalFlip",
                    "Smear",
                ];
                let bgChecklist = ["1", "2", "25"];
                if (scenes) {
                    let dx = (1920 - parseFloat(resolution.width)) / 2;
                    scenes.forEach((scene, index) => {
                        scene.resolution = resolution;
                        if (
                            !senceEffectChecklist.includes(
                                scene.enterEffect.type
                            )
                        ) {
                            scene.enterEffect.type = "FadeIn";
                        }
                        if (
                            !senceEffectChecklist.includes(
                                scene.exitEffect.type
                            )
                        ) {
                            scene.exitEffect.type = "FadeIn";
                        }

                        for (let i = 0; i < scene.sprites.length; i++) {
                            let sprite = scene.sprites[i];
                            if (sprite.type == "RichText") {
                                scene.sprites.splice(i, 1);
                                i--;
                            } else {
                                if (sprite.type === "Chart") {
                                    scene.sprites.splice(i, 1);
                                }
                                if (sprite.type == "Text") {
                                    sprite.fileType = "15";
                                    if (
                                        textEffectChecklist.includes(
                                            sprite.enterEffect.type
                                        )
                                    ) {
                                        sprite.enterEffect.type = "Write";
                                        sprite.enterEffect.hand = {
                                            anchorPointX: 25,
                                            anchorPointY: 75,
                                            palmRect: {
                                                x: 0,
                                                y: 0,
                                                width: 266.70001220703125,
                                                height: 385.10000610351563,
                                            },
                                            armRect: {
                                                x: 136.69999694824219,
                                                y: 328.5,
                                                width: 254.39999389648438,
                                                height: 355.70001220703125,
                                            },
                                            penRect: {
                                                x: 32,
                                                y: 84.300003051757813,
                                                width: 140.80000305175781,
                                                height: 149.80000305175781,
                                            },
                                            resourceId: "283",
                                            url: "2016-8-22/1471867109442.png",
                                        };
                                    }
                                }
                                if (
                                    sprite.type == "Svg" &&
                                    !svgChecklist.includes(sprite.fileType)
                                ) {
                                    sprite.fileType = "19";
                                }
                                if (sprite.type == "Lottie") {
                                    if (
                                        !lottieChecklist.includes(
                                            sprite.fileType
                                        )
                                    ) {
                                        sprite.fileType = "5";
                                    }
                                }
                                sprite["outward"].x -= dx;
                                //console.log("sceneId:" + scene.sceneId + "  sprite:" + i + "  x:" + sprite["outward"].x);
                                sprite.stayEffect.animationGraphs = null;
                            }
                        }
                        if (scene.background.type != "Color") {
                            if (
                                !bgChecklist.includes(scene.background.fileType)
                            ) {
                                if (scene.background.type == "Image") {
                                    scene.background.fileType = "1";
                                } else if (scene.background.type == "Video") {
                                    scene.background.fileType = "25";
                                }
                            }
                        } else {
                            scene.background.fileType = null; //手机端 “”字符串解析不出来，只能解析null
                        }

                        if (scene.sound) {
                            scene.sound.forEach((item) => {
                                item.type = "Common";
                                sounds.push(item);
                            });
                        }
                    });
                }
                json.sound = sounds;
                return json;
            },

            formAppJson: function (json) {
                if (json.optimized === "Vertical") {
                    let resolution = json.resolution;
                    let tarResolution = { width: 1920, height: 1080 };
                    let scenes = json.scenes;
                    if (scenes && scenes.length > 0) {
                        let dx =
                            (tarResolution.width -
                                parseFloat(resolution.width)) /
                            2;
                        scenes.forEach((scene, index) => {
                            if (scene && scene.sprites.length > 0) {
                                scene.resolution = tarResolution;
                                scene.sprites.forEach((sprite) => {
                                    sprite["outward"].x += dx;
                                });
                            }
                        });
                    }
                    json.resolution = tarResolution;
                }

                return json;
            },

            // 套了层皮的fromJson
            fromJson: async function (json, type) {
                console.time('Draft_Load_Duration')
                // if(!json.version && !json.scenes){
                //     window.location.href = `${window.location.origin}/newtool/${window.location.hash}`;
                // }
                this.targetPlatform = json.targetPlatform || "Web";
                if (json.soundRecordMode === "scene") {
                    if (json.sound && json.sound.length) {
                        json.sound = json.sound.filter((v) => !v.isRecord);
                    }
                } else {
                    json.scenes.forEach((scene) => {
                        scene.sound = null;
                    });
                }

                //兼容5.4.0之前的声音
                if (!this.checkVersion(json.version, "5.4.0")) {
                    await this.converterMusic(json);
                }

                if (this.targetPlatform == "App") {
                    json = this.formAppJson(json);
                }
                var _this = this;
                this._setLoading("fromJson");
                if (!window.preloading) return this._fromJson(json, type);
                // 加载json文件中的字体，显示正在加载中遮罩
                this._setLoading("fromJson");
                return preloading.fontsLoader(json).then(function (fontList) {
                    _this.updateFontList(fontList);
                    eve("editor.updateFontList", _this, fontList);
                    return _this._fromJson(json, type);
                });
            },

            // 模板项目真正的fromJson
            _fromJson: function (json, type) {
                function handleSound(sound) {
                    if (Array.isArray(sound)) {
                        if (!sound.length) return;
                        if (!sound[0]) return;

                        sound[0].endTime *= 1000;
                        sound[0].startTime *= 1000;
                        return sound[0];
                    } else {
                        if (!sound) return;

                        sound.endTime *= 1000;
                        sound.startTime *= 1000;
                        // this.setSound(json.sound);
                        return sound;
                    }
                }
                this.clearCanvas();
                var _this = this,
                    task = [],
                    scale = this.clientWidth / json.resolution.width;

                //this._setLoading('fromJson');
                this.setOptimized(json.optimized); // 给予画布Optimized
                if (json.sound) {
                    if (Array.isArray(json.sound)) {
                        // if(!json.sound.length)return;
                        if (json.sound[0] && !json.sound[0].isRecord) {
                            json.sound[0].endTime *= 1000;
                            json.sound[0].startTime *= 1000;
                            this.setSound(json.sound[0]);
                        }
                    } else {
                        // if(!json.sound)return;

                        json.sound.endTime *= 1000;
                        json.sound.startTime *= 1000;
                        this.setSound(json.sound);
                    }
                }
                if (json.sound && json.sound.length) {
                    var fArr = json.sound.filter(function (item) {
                        return item.isRecord;
                    });
                    var sr = handleSound(fArr);
                    this.setSound(sr, false, "record");
                }
                this.soundRecordMode = json.soundRecordMode;

                if (json.productionPlatform) {
                    this.productionPlatform = json.productionPlatform;
                }

                // 加载音频
                if (this.previewMode && json.sound)
                    task.push(this.setSoundPreview(json.sound[0]));

                if (json.music && AnimEditor.soundPlayHandle) {
                    AnimEditor.soundPlayHandle.fromJson(json.music);
                }

                if (json.watermarkInfo) {
                    this.watermarkInfo = json.watermarkInfo;
                }
                if (json.isTplCommercial) {
                    this.isTplCommercial = json.isTplCommercial;
                }

                // 按顺序的异步操作
                json.scenes.forEach(function (scene) {
                    var func = function () {
                        if ("sceneId" in scene) {
                            scene.oldId = scene.sceneId;
                        }
                        if ("index" in scene) {
                            scene.zIndex = scene.index;
                        }
                        return _this
                            .addScenes(null, {
                                duration:
                                    scene.duration > 500
                                        ? scene.duration
                                        : scene.duration * 1000, // 去掉判断（后续需要观察）
                                oldId: scene.oldId,
                                groupList: scene.groupList || [],
                            })
                            .then(function (s) {
                                _this.selectScenes(s);
                                if (type === "tpl") {
                                    // uwp模版打开
                                    if (!scene.resourceId) {
                                        scene.resourceId = scene.sceneId;
                                    }
                                }
                                s.resourceId = scene.resourceId;
                                //只加载第一个
                                if (s.index < 1) {
                                    return s.fromJson(
                                        scene,
                                        _this.clientWidth /
                                            json.resolution.width
                                    );
                                } else {
                                    s.unLoadData.resolutionWidth =
                                        json.resolution.width;
                                    s.unLoadData.json = scene;
                                    return s.getUnloadThumbnails(
                                        _this.clientWidth /
                                            json.resolution.width
                                    );
                                }
                            });
                    };
                    task.push(func);
                });

                return this.sequenceTasks(task)
                    .then(function () {
                        //取消正在加载中遮罩
                        _this._cancelLoading("fromJson");
                        console.timeEnd('Draft_Load_Duration');
                        return Promise.resolve();
                    })
                    .catch(function (err) {
                        _this._cancelLoading("fromJson", "fail");
                        return Promise.reject(err);
                    });
            },
            //提供给引擎截图的fromjson，如果需要兼容老版本的gif，只需删除worker.js即可
            previewFromJson: function (json, type) {
                if (json.targetPlatform == "App") {
                    json = this.formAppJson(json);
                }

                function handleSound(sound) {
                    if (Array.isArray(sound)) {
                        if (!sound.length) return;
                        if (!sound[0]) return;
                        sound[0].endTime *= 1000;
                        sound[0].startTime *= 1000;
                        return sound[0];
                    } else {
                        if (!sound) return;
                        sound.endTime *= 1000;
                        sound.startTime *= 1000;
                        // this.setSound(json.sound);
                        return sound;
                    }
                }
                this.clearCanvas();
                var _this = this,
                    task = [],
                    scale = this.clientWidth / json.resolution.width;
                // this._setLoading('fromJson');
                this.setOptimized(json.optimized); // 给予画布Optimized
                if (json.sound) {
                    if (Array.isArray(json.sound)) {
                        // if(!json.sound.length)return;
                        if (json.sound[0] && !json.sound[0].isRecord) {
                            json.sound[0].endTime *= 1000;
                            json.sound[0].startTime *= 1000;
                            this.setSound(json.sound[0]);
                        }
                    } else {
                        // if(!json.sound)return;
                        json.sound.endTime *= 1000;
                        json.sound.startTime *= 1000;
                        this.setSound(json.sound);
                    }
                }
                if (json.sound && json.sound.length) {
                    var fArr = json.sound.filter(function (item) {
                        return item.isRecord;
                    });
                    var sr = handleSound(fArr);
                    this.setSound(sr, false, "record");
                }
                this.soundRecordMode = json.soundRecordMode;

                if (json.productionPlatform) {
                    this.productionPlatform = json.productionPlatform;
                }

                // 加载音频
                if (this.previewMode && json.sound)
                    task.push(this.setSoundPreview(json.sound[0]));

                if (json.music && AnimEditor.soundPlayHandle) {
                    AnimEditor.soundPlayHandle.fromJson(json.music);
                }

                // 按顺序的异步操作
                json.scenes.forEach(function (scene) {
                    var func = function () {
                        if ("sceneId" in scene) {
                            scene.oldId = scene.sceneId;
                        }
                        if ("index" in scene) {
                            scene.zIndex = scene.index;
                        }
                        return _this
                            .addScenes(null, {
                                duration:
                                    scene.duration > 500
                                        ? scene.duration
                                        : scene.duration * 1000, // 去掉判断（后续需要观察）
                                oldId: scene.oldId,
                                groupList: scene.groupList || [],
                            })
                            .then(function (s) {
                                _this.selectScenes(s);
                                if (type === "tpl") {
                                    // uwp模版打开
                                    if (!scene.resourceId) {
                                        scene.resourceId = scene.sceneId;
                                    }
                                }
                                //只加载第一个
                                return s.fromJson(
                                    scene,
                                    _this.clientWidth / json.resolution.width
                                );
                            });
                    };
                    task.push(func);
                });

                return this.sequenceTasks(task)
                    .then(function () {
                        //取消正在加载中遮罩
                        _this._cancelLoading("fromJson");
                        return Promise.resolve();
                    })
                    .catch(function (err) {
                        _this._cancelLoading("fromJson", "fail");
                        return Promise.reject(err);
                    });
            },
            // 维护已加载的字体列表
            updateFontList: function (font) {
                var proto = Object.prototype.toString.call(font);
                if (proto === "[object Array]") {
                    this.fontList = arrayUniq(this.fontList.concat(font));
                } else if (proto === "[object String]") {
                    if (this.fontList.indexOf(font) === -1) {
                        this.fontList.push(font);
                    }
                }
            },

            converterMusic: async function (json) {
                if (!json.music) {
                    json.music = {};
                    (json.music.data = []), (json.music.volume = [50, 0, 0]); //[配音音量,配乐音量,音效音量
                }
                let totalTime = 0;
                for (let i = 0; i < json.scenes.length; i++) {
                    let scene = json.scenes[i];
                    if (scene.sound && scene.sound.length > 0) {
                        let sound = scene.sound[0]; //场景页音频只有一个
                        if (!sound) continue;
                        let duration = await this.getAudioDuration(
                            handleAssetsUrl(sound.url)
                        );
                        let time =
                            duration < scene.duration
                                ? duration
                                : scene.duration;
                        let music = {
                            title: sound.title,
                            resourceId: sound.resourceId,
                            type: 1, //1:配音 2:配乐 3:音效
                            fileType: sound.fileType,
                            url: sound.url,
                            cut: [0, time], //裁剪时间段
                            timeSlot: [totalTime, totalTime + time], //在时间轴上的时间段
                            startEffect: 0, //开头音效 0(无) 1(渐强) 2(渐弱)
                            endEffect: 0, //结尾音效 0(无) 1(渐强) 2(渐弱)
                        };
                        json.music.data.push(music);
                        scene.sound = [];
                    }
                    totalTime += scene.duration;
                }
                //console.log('all music1:', json.music);

                if (json.sound) {
                    for (let i = 0; i < json.sound.length; i++) {
                        let sound = json.sound[i];
                        if (sound) {
                            let duration = await this.getAudioDuration(
                                handleAssetsUrl(sound.url)
                            );
                            if (!duration) continue;
                            let music = {
                                title: sound.title,
                                resourceId: sound.resourceId,
                                type: sound.isRecord ? 1 : 2, //1:配音 2:配乐 3:音效
                                fileType: sound.fileType,
                                url: sound.url,
                                cut: [], //裁剪时间段
                                timeSlot: [0, duration], //在时间轴上的时间段
                                startEffect: 0, //开头音效 0(无) 1(渐强) 2(渐弱)
                                endEffect: 0, //结尾音效 0(无) 1(渐强) 2(渐弱)
                            };
                            if (sound.isRecord) {
                                duration =
                                    duration < totalTime ? duration : totalTime;
                                music.timeSlot = [0, duration];
                                music.cut = [0, duration];
                                json.music.data.push(music);
                                json.music.volume[0] = sound.volume;
                            } else {
                                if (totalTime < duration) {
                                    music.cut = [0, totalTime];
                                    music.timeSlot = [0, totalTime];
                                    json.music.data.push(music);
                                } else if (!sound.isLoop) {
                                    music.cut = [0, duration];
                                    music.timeSlot = [0, duration];
                                    json.music.data.push(music);
                                } else {
                                    let count = Math.floor(
                                        totalTime / duration
                                    );
                                    for (let i = 0; i < count; i++) {
                                        let copyMusic = JSON.parse(
                                            JSON.stringify(music)
                                        );
                                        copyMusic.cut = [0, duration];
                                        copyMusic.timeSlot = [
                                            duration * i,
                                            duration * (i + 1),
                                        ];
                                        json.music.data.push(copyMusic);
                                    }
                                    let endMusic = JSON.parse(
                                        JSON.stringify(music)
                                    );
                                    endMusic.cut = [
                                        0,
                                        totalTime - duration * count,
                                    ];
                                    endMusic.timeSlot = [
                                        duration * count,
                                        totalTime,
                                    ];
                                    json.music.data.push(endMusic);
                                }
                                json.music.volume[1] = sound.volume;
                            }
                        }
                    }
                    json.sound = [];
                    console.log("--------:", json.music);
                }
            },

            getAudioDuration: function (url) {
                return new Promise(function (resolve, reject) {
                    let t = setTimeout(function () {
                        resolve(0);
                    }, 10000);
                    let audioElement = document.createElement("AUDIO");
                    audioElement.setAttribute("src", url);
                    audioElement.addEventListener(
                        "loadedmetadata",
                        function () {
                            clearTimeout(t);
                            let duration =
                                Math.floor(audioElement.duration * 100) / 100;
                            resolve(duration);
                        }
                    );
                });
            },

            checkVersion: function (v1, v2) {
                let vArray1 = v1.split(".");
                let vArray2 = v2.split(".");
                for (let i = 0; i < vArray1.length; i++) {
                    if (vArray1[i] < vArray2[i]) {
                        return false;
                    }
                }
                return true;
            },

            // 获取每个场景的开始时间（相对于整个动画时长）
            _getSceneStartTime: function (index, scenes) {
                var _this = this,
                    total = 0,
                    scenes = scenes || this.sprites;
                index > 0 &&
                    scenes.slice(0, index).forEach(function (s) {
                        total += parseInt(s.duration);
                    });

                return total;
            },

            // 音乐toJson
            sounds2json: function (json) {
                if (!json) json = this.toJson();
                // if (!json.sound || json.sound.length < 1) return;
                var result = [],
                    _this = this,
                    sceneStartTime,
                    globalSound = json.sound
                        ? json.sound[0]
                            ? json.sound[0]
                            : {}
                        : {},
                    globalRecord = json.sound ? json.sound[1] : null;
                // 全局音乐
                result.push(
                    Object.assign(
                        {
                            isLoop: true,
                            volume: 0,
                            global: true,
                        },
                        {
                            isLoop: globalSound.isLoop,
                            volume: globalSound.volume,
                            url: handleAssetsUrl(globalSound.url),
                            startTime: 0,
                            endTime: this.getDuration() / 1000,
                        }
                    )
                );

                if (globalSound.startTime || globalSound.endTime) {
                    result[0].cut = {
                        startTime: globalSound.startTime,
                        endTime: globalSound.endTime,
                    };
                }

                // 全局录音
                if (globalRecord && globalRecord.url) {
                    result.push({
                        url: handleAssetsUrl(globalRecord.url),
                        volume: globalRecord.volume,
                        startTime: globalRecord.startTime,
                        endTime: this.getDuration() / 1000,
                    });
                }

                // 场景音乐
                json.scenes.forEach(function (s, i) {
                    var sound = s.sound ? s.sound[0] : null;
                    if (sound && sound.url) {
                        sceneStartTime = _this._getSceneStartTime(
                            i,
                            _this.sprites
                        );
                        result.push({
                            url: handleAssetsUrl(sound.url),
                            startTime: sceneStartTime / 1000,
                            endTime:
                                (sceneStartTime +
                                    _this.sprites[i].getDuration()) /
                                1000,
                            volume: sound.volume,
                        });
                    }
                });
                if (result.length === 1 && !result[0].url) return null;
                return result;
            },

            // 获取到一个列表，包含所有场景的视频元素的音频信息
            getVideoSounds: function () {
                // var json = this.toJson();
                var results = [];
                var _this = this;
                this.sprites.forEach(function (scene, i) {
                    scene.sprites.forEach(function (sprite) {
                        if (!sprite.effect) return;
                        var st = sprite.effect.entranceAnim.end / 1000; // 入场完毕开始播放的时间
                        var et = sprite.effect.exitAnim.start / 1000; // 出场前
                        var s_st = _this._getSceneStartTime(i) / 1000;
                        if (sprite.type === "Video") {
                            if (!sprite.video.volume) return;
                            if (
                                !sprite.video.video[0]
                                    .webkitAudioDecodedByteCount &&
                                !_this.previewMode
                            )
                                return;

                            // 一个ffmpeg的bug，提取音频时，如果多次引用同一个输入，
                            // 使用剪裁(atrm)并循环concat时将会出现不可预料的bug，例如，
                            // 在剪裁为5秒以上时，循环合成音频将会导致短暂重复及末尾空白。
                            // 解决方案是，如果【有剪裁并将播放多次】的情况，当作多个【只播放一次的音频】处理

                            var cutDur = sprite.video.cutDuration;
                            var _remain = cutDur % 0.5;
                            var pieces = (cutDur / 0.5) | 0;
                            if (_remain < 0.25) {
                                cutDur = pieces * 0.5;
                            } else {
                                cutDur = pieces * 0.5 + 0.5;
                            }
                            var times = Math.ceil((et - st) / cutDur);
                            // 如果非设置循环，且指定的播放次数
                            if (!sprite.video.loop) {
                                times =
                                    times > sprite.video.repeatTimes
                                        ? sprite.video.repeatTimes
                                        : times;
                            }
                            // 仅在多次播放，且剪裁时长大于5时使用拆分的方法。
                            if (
                                times > 1 &&
                                (sprite.video.loop ||
                                    sprite.video.repeatTimes > 1) &&
                                cutDur > 5
                            ) {
                                var _startTime = s_st + st;
                                for (var j = 0; j < times; j++) {
                                    var _cutduration = cutDur;
                                    var _duration = et - st;
                                    var remainder = _duration % cutDur;
                                    if (
                                        j === times - 1 &&
                                        remainder &&
                                        _cutduration * times >= _duration
                                    ) {
                                        _cutduration = remainder;
                                    }

                                    results.push({
                                        type: "Video",
                                        url: handleAssetsUrl(sprite.option.url),
                                        isLoop: false,
                                        numberOfLoops: 1,
                                        startTime: _startTime,
                                        duration: _duration,
                                        vDuration: sprite.video.duration, // 视频本身长度
                                        volume: sprite.video.volume,
                                        cut: {
                                            duration: _cutduration,
                                            startTime: sprite.video.startTime,
                                        },
                                        isSplited: true, // 标记此音频是人为切开的，以此来计算空白填充的长度
                                    });
                                    _startTime += cutDur;
                                }
                            } else {
                                // 按照原来的方式
                                results.push({
                                    type: "Video",
                                    url: handleAssetsUrl(sprite.option.url),
                                    isLoop: sprite.video.loop,
                                    numberOfLoops: sprite.video.repeatTimes,
                                    startTime: s_st + st,
                                    duration: et - st,
                                    vDuration: sprite.video.duration, // 视频本身长度
                                    volume: sprite.video.volume,
                                    cut: {
                                        duration: cutDur,
                                        startTime: sprite.video.startTime,
                                    },
                                });
                            }
                            // 有声素材
                        } else if (sprite.getSound()) {
                            var sound = sprite.getSound();
                            if (parseInt(sound.volume) === 0) return;
                            if (!sound.url) return;
                            // lottie sprite的duration及audio的duration
                            var lo = sprite.effect.playerSprite.lottie;
                            var sDuration = lo.totalFrames / lo.frameRate;
                            var aDuration = sound.duration;
                            results.push({
                                type: "Sprite",
                                url: handleAssetsUrl(sound.url),
                                volume: sound.volume,
                                isLoop: sprite.isLoop,
                                numberOfLoops: sprite.numberOfLoops,
                                startTime: s_st + st,
                                duration: et - st,
                                sDuration: sDuration,
                                aDuration: aDuration,
                            });
                        }
                    });
                });
                return results;
            },

            // 获取一个列表，包含所有有声素材的音频信息
            getSpriteWithSounds: function () {},

            videoSprites2json: function (json) {
                if (!json) json = this.toJson();
            },

            sequenceTasks: function sequenceTasks(tasks) {
                function recordValue(results, value) {
                    results.push(value);
                    return results;
                }
                var pushValue = recordValue.bind(null, []);
                return tasks.reduce(function (promise, task) {
                    return promise.then(task).then(pushValue);
                }, Promise.resolve());
            },

            // 取消播放状态（隐藏播放层）
            cancelPlay: function () {
                this.player.ele.hide();
                this.content.css({
                    overflow: "visible",
                    opacity: "1",
                    transitionDuration: "0s",
                });
                // this.content.show();

                var $mList = $(".Tool .mask-blur").filter(function (index, el) {
                    return $(el).find("video").length;
                });
                $mList.each(function (index, el) {
                    var v = $(el).data("bgi");
                    v && $(el).css("backgroundImage", v);
                });
            },

            swapSprite: function (opts, undo) {
                var _this = this;
                var sprite = opts.sprite;
                var centerPoint = {
                    x: 0,
                    y: 0,
                };
                if (!sprite) {
                    throw new Error("未获取到切换前的sprite");
                }
                this._setLoading("swapSprite");
                if (undo) {
                    var data = {};
                    data.sprite = sprite.toJson(true);
                    data.sprite.scale = this.scale;
                    data.sprite.scenesId = sprite.scenesId;
                }
                centerPoint.x = sprite.positionLeft + sprite.width / 2;
                centerPoint.y = sprite.positionTop + sprite.height / 2;
                var spriteEffectEarly = sprite.effect;
                this.removeSprite(sprite.id);
                Object.assign(opts.optionForAdd, { isSwap: true });
                var adding;
                if (opts.typeForAdd === "group") {
                    adding =
                        opts.optionForAdd.callback &&
                        opts.optionForAdd.callback();
                    return adding.then(function (sList) {
                        // eve("editor.spriteSwapped", _this, null, sprite);
                        _this._cancelLoading("swapSprite");
                        if (undo) {
                            data.reSprite = {}; //newSprite.toJson(true);
                            data.gruop = sList || _this.selectedSprite;
                            data.reSprite.scale = _this.scale;
                            data.reSprite.scenesId = sprite.scenesId;
                            data.callback = opts.optionForAdd.callback;
                            eve("undo_redo", null, {
                                type: "swapSprite",
                                data: data,
                            });
                        }
                    });
                }
                adding = this.addSprite(opts.typeForAdd, opts.optionForAdd)
                    .then(function (newSprite) {
                        var pathAnimOpt = {};
                        var stayAnimOpt = {};

                        // var newWidth = sprite.width;
                        // var newHeight = newSprite.height * sprite.width / newSprite.width;
                        // if (sprite.width > sprite.height) {
                        //     newHeight = sprite.height;
                        //     newWidth = newSprite.width * sprite.height / newSprite.height;
                        // }
                        var isMotion =
                            opts.options && opts.options.type === "motion";
                        var newSize = isMotion
                            ? {}
                            : _this._getNewSpriteSize(newSprite, sprite);
                        var newWidth = newSize.width;
                        var newHeight = newSize.height;

                        // 针对更换角色动作
                        if (isMotion) {
                            // newWidth = sprite.width;
                            // newHeight = newSprite.height * newWidth / newSprite.width;

                            newHeight = sprite.height;
                            newWidth =
                                (newSprite.width * newHeight) /
                                newSprite.height;
                        }

                        var l = centerPoint.x - newWidth / 2;
                        var t = centerPoint.y - newHeight / 2;
                        _this.moveSpriteTo(newSprite.id, sprite.index);

                        newSprite.croppedFlag = false;
                        newSprite.cropBoxData = null;

                        if (newSprite.type === "Text") {
                            newWidth = Math.max(
                                newWidth,
                                newSprite.font.fontSize / _this.scale
                            );
                        }

                        newSprite.update({
                            positionLeft: l,
                            positionTop: t,
                            width: newWidth,
                            height: newHeight,
                            rotate: sprite.rotate,
                            flip: sprite.flip,
                            opacity: sprite.opacity,
                        });

                        newSprite.setShadow(sprite.boxShadow, "boxShadow");
                        newSprite.setShadow(sprite.dropShadow, "dropShadow");
                        sprite.border &&
                            newSprite.setBorder({
                                width: sprite.border.width,
                                style: sprite.border.style,
                                color: sprite.border.color,
                                radius:
                                    newSprite.type === "Lottie"
                                        ? ""
                                        : sprite.border.radius,
                            });
                        sprite.bgColor && newSprite.setBgColor(sprite.bgColor);

                        // if (
                        //     sprite.type === 'Svg' && newSprite.type === 'Svg' &&
                        //     /^(28|29)$/.test(sprite.option.fileType) &&
                        //     /^(28|29)$/.test(newSprite.option.fileType)
                        // ) {
                        //     newSprite.updateSprite({
                        //         fill: sprite.option.fill,
                        //         stroke: sprite.option.stroke,
                        //         strokeWidth: sprite.option.strokeWidth,
                        //     });
                        // }

                        // 初始化新素材的动画
                        var spriteEffect =
                            sprite.effect || spriteEffectEarly || {};
                        pathAnimOpt = Object.assign({}, spriteEffect.pathAnim);
                        stayAnimOpt = $.extend(true, {}, spriteEffect.stayAnim);
                        if (
                            spriteEffect &&
                            spriteEffect.pathAnim &&
                            spriteEffect.pathAnim.target
                        ) {
                            pathAnimOpt.target = JSON.parse(
                                JSON.stringify(spriteEffect.pathAnim.target)
                            );
                            pathAnimOpt.target.fillColor = "";
                            // pathAnimOpt.target.opacity = 1;

                            pathAnimOpt.target.w = newWidth;
                            pathAnimOpt.target.h = newSprite.height;
                        }

                        var effectOpts = {
                            drawingDuration: spriteEffect.drawingDuration,
                            code: spriteEffect.code,
                            direction: spriteEffect.direction,
                            easing: spriteEffect.easing,
                            entranceAnim: spriteEffect.entranceAnim,
                            exitAnim: spriteEffect.exitAnim,
                            pathAnim: pathAnimOpt,
                            stayAnim: stayAnimOpt,
                        };
                        // var isHandEffect = sprite.effect.code === 'Hand' || sprite.effect.code === 'Draw';
                        // if (isHandEffect /* && newSprite.type !== 'Text' */) {
                        //     (
                        //     (
                        //         newSprite.type === 'Svg' && newSprite.option &&
                        //         (newSprite.option.fileType === 4 || newSprite.option.fileType === 7 || newSprite.option.fileType === 19)
                        //     )
                        //     || newSprite.type === 'Image'
                        //     )
                        //     ? 1
                        //     : (effectOpts.code = 'None')
                        // }

                        newSprite.updateEffect(effectOpts);

                        // video sprite
                        if (newSprite.updateVideoDuration) {
                            newSprite.video.cutDuration = void 0;
                            newSprite.updateVideoDuration(
                                effectOpts.entranceAnim.end / 1000,
                                effectOpts.exitAnim.start / 1000
                            );
                        }

                        eve("editor.spriteSwapped", _this, newSprite, sprite);
                        _this._cancelLoading("swapSprite");
                        if (undo) {
                            data.reSprite = newSprite.toJson(true);
                            data.reSprite.scale = _this.scale;
                            data.reSprite.scenesId = sprite.scenesId;
                            eve("undo_redo", null, {
                                type: "swapSprite",
                                data: data,
                            });
                        }

                        return newSprite;
                    })
                    .catch(function (err) {
                        console.log("TCL: err", err);
                        _this._cancelLoading("swapSprite", "fail");
                    });

                return adding;
            },

            _getNewSpriteSize: function (newSprite, sprite) {
                var newWidth = sprite.width;
                var newHeight =
                    (newSprite.height * sprite.width) / newSprite.width;
                if (sprite.width > sprite.height) {
                    newHeight = sprite.height;
                    newWidth =
                        (newSprite.width * sprite.height) / newSprite.height;
                }
                if (newWidth < 64 && newWidth < newHeight) {
                    newWidth = 64;
                    newHeight = (newSprite.height / newSprite.width) * newWidth;
                }
                if (newHeight < 64 && newHeight < newWidth) {
                    newHeight = 64;
                    newWidth = (newSprite.width / newSprite.height) * newHeight;
                }

                return {
                    width: newWidth,
                    height: newHeight,
                };
            },

            _setLoading: function (type, text) {
                if (this.loading.status === "loading") return;
                this.loading.status = "loading";
                this.loading.type = type;
                this.loading.text = text || "";
            },

            _cancelLoading: function (type, status) {
                if (type !== this.loading.type) return;
                this.loading.status = status || "success";
                this.loading.type = "";
                this.loading.text = "";
            },

            /**
             *
             * @param {*} type 'sprite' | 'bg'
             * @param {*} data
             */
            addVideo(type, data, undo, spriteToRemove) {
                var taskResolve, taskReject;
                var task = new Promise(function (y, n) {
                    taskResolve = y;
                    taskReject = n;
                });
                var _this = this;
                var scene = this.selectedScenes;
                var currType = this.getVideoType();
                if (undo) {
                    var undoData = {};

                    undoData.scale = this.scale;
                    undoData.scenesId = scene.id;
                    undoData.reData = {
                        type: currType.type,
                        bg: JSON.parse(JSON.stringify(scene.background.data)),
                        sprite: "",
                    };
                    if (currType.type === "bg") {
                        undoData.reData.bg.zoomActive =
                            scene.background.zoomActive;
                        undoData.reData.bg.zoomOptions = JSON.parse(
                            JSON.stringify(scene.background.zoomOptions)
                        );
                        undoData.reData.bg.filter = JSON.parse(
                            JSON.stringify(scene.background.filter)
                        );
                    }
                    if (currType.type === "sprite") {
                        undoData.reData.sprite = currType.sprite.toJson(true);
                        undoData.reData.sprite.video = JSON.parse(
                            JSON.stringify(currType.sprite.video)
                        );

                        undoData.reData.bg.zoomActive =
                            scene.background.zoomActive;
                        undoData.reData.bg.zoomOptions = JSON.parse(
                            JSON.stringify(scene.background.zoomOptions)
                        );
                        undoData.reData.bg.filter = JSON.parse(
                            JSON.stringify(scene.background.filter)
                        );
                    }
                    if (spriteToRemove) {
                        undoData.reData.spriteToRemove =
                            spriteToRemove.toJson(true);
                    }

                    undoData.data = {
                        type: type,
                        bg: "",
                        sprite: "",
                    };

                    eve("undo_redo", null, {
                        type: "addVideo",
                        data: undoData,
                    });
                }

                this.removeVideos();
                if (type === "sprite") {
                    if (spriteToRemove) {
                        _this
                            .swapSprite({
                                sprite: spriteToRemove,
                                typeForAdd: "Video",
                                optionForAdd: data,
                            })
                            .then(function (sprite, oldSpriteJson) {
                                undoData.data.sprite = sprite.toJson();
                                if (oldSpriteJson) {
                                    undoData.data.spriteToRemove =
                                        oldSpriteJson;
                                    // _this.removeSprite(spriteToRemove.id);
                                }
                                undoData.data.sprite.video = JSON.parse(
                                    JSON.stringify(sprite.video)
                                );
                                _this.selectSprite([sprite]);
                                taskResolve(sprite, "sprite");
                            });
                    } else {
                        this.addSprite("Video", {
                            url: data.url,
                            userId: data.userId,
                            resourceId: data.id, // 资源id
                            fileType: isNaN(data.fileType)
                                ? null
                                : data.fileType,
                            thumbnailUrl: data.thumbnailUrl,
                            actionType: data.type || void 0,
                            video: data.video || {},
                        }).then(function (sprite) {
                            undoData.data.sprite = sprite.toJson();
                            // if (spriteToRemove) {
                            //     undoData.data.spriteToRemove = spriteToRemove.toJson();
                            //     _this.removeSprite(spriteToRemove.id);
                            // }
                            undoData.data.sprite.video = JSON.parse(
                                JSON.stringify(sprite.video)
                            );
                            _this.selectSprite([sprite]);
                            taskResolve(sprite, "sprite");
                        });
                    }
                }
                if (type === "bg") {
                    var type =
                        data.fileType === 25 || data.fileType === 26
                            ? "Video"
                            : "Image";

                    var bgOpts = {
                        // 设置场景背景
                        resourceId: data.id, // 背景资源id
                        fileType: data.fileType, // 背景资源type
                        type, // 背景类型 0:Color 1:Image 2:Video
                        source: data.source, //第三方素材库
                        data: {
                            // 颜色背景的数据
                            url: data.url, // 颜色值,8位数
                            blur: 0, // 高斯模糊
                            opacity: 1, // 透明度
                            poster: data.thumbnailUrl,
                        },
                        videoStartTime: 0,
                        videoEndTime: parseInt(scene.duration / 1000),
                        zoomActive: data.zoomActive || false,
                        zoomOptions: data.zoomOptions,
                        filter: data.filter,
                        userId: data.userId,
                    };

                    if (data.isSwap) {
                        bgOpts.data = Object.assign({}, data.data);
                        bgOpts.zoomActive = data.zoomActive;
                        bgOpts.zoomOptions = data.zoomOptions;
                        bgOpts.filter = data.filter;
                        bgOpts.laying = data.laying;
                    }

                    this.selectedScenes
                        .setBackground(bgOpts, null, false)
                        .then(function () {
                            var sceneBgProps = _this.selectedScenes.background;
                            undoData.data.bg = JSON.parse(
                                JSON.stringify(
                                    _this.selectedScenes.background.data
                                )
                            );
                            undoData.reData.bg.zoomActive =
                                sceneBgProps.zoomActive;
                            undoData.reData.bg.zoomOptions = JSON.parse(
                                JSON.stringify(sceneBgProps.zoomOptions)
                            );
                            undoData.reData.bg.filter = JSON.parse(
                                JSON.stringify(sceneBgProps.filter)
                            );

                            taskResolve(_this.selectedScenes, "bg");

                            eve("addVideo.bg", null, _this.selectedScenes);
                        });
                }

                eve("editor.addVideo", null, data);

                return task;
            },
            removeVideos: function () {
                var scene = this.selectedScenes;
                var sprites = scene.sprites || [];
                var bgType = scene.background.data.type;
                var videoBgExist = bgType === "Video";
                var videoSprites =
                    sprites.filter((s) => s.type === "Video") || [];

                if (videoBgExist) {
                    scene.setBackground(
                        {
                            // 设置场景背景
                            resourceId: null, // 背景资源id
                            fileType: null, // 背景资源type
                            type: "Color", // 背景类型 0:Color 1:Image 2:Video
                            data: {
                                // 颜色背景的数据
                                color: "#ffffff", // 颜色值,8位数
                                blur: 0, // 高斯模糊
                                opacity: 1, // 高斯模糊参数
                            },
                        },
                        null,
                        false
                    );
                }

                videoSprites.forEach((s) => {
                    this.removeSprite(s.id);
                });
            },
            getVideoType: function () {
                var scene = this.selectedScenes;
                var sprites = scene.sprites || [];
                var bgType = scene.background.data.type;
                var videoBgExist = bgType === "Video";
                var firstVideo = (sprites.filter((s) => s.type === "Video") ||
                    [])[0];
                var videoSpriteExist = (
                    sprites.filter((s) => s.type === "Video") || []
                ).length;

                if (videoBgExist) {
                    return { type: "bg" };
                }
                if (videoSpriteExist) {
                    return {
                        type: "sprite",
                        sprite: firstVideo,
                    };
                }
                return { type: "none" };
            },
            currentSceneHasVideo: function () {
                var scene = this.selectedScenes;
                var sprites = scene.sprites || [];
                var bgType = scene.background.data.type;
                var videoBgExist = bgType === "Video";
                var videoSpriteExist = (
                    sprites.filter((s) => s.type === "Video") || []
                ).length;
                var ret = videoBgExist || videoSpriteExist;

                return !!ret;
            },
        });

    if (typeof noGlobal === typeof undefined) {
        window.AnimEditor = AnimEditor;
    }

    return AnimEditor;
});



//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/neweditor.js
// module id = 3a/z
// module chunks = 16